webpackJsonp([4],{

/***/ 1058:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Home_vue_vue_type_template_id_1a6d6940_scoped_true___ = __webpack_require__(2352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Home_vue_vue_type_script_setup_true_lang_js___ = __webpack_require__(2081);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Home_vue_vue_type_style_index_0_id_1a6d6940_prod_lang_scss_scoped_true___ = __webpack_require__(2434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(47);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Home_vue_vue_type_script_setup_true_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Home_vue_vue_type_template_id_1a6d6940_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Home_vue_vue_type_template_id_1a6d6940_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "1a6d6940",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ 1126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return a; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return p; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return k; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return l; });
/* unused harmony export config */
/* unused harmony export createTypes */
/* unused harmony export custom */
/* unused harmony export default */
/* unused harmony export fromType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return s; });
/* unused harmony export instanceOf */
/* unused harmony export integer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return P; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return y; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return b; });
/* unused harmony export objectOf */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return h; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return m; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return _; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return d; });
/* unused harmony export symbol */
/* unused harmony export toType */
/* unused harmony export toValidableType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return V; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_plain_object__ = __webpack_require__(1147);
function e(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function n(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),Object.defineProperty(t,"prototype",{writable:!1}),t}function r(t,e){t.prototype=Object.create(e.prototype),t.prototype.constructor=t,u(t,e)}function u(t,e){return u=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t},u(t,e)}var i={silent:!1,logLevel:"warn"},o=Object.defineProperty,f=Array.isArray||function(t){return"[object Array]"===Object.prototype.toString.call(t)};function c(e,n,r){void 0===n&&(n={}),void 0===r&&(r=!1);var u={_vueTypes_name:{value:e,writable:!0},def:{value:function(e){return void 0===e?("default"in this&&delete this.default,this):(this.default=f(e)?function(){return[].concat(e)}:Object(__WEBPACK_IMPORTED_MODULE_0_is_plain_object__["a" /* isPlainObject */])(e)?function(){return Object.assign({},e)}:e,this)}},isRequired:{get:function(){return this.required=!0,this}}};return r&&(u.validate={value:function(){}}),n.validator||(n.validator=function(){return!0}),Object.defineProperties(n,u)}var a=function(){return c("any",{},!0)},s=function(){return c("func",{type:Function},!0)},l=function(){return c("bool",{type:Boolean},!0)},d=function(){return c("string",{type:String},!0)},y=function(){return c("number",{type:Number},!0)},p=function(){return c("array",{type:Array},!0)},b=function(){return c("object",{type:Object},!0)},v=function(){return c("symbol")},g=function(){return c("integer",{type:Number})},h=function(t){return c("oneOf")},O=function(t){return c("custom")},j=function(t){return c("instanceOf",{type:t})},m=function(t){return c("oneOfType")},k=function(t){return c("arrayOf",{type:Array})},w=function(t){return c("objectOf",{type:Object})},_=function(t){return o(c("shape",{type:Object}),"loose",{get:function(){return this}})},P=function(){return{type:null}};function T(t,e,n,r,u){var i;void 0===r&&(r=!1),void 0===u&&(u=!1);var f=((i={})[r?"get":"value"]=function(){return c(e,Object.assign({},n),u).def(r?t.defaults[e]:void 0)},i);return o(t,e,f)}function A(t,e,n){void 0===n&&(n={});var r=c(t,Object.assign({},e,n),!!e.validable);return r.validator&&delete r.validator,r}var N=function(t,e){return c(t,e,!0)},x=function(t,e){return c(t,e)},D=/*#__PURE__*/function(){var e;return e=/*#__PURE__*/function(){function e(){}return e.extend=function(e){var n=this;if(f(e))return e.forEach(function(t){return n.extend(t)}),this;var r=e.validate,u=e.getter,i=void 0!==u&&u,o=e.type,c=void 0===o?null:o;return T(this,e.name,{type:Object(__WEBPACK_IMPORTED_MODULE_0_is_plain_object__["a" /* isPlainObject */])(c)&&c.type?null:c},i,!!r)},n(e,null,[{key:"any",get:function(){return a()}},{key:"func",get:function(){return s().def(this.defaults.func)}},{key:"bool",get:function(){return l().def(this.defaults.bool)}},{key:"string",get:function(){return d().def(this.defaults.string)}},{key:"number",get:function(){return y().def(this.defaults.number)}},{key:"array",get:function(){return p().def(this.defaults.array)}},{key:"object",get:function(){return b().def(this.defaults.object)}},{key:"symbol",get:function(){return v()}},{key:"integer",get:function(){return g().def(this.defaults.integer)}},{key:"nullable",get:function(){return{type:null}}}]),e}(),e.defaults={},e.sensibleDefaults=void 0,e.config=i,e.oneOf=h,e.custom=O,e.instanceOf=j,e.oneOfType=m,e.arrayOf=k,e.objectOf=w,e.shape=_,e.utils={toType:c,validate:function(){return!![].slice.call(arguments)}},e}();function E(t){var e;return void 0===t&&(t={func:function(){},bool:!0,string:"",number:0,array:function(){return[]},object:function(){return{}},integer:0}),e=/*#__PURE__*/function(e){function u(){return e.apply(this,arguments)||this}return r(u,e),n(u,null,[{key:"sensibleDefaults",get:function(){return Object.assign({},this.defaults)},set:function(e){this.defaults=!1!==e?Object.assign({},!0!==e?e:t):{}}}]),u}(D),e.defaults=Object.assign({},t),e}function V(t,e,n){return!0}"production"!=="production"&&!1===i.silent&&console.warn("You are using the production shimmed version of VueTypes in a development build. Refer to https://dwightjack.github.io/vue-types/guide/installation.html#production-build to learn how to configure VueTypes for usage in multiple environments.");var q=/*#__PURE__*/function(t){function e(){return t.apply(this,arguments)||this}return r(e,t),e}(E());


/***/ }),

/***/ 1147:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isPlainObject; });
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */

function isObject(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}
function isPlainObject(o) {
  var ctor, prot;
  if (isObject(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (ctor === undefined) return true;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
}


/***/ }),

/***/ 1161:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
  * vue-router v3.6.5
  * (c) 2022 Evan You
  * @license MIT
  */


Object.defineProperty(exports, '__esModule', { value: true })

var vue = __webpack_require__(29)

// dev only warn if no current instance

function throwNoCurrentInstance (method) {
  if (!vue.getCurrentInstance()) {
    throw new Error(
      ('[vue-router]: Missing current instance. ' + method + '() must be called inside <script setup> or setup().')
    )
  }
}

function useRouter () {
  if (false) {
    throwNoCurrentInstance('useRouter')
  }

  return vue.getCurrentInstance().proxy.$root.$router
}

function useRoute () {
  if (false) {
    throwNoCurrentInstance('useRoute')
  }

  var root = vue.getCurrentInstance().proxy.$root
  if (!root._$route) {
    var route = vue.effectScope(true).run(function () { return vue.shallowReactive(Object.assign({}, root.$router.currentRoute)) }
    )
    root._$route = route

    root.$router.afterEach(function (to) {
      Object.assign(route, to)
    })
  }

  return root._$route
}

function onBeforeRouteUpdate (guard) {
  if (false) {
    throwNoCurrentInstance('onBeforeRouteUpdate')
  }

  return useFilteredGuard(guard, isUpdateNavigation)
}
function isUpdateNavigation (to, from, depth) {
  var toMatched = to.matched
  var fromMatched = from.matched
  return (
    toMatched.length >= depth &&
    toMatched
      .slice(0, depth + 1)
      .every(function (record, i) { return record === fromMatched[i] })
  )
}

function isLeaveNavigation (to, from, depth) {
  var toMatched = to.matched
  var fromMatched = from.matched
  return toMatched.length < depth || toMatched[depth] !== fromMatched[depth]
}

function onBeforeRouteLeave (guard) {
  if (false) {
    throwNoCurrentInstance('onBeforeRouteLeave')
  }

  return useFilteredGuard(guard, isLeaveNavigation)
}

var noop = function () {}
function useFilteredGuard (guard, fn) {
  var instance = vue.getCurrentInstance()
  var router = useRouter()

  var target = instance.proxy
  // find the nearest RouterView to know the depth
  while (
    target &&
    target.$vnode &&
    target.$vnode.data &&
    target.$vnode.data.routerViewDepth == null
  ) {
    target = target.$parent
  }

  var depth =
    target && target.$vnode && target.$vnode.data
      ? target.$vnode.data.routerViewDepth
      : null

  if (depth != null) {
    var removeGuard = router.beforeEach(function (to, from, next) {
      return fn(to, from, depth) ? guard(to, from, next) : next()
    })

    vue.onUnmounted(removeGuard)
    return removeGuard
  }

  return noop
}

/*  */

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target')
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault()
  }
  return true
}

function includesParams (outer, inner) {
  var loop = function (key) {
    var innerValue = inner[key]
    var outerValue = outer[key]
    if (typeof innerValue === 'string') {
      if (innerValue !== outerValue) { return { v: false } }
    } else {
      if (
        !Array.isArray(outerValue) ||
        outerValue.length !== innerValue.length ||
        innerValue.some(function (value, i) { return value !== outerValue[i] })
      ) {
        return { v: false }
      }
    }
  }

  for (var key in inner) {
    var returned = loop(key)

    if (returned) return returned.v
  }

  return true
}

// helpers from vue router 4

function isSameRouteLocationParamsValue (a, b) {
  return Array.isArray(a)
    ? isEquivalentArray(a, b)
    : Array.isArray(b)
      ? isEquivalentArray(b, a)
      : a === b
}

function isEquivalentArray (a, b) {
  return Array.isArray(b)
    ? a.length === b.length && a.every(function (value, i) { return value === b[i] })
    : a.length === 1 && a[0] === b
}

function isSameRouteLocationParams (a, b) {
  if (Object.keys(a).length !== Object.keys(b).length) { return false }

  for (var key in a) {
    if (!isSameRouteLocationParamsValue(a[key], b[key])) { return false }
  }

  return true
}

function useLink (props) {
  if (false) {
    throwNoCurrentInstance('useLink')
  }

  var router = useRouter()
  var currentRoute = useRoute()

  var resolvedRoute = vue.computed(function () { return router.resolve(vue.unref(props.to), currentRoute) })

  var activeRecordIndex = vue.computed(function () {
    var route = resolvedRoute.value.route
    var matched = route.matched
    var length = matched.length
    var routeMatched = matched[length - 1]
    var currentMatched = currentRoute.matched
    if (!routeMatched || !currentMatched.length) { return -1 }
    var index = currentMatched.indexOf(routeMatched)
    if (index > -1) { return index }
    // possible parent record
    var parentRecord = currentMatched[currentMatched.length - 2]

    return (
      // we are dealing with nested routes
      length > 1 &&
        // if the parent and matched route have the same path, this link is
        // referring to the empty child. Or we currently are on a different
        // child of the same parent
        parentRecord && parentRecord === routeMatched.parent
    )
  })

  var isActive = vue.computed(
    function () {
      return activeRecordIndex.value > -1 &&
      includesParams(currentRoute.params, resolvedRoute.value.route.params)
    }
  )
  var isExactActive = vue.computed(
    function () {
      return activeRecordIndex.value > -1 &&
      activeRecordIndex.value === currentRoute.matched.length - 1 &&
      isSameRouteLocationParams(currentRoute.params, resolvedRoute.value.route.params)
    }
  )

  var navigate = function (e) {
    var href = resolvedRoute.value.route
    if (guardEvent(e)) {
      return props.replace
        ? router.replace(href)
        : router.push(href)
    }
    return Promise.resolve()
  }

  return {
    href: vue.computed(function () { return resolvedRoute.value.href }),
    route: vue.computed(function () { return resolvedRoute.value.route }),
    isExactActive: isExactActive,
    isActive: isActive,
    navigate: navigate
  }
}

exports.isSameRouteLocationParams = isSameRouteLocationParams
exports.onBeforeRouteLeave = onBeforeRouteLeave
exports.onBeforeRouteUpdate = onBeforeRouteUpdate
exports.useLink = useLink
exports.useRoute = useRoute
exports.useRouter = useRouter


/***/ }),

/***/ 1183:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SmoothReflow_vue_vue_type_script_lang_js___ = __webpack_require__(1184);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SmoothReflow_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 1184:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_smooth_reflow__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_smooth_reflow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_smooth_reflow__);
// https://github.com/guanzo/vue-smooth-reflow

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SmoothReflow',
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_smooth_reflow___default.a],
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    options: {
      type: Object,
      default: function _default() {}
    }
  },
  mounted: function mounted() {
    this.$smoothReflow(this.options);
  }
});

/***/ }),

/***/ 1245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SmoothReflow_vue_vue_type_template_id_3ebd420e___ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SmoothReflow_vue_vue_type_script_lang_js___ = __webpack_require__(1183);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(47);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__SmoothReflow_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__SmoothReflow_vue_vue_type_template_id_3ebd420e___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SmoothReflow_vue_vue_type_template_id_3ebd420e___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 1248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SmoothReflow_vue_vue_type_template_id_3ebd420e___ = __webpack_require__(1249);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SmoothReflow_vue_vue_type_template_id_3ebd420e___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SmoothReflow_vue_vue_type_template_id_3ebd420e___["b"]; });


/***/ }),

/***/ 1249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(_vm.tag, {
    tag: "component"
  }, [_vm._t("default")], 2);
};
var staticRenderFns = [];


/***/ }),

/***/ 1250:
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.SmoothReflow=e():t.SmoothReflow=e()}("undefined"!=typeof self?self:this,function(){return function(t){var e={};function n(r){if(e[r])return e[r].exports;var o=e[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var o in t)n.d(r,o,function(e){return t[e]}.bind(null,o));return r},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=44)}([function(t,e,n){var r=n(28)("wks"),o=n(14),i=n(1).Symbol,u="function"==typeof i;(t.exports=function(t){return r[t]||(r[t]=u&&i[t]||(u?i:o)("Symbol."+t))}).store=r},function(t,e){var n=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(t,e,n){var r=n(1),o=n(7),i=n(3),u=n(19),s=n(24),f=function(t,e,n){var a,c,l,p,v=t&f.F,h=t&f.G,y=t&f.S,d=t&f.P,m=t&f.B,g=h?r:y?r[e]||(r[e]={}):(r[e]||{}).prototype,b=h?o:o[e]||(o[e]={}),S=b.prototype||(b.prototype={});for(a in h&&(n=e),n)l=((c=!v&&g&&void 0!==g[a])?g:n)[a],p=m&&c?s(l,r):d&&"function"==typeof l?s(Function.call,l):l,g&&u(g,a,l,t&f.U),b[a]!=l&&i(b,a,p),d&&S[a]!=l&&(S[a]=l)};r.core=o,f.F=1,f.G=2,f.S=4,f.P=8,f.B=16,f.W=32,f.U=64,f.R=128,t.exports=f},function(t,e,n){var r=n(4),o=n(13);t.exports=n(8)?function(t,e,n){return r.f(t,e,o(1,n))}:function(t,e,n){return t[e]=n,t}},function(t,e,n){var r=n(12),o=n(34),i=n(23),u=Object.defineProperty;e.f=n(8)?Object.defineProperty:function(t,e,n){if(r(t),e=i(e,!0),r(n),o)try{return u(t,e,n)}catch(t){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(t[e]=n.value),t}},function(t,e){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}},function(t,e){var n=t.exports={version:"2.5.7"};"number"==typeof __e&&(__e=n)},function(t,e,n){t.exports=!n(9)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,e){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,e,n){var r=n(37),o=n(29);t.exports=Object.keys||function(t){return r(t,o)}},function(t,e,n){var r=n(25),o=n(17);t.exports=function(t){return r(o(t))}},function(t,e,n){var r=n(5);t.exports=function(t){if(!r(t))throw TypeError(t+" is not an object!");return t}},function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e){var n=0,r=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++n+r).toString(36))}},function(t,e){t.exports={}},function(t,e,n){var r=n(17);t.exports=function(t){return Object(r(t))}},function(t,e){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,e){t.exports=!1},function(t,e,n){var r=n(1),o=n(3),i=n(6),u=n(14)("src"),s=Function.toString,f=(""+s).split("toString");n(7).inspectSource=function(t){return s.call(t)},(t.exports=function(t,e,n,s){var a="function"==typeof n;a&&(i(n,"name")||o(n,"name",e)),t[e]!==n&&(a&&(i(n,u)||o(n,u,t[e]?""+t[e]:f.join(String(e)))),t===r?t[e]=n:s?t[e]?t[e]=n:o(t,e,n):(delete t[e],o(t,e,n)))})(Function.prototype,"toString",function(){return"function"==typeof this&&this[u]||s.call(this)})},function(t,e){var n={}.toString;t.exports=function(t){return n.call(t).slice(8,-1)}},function(t,e){e.f={}.propertyIsEnumerable},function(t,e){var n=Math.ceil,r=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?r:n)(t)}},function(t,e,n){var r=n(5);t.exports=function(t,e){if(!r(t))return t;var n,o;if(e&&"function"==typeof(n=t.toString)&&!r(o=n.call(t)))return o;if("function"==typeof(n=t.valueOf)&&!r(o=n.call(t)))return o;if(!e&&"function"==typeof(n=t.toString)&&!r(o=n.call(t)))return o;throw TypeError("Can't convert object to primitive value")}},function(t,e,n){var r=n(47);t.exports=function(t,e,n){if(r(t),void 0===e)return t;switch(n){case 1:return function(n){return t.call(e,n)};case 2:return function(n,r){return t.call(e,n,r)};case 3:return function(n,r,o){return t.call(e,n,r,o)}}return function(){return t.apply(e,arguments)}}},function(t,e,n){var r=n(20);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==r(t)?t.split(""):Object(t)}},function(t,e,n){var r=n(22),o=Math.min;t.exports=function(t){return t>0?o(r(t),9007199254740991):0}},function(t,e,n){var r=n(28)("keys"),o=n(14);t.exports=function(t){return r[t]||(r[t]=o(t))}},function(t,e,n){var r=n(7),o=n(1),i=o["__core-js_shared__"]||(o["__core-js_shared__"]={});(t.exports=function(t,e){return i[t]||(i[t]=void 0!==e?e:{})})("versions",[]).push({version:r.version,mode:n(18)?"pure":"global",copyright:"© 2018 Denis Pushkarev (zloirock.ru)"})},function(t,e){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(t,e,n){var r=n(4).f,o=n(6),i=n(0)("toStringTag");t.exports=function(t,e,n){t&&!o(t=n?t:t.prototype,i)&&r(t,i,{configurable:!0,value:e})}},function(t,e,n){var r=n(0)("unscopables"),o=Array.prototype;void 0==o[r]&&n(3)(o,r,{}),t.exports=function(t){o[r][t]=!0}},function(t,e){e.f=Object.getOwnPropertySymbols},function(t,e,n){"use strict";var r=n(18),o=n(2),i=n(19),u=n(3),s=n(15),f=n(48),a=n(30),c=n(52),l=n(0)("iterator"),p=!([].keys&&"next"in[].keys()),v=function(){return this};t.exports=function(t,e,n,h,y,d,m){f(n,e,h);var g,b,S,x=function(t){if(!p&&t in j)return j[t];switch(t){case"keys":case"values":return function(){return new n(this,t)}}return function(){return new n(this,t)}},w=e+" Iterator",E="values"==y,O=!1,j=t.prototype,_=j[l]||j["@@iterator"]||y&&j[y],T=_||x(y),A=y?E?x("entries"):T:void 0,P="Array"==e&&j.entries||_;if(P&&(S=c(P.call(new t)))!==Object.prototype&&S.next&&(a(S,w,!0),r||"function"==typeof S[l]||u(S,l,v)),E&&_&&"values"!==_.name&&(O=!0,T=function(){return _.call(this)}),r&&!m||!p&&!O&&j[l]||u(j,l,T),s[e]=T,s[w]=v,y)if(g={values:E?T:x("values"),keys:d?T:x("keys"),entries:A},m)for(b in g)b in j||i(j,b,g[b]);else o(o.P+o.F*(p||O),e,g);return g}},function(t,e,n){t.exports=!n(8)&&!n(9)(function(){return 7!=Object.defineProperty(n(35)("div"),"a",{get:function(){return 7}}).a})},function(t,e,n){var r=n(5),o=n(1).document,i=r(o)&&r(o.createElement);t.exports=function(t){return i?o.createElement(t):{}}},function(t,e,n){var r=n(12),o=n(49),i=n(29),u=n(27)("IE_PROTO"),s=function(){},f=function(){var t,e=n(35)("iframe"),r=i.length;for(e.style.display="none",n(51).appendChild(e),e.src="javascript:",(t=e.contentWindow.document).open(),t.write("<script>document.F=Object<\/script>"),t.close(),f=t.F;r--;)delete f.prototype[i[r]];return f()};t.exports=Object.create||function(t,e){var n;return null!==t?(s.prototype=r(t),n=new s,s.prototype=null,n[u]=t):n=f(),void 0===e?n:o(n,e)}},function(t,e,n){var r=n(6),o=n(11),i=n(38)(!1),u=n(27)("IE_PROTO");t.exports=function(t,e){var n,s=o(t),f=0,a=[];for(n in s)n!=u&&r(s,n)&&a.push(n);for(;e.length>f;)r(s,n=e[f++])&&(~i(a,n)||a.push(n));return a}},function(t,e,n){var r=n(11),o=n(26),i=n(50);t.exports=function(t){return function(e,n,u){var s,f=r(e),a=o(f.length),c=i(u,a);if(t&&n!=n){for(;a>c;)if((s=f[c++])!=s)return!0}else for(;a>c;c++)if((t||c in f)&&f[c]===n)return t||c||0;return!t&&-1}}},function(t,e,n){"use strict";var r=n(31),o=n(65),i=n(15),u=n(11);t.exports=n(33)(Array,"Array",function(t,e){this._t=u(t),this._i=0,this._k=e},function(){var t=this._t,e=this._k,n=this._i++;return!t||n>=t.length?(this._t=void 0,o(1)):o(0,"keys"==e?n:"values"==e?t[n]:[n,t[n]])},"values"),i.Arguments=i.Array,r("keys"),r("values"),r("entries")},function(t,e,n){var r=n(20);t.exports=Array.isArray||function(t){return"Array"==r(t)}},function(t,e,n){var r=n(1),o=n(7),i=n(18),u=n(42),s=n(4).f;t.exports=function(t){var e=o.Symbol||(o.Symbol=i?{}:r.Symbol||{});"_"==t.charAt(0)||t in e||s(e,t,{value:u.f(t)})}},function(t,e,n){e.f=n(0)},function(t,e,n){var r=n(37),o=n(29).concat("length","prototype");e.f=Object.getOwnPropertyNames||function(t){return r(t,o)}},function(t,e,n){"use strict";n.r(e);n(45),n(53),n(60),n(61),n(39),n(66),n(68),n(70),n(74),n(75),n(80);function r(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}var o={methods:{$smoothReflow:function(t){var e=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this._smoothElements.push(new a(t))}.bind(this);Array.isArray(t)?t.forEach(e):e(t)},$unsmoothReflow:function(t){var e=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:f(),e=this.$el,n=this._smoothElements.findIndex(function(n){return u(e,n.options.el)===u(e,t.el)});if(-1===n)return void console.error("VSR_ERROR: $unsmoothReflow failed due to invalid el option");this._smoothElements[n].scheduleRemoval()}.bind(this);Array.isArray(t)?t.forEach(e):e(t)}},beforeMount:function(){var t=this;this._smoothElements=[],this._endListener=function(e){var n=!0,r=!1,o=void 0;try{for(var i,u=t._smoothElements[Symbol.iterator]();!(n=(i=u.next()).done);n=!0){i.value.endListener(e)}}catch(t){r=!0,o=t}finally{try{n||null==u.return||u.return()}finally{if(r)throw o}}}},mounted:function(){this.$el.addEventListener("transitionend",this._endListener,{passive:!0})},destroyed:function(){this.$el.removeEventListener("transitionend",this._endListener,{passive:!0})},beforeUpdate:function(){this.$el.addEventListener("transitionend",this._endListener,{passive:!0}),i(this);var t=!0,e=!1,n=void 0;try{for(var r,o=this._smoothElements[Symbol.iterator]();!(t=(r=o.next()).done);t=!0){var s=r.value,f=u(this.$el,s.options.el);s.setSmoothElement(f),s.setBeforeValues()}}catch(t){e=!0,n=t}finally{try{t||null==o.return||o.return()}finally{if(e)throw n}}},updated:function(){var t=this;this.$nextTick(function(){var e=!0,n=!1,r=void 0;try{for(var o,s=t._smoothElements[Symbol.iterator]();!(e=(o=s.next()).done);e=!0){var f=o.value,a=u(t.$el,f.options.el);f.setSmoothElement(a),f.doSmoothReflow()}}catch(t){n=!0,r=t}finally{try{e||null==s.return||s.return()}finally{if(n)throw r}}i(t)})}};function i(t){for(var e=t._smoothElements.length;e--;){var n=t._smoothElements[e];n.isRemoved&&(n.stopTransition(),t._smoothElements.splice(e,1))}}function u(t,e){return!t||t instanceof Node&&t.nodeType===Node.COMMENT_NODE?null:null===e?t:function(t,e){return"string"==typeof e?t.matches(e)?t:t.querySelector(e):e}(t,e)}var s={INACTIVE:"INACTIVE",ACTIVE:"ACTIVE"},f=function(){return{el:null,property:"height",transitionEvent:null,hideOverflow:!0,debug:!1}},a=function(){function t(e){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t);var n=f();Object.assign(n,e);var r=this.parsePropertyOption(n.property);n.transition||(n.transition=r.map(function(t){return"".concat(t," .5s")}).join(","));var o={$smoothEl:null,properties:r,beforeRect:{},state:s.INACTIVE,isRemoved:!1};Object.assign(this,{options:n},o),this.endListener=this.endListener.bind(this),this.debug=this.debug.bind(this)}return function(t,e,n){e&&r(t.prototype,e),n&&r(t,n)}(t,[{key:"setSmoothElement",value:function(t){this.$smoothEl=t}},{key:"transitionTo",value:function(t){this.state=t}},{key:"parsePropertyOption",value:function(t){return"string"==typeof t?[t]:Array.isArray(t)?t:[]}},{key:"setBeforeValues",value:function(){var t=this.$smoothEl;if(this.beforeRect={},t){var e=window.getComputedStyle(t)||{},n=e.transition,r=e.overflowX,o=e.overflowY;this.computedTransition=n,this.overflowX=r,this.overflowY=o,this.beforeRect=c(t),this.state===s.ACTIVE&&(this.stopTransition(),this.debug("Transition was interrupted."))}}},{key:"didValuesChange",value:function(t,e){var n=t,r=e;if(0===Object.keys(t).length)return!1;var o=!0,i=!1,u=void 0;try{for(var s,f=this.properties[Symbol.iterator]();!(o=(s=f.next()).done);o=!0){var a=s.value;if("transform"===a&&(n.top!==r.top||n.left!==r.left))return!0;if(n[a]!==r[a])return!0}}catch(t){i=!0,u=t}finally{try{o||null==f.return||f.return()}finally{if(i)throw u}}return!1}},{key:"doSmoothReflow",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"data update",e=this.$smoothEl;if(!e)return this.debug("Could not find registered el to perform doSmoothReflow."),void this.transitionTo(s.INACTIVE);if(this.state!==s.ACTIVE){var n=this.beforeRect,r=this.properties,o=this.options,i=this.overflowX,u=this.overflowY,f=this.debug;this.transitionTo(s.ACTIVE),f("doSmoothReflow triggered by:","string"==typeof t?t:t.target);var a=c(e);if(!this.didValuesChange(n,a))return f("Property values did not change."),void this.transitionTo(s.INACTIVE);f("beforeRect",n),f("afterRect",a),this.saveOverflowValues(e,i,u);var l=!0,p=!1,v=void 0;try{for(var h,y=r[Symbol.iterator]();!(l=(h=y.next()).done);l=!0){var d=h.value;if("transform"===d){var m=n.left-a.left,g=n.top-a.top;e.style.transform="translate(".concat(m,"px, ").concat(g,"px)")}else e.style[d]=n[d]+"px"}}catch(t){p=!0,v=t}finally{try{l||null==y.return||y.return()}finally{if(p)throw v}}e.offsetHeight,e.style.transition=[this.computedTransition,o.transition].filter(function(t){return t}).join(",");var b=!0,S=!1,x=void 0;try{for(var w,E=r[Symbol.iterator]();!(b=(w=E.next()).done);b=!0){var O=w.value;"transform"===O?e.style.transform="":e.style[O]=a[O]+"px"}}catch(t){S=!0,x=t}finally{try{b||null==E.return||E.return()}finally{if(S)throw x}}}}},{key:"endListener",value:function(t){var e=this.$smoothEl,n=this.properties;e===t.target?n.includes(t.propertyName)&&(this.stopTransition(),this.hasRegisteredEventEmitter()&&this.setBeforeValues()):this.isRegisteredEventEmitter(e,t)&&this.doSmoothReflow(t)}},{key:"hasRegisteredEventEmitter",value:function(){var t=this.options.transitionEvent;return null!==t&&Object.keys(t).length>0}},{key:"isRegisteredEventEmitter",value:function(t,e){if(!this.hasRegisteredEventEmitter())return!1;var n=e.target,r=this.options.transitionEvent,o=r.selector,i=r.propertyName;if(null!=i&&i!==e.propertyName)return!1;if(null!=o&&!n.matches(o))return!1;if(-1===this.properties.indexOf("transform")){var u=!1,s=e.composedPath?e.composedPath():[],f=!0,a=!1,c=void 0;try{for(var l,p=s[Symbol.iterator]();!(f=(l=p.next()).done);f=!0){if(t===l.value){u=!0;break}}}catch(t){a=!0,c=t}finally{try{f||null==p.return||p.return()}finally{if(a)throw c}}if(!u)return!1}return!0}},{key:"saveOverflowValues",value:function(t,e,n){this.options.hideOverflow&&(this.overflowX=e,this.overflowY=n,t.style.overflowX="hidden",t.style.overflowY="hidden")}},{key:"restoreOverflowValues",value:function(t){var e=this.options,n=this.overflowX,r=this.overflowY;e.hideOverflow&&(t.style.overflowX=n,t.style.overflowY=r)}},{key:"stopTransition",value:function(){var t=this.$smoothEl,e=this.properties,n=!0,r=!1,o=void 0;try{for(var i,u=e[Symbol.iterator]();!(n=(i=u.next()).done);n=!0){var f=i.value;t.style[f]=null}}catch(t){r=!0,o=t}finally{try{n||null==u.return||u.return()}finally{if(r)throw o}}this.restoreOverflowValues(t),t.style.transition=null,this.transitionTo(s.INACTIVE)}},{key:"scheduleRemoval",value:function(){this.isRemoved=!0}},{key:"debug",value:function(){if(this.options.debug){var t=["VSR_DEBUG:"].concat(Array.from(arguments));console.log.apply(null,t)}}}]),t}(),c=function(t){t.style.overflow="hidden";var e=t.getBoundingClientRect(),n=e.top,r=e.right,o=e.bottom,i=e.left,u=e.width,s=e.height,f=e.x,a=e.y;return t.style.overflow=null,{top:n,right:r,bottom:o,left:i,width:u,height:s,x:f,y:a}};"undefined"!=typeof Element&&Element.prototype&&!Element.prototype.matches&&(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.mozMatchesSelector||Element.prototype.msMatchesSelector||Element.prototype.oMatchesSelector||Element.prototype.webkitMatchesSelector||function(t){for(var e=(this.document||this.ownerDocument).querySelectorAll(t),n=e.length;--n>=0&&e.item(n)!==this;);return n>-1}),e.default=o},function(t,e,n){"use strict";var r=n(46)(!0);n(33)(String,"String",function(t){this._t=String(t),this._i=0},function(){var t,e=this._t,n=this._i;return n>=e.length?{value:void 0,done:!0}:(t=r(e,n),this._i+=t.length,{value:t,done:!1})})},function(t,e,n){var r=n(22),o=n(17);t.exports=function(t){return function(e,n){var i,u,s=String(o(e)),f=r(n),a=s.length;return f<0||f>=a?t?"":void 0:(i=s.charCodeAt(f))<55296||i>56319||f+1===a||(u=s.charCodeAt(f+1))<56320||u>57343?t?s.charAt(f):i:t?s.slice(f,f+2):u-56320+(i-55296<<10)+65536}}},function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,e,n){"use strict";var r=n(36),o=n(13),i=n(30),u={};n(3)(u,n(0)("iterator"),function(){return this}),t.exports=function(t,e,n){t.prototype=r(u,{next:o(1,n)}),i(t,e+" Iterator")}},function(t,e,n){var r=n(4),o=n(12),i=n(10);t.exports=n(8)?Object.defineProperties:function(t,e){o(t);for(var n,u=i(e),s=u.length,f=0;s>f;)r.f(t,n=u[f++],e[n]);return t}},function(t,e,n){var r=n(22),o=Math.max,i=Math.min;t.exports=function(t,e){return(t=r(t))<0?o(t+e,0):i(t,e)}},function(t,e,n){var r=n(1).document;t.exports=r&&r.documentElement},function(t,e,n){var r=n(6),o=n(16),i=n(27)("IE_PROTO"),u=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=o(t),r(t,i)?t[i]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?u:null}},function(t,e,n){"use strict";var r=n(24),o=n(2),i=n(16),u=n(54),s=n(55),f=n(26),a=n(56),c=n(57);o(o.S+o.F*!n(59)(function(t){Array.from(t)}),"Array",{from:function(t){var e,n,o,l,p=i(t),v="function"==typeof this?this:Array,h=arguments.length,y=h>1?arguments[1]:void 0,d=void 0!==y,m=0,g=c(p);if(d&&(y=r(y,h>2?arguments[2]:void 0,2)),void 0==g||v==Array&&s(g))for(n=new v(e=f(p.length));e>m;m++)a(n,m,d?y(p[m],m):p[m]);else for(l=g.call(p),n=new v;!(o=l.next()).done;m++)a(n,m,d?u(l,y,[o.value,m],!0):o.value);return n.length=m,n}})},function(t,e,n){var r=n(12);t.exports=function(t,e,n,o){try{return o?e(r(n)[0],n[1]):e(n)}catch(e){var i=t.return;throw void 0!==i&&r(i.call(t)),e}}},function(t,e,n){var r=n(15),o=n(0)("iterator"),i=Array.prototype;t.exports=function(t){return void 0!==t&&(r.Array===t||i[o]===t)}},function(t,e,n){"use strict";var r=n(4),o=n(13);t.exports=function(t,e,n){e in t?r.f(t,e,o(0,n)):t[e]=n}},function(t,e,n){var r=n(58),o=n(0)("iterator"),i=n(15);t.exports=n(7).getIteratorMethod=function(t){if(void 0!=t)return t[o]||t["@@iterator"]||i[r(t)]}},function(t,e,n){var r=n(20),o=n(0)("toStringTag"),i="Arguments"==r(function(){return arguments}());t.exports=function(t){var e,n,u;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=function(t,e){try{return t[e]}catch(t){}}(e=Object(t),o))?n:i?r(e):"Object"==(u=r(e))&&"function"==typeof e.callee?"Arguments":u}},function(t,e,n){var r=n(0)("iterator"),o=!1;try{var i=[7][r]();i.return=function(){o=!0},Array.from(i,function(){throw 2})}catch(t){}t.exports=function(t,e){if(!e&&!o)return!1;var n=!1;try{var i=[7],u=i[r]();u.next=function(){return{done:n=!0}},i[r]=function(){return u},t(i)}catch(t){}return n}},function(t,e,n){"use strict";var r=n(2),o=n(38)(!0);r(r.P,"Array",{includes:function(t){return o(this,t,arguments.length>1?arguments[1]:void 0)}}),n(31)("includes")},function(t,e,n){"use strict";var r=n(2),o=n(62);r(r.P+r.F*n(64)("includes"),"String",{includes:function(t){return!!~o(this,t,"includes").indexOf(t,arguments.length>1?arguments[1]:void 0)}})},function(t,e,n){var r=n(63),o=n(17);t.exports=function(t,e,n){if(r(e))throw TypeError("String#"+n+" doesn't accept regex!");return String(o(t))}},function(t,e,n){var r=n(5),o=n(20),i=n(0)("match");t.exports=function(t){var e;return r(t)&&(void 0!==(e=t[i])?!!e:"RegExp"==o(t))}},function(t,e,n){var r=n(0)("match");t.exports=function(t){var e=/./;try{"/./"[t](e)}catch(n){try{return e[r]=!1,!"/./"[t](e)}catch(t){}}return!0}},function(t,e){t.exports=function(t,e){return{value:e,done:!!t}}},function(t,e,n){var r=n(16),o=n(10);n(67)("keys",function(){return function(t){return o(r(t))}})},function(t,e,n){var r=n(2),o=n(7),i=n(9);t.exports=function(t,e){var n=(o.Object||{})[t]||Object[t],u={};u[t]=e(n),r(r.S+r.F*i(function(){n(1)}),"Object",u)}},function(t,e,n){var r=n(2);r(r.S+r.F,"Object",{assign:n(69)})},function(t,e,n){"use strict";var r=n(10),o=n(32),i=n(21),u=n(16),s=n(25),f=Object.assign;t.exports=!f||n(9)(function(){var t={},e={},n=Symbol(),r="abcdefghijklmnopqrst";return t[n]=7,r.split("").forEach(function(t){e[t]=t}),7!=f({},t)[n]||Object.keys(f({},e)).join("")!=r})?function(t,e){for(var n=u(t),f=arguments.length,a=1,c=o.f,l=i.f;f>a;)for(var p,v=s(arguments[a++]),h=c?r(v).concat(c(v)):r(v),y=h.length,d=0;y>d;)l.call(v,p=h[d++])&&(n[p]=v[p]);return n}:f},function(t,e,n){"use strict";var r=n(2),o=n(71)(6),i="findIndex",u=!0;i in[]&&Array(1)[i](function(){u=!1}),r(r.P+r.F*u,"Array",{findIndex:function(t){return o(this,t,arguments.length>1?arguments[1]:void 0)}}),n(31)(i)},function(t,e,n){var r=n(24),o=n(25),i=n(16),u=n(26),s=n(72);t.exports=function(t,e){var n=1==t,f=2==t,a=3==t,c=4==t,l=6==t,p=5==t||l,v=e||s;return function(e,s,h){for(var y,d,m=i(e),g=o(m),b=r(s,h,3),S=u(g.length),x=0,w=n?v(e,S):f?v(e,0):void 0;S>x;x++)if((p||x in g)&&(d=b(y=g[x],x,m),t))if(n)w[x]=d;else if(d)switch(t){case 3:return!0;case 5:return y;case 6:return x;case 2:w.push(y)}else if(c)return!1;return l?-1:a||c?c:w}}},function(t,e,n){var r=n(73);t.exports=function(t,e){return new(r(t))(e)}},function(t,e,n){var r=n(5),o=n(40),i=n(0)("species");t.exports=function(t){var e;return o(t)&&("function"!=typeof(e=t.constructor)||e!==Array&&!o(e.prototype)||(e=void 0),r(e)&&null===(e=e[i])&&(e=void 0)),void 0===e?Array:e}},function(t,e,n){n(41)("asyncIterator")},function(t,e,n){"use strict";var r=n(1),o=n(6),i=n(8),u=n(2),s=n(19),f=n(76).KEY,a=n(9),c=n(28),l=n(30),p=n(14),v=n(0),h=n(42),y=n(41),d=n(77),m=n(40),g=n(12),b=n(5),S=n(11),x=n(23),w=n(13),E=n(36),O=n(78),j=n(79),_=n(4),T=n(10),A=j.f,P=_.f,k=O.f,R=r.Symbol,L=r.JSON,I=L&&L.stringify,M=v("_hidden"),C=v("toPrimitive"),N={}.propertyIsEnumerable,V=c("symbol-registry"),F=c("symbols"),$=c("op-symbols"),D=Object.prototype,G="function"==typeof R,Y=r.QObject,B=!Y||!Y.prototype||!Y.prototype.findChild,X=i&&a(function(){return 7!=E(P({},"a",{get:function(){return P(this,"a",{value:7}).a}})).a})?function(t,e,n){var r=A(D,e);r&&delete D[e],P(t,e,n),r&&t!==D&&P(D,e,r)}:P,H=function(t){var e=F[t]=E(R.prototype);return e._k=t,e},U=G&&"symbol"==typeof R.iterator?function(t){return"symbol"==typeof t}:function(t){return t instanceof R},W=function(t,e,n){return t===D&&W($,e,n),g(t),e=x(e,!0),g(n),o(F,e)?(n.enumerable?(o(t,M)&&t[M][e]&&(t[M][e]=!1),n=E(n,{enumerable:w(0,!1)})):(o(t,M)||P(t,M,w(1,{})),t[M][e]=!0),X(t,e,n)):P(t,e,n)},q=function(t,e){g(t);for(var n,r=d(e=S(e)),o=0,i=r.length;i>o;)W(t,n=r[o++],e[n]);return t},z=function(t){var e=N.call(this,t=x(t,!0));return!(this===D&&o(F,t)&&!o($,t))&&(!(e||!o(this,t)||!o(F,t)||o(this,M)&&this[M][t])||e)},J=function(t,e){if(t=S(t),e=x(e,!0),t!==D||!o(F,e)||o($,e)){var n=A(t,e);return!n||!o(F,e)||o(t,M)&&t[M][e]||(n.enumerable=!0),n}},K=function(t){for(var e,n=k(S(t)),r=[],i=0;n.length>i;)o(F,e=n[i++])||e==M||e==f||r.push(e);return r},Q=function(t){for(var e,n=t===D,r=k(n?$:S(t)),i=[],u=0;r.length>u;)!o(F,e=r[u++])||n&&!o(D,e)||i.push(F[e]);return i};G||(s((R=function(){if(this instanceof R)throw TypeError("Symbol is not a constructor!");var t=p(arguments.length>0?arguments[0]:void 0),e=function(n){this===D&&e.call($,n),o(this,M)&&o(this[M],t)&&(this[M][t]=!1),X(this,t,w(1,n))};return i&&B&&X(D,t,{configurable:!0,set:e}),H(t)}).prototype,"toString",function(){return this._k}),j.f=J,_.f=W,n(43).f=O.f=K,n(21).f=z,n(32).f=Q,i&&!n(18)&&s(D,"propertyIsEnumerable",z,!0),h.f=function(t){return H(v(t))}),u(u.G+u.W+u.F*!G,{Symbol:R});for(var Z="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),tt=0;Z.length>tt;)v(Z[tt++]);for(var et=T(v.store),nt=0;et.length>nt;)y(et[nt++]);u(u.S+u.F*!G,"Symbol",{for:function(t){return o(V,t+="")?V[t]:V[t]=R(t)},keyFor:function(t){if(!U(t))throw TypeError(t+" is not a symbol!");for(var e in V)if(V[e]===t)return e},useSetter:function(){B=!0},useSimple:function(){B=!1}}),u(u.S+u.F*!G,"Object",{create:function(t,e){return void 0===e?E(t):q(E(t),e)},defineProperty:W,defineProperties:q,getOwnPropertyDescriptor:J,getOwnPropertyNames:K,getOwnPropertySymbols:Q}),L&&u(u.S+u.F*(!G||a(function(){var t=R();return"[null]"!=I([t])||"{}"!=I({a:t})||"{}"!=I(Object(t))})),"JSON",{stringify:function(t){for(var e,n,r=[t],o=1;arguments.length>o;)r.push(arguments[o++]);if(n=e=r[1],(b(e)||void 0!==t)&&!U(t))return m(e)||(e=function(t,e){if("function"==typeof n&&(e=n.call(this,t,e)),!U(e))return e}),r[1]=e,I.apply(L,r)}}),R.prototype[C]||n(3)(R.prototype,C,R.prototype.valueOf),l(R,"Symbol"),l(Math,"Math",!0),l(r.JSON,"JSON",!0)},function(t,e,n){var r=n(14)("meta"),o=n(5),i=n(6),u=n(4).f,s=0,f=Object.isExtensible||function(){return!0},a=!n(9)(function(){return f(Object.preventExtensions({}))}),c=function(t){u(t,r,{value:{i:"O"+ ++s,w:{}}})},l=t.exports={KEY:r,NEED:!1,fastKey:function(t,e){if(!o(t))return"symbol"==typeof t?t:("string"==typeof t?"S":"P")+t;if(!i(t,r)){if(!f(t))return"F";if(!e)return"E";c(t)}return t[r].i},getWeak:function(t,e){if(!i(t,r)){if(!f(t))return!0;if(!e)return!1;c(t)}return t[r].w},onFreeze:function(t){return a&&l.NEED&&f(t)&&!i(t,r)&&c(t),t}}},function(t,e,n){var r=n(10),o=n(32),i=n(21);t.exports=function(t){var e=r(t),n=o.f;if(n)for(var u,s=n(t),f=i.f,a=0;s.length>a;)f.call(t,u=s[a++])&&e.push(u);return e}},function(t,e,n){var r=n(11),o=n(43).f,i={}.toString,u="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[];t.exports.f=function(t){return u&&"[object Window]"==i.call(t)?function(t){try{return o(t)}catch(t){return u.slice()}}(t):o(r(t))}},function(t,e,n){var r=n(21),o=n(13),i=n(11),u=n(23),s=n(6),f=n(34),a=Object.getOwnPropertyDescriptor;e.f=n(8)?a:function(t,e){if(t=i(t),e=u(e,!0),f)try{return a(t,e)}catch(t){}if(s(t,e))return o(!r.f.call(t,e),t[e])}},function(t,e,n){for(var r=n(39),o=n(10),i=n(19),u=n(1),s=n(3),f=n(15),a=n(0),c=a("iterator"),l=a("toStringTag"),p=f.Array,v={CSSRuleList:!0,CSSStyleDeclaration:!1,CSSValueList:!1,ClientRectList:!1,DOMRectList:!1,DOMStringList:!1,DOMTokenList:!0,DataTransferItemList:!1,FileList:!1,HTMLAllCollection:!1,HTMLCollection:!1,HTMLFormElement:!1,HTMLSelectElement:!1,MediaList:!0,MimeTypeArray:!1,NamedNodeMap:!1,NodeList:!0,PaintRequestList:!1,Plugin:!1,PluginArray:!1,SVGLengthList:!1,SVGNumberList:!1,SVGPathSegList:!1,SVGPointList:!1,SVGStringList:!1,SVGTransformList:!1,SourceBufferList:!1,StyleSheetList:!0,TextTrackCueList:!1,TextTrackList:!1,TouchList:!1},h=o(v),y=0;y<h.length;y++){var d,m=h[y],g=v[m],b=u[m],S=b&&b.prototype;if(S&&(S[c]||s(S,c,p),S[l]||s(S,l,m),f[m]=p,g))for(d in r)S[d]||i(S,d,r[d],!0)}}]).default});

/***/ }),

/***/ 1468:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export assert */
/* unused harmony export autoResetRef */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bypassFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clamp; });
/* unused harmony export computedEager */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return computedWithControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return containsProp; });
/* unused harmony export controlledComputed */
/* unused harmony export controlledRef */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createEventHook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return createFilterWrapper; });
/* unused harmony export createGlobalState */
/* unused harmony export createInjectionState */
/* unused harmony export createReactiveFn */
/* unused harmony export createSharedComposable */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return createSingletonPromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return debounceFilter; });
/* unused harmony export debouncedRef */
/* unused harmony export debouncedWatch */
/* unused harmony export directiveHooks */
/* unused harmony export eagerComputed */
/* unused harmony export extendRef */
/* unused harmony export formatDate */
/* unused harmony export get */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return hasOwn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return identity; });
/* unused harmony export ignorableWatch */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return increaseWithUnit; });
/* unused harmony export invoke */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return isClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isDef; });
/* unused harmony export isDefined */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return isIOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return isObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return makeDestructurable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return noop; });
/* unused harmony export normalizeDate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return notNullish; });
/* unused harmony export now */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return objectEntries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return objectOmit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return objectPick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return pausableFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return watchPausable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return promiseTimeout; });
/* unused harmony export rand */
/* unused harmony export reactify */
/* unused harmony export reactifyObject */
/* unused harmony export reactiveComputed */
/* unused harmony export reactiveOmit */
/* unused harmony export reactivePick */
/* unused harmony export refAutoReset */
/* unused harmony export refDebounced */
/* unused harmony export refDefault */
/* unused harmony export refThrottled */
/* unused harmony export refWithControl */
/* unused harmony export resolveRef */
/* unused harmony export resolveUnref */
/* unused harmony export set */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return syncRef; });
/* unused harmony export syncRefs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return throttleFilter; });
/* unused harmony export throttledRef */
/* unused harmony export throttledWatch */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return timestamp; });
/* unused harmony export toReactive */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return toRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return toRefs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return toValue; });
/* unused harmony export tryOnBeforeMount */
/* unused harmony export tryOnBeforeUnmount */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return tryOnMounted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return tryOnScopeDispose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return tryOnUnmounted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return until; });
/* unused harmony export useArrayDifference */
/* unused harmony export useArrayEvery */
/* unused harmony export useArrayFilter */
/* unused harmony export useArrayFind */
/* unused harmony export useArrayFindIndex */
/* unused harmony export useArrayFindLast */
/* unused harmony export useArrayIncludes */
/* unused harmony export useArrayJoin */
/* unused harmony export useArrayMap */
/* unused harmony export useArrayReduce */
/* unused harmony export useArraySome */
/* unused harmony export useArrayUnique */
/* unused harmony export useCounter */
/* unused harmony export useDateFormat */
/* unused harmony export useDebounce */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return useDebounceFn; });
/* unused harmony export useInterval */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return useIntervalFn; });
/* unused harmony export useLastChanged */
/* unused harmony export useThrottle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return useThrottleFn; });
/* unused harmony export useTimeout */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return useTimeoutFn; });
/* unused harmony export useToNumber */
/* unused harmony export useToString */
/* unused harmony export useToggle */
/* unused harmony export watchArray */
/* unused harmony export watchAtMost */
/* unused harmony export watchDebounced */
/* unused harmony export watchDeep */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return watchIgnorable; });
/* unused harmony export watchImmediate */
/* unused harmony export watchOnce */
/* unused harmony export watchPausable */
/* unused harmony export watchThrottled */
/* unused harmony export watchTriggerable */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return watchWithFilter; });
/* unused harmony export whenever */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_demi__ = __webpack_require__(498);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

var __defProp$b = Object.defineProperty;
var __defProps$8 = Object.defineProperties;
var __getOwnPropDescs$8 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$d = Object.getOwnPropertySymbols;
var __hasOwnProp$d = Object.prototype.hasOwnProperty;
var __propIsEnum$d = Object.prototype.propertyIsEnumerable;
var __defNormalProp$b = function __defNormalProp$b(obj, key, value) {
  return key in obj ? __defProp$b(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$b = function __spreadValues$b(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$d.call(b, prop)) __defNormalProp$b(a, prop, b[prop]);
  if (__getOwnPropSymbols$d) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols$d(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum$d.call(b, prop)) __defNormalProp$b(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps$8 = function __spreadProps$8(a, b) {
  return __defProps$8(a, __getOwnPropDescs$8(b));
};
function computedEager(fn, options) {
  var _a;
  var result = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["shallowRef"])();
  Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["watchEffect"])(function () {
    result.value = fn();
  }, __spreadProps$8(__spreadValues$b({}, options), {
    flush: (_a = options == null ? void 0 : options.flush) != null ? _a : "sync"
  }));
  return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["readonly"])(result);
}
function computedWithControl(source, fn) {
  var v = void 0;
  var track;
  var trigger;
  var dirty = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["ref"])(true);
  var update = function update() {
    dirty.value = true;
    trigger();
  };
  Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["watch"])(source, update, {
    flush: "sync"
  });
  var _get = typeof fn === "function" ? fn : fn.get;
  var _set = typeof fn === "function" ? void 0 : fn.set;
  var result = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["customRef"])(function (_track, _trigger) {
    track = _track;
    trigger = _trigger;
    return {
      get: function get() {
        if (dirty.value) {
          v = _get();
          dirty.value = false;
        }
        track();
        return v;
      },
      set: function set(v2) {
        _set == null ? void 0 : _set(v2);
      }
    };
  });
  if (Object.isExtensible(result)) result.trigger = update;
  return result;
}
function tryOnScopeDispose(fn) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["getCurrentScope"])()) {
    Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["onScopeDispose"])(fn);
    return true;
  }
  return false;
}
function createEventHook() {
  var fns = /* @__PURE__ */new Set();
  var off = function off(fn) {
    fns.delete(fn);
  };
  var on = function on(fn) {
    fns.add(fn);
    var offFn = function offFn() {
      return off(fn);
    };
    tryOnScopeDispose(offFn);
    return {
      off: offFn
    };
  };
  var trigger = function trigger(param) {
    return Promise.all(Array.from(fns).map(function (fn) {
      return fn(param);
    }));
  };
  return {
    on: on,
    off: off,
    trigger: trigger
  };
}
function createGlobalState(stateFactory) {
  var initialized = false;
  var state;
  var scope = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["effectScope"])(true);
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (!initialized) {
      state = scope.run(function () {
        return stateFactory.apply(void 0, args);
      });
      initialized = true;
    }
    return state;
  };
}
function createInjectionState(composable) {
  var key = Symbol("InjectionState");
  var useProvidingState = function useProvidingState() {
    var state = composable.apply(void 0, arguments);
    Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["provide"])(key, state);
    return state;
  };
  var useInjectedState = function useInjectedState() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["inject"])(key);
  };
  return [useProvidingState, useInjectedState];
}
function createSharedComposable(composable) {
  var subscribers = 0;
  var state;
  var scope;
  var dispose = function dispose() {
    subscribers -= 1;
    if (scope && subscribers <= 0) {
      scope.stop();
      state = void 0;
      scope = void 0;
    }
  };
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    subscribers += 1;
    if (!state) {
      scope = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["effectScope"])(true);
      state = scope.run(function () {
        return composable.apply(void 0, args);
      });
    }
    tryOnScopeDispose(dispose);
    return state;
  };
}
function extendRef(ref, extend) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$enumerable = _ref.enumerable,
    enumerable = _ref$enumerable === void 0 ? false : _ref$enumerable,
    _ref$unwrap = _ref.unwrap,
    unwrap = _ref$unwrap === void 0 ? true : _ref$unwrap;
  if (!__WEBPACK_IMPORTED_MODULE_0_vue_demi__["isVue3"] && !__WEBPACK_IMPORTED_MODULE_0_vue_demi__["version"].startsWith("2.7.")) {
    if (false) throw new Error("[VueUse] extendRef only works in Vue 2.7 or above.");
    return;
  }
  var _loop = function _loop() {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    if (key === "value") return "continue";
    if (Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["isRef"])(value) && unwrap) {
      Object.defineProperty(ref, key, {
        get: function get() {
          return value.value;
        },
        set: function set(v) {
          value.value = v;
        },
        enumerable: enumerable
      });
    } else {
      Object.defineProperty(ref, key, {
        value: value,
        enumerable: enumerable
      });
    }
  };
  for (var _i = 0, _Object$entries = Object.entries(extend); _i < _Object$entries.length; _i++) {
    var _ret = _loop();
    if (_ret === "continue") continue;
  }
  return ref;
}
function get(obj, key) {
  if (key == null) return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["unref"])(obj);
  return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["unref"])(obj)[key];
}
function isDefined(v) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["unref"])(v) != null;
}
var __defProp$a = Object.defineProperty;
var __getOwnPropSymbols$c = Object.getOwnPropertySymbols;
var __hasOwnProp$c = Object.prototype.hasOwnProperty;
var __propIsEnum$c = Object.prototype.propertyIsEnumerable;
var __defNormalProp$a = function __defNormalProp$a(obj, key, value) {
  return key in obj ? __defProp$a(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$a = function __spreadValues$a(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$c.call(b, prop)) __defNormalProp$a(a, prop, b[prop]);
  if (__getOwnPropSymbols$c) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols$c(b)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (__propIsEnum$c.call(b, prop)) __defNormalProp$a(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return a;
};
function makeDestructurable(obj, arr) {
  if (typeof Symbol !== "undefined") {
    var clone = __spreadValues$a({}, obj);
    Object.defineProperty(clone, Symbol.iterator, {
      enumerable: false,
      value: function value() {
        var index = 0;
        return {
          next: function next() {
            return {
              value: arr[index++],
              done: index > arr.length
            };
          }
        };
      }
    });
    return clone;
  } else {
    return Object.assign(_toConsumableArray(arr), obj);
  }
}
function toValue(r) {
  return typeof r === "function" ? r() : Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["unref"])(r);
}
var resolveUnref = toValue;
function reactify(fn, options) {
  var unrefFn = (options == null ? void 0 : options.computedGetter) === false ? __WEBPACK_IMPORTED_MODULE_0_vue_demi__["unref"] : toValue;
  return function () {
    var _this = this;
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["computed"])(function () {
      return fn.apply(_this, args.map(function (i) {
        return unrefFn(i);
      }));
    });
  };
}
function reactifyObject(obj) {
  var optionsOrKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var keys = [];
  var options;
  if (Array.isArray(optionsOrKeys)) {
    keys = optionsOrKeys;
  } else {
    var _keys, _keys2;
    options = optionsOrKeys;
    var _optionsOrKeys$includ = optionsOrKeys.includeOwnProperties,
      includeOwnProperties = _optionsOrKeys$includ === void 0 ? true : _optionsOrKeys$includ;
    (_keys = keys).push.apply(_keys, _toConsumableArray(Object.keys(obj)));
    if (includeOwnProperties) (_keys2 = keys).push.apply(_keys2, _toConsumableArray(Object.getOwnPropertyNames(obj)));
  }
  return Object.fromEntries(keys.map(function (key) {
    var value = obj[key];
    return [key, typeof value === "function" ? reactify(value.bind(obj), options) : value];
  }));
}
function toReactive(objectRef) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["isRef"])(objectRef)) return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["reactive"])(objectRef);
  var proxy = new Proxy({}, {
    get: function get(_, p, receiver) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["unref"])(Reflect.get(objectRef.value, p, receiver));
    },
    set: function set(_, p, value) {
      if (Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["isRef"])(objectRef.value[p]) && !Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["isRef"])(value)) objectRef.value[p].value = value;else objectRef.value[p] = value;
      return true;
    },
    deleteProperty: function deleteProperty(_, p) {
      return Reflect.deleteProperty(objectRef.value, p);
    },
    has: function has(_, p) {
      return Reflect.has(objectRef.value, p);
    },
    ownKeys: function ownKeys() {
      return Object.keys(objectRef.value);
    },
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor() {
      return {
        enumerable: true,
        configurable: true
      };
    }
  });
  return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["reactive"])(proxy);
}
function reactiveComputed(fn) {
  return toReactive(Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["computed"])(fn));
}
function reactiveOmit(obj) {
  for (var _len4 = arguments.length, keys = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    keys[_key4 - 1] = arguments[_key4];
  }
  var flatKeys = keys.flat();
  var predicate = flatKeys[0];
  return reactiveComputed(function () {
    return typeof predicate === "function" ? Object.fromEntries(Object.entries(Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["toRefs"])(obj)).filter(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        k = _ref3[0],
        v = _ref3[1];
      return !predicate(toValue(v), k);
    })) : Object.fromEntries(Object.entries(Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["toRefs"])(obj)).filter(function (e) {
      return !flatKeys.includes(e[0]);
    }));
  });
}
var isClient = typeof window !== "undefined";
var isDef = function isDef(val) {
  return typeof val !== "undefined";
};
var notNullish = function notNullish(val) {
  return val != null;
};
var assert = function assert(condition) {
  var _console;
  for (var _len5 = arguments.length, infos = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    infos[_key5 - 1] = arguments[_key5];
  }
  if (!condition) (_console = console).warn.apply(_console, infos);
};
var toString = Object.prototype.toString;
var isObject = function isObject(val) {
  return toString.call(val) === "[object Object]";
};
var now = function now() {
  return Date.now();
};
var timestamp = function timestamp() {
  return +Date.now();
};
var clamp = function clamp(n, min, max) {
  return Math.min(max, Math.max(min, n));
};
var noop = function noop() {};
var rand = function rand(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};
var hasOwn = function hasOwn(val, key) {
  return Object.prototype.hasOwnProperty.call(val, key);
};
var isIOS = /* @__PURE__ */getIsIOS();
function getIsIOS() {
  var _a;
  return isClient && ((_a = window == null ? void 0 : window.navigator) == null ? void 0 : _a.userAgent) && /* @__PURE__ */ /iP(ad|hone|od)/.test(window.navigator.userAgent);
}
function createFilterWrapper(filter, fn) {
  function wrapper() {
    var _this2 = this;
    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }
    return new Promise(function (resolve, reject) {
      Promise.resolve(filter(function () {
        return fn.apply(_this2, args);
      }, {
        fn: fn,
        thisArg: _this2,
        args: args
      })).then(resolve).catch(reject);
    });
  }
  return wrapper;
}
var bypassFilter = function bypassFilter(invoke) {
  return invoke();
};
function debounceFilter(ms) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var timer;
  var maxTimer;
  var lastRejector = noop;
  var _clearTimeout = function _clearTimeout(timer2) {
    clearTimeout(timer2);
    lastRejector();
    lastRejector = noop;
  };
  var filter = function filter(invoke) {
    var duration = toValue(ms);
    var maxDuration = toValue(options.maxWait);
    if (timer) _clearTimeout(timer);
    if (duration <= 0 || maxDuration !== void 0 && maxDuration <= 0) {
      if (maxTimer) {
        _clearTimeout(maxTimer);
        maxTimer = null;
      }
      return Promise.resolve(invoke());
    }
    return new Promise(function (resolve, reject) {
      lastRejector = options.rejectOnCancel ? reject : resolve;
      if (maxDuration && !maxTimer) {
        maxTimer = setTimeout(function () {
          if (timer) _clearTimeout(timer);
          maxTimer = null;
          resolve(invoke());
        }, maxDuration);
      }
      timer = setTimeout(function () {
        if (maxTimer) _clearTimeout(maxTimer);
        maxTimer = null;
        resolve(invoke());
      }, duration);
    });
  };
  return filter;
}
function throttleFilter(ms) {
  var trailing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var leading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var rejectOnCancel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var lastExec = 0;
  var timer;
  var isLeading = true;
  var lastRejector = noop;
  var lastValue;
  var clear = function clear() {
    if (timer) {
      clearTimeout(timer);
      timer = void 0;
      lastRejector();
      lastRejector = noop;
    }
  };
  var filter = function filter(_invoke) {
    var duration = toValue(ms);
    var elapsed = Date.now() - lastExec;
    var invoke = function invoke() {
      return lastValue = _invoke();
    };
    clear();
    if (duration <= 0) {
      lastExec = Date.now();
      return invoke();
    }
    if (elapsed > duration && (leading || !isLeading)) {
      lastExec = Date.now();
      invoke();
    } else if (trailing) {
      lastValue = new Promise(function (resolve, reject) {
        lastRejector = rejectOnCancel ? reject : resolve;
        timer = setTimeout(function () {
          lastExec = Date.now();
          isLeading = true;
          resolve(invoke());
          clear();
        }, Math.max(0, duration - elapsed));
      });
    }
    if (!leading && !timer) timer = setTimeout(function () {
      return isLeading = true;
    }, duration);
    isLeading = false;
    return lastValue;
  };
  return filter;
}
function pausableFilter() {
  var extendFilter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : bypassFilter;
  var isActive = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["ref"])(true);
  function pause() {
    isActive.value = false;
  }
  function resume() {
    isActive.value = true;
  }
  var eventFilter = function eventFilter() {
    if (isActive.value) extendFilter.apply(void 0, arguments);
  };
  return {
    isActive: Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["readonly"])(isActive),
    pause: pause,
    resume: resume,
    eventFilter: eventFilter
  };
}
var directiveHooks = {
  mounted: __WEBPACK_IMPORTED_MODULE_0_vue_demi__["isVue3"] ? "mounted" : "inserted",
  updated: __WEBPACK_IMPORTED_MODULE_0_vue_demi__["isVue3"] ? "updated" : "componentUpdated",
  unmounted: __WEBPACK_IMPORTED_MODULE_0_vue_demi__["isVue3"] ? "unmounted" : "unbind"
};
function promiseTimeout(ms) {
  var throwOnTimeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "Timeout";
  return new Promise(function (resolve, reject) {
    if (throwOnTimeout) setTimeout(function () {
      return reject(reason);
    }, ms);else setTimeout(resolve, ms);
  });
}
function identity(arg) {
  return arg;
}
function createSingletonPromise(fn) {
  var _promise;
  function wrapper() {
    if (!_promise) _promise = fn();
    return _promise;
  }
  wrapper.reset = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _prev;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _prev = _promise;
          _promise = void 0;
          if (!_prev) {
            _context.next = 5;
            break;
          }
          _context.next = 5;
          return _prev;
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return wrapper;
}
function invoke(fn) {
  return fn();
}
function containsProp(obj) {
  for (var _len7 = arguments.length, props = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    props[_key7 - 1] = arguments[_key7];
  }
  return props.some(function (k) {
    return k in obj;
  });
}
function increaseWithUnit(target, delta) {
  var _a;
  if (typeof target === "number") return target + delta;
  var value = ((_a = target.match(/^-?[0-9]+\.?[0-9]*/)) == null ? void 0 : _a[0]) || "";
  var unit = target.slice(value.length);
  var result = parseFloat(value) + delta;
  if (Number.isNaN(result)) return target;
  return result + unit;
}
function objectPick(obj, keys) {
  var omitUndefined = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return keys.reduce(function (n, k) {
    if (k in obj) {
      if (!omitUndefined || obj[k] !== void 0) n[k] = obj[k];
    }
    return n;
  }, {});
}
function objectOmit(obj, keys) {
  var omitUndefined = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return Object.fromEntries(Object.entries(obj).filter(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
      key = _ref6[0],
      value = _ref6[1];
    return (!omitUndefined || value !== void 0) && !keys.includes(key);
  }));
}
function objectEntries(obj) {
  return Object.entries(obj);
}
function toRef() {
  if (arguments.length !== 1) return __WEBPACK_IMPORTED_MODULE_0_vue_demi__["toRef"].apply(void 0, arguments);
  var r = arguments.length <= 0 ? undefined : arguments[0];
  return typeof r === "function" ? Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["readonly"])(Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["customRef"])(function () {
    return {
      get: r,
      set: noop
    };
  })) : Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["ref"])(r);
}
var resolveRef = toRef;
function reactivePick(obj) {
  for (var _len8 = arguments.length, keys = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
    keys[_key8 - 1] = arguments[_key8];
  }
  var flatKeys = keys.flat();
  var predicate = flatKeys[0];
  return reactiveComputed(function () {
    return typeof predicate === "function" ? Object.fromEntries(Object.entries(Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["toRefs"])(obj)).filter(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 2),
        k = _ref8[0],
        v = _ref8[1];
      return predicate(toValue(v), k);
    })) : Object.fromEntries(flatKeys.map(function (k) {
      return [k, toRef(obj, k)];
    }));
  });
}
function refAutoReset(defaultValue) {
  var afterMs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1e4;
  return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["customRef"])(function (track, trigger) {
    var value = defaultValue;
    var timer;
    var resetAfter = function resetAfter() {
      return setTimeout(function () {
        value = defaultValue;
        trigger();
      }, toValue(afterMs));
    };
    tryOnScopeDispose(function () {
      clearTimeout(timer);
    });
    return {
      get: function get() {
        track();
        return value;
      },
      set: function set(newValue) {
        value = newValue;
        trigger();
        clearTimeout(timer);
        timer = resetAfter();
      }
    };
  });
}
function useDebounceFn(fn) {
  var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return createFilterWrapper(debounceFilter(ms, options), fn);
}
function refDebounced(value) {
  var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var debounced = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["ref"])(value.value);
  var updater = useDebounceFn(function () {
    debounced.value = value.value;
  }, ms, options);
  Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["watch"])(value, function () {
    return updater();
  });
  return debounced;
}
function refDefault(source, defaultValue) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["computed"])({
    get: function get() {
      var _a;
      return (_a = source.value) != null ? _a : defaultValue;
    },
    set: function set(value) {
      source.value = value;
    }
  });
}
function useThrottleFn(fn) {
  var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  var trailing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var leading = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var rejectOnCancel = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  return createFilterWrapper(throttleFilter(ms, trailing, leading, rejectOnCancel), fn);
}
function refThrottled(value) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  var trailing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var leading = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  if (delay <= 0) return value;
  var throttled = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["ref"])(value.value);
  var updater = useThrottleFn(function () {
    throttled.value = value.value;
  }, delay, trailing, leading);
  Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["watch"])(value, function () {
    return updater();
  });
  return throttled;
}
function refWithControl(initial) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var source = initial;
  var track;
  var trigger;
  var ref = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["customRef"])(function (_track, _trigger) {
    track = _track;
    trigger = _trigger;
    return {
      get: function get() {
        return _get2();
      },
      set: function set(v) {
        _set2(v);
      }
    };
  });
  function _get2() {
    var tracking = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    if (tracking) track();
    return source;
  }
  function _set2(value) {
    var triggering = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var _a, _b;
    if (value === source) return;
    var old = source;
    if (((_a = options.onBeforeChange) == null ? void 0 : _a.call(options, value, old)) === false) return;
    source = value;
    (_b = options.onChanged) == null ? void 0 : _b.call(options, value, old);
    if (triggering) trigger();
  }
  var untrackedGet = function untrackedGet() {
    return _get2(false);
  };
  var silentSet = function silentSet(v) {
    return _set2(v, false);
  };
  var peek = function peek() {
    return _get2(false);
  };
  var lay = function lay(v) {
    return _set2(v, false);
  };
  return extendRef(ref, {
    get: _get2,
    set: _set2,
    untrackedGet: untrackedGet,
    silentSet: silentSet,
    peek: peek,
    lay: lay
  }, {
    enumerable: true
  });
}
var controlledRef = refWithControl;
function set() {
  for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
    args[_key9] = arguments[_key9];
  }
  if (args.length === 2) {
    var _ref9 = args[0],
      value = args[1];
    _ref9.value = value;
  }
  if (args.length === 3) {
    if (__WEBPACK_IMPORTED_MODULE_0_vue_demi__["isVue2"]) {
      __WEBPACK_IMPORTED_MODULE_0_vue_demi__["set"].apply(void 0, args);
    } else {
      var target = args[0],
        key = args[1],
        _value2 = args[2];
      target[key] = _value2;
    }
  }
}
function syncRef(left, right) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _a, _b;
  var _options$flush = options.flush,
    flush = _options$flush === void 0 ? "sync" : _options$flush,
    _options$deep = options.deep,
    deep = _options$deep === void 0 ? false : _options$deep,
    _options$immediate = options.immediate,
    immediate = _options$immediate === void 0 ? true : _options$immediate,
    _options$direction = options.direction,
    direction = _options$direction === void 0 ? "both" : _options$direction,
    _options$transform = options.transform,
    transform = _options$transform === void 0 ? {} : _options$transform;
  var watchLeft;
  var watchRight;
  var transformLTR = (_a = transform.ltr) != null ? _a : function (v) {
    return v;
  };
  var transformRTL = (_b = transform.rtl) != null ? _b : function (v) {
    return v;
  };
  if (direction === "both" || direction === "ltr") {
    watchLeft = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["watch"])(left, function (newValue) {
      return right.value = transformLTR(newValue);
    }, {
      flush: flush,
      deep: deep,
      immediate: immediate
    });
  }
  if (direction === "both" || direction === "rtl") {
    watchRight = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["watch"])(right, function (newValue) {
      return left.value = transformRTL(newValue);
    }, {
      flush: flush,
      deep: deep,
      immediate: immediate
    });
  }
  return function () {
    watchLeft == null ? void 0 : watchLeft();
    watchRight == null ? void 0 : watchRight();
  };
}
function syncRefs(source, targets) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$flush2 = options.flush,
    flush = _options$flush2 === void 0 ? "sync" : _options$flush2,
    _options$deep2 = options.deep,
    deep = _options$deep2 === void 0 ? false : _options$deep2,
    _options$immediate2 = options.immediate,
    immediate = _options$immediate2 === void 0 ? true : _options$immediate2;
  if (!Array.isArray(targets)) targets = [targets];
  return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["watch"])(source, function (newValue) {
    return targets.forEach(function (target) {
      return target.value = newValue;
    });
  }, {
    flush: flush,
    deep: deep,
    immediate: immediate
  });
}
var __defProp$9 = Object.defineProperty;
var __defProps$7 = Object.defineProperties;
var __getOwnPropDescs$7 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$b = Object.getOwnPropertySymbols;
var __hasOwnProp$b = Object.prototype.hasOwnProperty;
var __propIsEnum$b = Object.prototype.propertyIsEnumerable;
var __defNormalProp$9 = function __defNormalProp$9(obj, key, value) {
  return key in obj ? __defProp$9(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$9 = function __spreadValues$9(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$b.call(b, prop)) __defNormalProp$9(a, prop, b[prop]);
  if (__getOwnPropSymbols$b) {
    var _iterator3 = _createForOfIteratorHelper(__getOwnPropSymbols$b(b)),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var prop = _step3.value;
        if (__propIsEnum$b.call(b, prop)) __defNormalProp$9(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }
  return a;
};
var __spreadProps$7 = function __spreadProps$7(a, b) {
  return __defProps$7(a, __getOwnPropDescs$7(b));
};
function toRefs(objectRef) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["isRef"])(objectRef)) return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["toRefs"])(objectRef);
  var result = Array.isArray(objectRef.value) ? new Array(objectRef.value.length) : {};
  var _loop2 = function _loop2(key) {
    result[key] = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["customRef"])(function () {
      return {
        get: function get() {
          return objectRef.value[key];
        },
        set: function set(v) {
          if (Array.isArray(objectRef.value)) {
            var copy = _toConsumableArray(objectRef.value);
            copy[key] = v;
            objectRef.value = copy;
          } else {
            var newObject = __spreadProps$7(__spreadValues$9({}, objectRef.value), _defineProperty({}, key, v));
            Object.setPrototypeOf(newObject, objectRef.value);
            objectRef.value = newObject;
          }
        }
      };
    });
  };
  for (var key in objectRef.value) {
    _loop2(key);
  }
  return result;
}
function tryOnBeforeMount(fn) {
  var sync = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["getCurrentInstance"])()) Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["onBeforeMount"])(fn);else if (sync) fn();else Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["nextTick"])(fn);
}
function tryOnBeforeUnmount(fn) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["getCurrentInstance"])()) Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["onBeforeUnmount"])(fn);
}
function tryOnMounted(fn) {
  var sync = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["getCurrentInstance"])()) Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["onMounted"])(fn);else if (sync) fn();else Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["nextTick"])(fn);
}
function tryOnUnmounted(fn) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["getCurrentInstance"])()) Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["onUnmounted"])(fn);
}
function createUntil(r) {
  var isNot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  function toMatch(condition) {
    var _ref10 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref10$flush = _ref10.flush,
      flush = _ref10$flush === void 0 ? "sync" : _ref10$flush,
      _ref10$deep = _ref10.deep,
      deep = _ref10$deep === void 0 ? false : _ref10$deep,
      timeout = _ref10.timeout,
      throwOnTimeout = _ref10.throwOnTimeout;
    var stop = null;
    var watcher = new Promise(function (resolve) {
      stop = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["watch"])(r, function (v) {
        if (condition(v) !== isNot) {
          stop == null ? void 0 : stop();
          resolve(v);
        }
      }, {
        flush: flush,
        deep: deep,
        immediate: true
      });
    });
    var promises = [watcher];
    if (timeout != null) {
      promises.push(promiseTimeout(timeout, throwOnTimeout).then(function () {
        return toValue(r);
      }).finally(function () {
        return stop == null ? void 0 : stop();
      }));
    }
    return Promise.race(promises);
  }
  function toBe(value, options) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["isRef"])(value)) return toMatch(function (v) {
      return v === value;
    }, options);
    var _ref11 = options != null ? options : {},
      _ref11$flush = _ref11.flush,
      flush = _ref11$flush === void 0 ? "sync" : _ref11$flush,
      _ref11$deep = _ref11.deep,
      deep = _ref11$deep === void 0 ? false : _ref11$deep,
      timeout = _ref11.timeout,
      throwOnTimeout = _ref11.throwOnTimeout;
    var stop = null;
    var watcher = new Promise(function (resolve) {
      stop = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["watch"])([r, value], function (_ref12) {
        var _ref13 = _slicedToArray(_ref12, 2),
          v1 = _ref13[0],
          v2 = _ref13[1];
        if (isNot !== (v1 === v2)) {
          stop == null ? void 0 : stop();
          resolve(v1);
        }
      }, {
        flush: flush,
        deep: deep,
        immediate: true
      });
    });
    var promises = [watcher];
    if (timeout != null) {
      promises.push(promiseTimeout(timeout, throwOnTimeout).then(function () {
        return toValue(r);
      }).finally(function () {
        stop == null ? void 0 : stop();
        return toValue(r);
      }));
    }
    return Promise.race(promises);
  }
  function toBeTruthy(options) {
    return toMatch(function (v) {
      return Boolean(v);
    }, options);
  }
  function toBeNull(options) {
    return toBe(null, options);
  }
  function toBeUndefined(options) {
    return toBe(void 0, options);
  }
  function toBeNaN(options) {
    return toMatch(Number.isNaN, options);
  }
  function toContains(value, options) {
    return toMatch(function (v) {
      var array = Array.from(v);
      return array.includes(value) || array.includes(toValue(value));
    }, options);
  }
  function changed(options) {
    return changedTimes(1, options);
  }
  function changedTimes() {
    var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var options = arguments.length > 1 ? arguments[1] : undefined;
    var count = -1;
    return toMatch(function () {
      count += 1;
      return count >= n;
    }, options);
  }
  if (Array.isArray(toValue(r))) {
    var instance = {
      toMatch: toMatch,
      toContains: toContains,
      changed: changed,
      changedTimes: changedTimes,
      get not() {
        return createUntil(r, !isNot);
      }
    };
    return instance;
  } else {
    var _instance = {
      toMatch: toMatch,
      toBe: toBe,
      toBeTruthy: toBeTruthy,
      toBeNull: toBeNull,
      toBeNaN: toBeNaN,
      toBeUndefined: toBeUndefined,
      changed: changed,
      changedTimes: changedTimes,
      get not() {
        return createUntil(r, !isNot);
      }
    };
    return _instance;
  }
}
function until(r) {
  return createUntil(r);
}
function defaultComparator(value, othVal) {
  return value === othVal;
}
function useArrayDifference() {
  var _a;
  var list = arguments.length <= 0 ? undefined : arguments[0];
  var values = arguments.length <= 1 ? undefined : arguments[1];
  var compareFn = (_a = arguments.length <= 2 ? undefined : arguments[2]) != null ? _a : defaultComparator;
  if (typeof compareFn === "string") {
    var key = compareFn;
    compareFn = function compareFn(value, othVal) {
      return value[key] === othVal[key];
    };
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["computed"])(function () {
    return toValue(list).filter(function (x) {
      return toValue(values).findIndex(function (y) {
        return compareFn(x, y);
      }) === -1;
    });
  });
}
function useArrayEvery(list, fn) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["computed"])(function () {
    return toValue(list).every(function (element, index, array) {
      return fn(toValue(element), index, array);
    });
  });
}
function useArrayFilter(list, fn) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["computed"])(function () {
    return toValue(list).map(function (i) {
      return toValue(i);
    }).filter(fn);
  });
}
function useArrayFind(list, fn) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["computed"])(function () {
    return toValue(toValue(list).find(function (element, index, array) {
      return fn(toValue(element), index, array);
    }));
  });
}
function useArrayFindIndex(list, fn) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["computed"])(function () {
    return toValue(list).findIndex(function (element, index, array) {
      return fn(toValue(element), index, array);
    });
  });
}
function findLast(arr, cb) {
  var index = arr.length;
  while (index-- > 0) {
    if (cb(arr[index], index, arr)) return arr[index];
  }
  return void 0;
}
function useArrayFindLast(list, fn) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["computed"])(function () {
    return toValue(!Array.prototype.findLast ? findLast(toValue(list), function (element, index, array) {
      return fn(toValue(element), index, array);
    }) : toValue(list).findLast(function (element, index, array) {
      return fn(toValue(element), index, array);
    }));
  });
}
function isArrayIncludesOptions(obj) {
  return isObject(obj) && containsProp(obj, "formIndex", "comparator");
}
function useArrayIncludes() {
  var _a;
  var list = arguments.length <= 0 ? undefined : arguments[0];
  var value = arguments.length <= 1 ? undefined : arguments[1];
  var comparator = arguments.length <= 2 ? undefined : arguments[2];
  var formIndex = 0;
  if (isArrayIncludesOptions(comparator)) {
    formIndex = (_a = comparator.fromIndex) != null ? _a : 0;
    comparator = comparator.comparator;
  }
  if (typeof comparator === "string") {
    var key = comparator;
    comparator = function comparator(element, value2) {
      return element[key] === toValue(value2);
    };
  }
  comparator = comparator != null ? comparator : function (element, value2) {
    return element === toValue(value2);
  };
  return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["computed"])(function () {
    return toValue(list).slice(formIndex).some(function (element, index, array) {
      return comparator(toValue(element), toValue(value), index, toValue(array));
    });
  });
}
function useArrayJoin(list, separator) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["computed"])(function () {
    return toValue(list).map(function (i) {
      return toValue(i);
    }).join(toValue(separator));
  });
}
function useArrayMap(list, fn) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["computed"])(function () {
    return toValue(list).map(function (i) {
      return toValue(i);
    }).map(fn);
  });
}
function useArrayReduce(list, reducer) {
  for (var _len10 = arguments.length, args = new Array(_len10 > 2 ? _len10 - 2 : 0), _key10 = 2; _key10 < _len10; _key10++) {
    args[_key10 - 2] = arguments[_key10];
  }
  var reduceCallback = function reduceCallback(sum, value, index) {
    return reducer(toValue(sum), toValue(value), index);
  };
  return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["computed"])(function () {
    var resolved = toValue(list);
    return args.length ? resolved.reduce(reduceCallback, toValue(args[0])) : resolved.reduce(reduceCallback);
  });
}
function useArraySome(list, fn) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["computed"])(function () {
    return toValue(list).some(function (element, index, array) {
      return fn(toValue(element), index, array);
    });
  });
}
function uniq(array) {
  return Array.from(new Set(array));
}
function uniqueElementsBy(array, fn) {
  return array.reduce(function (acc, v) {
    if (!acc.some(function (x) {
      return fn(v, x, array);
    })) acc.push(v);
    return acc;
  }, []);
}
function useArrayUnique(list, compareFn) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["computed"])(function () {
    var resolvedList = toValue(list).map(function (element) {
      return toValue(element);
    });
    return compareFn ? uniqueElementsBy(resolvedList, compareFn) : uniq(resolvedList);
  });
}
function useCounter() {
  var initialValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var count = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["ref"])(initialValue);
  var _options$max = options.max,
    max = _options$max === void 0 ? Infinity : _options$max,
    _options$min = options.min,
    min = _options$min === void 0 ? -Infinity : _options$min;
  var inc = function inc() {
    var delta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return count.value = Math.min(max, count.value + delta);
  };
  var dec = function dec() {
    var delta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return count.value = Math.max(min, count.value - delta);
  };
  var get = function get() {
    return count.value;
  };
  var set = function set(val) {
    return count.value = Math.max(min, Math.min(max, val));
  };
  var reset = function reset() {
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialValue;
    initialValue = val;
    return set(val);
  };
  return {
    count: count,
    inc: inc,
    dec: dec,
    get: get,
    set: set,
    reset: reset
  };
}
var REGEX_PARSE = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/;
var REGEX_FORMAT = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a{1,2}|A{1,2}|m{1,2}|s{1,2}|Z{1,2}|SSS/g;
function defaultMeridiem(hours, minutes, isLowercase, hasPeriod) {
  var m = hours < 12 ? "AM" : "PM";
  if (hasPeriod) m = m.split("").reduce(function (acc, curr) {
    return acc += "".concat(curr, ".");
  }, "");
  return isLowercase ? m.toLowerCase() : m;
}
function formatDate(date, formatStr) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _a;
  var years = date.getFullYear();
  var month = date.getMonth();
  var days = date.getDate();
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var seconds = date.getSeconds();
  var milliseconds = date.getMilliseconds();
  var day = date.getDay();
  var meridiem = (_a = options.customMeridiem) != null ? _a : defaultMeridiem;
  var matches = {
    YY: function YY() {
      return String(years).slice(-2);
    },
    YYYY: function YYYY() {
      return years;
    },
    M: function M() {
      return month + 1;
    },
    MM: function MM() {
      return "".concat(month + 1).padStart(2, "0");
    },
    MMM: function MMM() {
      return date.toLocaleDateString(options.locales, {
        month: "short"
      });
    },
    MMMM: function MMMM() {
      return date.toLocaleDateString(options.locales, {
        month: "long"
      });
    },
    D: function D() {
      return String(days);
    },
    DD: function DD() {
      return "".concat(days).padStart(2, "0");
    },
    H: function H() {
      return String(hours);
    },
    HH: function HH() {
      return "".concat(hours).padStart(2, "0");
    },
    h: function h() {
      return "".concat(hours % 12 || 12).padStart(1, "0");
    },
    hh: function hh() {
      return "".concat(hours % 12 || 12).padStart(2, "0");
    },
    m: function m() {
      return String(minutes);
    },
    mm: function mm() {
      return "".concat(minutes).padStart(2, "0");
    },
    s: function s() {
      return String(seconds);
    },
    ss: function ss() {
      return "".concat(seconds).padStart(2, "0");
    },
    SSS: function SSS() {
      return "".concat(milliseconds).padStart(3, "0");
    },
    d: function d() {
      return day;
    },
    dd: function dd() {
      return date.toLocaleDateString(options.locales, {
        weekday: "narrow"
      });
    },
    ddd: function ddd() {
      return date.toLocaleDateString(options.locales, {
        weekday: "short"
      });
    },
    dddd: function dddd() {
      return date.toLocaleDateString(options.locales, {
        weekday: "long"
      });
    },
    A: function A() {
      return meridiem(hours, minutes);
    },
    AA: function AA() {
      return meridiem(hours, minutes, false, true);
    },
    a: function a() {
      return meridiem(hours, minutes, true);
    },
    aa: function aa() {
      return meridiem(hours, minutes, true, true);
    }
  };
  return formatStr.replace(REGEX_FORMAT, function (match, $1) {
    var _a2;
    return $1 || ((_a2 = matches[match]) == null ? void 0 : _a2.call(matches)) || match;
  });
}
function normalizeDate(date) {
  if (date === null) return /* @__PURE__ */new Date(NaN);
  if (date === void 0) return /* @__PURE__ */new Date();
  if (date instanceof Date) return new Date(date);
  if (typeof date === "string" && !/Z$/i.test(date)) {
    var d = date.match(REGEX_PARSE);
    if (d) {
      var m = d[2] - 1 || 0;
      var ms = (d[7] || "0").substring(0, 3);
      return new Date(d[1], m, d[3] || 1, d[4] || 0, d[5] || 0, d[6] || 0, ms);
    }
  }
  return new Date(date);
}
function useDateFormat(date) {
  var formatStr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "HH:mm:ss";
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["computed"])(function () {
    return formatDate(normalizeDate(toValue(date)), toValue(formatStr), options);
  });
}
function useIntervalFn(cb) {
  var interval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1e3;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$immediate3 = options.immediate,
    immediate = _options$immediate3 === void 0 ? true : _options$immediate3,
    _options$immediateCal = options.immediateCallback,
    immediateCallback = _options$immediateCal === void 0 ? false : _options$immediateCal;
  var timer = null;
  var isActive = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["ref"])(false);
  function clean() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }
  function pause() {
    isActive.value = false;
    clean();
  }
  function resume() {
    var intervalValue = toValue(interval);
    if (intervalValue <= 0) return;
    isActive.value = true;
    if (immediateCallback) cb();
    clean();
    timer = setInterval(cb, intervalValue);
  }
  if (immediate && isClient) resume();
  if (Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["isRef"])(interval) || typeof interval === "function") {
    var stopWatch = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["watch"])(interval, function () {
      if (isActive.value && isClient) resume();
    });
    tryOnScopeDispose(stopWatch);
  }
  tryOnScopeDispose(pause);
  return {
    isActive: isActive,
    pause: pause,
    resume: resume
  };
}
var __defProp$8 = Object.defineProperty;
var __getOwnPropSymbols$a = Object.getOwnPropertySymbols;
var __hasOwnProp$a = Object.prototype.hasOwnProperty;
var __propIsEnum$a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$8 = function __defNormalProp$8(obj, key, value) {
  return key in obj ? __defProp$8(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$8 = function __spreadValues$8(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$a.call(b, prop)) __defNormalProp$8(a, prop, b[prop]);
  if (__getOwnPropSymbols$a) {
    var _iterator4 = _createForOfIteratorHelper(__getOwnPropSymbols$a(b)),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var prop = _step4.value;
        if (__propIsEnum$a.call(b, prop)) __defNormalProp$8(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }
  return a;
};
function useInterval() {
  var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1e3;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$controls = options.controls,
    exposeControls = _options$controls === void 0 ? false : _options$controls,
    _options$immediate4 = options.immediate,
    immediate = _options$immediate4 === void 0 ? true : _options$immediate4,
    callback = options.callback;
  var counter = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["ref"])(0);
  var update = function update() {
    return counter.value += 1;
  };
  var reset = function reset() {
    counter.value = 0;
  };
  var controls = useIntervalFn(callback ? function () {
    update();
    callback(counter.value);
  } : update, interval, {
    immediate: immediate
  });
  if (exposeControls) {
    return __spreadValues$8({
      counter: counter,
      reset: reset
    }, controls);
  } else {
    return counter;
  }
}
function useLastChanged(source) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _a;
  var ms = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["ref"])((_a = options.initialValue) != null ? _a : null);
  Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["watch"])(source, function () {
    return ms.value = timestamp();
  }, options);
  return ms;
}
function useTimeoutFn(cb, interval) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$immediate5 = options.immediate,
    immediate = _options$immediate5 === void 0 ? true : _options$immediate5;
  var isPending = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["ref"])(false);
  var timer = null;
  function clear() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }
  function stop() {
    isPending.value = false;
    clear();
  }
  function start() {
    for (var _len11 = arguments.length, args = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
      args[_key11] = arguments[_key11];
    }
    clear();
    isPending.value = true;
    timer = setTimeout(function () {
      isPending.value = false;
      timer = null;
      cb.apply(void 0, args);
    }, toValue(interval));
  }
  if (immediate) {
    isPending.value = true;
    if (isClient) start();
  }
  tryOnScopeDispose(stop);
  return {
    isPending: Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["readonly"])(isPending),
    start: start,
    stop: stop
  };
}
var __defProp$7 = Object.defineProperty;
var __getOwnPropSymbols$9 = Object.getOwnPropertySymbols;
var __hasOwnProp$9 = Object.prototype.hasOwnProperty;
var __propIsEnum$9 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$7 = function __defNormalProp$7(obj, key, value) {
  return key in obj ? __defProp$7(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$7 = function __spreadValues$7(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$9.call(b, prop)) __defNormalProp$7(a, prop, b[prop]);
  if (__getOwnPropSymbols$9) {
    var _iterator5 = _createForOfIteratorHelper(__getOwnPropSymbols$9(b)),
      _step5;
    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var prop = _step5.value;
        if (__propIsEnum$9.call(b, prop)) __defNormalProp$7(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  }
  return a;
};
function useTimeout() {
  var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1e3;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$controls2 = options.controls,
    exposeControls = _options$controls2 === void 0 ? false : _options$controls2,
    callback = options.callback;
  var controls = useTimeoutFn(callback != null ? callback : noop, interval, options);
  var ready = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["computed"])(function () {
    return !controls.isPending.value;
  });
  if (exposeControls) {
    return __spreadValues$7({
      ready: ready
    }, controls);
  } else {
    return ready;
  }
}
function useToNumber(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$method = options.method,
    method = _options$method === void 0 ? "parseFloat" : _options$method,
    radix = options.radix,
    nanToZero = options.nanToZero;
  return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["computed"])(function () {
    var resolved = toValue(value);
    if (typeof resolved === "string") resolved = Number[method](resolved, radix);
    if (nanToZero && isNaN(resolved)) resolved = 0;
    return resolved;
  });
}
function useToString(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["computed"])(function () {
    return "".concat(toValue(value));
  });
}
function useToggle() {
  var initialValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$truthyValue = options.truthyValue,
    truthyValue = _options$truthyValue === void 0 ? true : _options$truthyValue,
    _options$falsyValue = options.falsyValue,
    falsyValue = _options$falsyValue === void 0 ? false : _options$falsyValue;
  var valueIsRef = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["isRef"])(initialValue);
  var _value = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["ref"])(initialValue);
  function toggle(value) {
    if (arguments.length) {
      _value.value = value;
      return _value.value;
    } else {
      var truthy = toValue(truthyValue);
      _value.value = _value.value === truthy ? toValue(falsyValue) : truthy;
      return _value.value;
    }
  }
  if (valueIsRef) return toggle;else return [_value, toggle];
}
function watchArray(source, cb, options) {
  var oldList = (options == null ? void 0 : options.immediate) ? [] : _toConsumableArray(source instanceof Function ? source() : Array.isArray(source) ? source : toValue(source));
  return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["watch"])(source, function (newList, _, onCleanup) {
    var oldListRemains = new Array(oldList.length);
    var added = [];
    var _iterator6 = _createForOfIteratorHelper(newList),
      _step6;
    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var obj = _step6.value;
        var found = false;
        for (var i = 0; i < oldList.length; i++) {
          if (!oldListRemains[i] && obj === oldList[i]) {
            oldListRemains[i] = true;
            found = true;
            break;
          }
        }
        if (!found) added.push(obj);
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
    var removed = oldList.filter(function (_2, i) {
      return !oldListRemains[i];
    });
    cb(newList, oldList, added, removed, onCleanup);
    oldList = _toConsumableArray(newList);
  }, options);
}
var __getOwnPropSymbols$8 = Object.getOwnPropertySymbols;
var __hasOwnProp$8 = Object.prototype.hasOwnProperty;
var __propIsEnum$8 = Object.prototype.propertyIsEnumerable;
var __objRest$5 = function __objRest$5(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$8.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$8) {
    var _iterator7 = _createForOfIteratorHelper(__getOwnPropSymbols$8(source)),
      _step7;
    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var prop = _step7.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$8.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }
  }
  return target;
};
function watchWithFilter(source, cb) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _a = options,
    _a$eventFilter = _a.eventFilter,
    eventFilter = _a$eventFilter === void 0 ? bypassFilter : _a$eventFilter,
    watchOptions = __objRest$5(_a, ["eventFilter"]);
  return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["watch"])(source, createFilterWrapper(eventFilter, cb), watchOptions);
}
var __getOwnPropSymbols$7 = Object.getOwnPropertySymbols;
var __hasOwnProp$7 = Object.prototype.hasOwnProperty;
var __propIsEnum$7 = Object.prototype.propertyIsEnumerable;
var __objRest$4 = function __objRest$4(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$7.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$7) {
    var _iterator8 = _createForOfIteratorHelper(__getOwnPropSymbols$7(source)),
      _step8;
    try {
      for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
        var prop = _step8.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$7.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator8.e(err);
    } finally {
      _iterator8.f();
    }
  }
  return target;
};
function watchAtMost(source, cb, options) {
  var _a = options,
    count = _a.count,
    watchOptions = __objRest$4(_a, ["count"]);
  var current = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["ref"])(0);
  var stop = watchWithFilter(source, function () {
    current.value += 1;
    if (current.value >= toValue(count)) Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["nextTick"])(function () {
      return stop();
    });
    cb.apply(void 0, arguments);
  }, watchOptions);
  return {
    count: current,
    stop: stop
  };
}
var __defProp$6 = Object.defineProperty;
var __defProps$6 = Object.defineProperties;
var __getOwnPropDescs$6 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$6 = Object.getOwnPropertySymbols;
var __hasOwnProp$6 = Object.prototype.hasOwnProperty;
var __propIsEnum$6 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6 = function __defNormalProp$6(obj, key, value) {
  return key in obj ? __defProp$6(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$6 = function __spreadValues$6(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$6.call(b, prop)) __defNormalProp$6(a, prop, b[prop]);
  if (__getOwnPropSymbols$6) {
    var _iterator9 = _createForOfIteratorHelper(__getOwnPropSymbols$6(b)),
      _step9;
    try {
      for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
        var prop = _step9.value;
        if (__propIsEnum$6.call(b, prop)) __defNormalProp$6(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator9.e(err);
    } finally {
      _iterator9.f();
    }
  }
  return a;
};
var __spreadProps$6 = function __spreadProps$6(a, b) {
  return __defProps$6(a, __getOwnPropDescs$6(b));
};
var __objRest$3 = function __objRest$3(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$6.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6) {
    var _iterator10 = _createForOfIteratorHelper(__getOwnPropSymbols$6(source)),
      _step10;
    try {
      for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
        var prop = _step10.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$6.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator10.e(err);
    } finally {
      _iterator10.f();
    }
  }
  return target;
};
function watchDebounced(source, cb) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _a = options,
    _a$debounce = _a.debounce,
    debounce = _a$debounce === void 0 ? 0 : _a$debounce,
    _a$maxWait = _a.maxWait,
    maxWait = _a$maxWait === void 0 ? void 0 : _a$maxWait,
    watchOptions = __objRest$3(_a, ["debounce", "maxWait"]);
  return watchWithFilter(source, cb, __spreadProps$6(__spreadValues$6({}, watchOptions), {
    eventFilter: debounceFilter(debounce, {
      maxWait: maxWait
    })
  }));
}
var __defProp$5 = Object.defineProperty;
var __defProps$5 = Object.defineProperties;
var __getOwnPropDescs$5 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$5 = Object.getOwnPropertySymbols;
var __hasOwnProp$5 = Object.prototype.hasOwnProperty;
var __propIsEnum$5 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5 = function __defNormalProp$5(obj, key, value) {
  return key in obj ? __defProp$5(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$5 = function __spreadValues$5(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$5.call(b, prop)) __defNormalProp$5(a, prop, b[prop]);
  if (__getOwnPropSymbols$5) {
    var _iterator11 = _createForOfIteratorHelper(__getOwnPropSymbols$5(b)),
      _step11;
    try {
      for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
        var prop = _step11.value;
        if (__propIsEnum$5.call(b, prop)) __defNormalProp$5(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator11.e(err);
    } finally {
      _iterator11.f();
    }
  }
  return a;
};
var __spreadProps$5 = function __spreadProps$5(a, b) {
  return __defProps$5(a, __getOwnPropDescs$5(b));
};
function watchDeep(source, cb, options) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["watch"])(source, cb, __spreadProps$5(__spreadValues$5({}, options), {
    deep: true
  }));
}
var __defProp$4 = Object.defineProperty;
var __defProps$4 = Object.defineProperties;
var __getOwnPropDescs$4 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4 = function __defNormalProp$4(obj, key, value) {
  return key in obj ? __defProp$4(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$4 = function __spreadValues$4(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$4.call(b, prop)) __defNormalProp$4(a, prop, b[prop]);
  if (__getOwnPropSymbols$4) {
    var _iterator12 = _createForOfIteratorHelper(__getOwnPropSymbols$4(b)),
      _step12;
    try {
      for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
        var prop = _step12.value;
        if (__propIsEnum$4.call(b, prop)) __defNormalProp$4(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator12.e(err);
    } finally {
      _iterator12.f();
    }
  }
  return a;
};
var __spreadProps$4 = function __spreadProps$4(a, b) {
  return __defProps$4(a, __getOwnPropDescs$4(b));
};
var __objRest$2 = function __objRest$2(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$4.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4) {
    var _iterator13 = _createForOfIteratorHelper(__getOwnPropSymbols$4(source)),
      _step13;
    try {
      for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
        var prop = _step13.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$4.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator13.e(err);
    } finally {
      _iterator13.f();
    }
  }
  return target;
};
function watchIgnorable(source, cb) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _a = options,
    _a$eventFilter2 = _a.eventFilter,
    eventFilter = _a$eventFilter2 === void 0 ? bypassFilter : _a$eventFilter2,
    watchOptions = __objRest$2(_a, ["eventFilter"]);
  var filteredCb = createFilterWrapper(eventFilter, cb);
  var ignoreUpdates;
  var ignorePrevAsyncUpdates;
  var stop;
  if (watchOptions.flush === "sync") {
    var ignore = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["ref"])(false);
    ignorePrevAsyncUpdates = function ignorePrevAsyncUpdates() {};
    ignoreUpdates = function ignoreUpdates(updater) {
      ignore.value = true;
      updater();
      ignore.value = false;
    };
    stop = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["watch"])(source, function () {
      if (!ignore.value) filteredCb.apply(void 0, arguments);
    }, watchOptions);
  } else {
    var disposables = [];
    var ignoreCounter = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["ref"])(0);
    var syncCounter = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["ref"])(0);
    ignorePrevAsyncUpdates = function ignorePrevAsyncUpdates() {
      ignoreCounter.value = syncCounter.value;
    };
    disposables.push(Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["watch"])(source, function () {
      syncCounter.value++;
    }, __spreadProps$4(__spreadValues$4({}, watchOptions), {
      flush: "sync"
    })));
    ignoreUpdates = function ignoreUpdates(updater) {
      var syncCounterPrev = syncCounter.value;
      updater();
      ignoreCounter.value += syncCounter.value - syncCounterPrev;
    };
    disposables.push(Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["watch"])(source, function () {
      var ignore = ignoreCounter.value > 0 && ignoreCounter.value === syncCounter.value;
      ignoreCounter.value = 0;
      syncCounter.value = 0;
      if (ignore) return;
      filteredCb.apply(void 0, arguments);
    }, watchOptions));
    stop = function stop() {
      disposables.forEach(function (fn) {
        return fn();
      });
    };
  }
  return {
    stop: stop,
    ignoreUpdates: ignoreUpdates,
    ignorePrevAsyncUpdates: ignorePrevAsyncUpdates
  };
}
var __defProp$3 = Object.defineProperty;
var __defProps$3 = Object.defineProperties;
var __getOwnPropDescs$3 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = function __defNormalProp$3(obj, key, value) {
  return key in obj ? __defProp$3(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$3 = function __spreadValues$3(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$3.call(b, prop)) __defNormalProp$3(a, prop, b[prop]);
  if (__getOwnPropSymbols$3) {
    var _iterator14 = _createForOfIteratorHelper(__getOwnPropSymbols$3(b)),
      _step14;
    try {
      for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
        var prop = _step14.value;
        if (__propIsEnum$3.call(b, prop)) __defNormalProp$3(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator14.e(err);
    } finally {
      _iterator14.f();
    }
  }
  return a;
};
var __spreadProps$3 = function __spreadProps$3(a, b) {
  return __defProps$3(a, __getOwnPropDescs$3(b));
};
function watchImmediate(source, cb, options) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["watch"])(source, cb, __spreadProps$3(__spreadValues$3({}, options), {
    immediate: true
  }));
}
function watchOnce(source, cb, options) {
  var stop = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["watch"])(source, function () {
    Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["nextTick"])(function () {
      return stop();
    });
    return cb.apply(void 0, arguments);
  }, options);
}
var __defProp$2 = Object.defineProperty;
var __defProps$2 = Object.defineProperties;
var __getOwnPropDescs$2 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = function __defNormalProp$2(obj, key, value) {
  return key in obj ? __defProp$2(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2 = function __spreadValues$2(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2) {
    var _iterator15 = _createForOfIteratorHelper(__getOwnPropSymbols$2(b)),
      _step15;
    try {
      for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
        var prop = _step15.value;
        if (__propIsEnum$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator15.e(err);
    } finally {
      _iterator15.f();
    }
  }
  return a;
};
var __spreadProps$2 = function __spreadProps$2(a, b) {
  return __defProps$2(a, __getOwnPropDescs$2(b));
};
var __objRest$1 = function __objRest$1(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$2.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2) {
    var _iterator16 = _createForOfIteratorHelper(__getOwnPropSymbols$2(source)),
      _step16;
    try {
      for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
        var prop = _step16.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$2.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator16.e(err);
    } finally {
      _iterator16.f();
    }
  }
  return target;
};
function watchPausable(source, cb) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _a = options,
    filter = _a.eventFilter,
    watchOptions = __objRest$1(_a, ["eventFilter"]);
  var _pausableFilter = pausableFilter(filter),
    eventFilter = _pausableFilter.eventFilter,
    pause = _pausableFilter.pause,
    resume = _pausableFilter.resume,
    isActive = _pausableFilter.isActive;
  var stop = watchWithFilter(source, cb, __spreadProps$2(__spreadValues$2({}, watchOptions), {
    eventFilter: eventFilter
  }));
  return {
    stop: stop,
    pause: pause,
    resume: resume,
    isActive: isActive
  };
}
var __defProp$1 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = function __defNormalProp$1(obj, key, value) {
  return key in obj ? __defProp$1(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1 = function __spreadValues$1(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1) {
    var _iterator17 = _createForOfIteratorHelper(__getOwnPropSymbols$1(b)),
      _step17;
    try {
      for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
        var prop = _step17.value;
        if (__propIsEnum$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator17.e(err);
    } finally {
      _iterator17.f();
    }
  }
  return a;
};
var __spreadProps$1 = function __spreadProps$1(a, b) {
  return __defProps$1(a, __getOwnPropDescs$1(b));
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1) {
    var _iterator18 = _createForOfIteratorHelper(__getOwnPropSymbols$1(source)),
      _step18;
    try {
      for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
        var prop = _step18.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator18.e(err);
    } finally {
      _iterator18.f();
    }
  }
  return target;
};
function watchThrottled(source, cb) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _a = options,
    _a$throttle = _a.throttle,
    throttle = _a$throttle === void 0 ? 0 : _a$throttle,
    _a$trailing = _a.trailing,
    trailing = _a$trailing === void 0 ? true : _a$trailing,
    _a$leading = _a.leading,
    leading = _a$leading === void 0 ? true : _a$leading,
    watchOptions = __objRest(_a, ["throttle", "trailing", "leading"]);
  return watchWithFilter(source, cb, __spreadProps$1(__spreadValues$1({}, watchOptions), {
    eventFilter: throttleFilter(throttle, trailing, leading)
  }));
}
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator19 = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step19;
    try {
      for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
        var prop = _step19.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator19.e(err);
    } finally {
      _iterator19.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
function watchTriggerable(source, cb) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var cleanupFn;
  function onEffect() {
    if (!cleanupFn) return;
    var fn = cleanupFn;
    cleanupFn = void 0;
    fn();
  }
  function onCleanup(callback) {
    cleanupFn = callback;
  }
  var _cb = function _cb(value, oldValue) {
    onEffect();
    return cb(value, oldValue, onCleanup);
  };
  var res = watchIgnorable(source, _cb, options);
  var ignoreUpdates = res.ignoreUpdates;
  var trigger = function trigger() {
    var res2;
    ignoreUpdates(function () {
      res2 = _cb(getWatchSources(source), getOldValue(source));
    });
    return res2;
  };
  return __spreadProps(__spreadValues({}, res), {
    trigger: trigger
  });
}
function getWatchSources(sources) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["isReactive"])(sources)) return sources;
  if (Array.isArray(sources)) return sources.map(function (item) {
    return toValue(item);
  });
  return toValue(sources);
}
function getOldValue(source) {
  return Array.isArray(source) ? source.map(function () {
    return void 0;
  }) : void 0;
}
function whenever(source, cb, options) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["watch"])(source, function (v, ov, onInvalidate) {
    if (v) cb(v, ov, onInvalidate);
  }, options);
}


/***/ }),

/***/ 1469:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FaqCollapsible_vue_vue_type_script_setup_true_lang_js___ = __webpack_require__(1470);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FaqCollapsible_vue_vue_type_script_setup_true_lang_js___["a" /* default */]); 

/***/ }),

/***/ 1470:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid_v4__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_reused_components_smooth_reflow_SmoothReflow__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_types__ = __webpack_require__(1126);




/* harmony default export */ __webpack_exports__["a"] = ({
  __name: 'FaqCollapsible',
  props: {
    hasWhiteArrow: Object(__WEBPACK_IMPORTED_MODULE_3_vue_types__["d" /* bool */])().def(false)
  },
  setup: function setup(__props) {
    var props = __props;
    var faqEntryId = __WEBPACK_IMPORTED_MODULE_0_uuid_v4___default()();
    var isExpanded = Object(__WEBPACK_IMPORTED_MODULE_1_vue__["ref"])(false);
    return {
      __sfc: true,
      faqEntryId: faqEntryId,
      isExpanded: isExpanded,
      props: props,
      SmoothReflow: __WEBPACK_IMPORTED_MODULE_2_components_reused_components_smooth_reflow_SmoothReflow__["a" /* default */]
    };
  }
});

/***/ }),

/***/ 1855:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export DefaultMagicKeysAliasMap */
/* unused harmony export StorageSerializers */
/* unused harmony export TransitionPresets */
/* unused harmony export asyncComputed */
/* unused harmony export breakpointsAntDesign */
/* unused harmony export breakpointsBootstrapV5 */
/* unused harmony export breakpointsMasterCss */
/* unused harmony export breakpointsQuasar */
/* unused harmony export breakpointsSematic */
/* unused harmony export breakpointsTailwind */
/* unused harmony export breakpointsVuetify */
/* unused harmony export cloneFnJSON */
/* unused harmony export computedAsync */
/* unused harmony export computedInject */
/* unused harmony export createFetch */
/* unused harmony export createReusableTemplate */
/* unused harmony export createTemplatePromise */
/* unused harmony export createUnrefFn */
/* unused harmony export customStorageEventName */
/* unused harmony export defaultDocument */
/* unused harmony export defaultLocation */
/* unused harmony export defaultNavigator */
/* unused harmony export defaultWindow */
/* unused harmony export executeTransition */
/* unused harmony export formatTimeAgo */
/* unused harmony export getSSRHandler */
/* unused harmony export mapGamepadToXbox360Controller */
/* unused harmony export onClickOutside */
/* unused harmony export onKeyDown */
/* unused harmony export onKeyPressed */
/* unused harmony export onKeyStroke */
/* unused harmony export onKeyUp */
/* unused harmony export onLongPress */
/* unused harmony export onStartTyping */
/* unused harmony export setSSRHandler */
/* unused harmony export templateRef */
/* unused harmony export unrefElement */
/* unused harmony export useActiveElement */
/* unused harmony export useAnimate */
/* unused harmony export useAsyncQueue */
/* unused harmony export useAsyncState */
/* unused harmony export useBase64 */
/* unused harmony export useBattery */
/* unused harmony export useBluetooth */
/* unused harmony export useBreakpoints */
/* unused harmony export useBroadcastChannel */
/* unused harmony export useBrowserLocation */
/* unused harmony export useCached */
/* unused harmony export useClipboard */
/* unused harmony export useCloned */
/* unused harmony export useColorMode */
/* unused harmony export useConfirmDialog */
/* unused harmony export useCssVar */
/* unused harmony export useCurrentElement */
/* unused harmony export useCycleList */
/* unused harmony export useDark */
/* unused harmony export useDebouncedRefHistory */
/* unused harmony export useDeviceMotion */
/* unused harmony export useDeviceOrientation */
/* unused harmony export useDevicePixelRatio */
/* unused harmony export useDevicesList */
/* unused harmony export useDisplayMedia */
/* unused harmony export useDocumentVisibility */
/* unused harmony export useDraggable */
/* unused harmony export useDropZone */
/* unused harmony export useElementBounding */
/* unused harmony export useElementByPoint */
/* unused harmony export useElementHover */
/* unused harmony export useElementSize */
/* unused harmony export useElementVisibility */
/* unused harmony export useEventBus */
/* unused harmony export useEventListener */
/* unused harmony export useEventSource */
/* unused harmony export useEyeDropper */
/* unused harmony export useFavicon */
/* unused harmony export useFetch */
/* unused harmony export useFileDialog */
/* unused harmony export useFileSystemAccess */
/* unused harmony export useFocus */
/* unused harmony export useFocusWithin */
/* unused harmony export useFps */
/* unused harmony export useFullscreen */
/* unused harmony export useGamepad */
/* unused harmony export useGeolocation */
/* unused harmony export useIdle */
/* unused harmony export useImage */
/* unused harmony export useInfiniteScroll */
/* unused harmony export useIntersectionObserver */
/* unused harmony export useKeyModifier */
/* unused harmony export useLocalStorage */
/* unused harmony export useMagicKeys */
/* unused harmony export useManualRefHistory */
/* unused harmony export useMediaControls */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useMediaQuery; });
/* unused harmony export useMemoize */
/* unused harmony export useMemory */
/* unused harmony export useMounted */
/* unused harmony export useMouse */
/* unused harmony export useMouseInElement */
/* unused harmony export useMousePressed */
/* unused harmony export useMutationObserver */
/* unused harmony export useNavigatorLanguage */
/* unused harmony export useNetwork */
/* unused harmony export useNow */
/* unused harmony export useObjectUrl */
/* unused harmony export useOffsetPagination */
/* unused harmony export useOnline */
/* unused harmony export usePageLeave */
/* unused harmony export useParallax */
/* unused harmony export useParentElement */
/* unused harmony export usePerformanceObserver */
/* unused harmony export usePermission */
/* unused harmony export usePointer */
/* unused harmony export usePointerLock */
/* unused harmony export usePointerSwipe */
/* unused harmony export usePreferredColorScheme */
/* unused harmony export usePreferredContrast */
/* unused harmony export usePreferredDark */
/* unused harmony export usePreferredLanguages */
/* unused harmony export usePreferredReducedMotion */
/* unused harmony export usePrevious */
/* unused harmony export useRafFn */
/* unused harmony export useRefHistory */
/* unused harmony export useResizeObserver */
/* unused harmony export useScreenOrientation */
/* unused harmony export useScreenSafeArea */
/* unused harmony export useScriptTag */
/* unused harmony export useScroll */
/* unused harmony export useScrollLock */
/* unused harmony export useSessionStorage */
/* unused harmony export useShare */
/* unused harmony export useSorted */
/* unused harmony export useSpeechRecognition */
/* unused harmony export useSpeechSynthesis */
/* unused harmony export useStepper */
/* unused harmony export useStorage */
/* unused harmony export useStorageAsync */
/* unused harmony export useStyleTag */
/* unused harmony export useSupported */
/* unused harmony export useSwipe */
/* unused harmony export useTemplateRefsList */
/* unused harmony export useTextDirection */
/* unused harmony export useTextSelection */
/* unused harmony export useTextareaAutosize */
/* unused harmony export useThrottledRefHistory */
/* unused harmony export useTimeAgo */
/* unused harmony export useTimeoutPoll */
/* unused harmony export useTimestamp */
/* unused harmony export useTitle */
/* unused harmony export useTransition */
/* unused harmony export useUrlSearchParams */
/* unused harmony export useUserMedia */
/* unused harmony export useVModel */
/* unused harmony export useVModels */
/* unused harmony export useVibrate */
/* unused harmony export useVirtualList */
/* unused harmony export useWakeLock */
/* unused harmony export useWebNotification */
/* unused harmony export useWebSocket */
/* unused harmony export useWebWorker */
/* unused harmony export useWebWorkerFn */
/* unused harmony export useWindowFocus */
/* unused harmony export useWindowScroll */
/* unused harmony export useWindowSize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vueuse_shared__ = __webpack_require__(1468);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_demi__ = __webpack_require__(498);
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }



function computedAsync(evaluationCallback, initialState, optionsOrRef) {
  var options;
  if (Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["isRef"])(optionsOrRef)) {
    options = {
      evaluating: optionsOrRef
    };
  } else {
    options = optionsOrRef || {};
  }
  var _options2 = options,
    _options2$lazy = _options2.lazy,
    lazy = _options2$lazy === void 0 ? false : _options2$lazy,
    _options2$evaluating = _options2.evaluating,
    evaluating = _options2$evaluating === void 0 ? void 0 : _options2$evaluating,
    _options2$shallow = _options2.shallow,
    shallow = _options2$shallow === void 0 ? true : _options2$shallow,
    _options2$onError = _options2.onError,
    onError = _options2$onError === void 0 ? __WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["q" /* noop */] : _options2$onError;
  var started = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(!lazy);
  var current = shallow ? Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["shallowRef"])(initialState) : Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(initialState);
  var counter = 0;
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watchEffect"])( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(onInvalidate) {
      var counterAtBeginning, hasFinished, result;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (started.value) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            counter++;
            counterAtBeginning = counter;
            hasFinished = false;
            if (evaluating) {
              Promise.resolve().then(function () {
                evaluating.value = true;
              });
            }
            _context.prev = 6;
            _context.next = 9;
            return evaluationCallback(function (cancelCallback) {
              onInvalidate(function () {
                if (evaluating) evaluating.value = false;
                if (!hasFinished) cancelCallback();
              });
            });
          case 9:
            result = _context.sent;
            if (counterAtBeginning === counter) current.value = result;
            _context.next = 16;
            break;
          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](6);
            onError(_context.t0);
          case 16:
            _context.prev = 16;
            if (evaluating && counterAtBeginning === counter) evaluating.value = false;
            hasFinished = true;
            return _context.finish(16);
          case 20:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[6, 13, 16, 20]]);
    }));
    return function (_x2) {
      return _ref.apply(this, arguments);
    };
  }());
  if (lazy) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
      started.value = true;
      return current.value;
    });
  } else {
    return current;
  }
}
function computedInject(key, options, defaultSource, treatDefaultAsFactory) {
  var source = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["inject"])(key);
  if (defaultSource) source = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["inject"])(key, defaultSource);
  if (treatDefaultAsFactory) source = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["inject"])(key, defaultSource, treatDefaultAsFactory);
  if (typeof options === "function") {
    return Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function (ctx) {
      return options(source, ctx);
    });
  } else {
    return Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])({
      get: function get(ctx) {
        return options.get(source, ctx);
      },
      set: options.set
    });
  }
}
var __defProp$p = Object.defineProperty;
var __defProps$c = Object.defineProperties;
var __getOwnPropDescs$c = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$s = Object.getOwnPropertySymbols;
var __hasOwnProp$s = Object.prototype.hasOwnProperty;
var __propIsEnum$s = Object.prototype.propertyIsEnumerable;
var __defNormalProp$p = function __defNormalProp$p(obj, key, value) {
  return key in obj ? __defProp$p(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$p = function __spreadValues$p(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$s.call(b, prop)) __defNormalProp$p(a, prop, b[prop]);
  if (__getOwnPropSymbols$s) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols$s(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum$s.call(b, prop)) __defNormalProp$p(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps$c = function __spreadProps$c(a, b) {
  return __defProps$c(a, __getOwnPropDescs$c(b));
};
function createReusableTemplate() {
  if (!__WEBPACK_IMPORTED_MODULE_1_vue_demi__["isVue3"] && !__WEBPACK_IMPORTED_MODULE_1_vue_demi__["version"].startsWith("2.7.")) {
    if (false) throw new Error("[VueUse] createReusableTemplate only works in Vue 2.7 or above.");
    return;
  }
  var render = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["shallowRef"])();
  var define = /* #__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["defineComponent"])({
    setup: function setup(_, _ref2) {
      var slots = _ref2.slots;
      return function () {
        render.value = slots.default;
      };
    }
  });
  var reuse = /* #__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["defineComponent"])({
    inheritAttrs: false,
    setup: function setup(_, _ref3) {
      var attrs = _ref3.attrs,
        slots = _ref3.slots;
      return function () {
        var _a;
        if (!render.value && "production" !== "production") throw new Error("[VueUse] Failed to find the definition of reusable template");
        return (_a = render.value) == null ? void 0 : _a.call(render, __spreadProps$c(__spreadValues$p({}, attrs), {
          $slots: slots
        }));
      };
    }
  });
  return Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["p" /* makeDestructurable */])({
    define: define,
    reuse: reuse
  }, [define, reuse]);
}
function createTemplatePromise() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!__WEBPACK_IMPORTED_MODULE_1_vue_demi__["isVue3"]) {
    if (false) throw new Error("[VueUse] createTemplatePromise only works in Vue 3 or above.");
    return;
  }
  var index = 0;
  var instances = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])([]);
  function create() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var props = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["shallowReactive"])({
      key: index++,
      args: args,
      promise: void 0,
      resolve: function resolve() {},
      reject: function reject() {},
      isResolving: false,
      options: options
    });
    instances.value.push(props);
    props.promise = new Promise(function (_resolve, _reject) {
      props.resolve = function (v) {
        props.isResolving = true;
        return _resolve(v);
      };
      props.reject = _reject;
    }).finally(function () {
      props.promise = void 0;
      var index2 = instances.value.indexOf(props);
      if (index2 !== -1) instances.value.splice(index2, 1);
    });
    return props.promise;
  }
  function start() {
    if (options.singleton && instances.value.length > 0) return instances.value[0].promise;
    return create.apply(void 0, arguments);
  }
  var component = /* #__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["defineComponent"])(function (_, _ref4) {
    var slots = _ref4.slots;
    var renderList = function renderList() {
      return instances.value.map(function (props) {
        var _a;
        return Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["h"])(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["Fragment"], {
          key: props.key
        }, (_a = slots.default) == null ? void 0 : _a.call(slots, props));
      });
    };
    if (options.transition) return function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["h"])(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["TransitionGroup"], options.transition, renderList);
    };
    return renderList;
  });
  component.start = start;
  return component;
}
function createUnrefFn(fn) {
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return fn.apply(this, args.map(function (i) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(i);
    }));
  };
}
function unrefElement(elRef) {
  var _a;
  var plain = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(elRef);
  return (_a = plain == null ? void 0 : plain.$el) != null ? _a : plain;
}
var defaultWindow = __WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["l" /* isClient */] ? window : void 0;
var defaultDocument = __WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["l" /* isClient */] ? window.document : void 0;
var defaultNavigator = __WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["l" /* isClient */] ? window.navigator : void 0;
var defaultLocation = __WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["l" /* isClient */] ? window.location : void 0;
function useEventListener() {
  var target;
  var events;
  var listeners;
  var options;
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }
  if (typeof args[0] === "string" || Array.isArray(args[0])) {
    events = args[0];
    listeners = args[1];
    options = args[2];
    target = defaultWindow;
  } else {
    target = args[0];
    events = args[1];
    listeners = args[2];
    options = args[3];
  }
  if (!target) return __WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["q" /* noop */];
  if (!Array.isArray(events)) events = [events];
  if (!Array.isArray(listeners)) listeners = [listeners];
  var cleanups = [];
  var cleanup = function cleanup() {
    cleanups.forEach(function (fn) {
      return fn();
    });
    cleanups.length = 0;
  };
  var register = function register(el, event, listener, options2) {
    el.addEventListener(event, listener, options2);
    return function () {
      return el.removeEventListener(event, listener, options2);
    };
  };
  var stopWatch = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(function () {
    return [unrefElement(target), Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(options)];
  }, function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
      el = _ref6[0],
      options2 = _ref6[1];
    cleanup();
    if (!el) return;
    cleanups.push.apply(cleanups, _toConsumableArray(events.flatMap(function (event) {
      return listeners.map(function (listener) {
        return register(el, event, listener, options2);
      });
    })));
  }, {
    immediate: true,
    flush: "post"
  });
  var stop = function stop() {
    stopWatch();
    cleanup();
  };
  Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["F" /* tryOnScopeDispose */])(stop);
  return stop;
}
var _iOSWorkaround = false;
function onClickOutside(target, handler) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$window = options.window,
    window = _options$window === void 0 ? defaultWindow : _options$window,
    _options$ignore = options.ignore,
    ignore = _options$ignore === void 0 ? [] : _options$ignore,
    _options$capture = options.capture,
    capture = _options$capture === void 0 ? true : _options$capture,
    _options$detectIframe = options.detectIframe,
    detectIframe = _options$detectIframe === void 0 ? false : _options$detectIframe;
  if (!window) return;
  if (__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["n" /* isIOS */] && !_iOSWorkaround) {
    _iOSWorkaround = true;
    Array.from(window.document.body.children).forEach(function (el) {
      return el.addEventListener("click", __WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["q" /* noop */]);
    });
  }
  var shouldListen = true;
  var shouldIgnore = function shouldIgnore(event) {
    return ignore.some(function (target2) {
      if (typeof target2 === "string") {
        return Array.from(window.document.querySelectorAll(target2)).some(function (el) {
          return el === event.target || event.composedPath().includes(el);
        });
      } else {
        var el = unrefElement(target2);
        return el && (event.target === el || event.composedPath().includes(el));
      }
    });
  };
  var listener = function listener(event) {
    var el = unrefElement(target);
    if (!el || el === event.target || event.composedPath().includes(el)) return;
    if (event.detail === 0) shouldListen = !shouldIgnore(event);
    if (!shouldListen) {
      shouldListen = true;
      return;
    }
    handler(event);
  };
  var cleanup = [useEventListener(window, "click", listener, {
    passive: true,
    capture: capture
  }), useEventListener(window, "pointerdown", function (e) {
    var el = unrefElement(target);
    if (el) shouldListen = !e.composedPath().includes(el) && !shouldIgnore(e);
  }, {
    passive: true
  }), detectIframe && useEventListener(window, "blur", function (event) {
    var _a;
    var el = unrefElement(target);
    if (((_a = window.document.activeElement) == null ? void 0 : _a.tagName) === "IFRAME" && !(el == null ? void 0 : el.contains(window.document.activeElement))) handler(event);
  })].filter(Boolean);
  var stop = function stop() {
    return cleanup.forEach(function (fn) {
      return fn();
    });
  };
  return stop;
}
var __defProp$o = Object.defineProperty;
var __defProps$b = Object.defineProperties;
var __getOwnPropDescs$b = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$r = Object.getOwnPropertySymbols;
var __hasOwnProp$r = Object.prototype.hasOwnProperty;
var __propIsEnum$r = Object.prototype.propertyIsEnumerable;
var __defNormalProp$o = function __defNormalProp$o(obj, key, value) {
  return key in obj ? __defProp$o(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$o = function __spreadValues$o(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$r.call(b, prop)) __defNormalProp$o(a, prop, b[prop]);
  if (__getOwnPropSymbols$r) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols$r(b)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (__propIsEnum$r.call(b, prop)) __defNormalProp$o(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return a;
};
var __spreadProps$b = function __spreadProps$b(a, b) {
  return __defProps$b(a, __getOwnPropDescs$b(b));
};
function createKeyPredicate(keyFilter) {
  if (typeof keyFilter === "function") return keyFilter;else if (typeof keyFilter === "string") return function (event) {
    return event.key === keyFilter;
  };else if (Array.isArray(keyFilter)) return function (event) {
    return keyFilter.includes(event.key);
  };
  return function () {
    return true;
  };
}
function onKeyStroke() {
  var key;
  var handler;
  var options = {};
  if (arguments.length === 3) {
    key = arguments.length <= 0 ? undefined : arguments[0];
    handler = arguments.length <= 1 ? undefined : arguments[1];
    options = arguments.length <= 2 ? undefined : arguments[2];
  } else if (arguments.length === 2) {
    if (_typeof(arguments.length <= 1 ? undefined : arguments[1]) === "object") {
      key = true;
      handler = arguments.length <= 0 ? undefined : arguments[0];
      options = arguments.length <= 1 ? undefined : arguments[1];
    } else {
      key = arguments.length <= 0 ? undefined : arguments[0];
      handler = arguments.length <= 1 ? undefined : arguments[1];
    }
  } else {
    key = true;
    handler = arguments.length <= 0 ? undefined : arguments[0];
  }
  var _options3 = options,
    _options3$target = _options3.target,
    target = _options3$target === void 0 ? defaultWindow : _options3$target,
    _options3$eventName = _options3.eventName,
    eventName = _options3$eventName === void 0 ? "keydown" : _options3$eventName,
    _options3$passive = _options3.passive,
    passive = _options3$passive === void 0 ? false : _options3$passive,
    _options3$dedupe = _options3.dedupe,
    dedupe = _options3$dedupe === void 0 ? false : _options3$dedupe;
  var predicate = createKeyPredicate(key);
  var listener = function listener(e) {
    if (e.repeat && Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(dedupe)) return;
    if (predicate(e)) handler(e);
  };
  return useEventListener(target, eventName, listener, passive);
}
function onKeyDown(key, handler) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return onKeyStroke(key, handler, __spreadProps$b(__spreadValues$o({}, options), {
    eventName: "keydown"
  }));
}
function onKeyPressed(key, handler) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return onKeyStroke(key, handler, __spreadProps$b(__spreadValues$o({}, options), {
    eventName: "keypress"
  }));
}
function onKeyUp(key, handler) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return onKeyStroke(key, handler, __spreadProps$b(__spreadValues$o({}, options), {
    eventName: "keyup"
  }));
}
var DEFAULT_DELAY = 500;
function onLongPress(target, handler, options) {
  var _a, _b;
  var elementRef = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return unrefElement(target);
  });
  var timeout;
  function clear() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = void 0;
    }
  }
  function onDown(ev) {
    var _a2, _b2, _c, _d;
    if (((_a2 = options == null ? void 0 : options.modifiers) == null ? void 0 : _a2.self) && ev.target !== elementRef.value) return;
    clear();
    if ((_b2 = options == null ? void 0 : options.modifiers) == null ? void 0 : _b2.prevent) ev.preventDefault();
    if ((_c = options == null ? void 0 : options.modifiers) == null ? void 0 : _c.stop) ev.stopPropagation();
    timeout = setTimeout(function () {
      return handler(ev);
    }, (_d = options == null ? void 0 : options.delay) != null ? _d : DEFAULT_DELAY);
  }
  var listenerOptions = {
    capture: (_a = options == null ? void 0 : options.modifiers) == null ? void 0 : _a.capture,
    once: (_b = options == null ? void 0 : options.modifiers) == null ? void 0 : _b.once
  };
  useEventListener(elementRef, "pointerdown", onDown, listenerOptions);
  useEventListener(elementRef, "pointerup", clear, listenerOptions);
  useEventListener(elementRef, "pointerleave", clear, listenerOptions);
}
function isFocusedElementEditable() {
  var _document = document,
    activeElement = _document.activeElement,
    body = _document.body;
  if (!activeElement) return false;
  if (activeElement === body) return false;
  switch (activeElement.tagName) {
    case "INPUT":
    case "TEXTAREA":
      return true;
  }
  return activeElement.hasAttribute("contenteditable");
}
function isTypedCharValid(_ref7) {
  var keyCode = _ref7.keyCode,
    metaKey = _ref7.metaKey,
    ctrlKey = _ref7.ctrlKey,
    altKey = _ref7.altKey;
  if (metaKey || ctrlKey || altKey) return false;
  if (keyCode >= 48 && keyCode <= 57) return true;
  if (keyCode >= 65 && keyCode <= 90) return true;
  if (keyCode >= 97 && keyCode <= 122) return true;
  return false;
}
function onStartTyping(callback) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$document = options.document,
    document2 = _options$document === void 0 ? defaultDocument : _options$document;
  var keydown = function keydown(event) {
    !isFocusedElementEditable() && isTypedCharValid(event) && callback(event);
  };
  if (document2) useEventListener(document2, "keydown", keydown, {
    passive: true
  });
}
function templateRef(key) {
  var initialValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var instance = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["getCurrentInstance"])();
  var _trigger = function _trigger() {};
  var element = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["customRef"])(function (track, trigger) {
    _trigger = trigger;
    return {
      get: function get() {
        var _a, _b;
        track();
        return (_b = (_a = instance == null ? void 0 : instance.proxy) == null ? void 0 : _a.$refs[key]) != null ? _b : initialValue;
      },
      set: function set() {}
    };
  });
  Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["E" /* tryOnMounted */])(_trigger);
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["onUpdated"])(_trigger);
  return element;
}
function useActiveElement() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _a;
  var _options$window2 = options.window,
    window = _options$window2 === void 0 ? defaultWindow : _options$window2;
  var document = (_a = options.document) != null ? _a : window == null ? void 0 : window.document;
  var activeElement = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["c" /* computedWithControl */])(function () {
    return null;
  }, function () {
    return document == null ? void 0 : document.activeElement;
  });
  if (window) {
    useEventListener(window, "blur", function (event) {
      if (event.relatedTarget !== null) return;
      activeElement.trigger();
    }, true);
    useEventListener(window, "focus", activeElement.trigger, true);
  }
  return activeElement;
}
function useMounted() {
  var isMounted = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  if (Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["getCurrentInstance"])()) {
    Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["onMounted"])(function () {
      isMounted.value = true;
    });
  }
  return isMounted;
}
function useSupported(callback) {
  var isMounted = useMounted();
  return Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    isMounted.value;
    return Boolean(callback());
  });
}
function useRafFn(fn) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$immediate = options.immediate,
    immediate = _options$immediate === void 0 ? true : _options$immediate,
    _options$window3 = options.window,
    window = _options$window3 === void 0 ? defaultWindow : _options$window3;
  var isActive = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  var previousFrameTimestamp = 0;
  var rafId = null;
  function loop(timestamp) {
    if (!isActive.value || !window) return;
    var delta = timestamp - previousFrameTimestamp;
    fn({
      delta: delta,
      timestamp: timestamp
    });
    previousFrameTimestamp = timestamp;
    rafId = window.requestAnimationFrame(loop);
  }
  function resume() {
    if (!isActive.value && window) {
      isActive.value = true;
      rafId = window.requestAnimationFrame(loop);
    }
  }
  function pause() {
    isActive.value = false;
    if (rafId != null && window) {
      window.cancelAnimationFrame(rafId);
      rafId = null;
    }
  }
  if (immediate) resume();
  Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["F" /* tryOnScopeDispose */])(pause);
  return {
    isActive: Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["readonly"])(isActive),
    pause: pause,
    resume: resume
  };
}
function useAnimate(target, keyframes, options) {
  var config;
  var animateOptions;
  if (Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["o" /* isObject */])(options)) {
    config = options;
    animateOptions = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["t" /* objectOmit */])(options, ["window", "immediate", "commitStyles", "persist", "onReady", "onError"]);
  } else {
    config = {
      duration: options
    };
    animateOptions = options;
  }
  var _config = config,
    _config$window = _config.window,
    window = _config$window === void 0 ? defaultWindow : _config$window,
    _config$immediate = _config.immediate,
    immediate = _config$immediate === void 0 ? true : _config$immediate,
    commitStyles = _config.commitStyles,
    persist = _config.persist,
    _config$playbackRate = _config.playbackRate,
    _playbackRate = _config$playbackRate === void 0 ? 1 : _config$playbackRate,
    onReady = _config.onReady,
    _config$onError = _config.onError,
    onError = _config$onError === void 0 ? function (e) {
      console.error(e);
    } : _config$onError;
  var isSupported = useSupported(function () {
    return window && HTMLElement && "animate" in HTMLElement.prototype;
  });
  var animate = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["shallowRef"])(void 0);
  var store = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["shallowReactive"])({
    startTime: null,
    currentTime: null,
    timeline: null,
    playbackRate: _playbackRate,
    pending: false,
    playState: immediate ? "idle" : "paused",
    replaceState: "active"
  });
  var pending = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return store.pending;
  });
  var playState = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return store.playState;
  });
  var replaceState = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return store.replaceState;
  });
  var startTime = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])({
    get: function get() {
      return store.startTime;
    },
    set: function set(value) {
      store.startTime = value;
      if (animate.value) animate.value.startTime = value;
    }
  });
  var currentTime = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])({
    get: function get() {
      return store.currentTime;
    },
    set: function set(value) {
      store.currentTime = value;
      if (animate.value) {
        animate.value.currentTime = value;
        syncResume();
      }
    }
  });
  var timeline = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])({
    get: function get() {
      return store.timeline;
    },
    set: function set(value) {
      store.timeline = value;
      if (animate.value) animate.value.timeline = value;
    }
  });
  var playbackRate = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])({
    get: function get() {
      return store.playbackRate;
    },
    set: function set(value) {
      store.playbackRate = value;
      if (animate.value) animate.value.playbackRate = value;
    }
  });
  var play = function play() {
    if (animate.value) {
      try {
        animate.value.play();
        syncResume();
      } catch (e) {
        syncPause();
        onError(e);
      }
    } else {
      update();
    }
  };
  var pause = function pause() {
    var _a;
    try {
      (_a = animate.value) == null ? void 0 : _a.pause();
      syncPause();
    } catch (e) {
      onError(e);
    }
  };
  var reverse = function reverse() {
    var _a;
    !animate.value && update();
    try {
      (_a = animate.value) == null ? void 0 : _a.reverse();
      syncResume();
    } catch (e) {
      syncPause();
      onError(e);
    }
  };
  var finish = function finish() {
    var _a;
    try {
      (_a = animate.value) == null ? void 0 : _a.finish();
      syncPause();
    } catch (e) {
      onError(e);
    }
  };
  var cancel = function cancel() {
    var _a;
    try {
      (_a = animate.value) == null ? void 0 : _a.cancel();
      syncPause();
    } catch (e) {
      onError(e);
    }
  };
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(function () {
    return unrefElement(target);
  }, function (el) {
    el && update();
  });
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(function () {
    return keyframes;
  }, function (value) {
    !animate.value && update();
    if (!unrefElement(target) && animate.value) {
      animate.value.effect = new KeyframeEffect(unrefElement(target), Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(value), animateOptions);
    }
  }, {
    deep: true
  });
  Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["E" /* tryOnMounted */])(function () {
    Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["nextTick"])(function () {
      return update(true);
    });
  });
  Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["F" /* tryOnScopeDispose */])(cancel);
  function update(init) {
    var el = unrefElement(target);
    if (!isSupported.value || !el) return;
    animate.value = el.animate(Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(keyframes), animateOptions);
    if (commitStyles) animate.value.commitStyles();
    if (persist) animate.value.persist();
    if (_playbackRate !== 1) animate.value.playbackRate = _playbackRate;
    if (init && !immediate) animate.value.pause();else syncResume();
    onReady == null ? void 0 : onReady(animate.value);
  }
  useEventListener(animate, "cancel", syncPause);
  useEventListener(animate, "finish", syncPause);
  useEventListener(animate, "remove", syncPause);
  var _useRafFn = useRafFn(function () {
      if (!animate.value) return;
      store.pending = animate.value.pending;
      store.playState = animate.value.playState;
      store.replaceState = animate.value.replaceState;
      store.startTime = animate.value.startTime;
      store.currentTime = animate.value.currentTime;
      store.timeline = animate.value.timeline;
      store.playbackRate = animate.value.playbackRate;
    }, {
      immediate: false
    }),
    resumeRef = _useRafFn.resume,
    pauseRef = _useRafFn.pause;
  function syncResume() {
    if (isSupported.value) resumeRef();
  }
  function syncPause() {
    if (isSupported.value && window) window.requestAnimationFrame(pauseRef);
  }
  return {
    isSupported: isSupported,
    animate: animate,
    // actions
    play: play,
    pause: pause,
    reverse: reverse,
    finish: finish,
    cancel: cancel,
    // state
    pending: pending,
    playState: playState,
    replaceState: replaceState,
    startTime: startTime,
    currentTime: currentTime,
    timeline: timeline,
    playbackRate: playbackRate
  };
}
function useAsyncQueue(tasks) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$interrupt = options.interrupt,
    interrupt = _options$interrupt === void 0 ? true : _options$interrupt,
    _options$onError = options.onError,
    onError = _options$onError === void 0 ? __WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["q" /* noop */] : _options$onError,
    _options$onFinished = options.onFinished,
    onFinished = _options$onFinished === void 0 ? __WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["q" /* noop */] : _options$onFinished;
  var promiseState = {
    pending: "pending",
    rejected: "rejected",
    fulfilled: "fulfilled"
  };
  var initialResult = Array.from(new Array(tasks.length), function () {
    return {
      state: promiseState.pending,
      data: null
    };
  });
  var result = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["reactive"])(initialResult);
  var activeIndex = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(-1);
  if (!tasks || tasks.length === 0) {
    onFinished();
    return {
      activeIndex: activeIndex,
      result: result
    };
  }
  function updateResult(state, res) {
    activeIndex.value++;
    result[activeIndex.value].data = res;
    result[activeIndex.value].state = state;
  }
  tasks.reduce(function (prev, curr) {
    return prev.then(function (prevRes) {
      var _a;
      if (((_a = result[activeIndex.value]) == null ? void 0 : _a.state) === promiseState.rejected && interrupt) {
        onFinished();
        return;
      }
      return curr(prevRes).then(function (currentRes) {
        updateResult(promiseState.fulfilled, currentRes);
        activeIndex.value === tasks.length - 1 && onFinished();
        return currentRes;
      });
    }).catch(function (e) {
      updateResult(promiseState.rejected, e);
      onError();
      return e;
    });
  }, Promise.resolve());
  return {
    activeIndex: activeIndex,
    result: result
  };
}
var __defProp$n = Object.defineProperty;
var __defProps$a = Object.defineProperties;
var __getOwnPropDescs$a = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$q = Object.getOwnPropertySymbols;
var __hasOwnProp$q = Object.prototype.hasOwnProperty;
var __propIsEnum$q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$n = function __defNormalProp$n(obj, key, value) {
  return key in obj ? __defProp$n(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$n = function __spreadValues$n(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$q.call(b, prop)) __defNormalProp$n(a, prop, b[prop]);
  if (__getOwnPropSymbols$q) {
    var _iterator3 = _createForOfIteratorHelper(__getOwnPropSymbols$q(b)),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var prop = _step3.value;
        if (__propIsEnum$q.call(b, prop)) __defNormalProp$n(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }
  return a;
};
var __spreadProps$a = function __spreadProps$a(a, b) {
  return __defProps$a(a, __getOwnPropDescs$a(b));
};
function useAsyncState(promise, initialState, options) {
  var _ref8 = options != null ? options : {},
    _ref8$immediate = _ref8.immediate,
    immediate = _ref8$immediate === void 0 ? true : _ref8$immediate,
    _ref8$delay = _ref8.delay,
    delay = _ref8$delay === void 0 ? 0 : _ref8$delay,
    _ref8$onError = _ref8.onError,
    onError = _ref8$onError === void 0 ? __WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["q" /* noop */] : _ref8$onError,
    _ref8$onSuccess = _ref8.onSuccess,
    onSuccess = _ref8$onSuccess === void 0 ? __WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["q" /* noop */] : _ref8$onSuccess,
    _ref8$resetOnExecute = _ref8.resetOnExecute,
    resetOnExecute = _ref8$resetOnExecute === void 0 ? true : _ref8$resetOnExecute,
    _ref8$shallow = _ref8.shallow,
    shallow = _ref8$shallow === void 0 ? true : _ref8$shallow,
    throwError = _ref8.throwError;
  var state = shallow ? Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["shallowRef"])(initialState) : Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(initialState);
  var isReady = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  var isLoading = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  var error = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["shallowRef"])(void 0);
  function execute() {
    return _execute.apply(this, arguments);
  }
  function _execute() {
    _execute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var delay2,
        _len4,
        args,
        _key4,
        _promise,
        data,
        _args2 = arguments;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            delay2 = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : 0;
            if (resetOnExecute) state.value = initialState;
            error.value = void 0;
            isReady.value = false;
            isLoading.value = true;
            if (!(delay2 > 0)) {
              _context2.next = 8;
              break;
            }
            _context2.next = 8;
            return Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["x" /* promiseTimeout */])(delay2);
          case 8:
            for (_len4 = _args2.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
              args[_key4 - 1] = _args2[_key4];
            }
            _promise = typeof promise === "function" ? promise.apply(void 0, args) : promise;
            _context2.prev = 10;
            _context2.next = 13;
            return _promise;
          case 13:
            data = _context2.sent;
            state.value = data;
            isReady.value = true;
            onSuccess(data);
            _context2.next = 25;
            break;
          case 19:
            _context2.prev = 19;
            _context2.t0 = _context2["catch"](10);
            error.value = _context2.t0;
            onError(_context2.t0);
            if (!throwError) {
              _context2.next = 25;
              break;
            }
            throw _context2.t0;
          case 25:
            _context2.prev = 25;
            isLoading.value = false;
            return _context2.finish(25);
          case 28:
            return _context2.abrupt("return", state.value);
          case 29:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[10, 19, 25, 28]]);
    }));
    return _execute.apply(this, arguments);
  }
  if (immediate) execute(delay);
  var shell = {
    state: state,
    isReady: isReady,
    isLoading: isLoading,
    error: error,
    execute: execute
  };
  function waitUntilIsLoaded() {
    return new Promise(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["H" /* until */])(isLoading).toBe(false).then(function () {
        return resolve(shell);
      }).catch(reject);
    });
  }
  return __spreadProps$a(__spreadValues$n({}, shell), {
    then: function then(onFulfilled, onRejected) {
      return waitUntilIsLoaded().then(onFulfilled, onRejected);
    }
  });
}
var defaults = {
  array: function array(v) {
    return JSON.stringify(v);
  },
  object: function object(v) {
    return JSON.stringify(v);
  },
  set: function set(v) {
    return JSON.stringify(Array.from(v));
  },
  map: function map(v) {
    return JSON.stringify(Object.fromEntries(v));
  },
  null: function _null() {
    return "";
  }
};
function getDefaultSerialization(target) {
  if (!target) return defaults.null;
  if (target instanceof Map) return defaults.map;else if (target instanceof Set) return defaults.set;else if (Array.isArray(target)) return defaults.array;else return defaults.object;
}
function useBase64(target, options) {
  var base64 = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])("");
  var promise = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])();
  function execute() {
    if (!__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["l" /* isClient */]) return;
    promise.value = new Promise(function (resolve, reject) {
      try {
        var _target = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(target);
        if (_target == null) {
          resolve("");
        } else if (typeof _target === "string") {
          resolve(blobToBase64(new Blob([_target], {
            type: "text/plain"
          })));
        } else if (_target instanceof Blob) {
          resolve(blobToBase64(_target));
        } else if (_target instanceof ArrayBuffer) {
          resolve(window.btoa(String.fromCharCode.apply(String, _toConsumableArray(new Uint8Array(_target)))));
        } else if (_target instanceof HTMLCanvasElement) {
          resolve(_target.toDataURL(options == null ? void 0 : options.type, options == null ? void 0 : options.quality));
        } else if (_target instanceof HTMLImageElement) {
          var img = _target.cloneNode(false);
          img.crossOrigin = "Anonymous";
          imgLoaded(img).then(function () {
            var canvas = document.createElement("canvas");
            var ctx = canvas.getContext("2d");
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            resolve(canvas.toDataURL(options == null ? void 0 : options.type, options == null ? void 0 : options.quality));
          }).catch(reject);
        } else if (_typeof(_target) === "object") {
          var _serializeFn = (options == null ? void 0 : options.serializer) || getDefaultSerialization(_target);
          var serialized = _serializeFn(_target);
          return resolve(blobToBase64(new Blob([serialized], {
            type: "application/json"
          })));
        } else {
          reject(new Error("target is unsupported types"));
        }
      } catch (error) {
        reject(error);
      }
    });
    promise.value.then(function (res) {
      return base64.value = res;
    });
    return promise.value;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["isRef"])(target) || typeof target === "function") Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(target, execute, {
    immediate: true
  });else execute();
  return {
    base64: base64,
    promise: promise,
    execute: execute
  };
}
function imgLoaded(img) {
  return new Promise(function (resolve, reject) {
    if (!img.complete) {
      img.onload = function () {
        resolve();
      };
      img.onerror = reject;
    } else {
      resolve();
    }
  });
}
function blobToBase64(blob) {
  return new Promise(function (resolve, reject) {
    var fr = new FileReader();
    fr.onload = function (e) {
      resolve(e.target.result);
    };
    fr.onerror = reject;
    fr.readAsDataURL(blob);
  });
}
function useBattery() {
  var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref9$navigator = _ref9.navigator,
    navigator = _ref9$navigator === void 0 ? defaultNavigator : _ref9$navigator;
  var events = ["chargingchange", "chargingtimechange", "dischargingtimechange", "levelchange"];
  var isSupported = useSupported(function () {
    return navigator && "getBattery" in navigator;
  });
  var charging = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  var chargingTime = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(0);
  var dischargingTime = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(0);
  var level = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(1);
  var battery;
  function updateBatteryInfo() {
    charging.value = this.charging;
    chargingTime.value = this.chargingTime || 0;
    dischargingTime.value = this.dischargingTime || 0;
    level.value = this.level;
  }
  if (isSupported.value) {
    navigator.getBattery().then(function (_battery) {
      battery = _battery;
      updateBatteryInfo.call(battery);
      var _iterator4 = _createForOfIteratorHelper(events),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var event = _step4.value;
          useEventListener(battery, event, updateBatteryInfo, {
            passive: true
          });
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    });
  }
  return {
    isSupported: isSupported,
    charging: charging,
    chargingTime: chargingTime,
    dischargingTime: dischargingTime,
    level: level
  };
}
function useBluetooth(options) {
  var _ref10 = options || {},
    _ref10$acceptAllDevic = _ref10.acceptAllDevices,
    acceptAllDevices = _ref10$acceptAllDevic === void 0 ? false : _ref10$acceptAllDevic;
  var _ref11 = options || {},
    _ref11$filters = _ref11.filters,
    filters = _ref11$filters === void 0 ? void 0 : _ref11$filters,
    _ref11$optionalServic = _ref11.optionalServices,
    optionalServices = _ref11$optionalServic === void 0 ? void 0 : _ref11$optionalServic,
    _ref11$navigator = _ref11.navigator,
    navigator = _ref11$navigator === void 0 ? defaultNavigator : _ref11$navigator;
  var isSupported = useSupported(function () {
    return navigator && "bluetooth" in navigator;
  });
  var device = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["shallowRef"])(void 0);
  var error = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["shallowRef"])(null);
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(device, function () {
    connectToBluetoothGATTServer();
  });
  function requestDevice() {
    return _requestDevice.apply(this, arguments);
  }
  function _requestDevice() {
    _requestDevice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (isSupported.value) {
              _context3.next = 2;
              break;
            }
            return _context3.abrupt("return");
          case 2:
            error.value = null;
            if (filters && filters.length > 0) acceptAllDevices = false;
            _context3.prev = 4;
            _context3.next = 7;
            return navigator == null ? void 0 : navigator.bluetooth.requestDevice({
              acceptAllDevices: acceptAllDevices,
              filters: filters,
              optionalServices: optionalServices
            });
          case 7:
            device.value = _context3.sent;
            _context3.next = 13;
            break;
          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3["catch"](4);
            error.value = _context3.t0;
          case 13:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[4, 10]]);
    }));
    return _requestDevice.apply(this, arguments);
  }
  var server = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])();
  var isConnected = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    var _a;
    return ((_a = server.value) == null ? void 0 : _a.connected) || false;
  });
  function connectToBluetoothGATTServer() {
    return _connectToBluetoothGATTServer.apply(this, arguments);
  }
  function _connectToBluetoothGATTServer() {
    _connectToBluetoothGATTServer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            error.value = null;
            if (!(device.value && device.value.gatt)) {
              _context4.next = 12;
              break;
            }
            device.value.addEventListener("gattserverdisconnected", function () {});
            _context4.prev = 3;
            _context4.next = 6;
            return device.value.gatt.connect();
          case 6:
            server.value = _context4.sent;
            _context4.next = 12;
            break;
          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4["catch"](3);
            error.value = _context4.t0;
          case 12:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[3, 9]]);
    }));
    return _connectToBluetoothGATTServer.apply(this, arguments);
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["E" /* tryOnMounted */])(function () {
    var _a;
    if (device.value) (_a = device.value.gatt) == null ? void 0 : _a.connect();
  });
  Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["F" /* tryOnScopeDispose */])(function () {
    var _a;
    if (device.value) (_a = device.value.gatt) == null ? void 0 : _a.disconnect();
  });
  return {
    isSupported: isSupported,
    isConnected: isConnected,
    // Device:
    device: device,
    requestDevice: requestDevice,
    // Server:
    server: server,
    // Errors:
    error: error
  };
}
function useMediaQuery(query) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$window4 = options.window,
    window = _options$window4 === void 0 ? defaultWindow : _options$window4;
  var isSupported = useSupported(function () {
    return window && "matchMedia" in window && typeof window.matchMedia === "function";
  });
  var mediaQuery;
  var matches = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  var cleanup = function cleanup() {
    if (!mediaQuery) return;
    if ("removeEventListener" in mediaQuery) mediaQuery.removeEventListener("change", update);else mediaQuery.removeListener(update);
  };
  var update = function update() {
    if (!isSupported.value) return;
    cleanup();
    mediaQuery = window.matchMedia(Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["B" /* toRef */])(query).value);
    matches.value = !!(mediaQuery == null ? void 0 : mediaQuery.matches);
    if (!mediaQuery) return;
    if ("addEventListener" in mediaQuery) mediaQuery.addEventListener("change", update);else mediaQuery.addListener(update);
  };
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watchEffect"])(update);
  Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["F" /* tryOnScopeDispose */])(function () {
    return cleanup();
  });
  return matches;
}
var breakpointsTailwind = {
  "sm": 640,
  "md": 768,
  "lg": 1024,
  "xl": 1280,
  "2xl": 1536
};
var breakpointsBootstrapV5 = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400
};
var breakpointsVuetify = {
  xs: 600,
  sm: 960,
  md: 1264,
  lg: 1904
};
var breakpointsAntDesign = {
  xs: 480,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1600
};
var breakpointsQuasar = {
  xs: 600,
  sm: 1024,
  md: 1440,
  lg: 1920
};
var breakpointsSematic = {
  mobileS: 320,
  mobileM: 375,
  mobileL: 425,
  tablet: 768,
  laptop: 1024,
  laptopL: 1440,
  desktop4K: 2560
};
var breakpointsMasterCss = {
  "3xs": 360,
  "2xs": 480,
  "xs": 600,
  "sm": 768,
  "md": 1024,
  "lg": 1280,
  "xl": 1440,
  "2xl": 1600,
  "3xl": 1920,
  "4xl": 2560
};
function useBreakpoints(breakpoints) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  function getValue(k, delta) {
    var v = breakpoints[k];
    if (delta != null) v = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["k" /* increaseWithUnit */])(v, delta);
    if (typeof v === "number") v = "".concat(v, "px");
    return v;
  }
  var _options$window5 = options.window,
    window = _options$window5 === void 0 ? defaultWindow : _options$window5;
  function match(query) {
    if (!window) return false;
    return window.matchMedia(query).matches;
  }
  var greaterOrEqual = function greaterOrEqual(k) {
    return useMediaQuery("(min-width: ".concat(getValue(k), ")"), options);
  };
  var shortcutMethods = Object.keys(breakpoints).reduce(function (shortcuts, k) {
    Object.defineProperty(shortcuts, k, {
      get: function get() {
        return greaterOrEqual(k);
      },
      enumerable: true,
      configurable: true
    });
    return shortcuts;
  }, {});
  return Object.assign(shortcutMethods, {
    greater: function greater(k) {
      return useMediaQuery("(min-width: ".concat(getValue(k, 0.1), ")"), options);
    },
    greaterOrEqual: greaterOrEqual,
    smaller: function smaller(k) {
      return useMediaQuery("(max-width: ".concat(getValue(k, -0.1), ")"), options);
    },
    smallerOrEqual: function smallerOrEqual(k) {
      return useMediaQuery("(max-width: ".concat(getValue(k), ")"), options);
    },
    between: function between(a, b) {
      return useMediaQuery("(min-width: ".concat(getValue(a), ") and (max-width: ").concat(getValue(b, -0.1), ")"), options);
    },
    isGreater: function isGreater(k) {
      return match("(min-width: ".concat(getValue(k, 0.1), ")"));
    },
    isGreaterOrEqual: function isGreaterOrEqual(k) {
      return match("(min-width: ".concat(getValue(k), ")"));
    },
    isSmaller: function isSmaller(k) {
      return match("(max-width: ".concat(getValue(k, -0.1), ")"));
    },
    isSmallerOrEqual: function isSmallerOrEqual(k) {
      return match("(max-width: ".concat(getValue(k), ")"));
    },
    isInBetween: function isInBetween(a, b) {
      return match("(min-width: ".concat(getValue(a), ") and (max-width: ").concat(getValue(b, -0.1), ")"));
    },
    current: function current() {
      var points = Object.keys(breakpoints).map(function (i) {
        return [i, greaterOrEqual(i)];
      });
      return Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
        return points.filter(function (_ref12) {
          var _ref13 = _slicedToArray(_ref12, 2),
            v = _ref13[1];
          return v.value;
        }).map(function (_ref14) {
          var _ref15 = _slicedToArray(_ref14, 1),
            k = _ref15[0];
          return k;
        });
      });
    }
  });
}
function useBroadcastChannel(options) {
  var name = options.name,
    _options$window6 = options.window,
    window = _options$window6 === void 0 ? defaultWindow : _options$window6;
  var isSupported = useSupported(function () {
    return window && "BroadcastChannel" in window;
  });
  var isClosed = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  var channel = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])();
  var data = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])();
  var error = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["shallowRef"])(null);
  var post = function post(data2) {
    if (channel.value) channel.value.postMessage(data2);
  };
  var close = function close() {
    if (channel.value) channel.value.close();
    isClosed.value = true;
  };
  if (isSupported.value) {
    Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["E" /* tryOnMounted */])(function () {
      error.value = null;
      channel.value = new BroadcastChannel(name);
      channel.value.addEventListener("message", function (e) {
        data.value = e.data;
      }, {
        passive: true
      });
      channel.value.addEventListener("messageerror", function (e) {
        error.value = e;
      }, {
        passive: true
      });
      channel.value.addEventListener("close", function () {
        isClosed.value = true;
      });
    });
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["F" /* tryOnScopeDispose */])(function () {
    close();
  });
  return {
    isSupported: isSupported,
    channel: channel,
    data: data,
    post: post,
    close: close,
    error: error,
    isClosed: isClosed
  };
}
var __defProp$m = Object.defineProperty;
var __getOwnPropSymbols$p = Object.getOwnPropertySymbols;
var __hasOwnProp$p = Object.prototype.hasOwnProperty;
var __propIsEnum$p = Object.prototype.propertyIsEnumerable;
var __defNormalProp$m = function __defNormalProp$m(obj, key, value) {
  return key in obj ? __defProp$m(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$m = function __spreadValues$m(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$p.call(b, prop)) __defNormalProp$m(a, prop, b[prop]);
  if (__getOwnPropSymbols$p) {
    var _iterator5 = _createForOfIteratorHelper(__getOwnPropSymbols$p(b)),
      _step5;
    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var prop = _step5.value;
        if (__propIsEnum$p.call(b, prop)) __defNormalProp$m(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  }
  return a;
};
var WRITABLE_PROPERTIES = ["hash", "host", "hostname", "href", "pathname", "port", "protocol", "search"];
function useBrowserLocation() {
  var _ref16 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref16$window = _ref16.window,
    window = _ref16$window === void 0 ? defaultWindow : _ref16$window;
  var refs = Object.fromEntries(WRITABLE_PROPERTIES.map(function (key) {
    return [key, Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])()];
  }));
  var _iterator6 = _createForOfIteratorHelper(Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["s" /* objectEntries */])(refs)),
    _step6;
  try {
    var _loop = function _loop() {
      var _step6$value = _slicedToArray(_step6.value, 2),
        key = _step6$value[0],
        ref2 = _step6$value[1];
      Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(ref2, function (value) {
        if (!(window == null ? void 0 : window.location) || window.location[key] === value) return;
        window.location[key] = value;
      });
    };
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }
  var buildState = function buildState(trigger) {
    var _a;
    var _ref17 = (window == null ? void 0 : window.history) || {},
      state2 = _ref17.state,
      length = _ref17.length;
    var _ref18 = (window == null ? void 0 : window.location) || {},
      origin = _ref18.origin;
    var _iterator7 = _createForOfIteratorHelper(WRITABLE_PROPERTIES),
      _step7;
    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var key = _step7.value;
        refs[key].value = (_a = window == null ? void 0 : window.location) == null ? void 0 : _a[key];
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }
    return Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["reactive"])(__spreadValues$m({
      trigger: trigger,
      state: state2,
      length: length,
      origin: origin
    }, refs));
  };
  var state = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(buildState("load"));
  if (window) {
    useEventListener(window, "popstate", function () {
      return state.value = buildState("popstate");
    }, {
      passive: true
    });
    useEventListener(window, "hashchange", function () {
      return state.value = buildState("hashchange");
    }, {
      passive: true
    });
  }
  return state;
}
function useCached(refValue) {
  var comparator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (a, b) {
    return a === b;
  };
  var watchOptions = arguments.length > 2 ? arguments[2] : undefined;
  var cachedValue = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(refValue.value);
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(function () {
    return refValue.value;
  }, function (value) {
    if (!comparator(value, cachedValue.value)) cachedValue.value = value;
  }, watchOptions);
  return cachedValue;
}
function useClipboard() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$navigator = options.navigator,
    navigator = _options$navigator === void 0 ? defaultNavigator : _options$navigator,
    _options$read = options.read,
    read = _options$read === void 0 ? false : _options$read,
    source = options.source,
    _options$copiedDuring = options.copiedDuring,
    copiedDuring = _options$copiedDuring === void 0 ? 1500 : _options$copiedDuring,
    _options$legacy = options.legacy,
    legacy = _options$legacy === void 0 ? false : _options$legacy;
  var events = ["copy", "cut"];
  var isClipboardApiSupported = useSupported(function () {
    return navigator && "clipboard" in navigator;
  });
  var isSupported = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return isClipboardApiSupported.value || legacy;
  });
  var text = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])("");
  var copied = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  var timeout = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["L" /* useTimeoutFn */])(function () {
    return copied.value = false;
  }, copiedDuring);
  function updateText() {
    if (isClipboardApiSupported.value) {
      navigator.clipboard.readText().then(function (value) {
        text.value = value;
      });
    } else {
      text.value = legacyRead();
    }
  }
  if (isSupported.value && read) {
    var _iterator8 = _createForOfIteratorHelper(events),
      _step8;
    try {
      for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
        var event = _step8.value;
        useEventListener(event, updateText);
      }
    } catch (err) {
      _iterator8.e(err);
    } finally {
      _iterator8.f();
    }
  }
  function copy() {
    return _copy.apply(this, arguments);
  }
  function _copy() {
    _copy = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var value,
        _args5 = arguments;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            value = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(source);
            if (!(isSupported.value && value != null)) {
              _context5.next = 11;
              break;
            }
            if (!isClipboardApiSupported.value) {
              _context5.next = 7;
              break;
            }
            _context5.next = 5;
            return navigator.clipboard.writeText(value);
          case 5:
            _context5.next = 8;
            break;
          case 7:
            legacyCopy(value);
          case 8:
            text.value = value;
            copied.value = true;
            timeout.start();
          case 11:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return _copy.apply(this, arguments);
  }
  function legacyCopy(value) {
    var ta = document.createElement("textarea");
    ta.value = value != null ? value : "";
    ta.style.position = "absolute";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    ta.remove();
  }
  function legacyRead() {
    var _a, _b, _c;
    return (_c = (_b = (_a = document == null ? void 0 : document.getSelection) == null ? void 0 : _a.call(document)) == null ? void 0 : _b.toString()) != null ? _c : "";
  }
  return {
    isSupported: isSupported,
    text: text,
    copied: copied,
    copy: copy
  };
}
var __defProp$l = Object.defineProperty;
var __defProps$9 = Object.defineProperties;
var __getOwnPropDescs$9 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$o = Object.getOwnPropertySymbols;
var __hasOwnProp$o = Object.prototype.hasOwnProperty;
var __propIsEnum$o = Object.prototype.propertyIsEnumerable;
var __defNormalProp$l = function __defNormalProp$l(obj, key, value) {
  return key in obj ? __defProp$l(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$l = function __spreadValues$l(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$o.call(b, prop)) __defNormalProp$l(a, prop, b[prop]);
  if (__getOwnPropSymbols$o) {
    var _iterator9 = _createForOfIteratorHelper(__getOwnPropSymbols$o(b)),
      _step9;
    try {
      for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
        var prop = _step9.value;
        if (__propIsEnum$o.call(b, prop)) __defNormalProp$l(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator9.e(err);
    } finally {
      _iterator9.f();
    }
  }
  return a;
};
var __spreadProps$9 = function __spreadProps$9(a, b) {
  return __defProps$9(a, __getOwnPropDescs$9(b));
};
function cloneFnJSON(source) {
  return JSON.parse(JSON.stringify(source));
}
function useCloned(source) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var cloned = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])({});
  var manual = options.manual,
    _options$clone = options.clone,
    clone = _options$clone === void 0 ? cloneFnJSON : _options$clone,
    _options$deep = options.deep,
    deep = _options$deep === void 0 ? true : _options$deep,
    _options$immediate2 = options.immediate,
    immediate = _options$immediate2 === void 0 ? true : _options$immediate2;
  function sync() {
    cloned.value = clone(Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(source));
  }
  if (!manual && Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["isRef"])(source)) {
    Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(source, sync, __spreadProps$9(__spreadValues$l({}, options), {
      deep: deep,
      immediate: immediate
    }));
  } else {
    sync();
  }
  return {
    cloned: cloned,
    sync: sync
  };
}
var _global = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
var globalKey = "__vueuse_ssr_handlers__";
var handlers = /* @__PURE__ */getHandlers();
function getHandlers() {
  if (!(globalKey in _global)) _global[globalKey] = _global[globalKey] || {};
  return _global[globalKey];
}
function getSSRHandler(key, fallback) {
  return handlers[key] || fallback;
}
function setSSRHandler(key, fn) {
  handlers[key] = fn;
}
function guessSerializerType(rawInit) {
  return rawInit == null ? "any" : rawInit instanceof Set ? "set" : rawInit instanceof Map ? "map" : rawInit instanceof Date ? "date" : typeof rawInit === "boolean" ? "boolean" : typeof rawInit === "string" ? "string" : _typeof(rawInit) === "object" ? "object" : !Number.isNaN(rawInit) ? "number" : "any";
}
var __defProp$k = Object.defineProperty;
var __getOwnPropSymbols$n = Object.getOwnPropertySymbols;
var __hasOwnProp$n = Object.prototype.hasOwnProperty;
var __propIsEnum$n = Object.prototype.propertyIsEnumerable;
var __defNormalProp$k = function __defNormalProp$k(obj, key, value) {
  return key in obj ? __defProp$k(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$k = function __spreadValues$k(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$n.call(b, prop)) __defNormalProp$k(a, prop, b[prop]);
  if (__getOwnPropSymbols$n) {
    var _iterator10 = _createForOfIteratorHelper(__getOwnPropSymbols$n(b)),
      _step10;
    try {
      for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
        var prop = _step10.value;
        if (__propIsEnum$n.call(b, prop)) __defNormalProp$k(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator10.e(err);
    } finally {
      _iterator10.f();
    }
  }
  return a;
};
var StorageSerializers = {
  boolean: {
    read: function read(v) {
      return v === "true";
    },
    write: function write(v) {
      return String(v);
    }
  },
  object: {
    read: function read(v) {
      return JSON.parse(v);
    },
    write: function write(v) {
      return JSON.stringify(v);
    }
  },
  number: {
    read: function read(v) {
      return Number.parseFloat(v);
    },
    write: function write(v) {
      return String(v);
    }
  },
  any: {
    read: function read(v) {
      return v;
    },
    write: function write(v) {
      return String(v);
    }
  },
  string: {
    read: function read(v) {
      return v;
    },
    write: function write(v) {
      return String(v);
    }
  },
  map: {
    read: function read(v) {
      return new Map(JSON.parse(v));
    },
    write: function write(v) {
      return JSON.stringify(Array.from(v.entries()));
    }
  },
  set: {
    read: function read(v) {
      return new Set(JSON.parse(v));
    },
    write: function write(v) {
      return JSON.stringify(Array.from(v));
    }
  },
  date: {
    read: function read(v) {
      return new Date(v);
    },
    write: function write(v) {
      return v.toISOString();
    }
  }
};
var customStorageEventName = "vueuse-storage";
function useStorage(key, defaults, storage) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _a;
  var _options$flush = options.flush,
    flush = _options$flush === void 0 ? "pre" : _options$flush,
    _options$deep2 = options.deep,
    deep = _options$deep2 === void 0 ? true : _options$deep2,
    _options$listenToStor = options.listenToStorageChanges,
    listenToStorageChanges = _options$listenToStor === void 0 ? true : _options$listenToStor,
    _options$writeDefault = options.writeDefaults,
    writeDefaults = _options$writeDefault === void 0 ? true : _options$writeDefault,
    _options$mergeDefault = options.mergeDefaults,
    mergeDefaults = _options$mergeDefault === void 0 ? false : _options$mergeDefault,
    shallow = options.shallow,
    _options$window7 = options.window,
    window = _options$window7 === void 0 ? defaultWindow : _options$window7,
    eventFilter = options.eventFilter,
    _options$onError2 = options.onError,
    onError = _options$onError2 === void 0 ? function (e) {
      console.error(e);
    } : _options$onError2;
  var data = (shallow ? __WEBPACK_IMPORTED_MODULE_1_vue_demi__["shallowRef"] : __WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(defaults);
  if (!storage) {
    try {
      storage = getSSRHandler("getDefaultStorage", function () {
        var _a2;
        return (_a2 = defaultWindow) == null ? void 0 : _a2.localStorage;
      })();
    } catch (e) {
      onError(e);
    }
  }
  if (!storage) return data;
  var rawInit = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(defaults);
  var type = guessSerializerType(rawInit);
  var serializer = (_a = options.serializer) != null ? _a : StorageSerializers[type];
  var _pausableWatch = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["w" /* pausableWatch */])(data, function () {
      return write(data.value);
    }, {
      flush: flush,
      deep: deep,
      eventFilter: eventFilter
    }),
    pauseWatch = _pausableWatch.pause,
    resumeWatch = _pausableWatch.resume;
  if (window && listenToStorageChanges) {
    useEventListener(window, "storage", update);
    useEventListener(window, customStorageEventName, updateFromCustomEvent);
  }
  update();
  return data;
  function write(v) {
    try {
      if (v == null) {
        storage.removeItem(key);
      } else {
        var serialized = serializer.write(v);
        var oldValue = storage.getItem(key);
        if (oldValue !== serialized) {
          storage.setItem(key, serialized);
          if (window) {
            window.dispatchEvent(new CustomEvent(customStorageEventName, {
              detail: {
                key: key,
                oldValue: oldValue,
                newValue: serialized,
                storageArea: storage
              }
            }));
          }
        }
      }
    } catch (e) {
      onError(e);
    }
  }
  function read(event) {
    var rawValue = event ? event.newValue : storage.getItem(key);
    if (rawValue == null) {
      if (writeDefaults && rawInit !== null) storage.setItem(key, serializer.write(rawInit));
      return rawInit;
    } else if (!event && mergeDefaults) {
      var value = serializer.read(rawValue);
      if (typeof mergeDefaults === "function") return mergeDefaults(value, rawInit);else if (type === "object" && !Array.isArray(value)) return __spreadValues$k(__spreadValues$k({}, rawInit), value);
      return value;
    } else if (typeof rawValue !== "string") {
      return rawValue;
    } else {
      return serializer.read(rawValue);
    }
  }
  function updateFromCustomEvent(event) {
    update(event.detail);
  }
  function update(event) {
    if (event && event.storageArea !== storage) return;
    if (event && event.key == null) {
      data.value = rawInit;
      return;
    }
    if (event && event.key !== key) return;
    pauseWatch();
    try {
      data.value = read(event);
    } catch (e) {
      onError(e);
    } finally {
      if (event) Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["nextTick"])(resumeWatch);else resumeWatch();
    }
  }
}
function usePreferredDark(options) {
  return useMediaQuery("(prefers-color-scheme: dark)", options);
}
var __defProp$j = Object.defineProperty;
var __getOwnPropSymbols$m = Object.getOwnPropertySymbols;
var __hasOwnProp$m = Object.prototype.hasOwnProperty;
var __propIsEnum$m = Object.prototype.propertyIsEnumerable;
var __defNormalProp$j = function __defNormalProp$j(obj, key, value) {
  return key in obj ? __defProp$j(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$j = function __spreadValues$j(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$m.call(b, prop)) __defNormalProp$j(a, prop, b[prop]);
  if (__getOwnPropSymbols$m) {
    var _iterator11 = _createForOfIteratorHelper(__getOwnPropSymbols$m(b)),
      _step11;
    try {
      for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
        var prop = _step11.value;
        if (__propIsEnum$m.call(b, prop)) __defNormalProp$j(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator11.e(err);
    } finally {
      _iterator11.f();
    }
  }
  return a;
};
function useColorMode() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$selector = options.selector,
    selector = _options$selector === void 0 ? "html" : _options$selector,
    _options$attribute = options.attribute,
    attribute = _options$attribute === void 0 ? "class" : _options$attribute,
    _options$initialValue = options.initialValue,
    initialValue = _options$initialValue === void 0 ? "auto" : _options$initialValue,
    _options$window8 = options.window,
    window = _options$window8 === void 0 ? defaultWindow : _options$window8,
    storage = options.storage,
    _options$storageKey = options.storageKey,
    storageKey = _options$storageKey === void 0 ? "vueuse-color-scheme" : _options$storageKey,
    _options$listenToStor2 = options.listenToStorageChanges,
    listenToStorageChanges = _options$listenToStor2 === void 0 ? true : _options$listenToStor2,
    storageRef = options.storageRef,
    emitAuto = options.emitAuto,
    _options$disableTrans = options.disableTransition,
    disableTransition = _options$disableTrans === void 0 ? true : _options$disableTrans;
  var modes = __spreadValues$j({
    auto: "",
    light: "light",
    dark: "dark"
  }, options.modes || {});
  var preferredDark = usePreferredDark({
    window: window
  });
  var system = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return preferredDark.value ? "dark" : "light";
  });
  var store = storageRef || (storageKey == null ? Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["B" /* toRef */])(initialValue) : useStorage(storageKey, initialValue, storage, {
    window: window,
    listenToStorageChanges: listenToStorageChanges
  }));
  var state = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return store.value === "auto" ? system.value : store.value;
  });
  var updateHTMLAttrs = getSSRHandler("updateHTMLAttrs", function (selector2, attribute2, value) {
    var el = typeof selector2 === "string" ? window == null ? void 0 : window.document.querySelector(selector2) : unrefElement(selector2);
    if (!el) return;
    var style;
    if (disableTransition) {
      style = window.document.createElement("style");
      style.appendChild(document.createTextNode("*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}"));
      window.document.head.appendChild(style);
    }
    if (attribute2 === "class") {
      var current = value.split(/\s/g);
      Object.values(modes).flatMap(function (i) {
        return (i || "").split(/\s/g);
      }).filter(Boolean).forEach(function (v) {
        if (current.includes(v)) el.classList.add(v);else el.classList.remove(v);
      });
    } else {
      el.setAttribute(attribute2, value);
    }
    if (disableTransition) {
      window.getComputedStyle(style).opacity;
      document.head.removeChild(style);
    }
  });
  function defaultOnChanged(mode) {
    var _a;
    updateHTMLAttrs(selector, attribute, (_a = modes[mode]) != null ? _a : mode);
  }
  function onChanged(mode) {
    if (options.onChanged) options.onChanged(mode, defaultOnChanged);else defaultOnChanged(mode);
  }
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(state, onChanged, {
    flush: "post",
    immediate: true
  });
  Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["E" /* tryOnMounted */])(function () {
    return onChanged(state.value);
  });
  var auto = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])({
    get: function get() {
      return emitAuto ? store.value : state.value;
    },
    set: function set(v) {
      store.value = v;
    }
  });
  try {
    return Object.assign(auto, {
      store: store,
      system: system,
      state: state
    });
  } catch (e) {
    return auto;
  }
}
function useConfirmDialog() {
  var revealed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  var confirmHook = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["e" /* createEventHook */])();
  var cancelHook = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["e" /* createEventHook */])();
  var revealHook = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["e" /* createEventHook */])();
  var _resolve = __WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["q" /* noop */];
  var reveal = function reveal(data) {
    revealHook.trigger(data);
    revealed.value = true;
    return new Promise(function (resolve) {
      _resolve = resolve;
    });
  };
  var confirm = function confirm(data) {
    revealed.value = false;
    confirmHook.trigger(data);
    _resolve({
      data: data,
      isCanceled: false
    });
  };
  var cancel = function cancel(data) {
    revealed.value = false;
    cancelHook.trigger(data);
    _resolve({
      data: data,
      isCanceled: true
    });
  };
  return {
    isRevealed: Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
      return revealed.value;
    }),
    reveal: reveal,
    confirm: confirm,
    cancel: cancel,
    onReveal: revealHook.on,
    onConfirm: confirmHook.on,
    onCancel: cancelHook.on
  };
}
var __getOwnPropSymbols$l = Object.getOwnPropertySymbols;
var __hasOwnProp$l = Object.prototype.hasOwnProperty;
var __propIsEnum$l = Object.prototype.propertyIsEnumerable;
var __objRest$3 = function __objRest$3(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$l.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$l) {
    var _iterator12 = _createForOfIteratorHelper(__getOwnPropSymbols$l(source)),
      _step12;
    try {
      for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
        var prop = _step12.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$l.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator12.e(err);
    } finally {
      _iterator12.f();
    }
  }
  return target;
};
function useMutationObserver(target, callback) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _a = options,
    _a$window = _a.window,
    window = _a$window === void 0 ? defaultWindow : _a$window,
    mutationOptions = __objRest$3(_a, ["window"]);
  var observer;
  var isSupported = useSupported(function () {
    return window && "MutationObserver" in window;
  });
  var cleanup = function cleanup() {
    if (observer) {
      observer.disconnect();
      observer = void 0;
    }
  };
  var stopWatch = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(function () {
    return unrefElement(target);
  }, function (el) {
    cleanup();
    if (isSupported.value && window && el) {
      observer = new MutationObserver(callback);
      observer.observe(el, mutationOptions);
    }
  }, {
    immediate: true
  });
  var stop = function stop() {
    cleanup();
    stopWatch();
  };
  Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["F" /* tryOnScopeDispose */])(stop);
  return {
    isSupported: isSupported,
    stop: stop
  };
}
function useCssVar(prop, target) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$window9 = options.window,
    window = _options$window9 === void 0 ? defaultWindow : _options$window9,
    _options$initialValue2 = options.initialValue,
    initialValue = _options$initialValue2 === void 0 ? "" : _options$initialValue2,
    _options$observe = options.observe,
    observe = _options$observe === void 0 ? false : _options$observe;
  var variable = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(initialValue);
  var elRef = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    var _a;
    return unrefElement(target) || ((_a = window == null ? void 0 : window.document) == null ? void 0 : _a.documentElement);
  });
  function updateCssVar() {
    var _a;
    var key = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(prop);
    var el = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(elRef);
    if (el && window) {
      var value = (_a = window.getComputedStyle(el).getPropertyValue(key)) == null ? void 0 : _a.trim();
      variable.value = value || initialValue;
    }
  }
  if (observe) {
    useMutationObserver(elRef, updateCssVar, {
      attributes: true,
      window: window
    });
  }
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])([elRef, function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(prop);
  }], updateCssVar, {
    immediate: true
  });
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(variable, function (val) {
    var _a;
    if ((_a = elRef.value) == null ? void 0 : _a.style) elRef.value.style.setProperty(Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(prop), val);
  });
  return variable;
}
function useCurrentElement() {
  var vm = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["getCurrentInstance"])();
  var currentElement = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["c" /* computedWithControl */])(function () {
    return null;
  }, function () {
    return vm.proxy.$el;
  });
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["onUpdated"])(currentElement.trigger);
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["onMounted"])(currentElement.trigger);
  return currentElement;
}
function useCycleList(list, options) {
  var state = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["shallowRef"])(getInitialValue());
  var listRef = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["B" /* toRef */])(list);
  var index = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])({
    get: function get() {
      var _a;
      var targetList = listRef.value;
      var index2 = (options == null ? void 0 : options.getIndexOf) ? options.getIndexOf(state.value, targetList) : targetList.indexOf(state.value);
      if (index2 < 0) index2 = (_a = options == null ? void 0 : options.fallbackIndex) != null ? _a : 0;
      return index2;
    },
    set: function set(v) {
      _set(v);
    }
  });
  function _set(i) {
    var targetList = listRef.value;
    var length = targetList.length;
    var index2 = (i % length + length) % length;
    var value = targetList[index2];
    state.value = value;
    return value;
  }
  function shift() {
    var delta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return _set(index.value + delta);
  }
  function next() {
    var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return shift(n);
  }
  function prev() {
    var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return shift(-n);
  }
  function getInitialValue() {
    var _a, _b;
    return (_b = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])((_a = options == null ? void 0 : options.initialValue) != null ? _a : Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(list)[0])) != null ? _b : void 0;
  }
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(listRef, function () {
    return _set(index.value);
  });
  return {
    state: state,
    index: index,
    next: next,
    prev: prev
  };
}
var __defProp$i = Object.defineProperty;
var __defProps$8 = Object.defineProperties;
var __getOwnPropDescs$8 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$k = Object.getOwnPropertySymbols;
var __hasOwnProp$k = Object.prototype.hasOwnProperty;
var __propIsEnum$k = Object.prototype.propertyIsEnumerable;
var __defNormalProp$i = function __defNormalProp$i(obj, key, value) {
  return key in obj ? __defProp$i(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$i = function __spreadValues$i(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$k.call(b, prop)) __defNormalProp$i(a, prop, b[prop]);
  if (__getOwnPropSymbols$k) {
    var _iterator13 = _createForOfIteratorHelper(__getOwnPropSymbols$k(b)),
      _step13;
    try {
      for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
        var prop = _step13.value;
        if (__propIsEnum$k.call(b, prop)) __defNormalProp$i(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator13.e(err);
    } finally {
      _iterator13.f();
    }
  }
  return a;
};
var __spreadProps$8 = function __spreadProps$8(a, b) {
  return __defProps$8(a, __getOwnPropDescs$8(b));
};
function useDark() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$valueDark = options.valueDark,
    valueDark = _options$valueDark === void 0 ? "dark" : _options$valueDark,
    _options$valueLight = options.valueLight,
    valueLight = _options$valueLight === void 0 ? "" : _options$valueLight;
  var mode = useColorMode(__spreadProps$8(__spreadValues$i({}, options), {
    onChanged: function onChanged(mode2, defaultHandler) {
      var _a;
      if (options.onChanged) (_a = options.onChanged) == null ? void 0 : _a.call(options, mode2 === "dark", defaultHandler, mode2);else defaultHandler(mode2);
    },
    modes: {
      dark: valueDark,
      light: valueLight
    }
  }));
  var isDark = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])({
    get: function get() {
      return mode.value === "dark";
    },
    set: function set(v) {
      var modeVal = v ? "dark" : "light";
      if (mode.system.value === modeVal) mode.value = "auto";else mode.value = modeVal;
    }
  });
  return isDark;
}
function fnBypass(v) {
  return v;
}
function fnSetSource(source, value) {
  return source.value = value;
}
function defaultDump(clone) {
  return clone ? typeof clone === "function" ? clone : cloneFnJSON : fnBypass;
}
function defaultParse(clone) {
  return clone ? typeof clone === "function" ? clone : cloneFnJSON : fnBypass;
}
function useManualRefHistory(source) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$clone2 = options.clone,
    clone = _options$clone2 === void 0 ? false : _options$clone2,
    _options$dump = options.dump,
    dump = _options$dump === void 0 ? defaultDump(clone) : _options$dump,
    _options$parse = options.parse,
    parse = _options$parse === void 0 ? defaultParse(clone) : _options$parse,
    _options$setSource = options.setSource,
    setSource = _options$setSource === void 0 ? fnSetSource : _options$setSource;
  function _createHistoryRecord() {
    return Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["markRaw"])({
      snapshot: dump(source.value),
      timestamp: Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["A" /* timestamp */])()
    });
  }
  var last = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(_createHistoryRecord());
  var undoStack = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])([]);
  var redoStack = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])([]);
  var _setSource = function _setSource(record) {
    setSource(source, parse(record.snapshot));
    last.value = record;
  };
  var commit = function commit() {
    undoStack.value.unshift(last.value);
    last.value = _createHistoryRecord();
    if (options.capacity && undoStack.value.length > options.capacity) undoStack.value.splice(options.capacity, Infinity);
    if (redoStack.value.length) redoStack.value.splice(0, redoStack.value.length);
  };
  var clear = function clear() {
    undoStack.value.splice(0, undoStack.value.length);
    redoStack.value.splice(0, redoStack.value.length);
  };
  var undo = function undo() {
    var state = undoStack.value.shift();
    if (state) {
      redoStack.value.unshift(last.value);
      _setSource(state);
    }
  };
  var redo = function redo() {
    var state = redoStack.value.shift();
    if (state) {
      undoStack.value.unshift(last.value);
      _setSource(state);
    }
  };
  var reset = function reset() {
    _setSource(last.value);
  };
  var history = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return [last.value].concat(_toConsumableArray(undoStack.value));
  });
  var canUndo = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return undoStack.value.length > 0;
  });
  var canRedo = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return redoStack.value.length > 0;
  });
  return {
    source: source,
    undoStack: undoStack,
    redoStack: redoStack,
    last: last,
    history: history,
    canUndo: canUndo,
    canRedo: canRedo,
    clear: clear,
    commit: commit,
    reset: reset,
    undo: undo,
    redo: redo
  };
}
var __defProp$h = Object.defineProperty;
var __defProps$7 = Object.defineProperties;
var __getOwnPropDescs$7 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$j = Object.getOwnPropertySymbols;
var __hasOwnProp$j = Object.prototype.hasOwnProperty;
var __propIsEnum$j = Object.prototype.propertyIsEnumerable;
var __defNormalProp$h = function __defNormalProp$h(obj, key, value) {
  return key in obj ? __defProp$h(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$h = function __spreadValues$h(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$j.call(b, prop)) __defNormalProp$h(a, prop, b[prop]);
  if (__getOwnPropSymbols$j) {
    var _iterator14 = _createForOfIteratorHelper(__getOwnPropSymbols$j(b)),
      _step14;
    try {
      for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
        var prop = _step14.value;
        if (__propIsEnum$j.call(b, prop)) __defNormalProp$h(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator14.e(err);
    } finally {
      _iterator14.f();
    }
  }
  return a;
};
var __spreadProps$7 = function __spreadProps$7(a, b) {
  return __defProps$7(a, __getOwnPropDescs$7(b));
};
function useRefHistory(source) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$deep3 = options.deep,
    deep = _options$deep3 === void 0 ? false : _options$deep3,
    _options$flush2 = options.flush,
    flush = _options$flush2 === void 0 ? "pre" : _options$flush2,
    eventFilter = options.eventFilter;
  var _pausableFilter = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["v" /* pausableFilter */])(eventFilter),
    composedFilter = _pausableFilter.eventFilter,
    pause = _pausableFilter.pause,
    resumeTracking = _pausableFilter.resume,
    isTracking = _pausableFilter.isActive;
  var _watchIgnorable = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["M" /* watchIgnorable */])(source, commit, {
      deep: deep,
      flush: flush,
      eventFilter: composedFilter
    }),
    ignoreUpdates = _watchIgnorable.ignoreUpdates,
    ignorePrevAsyncUpdates = _watchIgnorable.ignorePrevAsyncUpdates,
    stop = _watchIgnorable.stop;
  function setSource(source2, value) {
    ignorePrevAsyncUpdates();
    ignoreUpdates(function () {
      source2.value = value;
    });
  }
  var manualHistory = useManualRefHistory(source, __spreadProps$7(__spreadValues$h({}, options), {
    clone: options.clone || deep,
    setSource: setSource
  }));
  var clear = manualHistory.clear,
    manualCommit = manualHistory.commit;
  function commit() {
    ignorePrevAsyncUpdates();
    manualCommit();
  }
  function resume(commitNow) {
    resumeTracking();
    if (commitNow) commit();
  }
  function batch(fn) {
    var canceled = false;
    var cancel = function cancel() {
      return canceled = true;
    };
    ignoreUpdates(function () {
      fn(cancel);
    });
    if (!canceled) commit();
  }
  function dispose() {
    stop();
    clear();
  }
  return __spreadProps$7(__spreadValues$h({}, manualHistory), {
    isTracking: isTracking,
    pause: pause,
    resume: resume,
    commit: commit,
    batch: batch,
    dispose: dispose
  });
}
var __defProp$g = Object.defineProperty;
var __defProps$6 = Object.defineProperties;
var __getOwnPropDescs$6 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$i = Object.getOwnPropertySymbols;
var __hasOwnProp$i = Object.prototype.hasOwnProperty;
var __propIsEnum$i = Object.prototype.propertyIsEnumerable;
var __defNormalProp$g = function __defNormalProp$g(obj, key, value) {
  return key in obj ? __defProp$g(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$g = function __spreadValues$g(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$i.call(b, prop)) __defNormalProp$g(a, prop, b[prop]);
  if (__getOwnPropSymbols$i) {
    var _iterator15 = _createForOfIteratorHelper(__getOwnPropSymbols$i(b)),
      _step15;
    try {
      for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
        var prop = _step15.value;
        if (__propIsEnum$i.call(b, prop)) __defNormalProp$g(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator15.e(err);
    } finally {
      _iterator15.f();
    }
  }
  return a;
};
var __spreadProps$6 = function __spreadProps$6(a, b) {
  return __defProps$6(a, __getOwnPropDescs$6(b));
};
function useDebouncedRefHistory(source) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var filter = options.debounce ? Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["h" /* debounceFilter */])(options.debounce) : void 0;
  var history = useRefHistory(source, __spreadProps$6(__spreadValues$g({}, options), {
    eventFilter: filter
  }));
  return __spreadValues$g({}, history);
}
function useDeviceMotion() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$window10 = options.window,
    window = _options$window10 === void 0 ? defaultWindow : _options$window10,
    _options$eventFilter = options.eventFilter,
    eventFilter = _options$eventFilter === void 0 ? __WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["a" /* bypassFilter */] : _options$eventFilter;
  var acceleration = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])({
    x: null,
    y: null,
    z: null
  });
  var rotationRate = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])({
    alpha: null,
    beta: null,
    gamma: null
  });
  var interval = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(0);
  var accelerationIncludingGravity = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])({
    x: null,
    y: null,
    z: null
  });
  if (window) {
    var onDeviceMotion = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["f" /* createFilterWrapper */])(eventFilter, function (event) {
      acceleration.value = event.acceleration;
      accelerationIncludingGravity.value = event.accelerationIncludingGravity;
      rotationRate.value = event.rotationRate;
      interval.value = event.interval;
    });
    useEventListener(window, "devicemotion", onDeviceMotion);
  }
  return {
    acceleration: acceleration,
    accelerationIncludingGravity: accelerationIncludingGravity,
    rotationRate: rotationRate,
    interval: interval
  };
}
function useDeviceOrientation() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$window11 = options.window,
    window = _options$window11 === void 0 ? defaultWindow : _options$window11;
  var isSupported = useSupported(function () {
    return window && "DeviceOrientationEvent" in window;
  });
  var isAbsolute = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  var alpha = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(null);
  var beta = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(null);
  var gamma = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(null);
  if (window && isSupported.value) {
    useEventListener(window, "deviceorientation", function (event) {
      isAbsolute.value = event.absolute;
      alpha.value = event.alpha;
      beta.value = event.beta;
      gamma.value = event.gamma;
    });
  }
  return {
    isSupported: isSupported,
    isAbsolute: isAbsolute,
    alpha: alpha,
    beta: beta,
    gamma: gamma
  };
}
function useDevicePixelRatio() {
  var _ref19 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref19$window = _ref19.window,
    window = _ref19$window === void 0 ? defaultWindow : _ref19$window;
  var pixelRatio = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(1);
  if (window) {
    var observe = function observe() {
        pixelRatio.value = window.devicePixelRatio;
        cleanup();
        media = window.matchMedia("(resolution: ".concat(pixelRatio.value, "dppx)"));
        media.addEventListener("change", observe, {
          once: true
        });
      },
      cleanup = function cleanup() {
        media == null ? void 0 : media.removeEventListener("change", observe);
      };
    var media;
    observe();
    Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["F" /* tryOnScopeDispose */])(cleanup);
  }
  return {
    pixelRatio: pixelRatio
  };
}
function usePermission(permissionDesc) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$controls = options.controls,
    controls = _options$controls === void 0 ? false : _options$controls,
    _options$navigator2 = options.navigator,
    navigator = _options$navigator2 === void 0 ? defaultNavigator : _options$navigator2;
  var isSupported = useSupported(function () {
    return navigator && "permissions" in navigator;
  });
  var permissionStatus;
  var desc = typeof permissionDesc === "string" ? {
    name: permissionDesc
  } : permissionDesc;
  var state = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])();
  var onChange = function onChange() {
    if (permissionStatus) state.value = permissionStatus.state;
  };
  var query = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["g" /* createSingletonPromise */])( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          if (isSupported.value) {
            _context6.next = 2;
            break;
          }
          return _context6.abrupt("return");
        case 2:
          if (permissionStatus) {
            _context6.next = 14;
            break;
          }
          _context6.prev = 3;
          _context6.next = 6;
          return navigator.permissions.query(desc);
        case 6:
          permissionStatus = _context6.sent;
          useEventListener(permissionStatus, "change", onChange);
          onChange();
          _context6.next = 14;
          break;
        case 11:
          _context6.prev = 11;
          _context6.t0 = _context6["catch"](3);
          state.value = "prompt";
        case 14:
          return _context6.abrupt("return", permissionStatus);
        case 15:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[3, 11]]);
  })));
  query();
  if (controls) {
    return {
      state: state,
      isSupported: isSupported,
      query: query
    };
  } else {
    return state;
  }
}
function useDevicesList() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$navigator3 = options.navigator,
    navigator = _options$navigator3 === void 0 ? defaultNavigator : _options$navigator3,
    _options$requestPermi = options.requestPermissions,
    requestPermissions = _options$requestPermi === void 0 ? false : _options$requestPermi,
    _options$constraints = options.constraints,
    constraints = _options$constraints === void 0 ? {
      audio: true,
      video: true
    } : _options$constraints,
    onUpdated = options.onUpdated;
  var devices = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])([]);
  var videoInputs = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return devices.value.filter(function (i) {
      return i.kind === "videoinput";
    });
  });
  var audioInputs = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return devices.value.filter(function (i) {
      return i.kind === "audioinput";
    });
  });
  var audioOutputs = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return devices.value.filter(function (i) {
      return i.kind === "audiooutput";
    });
  });
  var isSupported = useSupported(function () {
    return navigator && navigator.mediaDevices && navigator.mediaDevices.enumerateDevices;
  });
  var permissionGranted = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  var stream;
  function update() {
    return _update.apply(this, arguments);
  }
  function _update() {
    _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            if (isSupported.value) {
              _context7.next = 2;
              break;
            }
            return _context7.abrupt("return");
          case 2:
            _context7.next = 4;
            return navigator.mediaDevices.enumerateDevices();
          case 4:
            devices.value = _context7.sent;
            onUpdated == null ? void 0 : onUpdated(devices.value);
            if (stream) {
              stream.getTracks().forEach(function (t) {
                return t.stop();
              });
              stream = null;
            }
          case 7:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return _update.apply(this, arguments);
  }
  function ensurePermissions() {
    return _ensurePermissions.apply(this, arguments);
  }
  function _ensurePermissions() {
    _ensurePermissions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
      var _usePermission, state, query;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            if (isSupported.value) {
              _context8.next = 2;
              break;
            }
            return _context8.abrupt("return", false);
          case 2:
            if (!permissionGranted.value) {
              _context8.next = 4;
              break;
            }
            return _context8.abrupt("return", true);
          case 4:
            _usePermission = usePermission("camera", {
              controls: true
            }), state = _usePermission.state, query = _usePermission.query;
            _context8.next = 7;
            return query();
          case 7:
            if (!(state.value !== "granted")) {
              _context8.next = 15;
              break;
            }
            _context8.next = 10;
            return navigator.mediaDevices.getUserMedia(constraints);
          case 10:
            stream = _context8.sent;
            update();
            permissionGranted.value = true;
            _context8.next = 16;
            break;
          case 15:
            permissionGranted.value = true;
          case 16:
            return _context8.abrupt("return", permissionGranted.value);
          case 17:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return _ensurePermissions.apply(this, arguments);
  }
  if (isSupported.value) {
    if (requestPermissions) ensurePermissions();
    useEventListener(navigator.mediaDevices, "devicechange", update);
    update();
  }
  return {
    devices: devices,
    ensurePermissions: ensurePermissions,
    permissionGranted: permissionGranted,
    videoInputs: videoInputs,
    audioInputs: audioInputs,
    audioOutputs: audioOutputs,
    isSupported: isSupported
  };
}
function useDisplayMedia() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _a;
  var enabled = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])((_a = options.enabled) != null ? _a : false);
  var video = options.video;
  var audio = options.audio;
  var _options$navigator4 = options.navigator,
    navigator = _options$navigator4 === void 0 ? defaultNavigator : _options$navigator4;
  var isSupported = useSupported(function () {
    var _a2;
    return (_a2 = navigator == null ? void 0 : navigator.mediaDevices) == null ? void 0 : _a2.getDisplayMedia;
  });
  var constraint = {
    audio: audio,
    video: video
  };
  var stream = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["shallowRef"])();
  function _start() {
    return _start2.apply(this, arguments);
  }
  function _start2() {
    _start2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            if (!(!isSupported.value || stream.value)) {
              _context9.next = 2;
              break;
            }
            return _context9.abrupt("return");
          case 2:
            _context9.next = 4;
            return navigator.mediaDevices.getDisplayMedia(constraint);
          case 4:
            stream.value = _context9.sent;
            return _context9.abrupt("return", stream.value);
          case 6:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));
    return _start2.apply(this, arguments);
  }
  function _stop() {
    return _stop2.apply(this, arguments);
  }
  function _stop2() {
    _stop2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
      var _a2;
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            (_a2 = stream.value) == null ? void 0 : _a2.getTracks().forEach(function (t) {
              return t.stop();
            });
            stream.value = void 0;
          case 2:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }));
    return _stop2.apply(this, arguments);
  }
  function stop() {
    _stop();
    enabled.value = false;
  }
  function start() {
    return _start3.apply(this, arguments);
  }
  function _start3() {
    _start3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
      return _regeneratorRuntime().wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            _context11.next = 2;
            return _start();
          case 2:
            if (stream.value) enabled.value = true;
            return _context11.abrupt("return", stream.value);
          case 4:
          case "end":
            return _context11.stop();
        }
      }, _callee11);
    }));
    return _start3.apply(this, arguments);
  }
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(enabled, function (v) {
    if (v) _start();else _stop();
  }, {
    immediate: true
  });
  return {
    isSupported: isSupported,
    stream: stream,
    start: start,
    stop: stop,
    enabled: enabled
  };
}
function useDocumentVisibility() {
  var _ref21 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref21$document = _ref21.document,
    document = _ref21$document === void 0 ? defaultDocument : _ref21$document;
  if (!document) return Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])("visible");
  var visibility = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(document.visibilityState);
  useEventListener(document, "visibilitychange", function () {
    visibility.value = document.visibilityState;
  });
  return visibility;
}
var __defProp$f = Object.defineProperty;
var __defProps$5 = Object.defineProperties;
var __getOwnPropDescs$5 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$h = Object.getOwnPropertySymbols;
var __hasOwnProp$h = Object.prototype.hasOwnProperty;
var __propIsEnum$h = Object.prototype.propertyIsEnumerable;
var __defNormalProp$f = function __defNormalProp$f(obj, key, value) {
  return key in obj ? __defProp$f(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$f = function __spreadValues$f(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$h.call(b, prop)) __defNormalProp$f(a, prop, b[prop]);
  if (__getOwnPropSymbols$h) {
    var _iterator16 = _createForOfIteratorHelper(__getOwnPropSymbols$h(b)),
      _step16;
    try {
      for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
        var prop = _step16.value;
        if (__propIsEnum$h.call(b, prop)) __defNormalProp$f(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator16.e(err);
    } finally {
      _iterator16.f();
    }
  }
  return a;
};
var __spreadProps$5 = function __spreadProps$5(a, b) {
  return __defProps$5(a, __getOwnPropDescs$5(b));
};
function useDraggable(target) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _a, _b;
  var pointerTypes = options.pointerTypes,
    preventDefault = options.preventDefault,
    stopPropagation = options.stopPropagation,
    exact = options.exact,
    onMove = options.onMove,
    onEnd = options.onEnd,
    onStart = options.onStart,
    initialValue = options.initialValue,
    _options$axis = options.axis,
    axis = _options$axis === void 0 ? "both" : _options$axis,
    _options$draggingElem = options.draggingElement,
    draggingElement = _options$draggingElem === void 0 ? defaultWindow : _options$draggingElem,
    _options$handle = options.handle,
    draggingHandle = _options$handle === void 0 ? target : _options$handle;
  var position = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])((_a = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(initialValue)) != null ? _a : {
    x: 0,
    y: 0
  });
  var pressedDelta = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])();
  var filterEvent = function filterEvent(e) {
    if (pointerTypes) return pointerTypes.includes(e.pointerType);
    return true;
  };
  var handleEvent = function handleEvent(e) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(preventDefault)) e.preventDefault();
    if (Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(stopPropagation)) e.stopPropagation();
  };
  var start = function start(e) {
    if (!filterEvent(e)) return;
    if (Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(exact) && e.target !== Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(target)) return;
    var rect = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(target).getBoundingClientRect();
    var pos = {
      x: e.clientX - rect.left,
      y: e.clientY - rect.top
    };
    if ((onStart == null ? void 0 : onStart(pos, e)) === false) return;
    pressedDelta.value = pos;
    handleEvent(e);
  };
  var move = function move(e) {
    if (!filterEvent(e)) return;
    if (!pressedDelta.value) return;
    var _position$value = position.value,
      x = _position$value.x,
      y = _position$value.y;
    if (axis === "x" || axis === "both") x = e.clientX - pressedDelta.value.x;
    if (axis === "y" || axis === "both") y = e.clientY - pressedDelta.value.y;
    position.value = {
      x: x,
      y: y
    };
    onMove == null ? void 0 : onMove(position.value, e);
    handleEvent(e);
  };
  var end = function end(e) {
    if (!filterEvent(e)) return;
    if (!pressedDelta.value) return;
    pressedDelta.value = void 0;
    onEnd == null ? void 0 : onEnd(position.value, e);
    handleEvent(e);
  };
  if (__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["l" /* isClient */]) {
    var config = {
      capture: (_b = options.capture) != null ? _b : true
    };
    useEventListener(draggingHandle, "pointerdown", start, config);
    useEventListener(draggingElement, "pointermove", move, config);
    useEventListener(draggingElement, "pointerup", end, config);
  }
  return __spreadProps$5(__spreadValues$f({}, Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["C" /* toRefs */])(position)), {
    position: position,
    isDragging: Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
      return !!pressedDelta.value;
    }),
    style: Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
      return "left:".concat(position.value.x, "px;top:").concat(position.value.y, "px;");
    })
  });
}
function useDropZone(target, onDrop) {
  var isOverDropZone = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  var counter = 0;
  if (__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["l" /* isClient */]) {
    useEventListener(target, "dragenter", function (event) {
      event.preventDefault();
      counter += 1;
      isOverDropZone.value = true;
    });
    useEventListener(target, "dragover", function (event) {
      event.preventDefault();
    });
    useEventListener(target, "dragleave", function (event) {
      event.preventDefault();
      counter -= 1;
      if (counter === 0) isOverDropZone.value = false;
    });
    useEventListener(target, "drop", function (event) {
      var _a, _b;
      event.preventDefault();
      counter = 0;
      isOverDropZone.value = false;
      var files = Array.from((_b = (_a = event.dataTransfer) == null ? void 0 : _a.files) != null ? _b : []);
      onDrop == null ? void 0 : onDrop(files.length === 0 ? null : files);
    });
  }
  return {
    isOverDropZone: isOverDropZone
  };
}
var __getOwnPropSymbols$g = Object.getOwnPropertySymbols;
var __hasOwnProp$g = Object.prototype.hasOwnProperty;
var __propIsEnum$g = Object.prototype.propertyIsEnumerable;
var __objRest$2 = function __objRest$2(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$g.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$g) {
    var _iterator17 = _createForOfIteratorHelper(__getOwnPropSymbols$g(source)),
      _step17;
    try {
      for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
        var prop = _step17.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$g.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator17.e(err);
    } finally {
      _iterator17.f();
    }
  }
  return target;
};
function useResizeObserver(target, callback) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _a = options,
    _a$window2 = _a.window,
    window = _a$window2 === void 0 ? defaultWindow : _a$window2,
    observerOptions = __objRest$2(_a, ["window"]);
  var observer;
  var isSupported = useSupported(function () {
    return window && "ResizeObserver" in window;
  });
  var cleanup = function cleanup() {
    if (observer) {
      observer.disconnect();
      observer = void 0;
    }
  };
  var targets = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return Array.isArray(target) ? target.map(function (el) {
      return unrefElement(el);
    }) : [unrefElement(target)];
  });
  var stopWatch = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(targets, function (els) {
    cleanup();
    if (isSupported.value && window) {
      observer = new ResizeObserver(callback);
      var _iterator18 = _createForOfIteratorHelper(els),
        _step18;
      try {
        for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
          var _el = _step18.value;
          _el && observer.observe(_el, observerOptions);
        }
      } catch (err) {
        _iterator18.e(err);
      } finally {
        _iterator18.f();
      }
    }
  }, {
    immediate: true,
    flush: "post",
    deep: true
  });
  var stop = function stop() {
    cleanup();
    stopWatch();
  };
  Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["F" /* tryOnScopeDispose */])(stop);
  return {
    isSupported: isSupported,
    stop: stop
  };
}
function useElementBounding(target) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$reset = options.reset,
    reset = _options$reset === void 0 ? true : _options$reset,
    _options$windowResize = options.windowResize,
    windowResize = _options$windowResize === void 0 ? true : _options$windowResize,
    _options$windowScroll = options.windowScroll,
    windowScroll = _options$windowScroll === void 0 ? true : _options$windowScroll,
    _options$immediate3 = options.immediate,
    immediate = _options$immediate3 === void 0 ? true : _options$immediate3;
  var height = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(0);
  var bottom = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(0);
  var left = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(0);
  var right = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(0);
  var top = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(0);
  var width = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(0);
  var x = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(0);
  var y = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(0);
  function update() {
    var el = unrefElement(target);
    if (!el) {
      if (reset) {
        height.value = 0;
        bottom.value = 0;
        left.value = 0;
        right.value = 0;
        top.value = 0;
        width.value = 0;
        x.value = 0;
        y.value = 0;
      }
      return;
    }
    var rect = el.getBoundingClientRect();
    height.value = rect.height;
    bottom.value = rect.bottom;
    left.value = rect.left;
    right.value = rect.right;
    top.value = rect.top;
    width.value = rect.width;
    x.value = rect.x;
    y.value = rect.y;
  }
  useResizeObserver(target, update);
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(function () {
    return unrefElement(target);
  }, function (ele) {
    return !ele && update();
  });
  if (windowScroll) useEventListener("scroll", update, {
    capture: true,
    passive: true
  });
  if (windowResize) useEventListener("resize", update, {
    passive: true
  });
  Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["E" /* tryOnMounted */])(function () {
    if (immediate) update();
  });
  return {
    height: height,
    bottom: bottom,
    left: left,
    right: right,
    top: top,
    width: width,
    x: x,
    y: y,
    update: update
  };
}
var __defProp$e = Object.defineProperty;
var __getOwnPropSymbols$f = Object.getOwnPropertySymbols;
var __hasOwnProp$f = Object.prototype.hasOwnProperty;
var __propIsEnum$f = Object.prototype.propertyIsEnumerable;
var __defNormalProp$e = function __defNormalProp$e(obj, key, value) {
  return key in obj ? __defProp$e(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$e = function __spreadValues$e(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$f.call(b, prop)) __defNormalProp$e(a, prop, b[prop]);
  if (__getOwnPropSymbols$f) {
    var _iterator19 = _createForOfIteratorHelper(__getOwnPropSymbols$f(b)),
      _step19;
    try {
      for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
        var prop = _step19.value;
        if (__propIsEnum$f.call(b, prop)) __defNormalProp$e(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator19.e(err);
    } finally {
      _iterator19.f();
    }
  }
  return a;
};
function useElementByPoint(options) {
  var element = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(null);
  var x = options.x,
    y = options.y,
    _options$document2 = options.document,
    document = _options$document2 === void 0 ? defaultDocument : _options$document2;
  var controls = useRafFn(function () {
    element.value = (document == null ? void 0 : document.elementFromPoint(Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(x), Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(y))) || null;
  });
  return __spreadValues$e({
    element: element
  }, controls);
}
function useElementHover(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$delayEnter = options.delayEnter,
    delayEnter = _options$delayEnter === void 0 ? 0 : _options$delayEnter,
    _options$delayLeave = options.delayLeave,
    delayLeave = _options$delayLeave === void 0 ? 0 : _options$delayLeave,
    _options$window12 = options.window,
    window = _options$window12 === void 0 ? defaultWindow : _options$window12;
  var isHovered = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  var timer;
  var toggle = function toggle(entering) {
    var delay = entering ? delayEnter : delayLeave;
    if (timer) {
      clearTimeout(timer);
      timer = void 0;
    }
    if (delay) timer = setTimeout(function () {
      return isHovered.value = entering;
    }, delay);else isHovered.value = entering;
  };
  if (!window) return isHovered;
  useEventListener(el, "mouseenter", function () {
    return toggle(true);
  }, {
    passive: true
  });
  useEventListener(el, "mouseleave", function () {
    return toggle(false);
  }, {
    passive: true
  });
  return isHovered;
}
function useElementSize(target) {
  var initialSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    width: 0,
    height: 0
  };
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$window13 = options.window,
    window = _options$window13 === void 0 ? defaultWindow : _options$window13,
    _options$box = options.box,
    box = _options$box === void 0 ? "content-box" : _options$box;
  var isSVG = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    var _a, _b;
    return (_b = (_a = unrefElement(target)) == null ? void 0 : _a.namespaceURI) == null ? void 0 : _b.includes("svg");
  });
  var width = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(initialSize.width);
  var height = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(initialSize.height);
  useResizeObserver(target, function (_ref22) {
    var _ref23 = _slicedToArray(_ref22, 1),
      entry = _ref23[0];
    var boxSize = box === "border-box" ? entry.borderBoxSize : box === "content-box" ? entry.contentBoxSize : entry.devicePixelContentBoxSize;
    if (window && isSVG.value) {
      var $elem = unrefElement(target);
      if ($elem) {
        var styles = window.getComputedStyle($elem);
        width.value = parseFloat(styles.width);
        height.value = parseFloat(styles.height);
      }
    } else {
      if (boxSize) {
        var formatBoxSize = Array.isArray(boxSize) ? boxSize : [boxSize];
        width.value = formatBoxSize.reduce(function (acc, _ref24) {
          var inlineSize = _ref24.inlineSize;
          return acc + inlineSize;
        }, 0);
        height.value = formatBoxSize.reduce(function (acc, _ref25) {
          var blockSize = _ref25.blockSize;
          return acc + blockSize;
        }, 0);
      } else {
        width.value = entry.contentRect.width;
        height.value = entry.contentRect.height;
      }
    }
  }, options);
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(function () {
    return unrefElement(target);
  }, function (ele) {
    width.value = ele ? initialSize.width : 0;
    height.value = ele ? initialSize.height : 0;
  });
  return {
    width: width,
    height: height
  };
}
function useIntersectionObserver(target, callback) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var root = options.root,
    _options$rootMargin = options.rootMargin,
    rootMargin = _options$rootMargin === void 0 ? "0px" : _options$rootMargin,
    _options$threshold = options.threshold,
    threshold = _options$threshold === void 0 ? 0.1 : _options$threshold,
    _options$window14 = options.window,
    window = _options$window14 === void 0 ? defaultWindow : _options$window14,
    _options$immediate4 = options.immediate,
    immediate = _options$immediate4 === void 0 ? true : _options$immediate4;
  var isSupported = useSupported(function () {
    return window && "IntersectionObserver" in window;
  });
  var targets = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    var _target = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(target);
    return (Array.isArray(_target) ? _target : [_target]).map(unrefElement).filter(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["r" /* notNullish */]);
  });
  var _cleanup = __WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["q" /* noop */];
  var isActive = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(immediate);
  var stopWatch = isSupported.value ? Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(function () {
    return [targets.value, unrefElement(root), isActive.value];
  }, function (_ref26) {
    var _ref27 = _slicedToArray(_ref26, 2),
      targets2 = _ref27[0],
      root2 = _ref27[1];
    _cleanup();
    if (!isActive.value) return;
    if (!targets2.length) return;
    var observer = new IntersectionObserver(callback, {
      root: unrefElement(root2),
      rootMargin: rootMargin,
      threshold: threshold
    });
    targets2.forEach(function (el) {
      return el && observer.observe(el);
    });
    _cleanup = function cleanup() {
      observer.disconnect();
      _cleanup = __WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["q" /* noop */];
    };
  }, {
    immediate: immediate,
    flush: "post"
  }) : __WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["q" /* noop */];
  var stop = function stop() {
    _cleanup();
    stopWatch();
    isActive.value = false;
  };
  Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["F" /* tryOnScopeDispose */])(stop);
  return {
    isSupported: isSupported,
    isActive: isActive,
    pause: function pause() {
      _cleanup();
      isActive.value = false;
    },
    resume: function resume() {
      isActive.value = true;
    },
    stop: stop
  };
}
function useElementVisibility(element) {
  var _ref28 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref28$window = _ref28.window,
    window = _ref28$window === void 0 ? defaultWindow : _ref28$window,
    scrollTarget = _ref28.scrollTarget;
  var elementIsVisible = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  useIntersectionObserver(element, function (_ref29) {
    var _ref30 = _slicedToArray(_ref29, 1),
      isIntersecting = _ref30[0].isIntersecting;
    elementIsVisible.value = isIntersecting;
  }, {
    root: scrollTarget,
    window: window
  });
  return elementIsVisible;
}
var events = /* @__PURE__ */new Map();
function useEventBus(key) {
  var scope = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["getCurrentScope"])();
  function on(listener) {
    var _a;
    var listeners = events.get(key) || /* @__PURE__ */new Set();
    listeners.add(listener);
    events.set(key, listeners);
    var _off = function _off() {
      return off(listener);
    };
    (_a = scope == null ? void 0 : scope.cleanups) == null ? void 0 : _a.push(_off);
    return _off;
  }
  function once(listener) {
    function _listener() {
      off(_listener);
      listener.apply(void 0, arguments);
    }
    return on(_listener);
  }
  function off(listener) {
    var listeners = events.get(key);
    if (!listeners) return;
    listeners.delete(listener);
    if (!listeners.size) reset();
  }
  function reset() {
    events.delete(key);
  }
  function emit(event, payload) {
    var _a;
    (_a = events.get(key)) == null ? void 0 : _a.forEach(function (v) {
      return v(event, payload);
    });
  }
  return {
    on: on,
    once: once,
    off: off,
    emit: emit,
    reset: reset
  };
}
function useEventSource(url) {
  var events = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var event = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(null);
  var data = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(null);
  var status = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])("CONNECTING");
  var eventSource = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(null);
  var error = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["shallowRef"])(null);
  var _options$withCredenti = options.withCredentials,
    withCredentials = _options$withCredenti === void 0 ? false : _options$withCredenti;
  var close = function close() {
    if (eventSource.value) {
      eventSource.value.close();
      eventSource.value = null;
      status.value = "CLOSED";
    }
  };
  var es = new EventSource(url, {
    withCredentials: withCredentials
  });
  eventSource.value = es;
  es.onopen = function () {
    status.value = "OPEN";
    error.value = null;
  };
  es.onerror = function (e) {
    status.value = "CLOSED";
    error.value = e;
  };
  es.onmessage = function (e) {
    event.value = null;
    data.value = e.data;
  };
  var _iterator20 = _createForOfIteratorHelper(events),
    _step20;
  try {
    var _loop2 = function _loop2() {
      var event_name = _step20.value;
      useEventListener(es, event_name, function (e) {
        event.value = event_name;
        data.value = e.data || null;
      });
    };
    for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
      _loop2();
    }
  } catch (err) {
    _iterator20.e(err);
  } finally {
    _iterator20.f();
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["F" /* tryOnScopeDispose */])(function () {
    close();
  });
  return {
    eventSource: eventSource,
    event: event,
    data: data,
    status: status,
    error: error,
    close: close
  };
}
function useEyeDropper() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$initialValue3 = options.initialValue,
    initialValue = _options$initialValue3 === void 0 ? "" : _options$initialValue3;
  var isSupported = useSupported(function () {
    return typeof window !== "undefined" && "EyeDropper" in window;
  });
  var sRGBHex = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(initialValue);
  function open(_x3) {
    return _open.apply(this, arguments);
  }
  function _open() {
    _open = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(openOptions) {
      var eyeDropper, result;
      return _regeneratorRuntime().wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            if (isSupported.value) {
              _context12.next = 2;
              break;
            }
            return _context12.abrupt("return");
          case 2:
            eyeDropper = new window.EyeDropper();
            _context12.next = 5;
            return eyeDropper.open(openOptions);
          case 5:
            result = _context12.sent;
            sRGBHex.value = result.sRGBHex;
            return _context12.abrupt("return", result);
          case 8:
          case "end":
            return _context12.stop();
        }
      }, _callee12);
    }));
    return _open.apply(this, arguments);
  }
  return {
    isSupported: isSupported,
    sRGBHex: sRGBHex,
    open: open
  };
}
function useFavicon() {
  var newIcon = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$baseUrl = options.baseUrl,
    baseUrl = _options$baseUrl === void 0 ? "" : _options$baseUrl,
    _options$rel = options.rel,
    rel = _options$rel === void 0 ? "icon" : _options$rel,
    _options$document3 = options.document,
    document = _options$document3 === void 0 ? defaultDocument : _options$document3;
  var favicon = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["B" /* toRef */])(newIcon);
  var applyIcon = function applyIcon(icon) {
    document == null ? void 0 : document.head.querySelectorAll("link[rel*=\"".concat(rel, "\"]")).forEach(function (el) {
      return el.href = "".concat(baseUrl).concat(icon);
    });
  };
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(favicon, function (i, o) {
    if (typeof i === "string" && i !== o) applyIcon(i);
  }, {
    immediate: true
  });
  return favicon;
}
var __defProp$d = Object.defineProperty;
var __defProps$4 = Object.defineProperties;
var __getOwnPropDescs$4 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$e = Object.getOwnPropertySymbols;
var __hasOwnProp$e = Object.prototype.hasOwnProperty;
var __propIsEnum$e = Object.prototype.propertyIsEnumerable;
var __defNormalProp$d = function __defNormalProp$d(obj, key, value) {
  return key in obj ? __defProp$d(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$d = function __spreadValues$d(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$e.call(b, prop)) __defNormalProp$d(a, prop, b[prop]);
  if (__getOwnPropSymbols$e) {
    var _iterator21 = _createForOfIteratorHelper(__getOwnPropSymbols$e(b)),
      _step21;
    try {
      for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
        var prop = _step21.value;
        if (__propIsEnum$e.call(b, prop)) __defNormalProp$d(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator21.e(err);
    } finally {
      _iterator21.f();
    }
  }
  return a;
};
var __spreadProps$4 = function __spreadProps$4(a, b) {
  return __defProps$4(a, __getOwnPropDescs$4(b));
};
var payloadMapping = {
  json: "application/json",
  text: "text/plain"
};
function isFetchOptions(obj) {
  return obj && Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["d" /* containsProp */])(obj, "immediate", "refetch", "initialData", "timeout", "beforeFetch", "afterFetch", "onFetchError", "fetch");
}
function isAbsoluteURL(url) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}
function headersToObject(headers) {
  if (typeof Headers !== "undefined" && headers instanceof Headers) return Object.fromEntries(_toConsumableArray(headers.entries()));
  return headers;
}
function combineCallbacks(combination) {
  for (var _len5 = arguments.length, callbacks = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    callbacks[_key5 - 1] = arguments[_key5];
  }
  if (combination === "overwrite") {
    return /*#__PURE__*/function () {
      var _ref31 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(ctx) {
        var callback;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              callback = callbacks[callbacks.length - 1];
              if (!callback) {
                _context13.next = 8;
                break;
              }
              _context13.t0 = __spreadValues$d;
              _context13.t1 = __spreadValues$d({}, ctx);
              _context13.next = 6;
              return callback(ctx);
            case 6:
              _context13.t2 = _context13.sent;
              return _context13.abrupt("return", (0, _context13.t0)(_context13.t1, _context13.t2));
            case 8:
              return _context13.abrupt("return", ctx);
            case 9:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }));
      return function (_x4) {
        return _ref31.apply(this, arguments);
      };
    }();
  } else {
    return /*#__PURE__*/function () {
      var _ref32 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(ctx) {
        var _iterator22, _step22, callback;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _iterator22 = _createForOfIteratorHelper(callbacks);
              _context14.prev = 1;
              _iterator22.s();
            case 3:
              if ((_step22 = _iterator22.n()).done) {
                _context14.next = 14;
                break;
              }
              callback = _step22.value;
              if (!callback) {
                _context14.next = 12;
                break;
              }
              _context14.t0 = __spreadValues$d;
              _context14.t1 = __spreadValues$d({}, ctx);
              _context14.next = 10;
              return callback(ctx);
            case 10:
              _context14.t2 = _context14.sent;
              ctx = (0, _context14.t0)(_context14.t1, _context14.t2);
            case 12:
              _context14.next = 3;
              break;
            case 14:
              _context14.next = 19;
              break;
            case 16:
              _context14.prev = 16;
              _context14.t3 = _context14["catch"](1);
              _iterator22.e(_context14.t3);
            case 19:
              _context14.prev = 19;
              _iterator22.f();
              return _context14.finish(19);
            case 22:
              return _context14.abrupt("return", ctx);
            case 23:
            case "end":
              return _context14.stop();
          }
        }, _callee14, null, [[1, 16, 19, 22]]);
      }));
      return function (_x5) {
        return _ref32.apply(this, arguments);
      };
    }();
  }
}
function createFetch() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _combination = config.combination || "chain";
  var _options = config.options || {};
  var _fetchOptions = config.fetchOptions || {};
  function useFactoryFetch(url) {
    var computedUrl = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
      var baseUrl = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(config.baseUrl);
      var targetUrl = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(url);
      return baseUrl && !isAbsoluteURL(targetUrl) ? joinPaths(baseUrl, targetUrl) : targetUrl;
    });
    var options = _options;
    var fetchOptions = _fetchOptions;
    for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
      args[_key6 - 1] = arguments[_key6];
    }
    if (args.length > 0) {
      if (isFetchOptions(args[0])) {
        options = __spreadProps$4(__spreadValues$d(__spreadValues$d({}, options), args[0]), {
          beforeFetch: combineCallbacks(_combination, _options.beforeFetch, args[0].beforeFetch),
          afterFetch: combineCallbacks(_combination, _options.afterFetch, args[0].afterFetch),
          onFetchError: combineCallbacks(_combination, _options.onFetchError, args[0].onFetchError)
        });
      } else {
        fetchOptions = __spreadProps$4(__spreadValues$d(__spreadValues$d({}, fetchOptions), args[0]), {
          headers: __spreadValues$d(__spreadValues$d({}, headersToObject(fetchOptions.headers) || {}), headersToObject(args[0].headers) || {})
        });
      }
    }
    if (args.length > 1 && isFetchOptions(args[1])) {
      options = __spreadProps$4(__spreadValues$d(__spreadValues$d({}, options), args[1]), {
        beforeFetch: combineCallbacks(_combination, _options.beforeFetch, args[1].beforeFetch),
        afterFetch: combineCallbacks(_combination, _options.afterFetch, args[1].afterFetch),
        onFetchError: combineCallbacks(_combination, _options.onFetchError, args[1].onFetchError)
      });
    }
    return useFetch(computedUrl, fetchOptions, options);
  }
  return useFactoryFetch;
}
function useFetch(url) {
  var _a;
  var supportsAbort = typeof AbortController === "function";
  var fetchOptions = {};
  var options = {
    immediate: true,
    refetch: false,
    timeout: 0
  };
  var config = {
    method: "GET",
    type: "text",
    payload: void 0
  };
  if ((arguments.length <= 1 ? 0 : arguments.length - 1) > 0) {
    if (isFetchOptions(arguments.length <= 1 ? undefined : arguments[1])) options = __spreadValues$d(__spreadValues$d({}, options), arguments.length <= 1 ? undefined : arguments[1]);else fetchOptions = arguments.length <= 1 ? undefined : arguments[1];
  }
  if ((arguments.length <= 1 ? 0 : arguments.length - 1) > 1) {
    if (isFetchOptions(arguments.length <= 2 ? undefined : arguments[2])) options = __spreadValues$d(__spreadValues$d({}, options), arguments.length <= 2 ? undefined : arguments[2]);
  }
  var _options4 = options,
    _options4$fetch = _options4.fetch,
    fetch = _options4$fetch === void 0 ? (_a = defaultWindow) == null ? void 0 : _a.fetch : _options4$fetch,
    initialData = _options4.initialData,
    timeout = _options4.timeout;
  var responseEvent = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["e" /* createEventHook */])();
  var errorEvent = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["e" /* createEventHook */])();
  var finallyEvent = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["e" /* createEventHook */])();
  var isFinished = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  var isFetching = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  var aborted = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  var statusCode = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(null);
  var response = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["shallowRef"])(null);
  var error = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["shallowRef"])(null);
  var data = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["shallowRef"])(initialData || null);
  var canAbort = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return supportsAbort && isFetching.value;
  });
  var controller;
  var timer;
  var abort = function abort() {
    if (supportsAbort) {
      controller == null ? void 0 : controller.abort();
      controller = new AbortController();
      controller.signal.onabort = function () {
        return aborted.value = true;
      };
      fetchOptions = __spreadProps$4(__spreadValues$d({}, fetchOptions), {
        signal: controller.signal
      });
    }
  };
  var loading = function loading(isLoading) {
    isFetching.value = isLoading;
    isFinished.value = !isLoading;
  };
  if (timeout) timer = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["L" /* useTimeoutFn */])(abort, timeout, {
    immediate: false
  });
  var execute = /*#__PURE__*/function () {
    var _ref33 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
      var throwOnFailed,
        _a2,
        defaultFetchOptions,
        headers,
        payload,
        isCanceled,
        context,
        responseData,
        _args17 = arguments;
      return _regeneratorRuntime().wrap(function _callee17$(_context17) {
        while (1) switch (_context17.prev = _context17.next) {
          case 0:
            throwOnFailed = _args17.length > 0 && _args17[0] !== undefined ? _args17[0] : false;
            abort();
            loading(true);
            error.value = null;
            statusCode.value = null;
            aborted.value = false;
            defaultFetchOptions = {
              method: config.method,
              headers: {}
            };
            if (config.payload) {
              headers = headersToObject(defaultFetchOptions.headers);
              if (config.payloadType) headers["Content-Type"] = (_a2 = payloadMapping[config.payloadType]) != null ? _a2 : config.payloadType;
              payload = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(config.payload);
              defaultFetchOptions.body = config.payloadType === "json" ? JSON.stringify(payload) : payload;
            }
            isCanceled = false;
            context = {
              url: Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(url),
              options: __spreadValues$d(__spreadValues$d({}, defaultFetchOptions), fetchOptions),
              cancel: function cancel() {
                isCanceled = true;
              }
            };
            if (!options.beforeFetch) {
              _context17.next = 17;
              break;
            }
            _context17.t0 = Object;
            _context17.t1 = context;
            _context17.next = 15;
            return options.beforeFetch(context);
          case 15:
            _context17.t2 = _context17.sent;
            _context17.t0.assign.call(_context17.t0, _context17.t1, _context17.t2);
          case 17:
            if (!(isCanceled || !fetch)) {
              _context17.next = 20;
              break;
            }
            loading(false);
            return _context17.abrupt("return", Promise.resolve(null));
          case 20:
            responseData = null;
            if (timer) timer.start();
            return _context17.abrupt("return", new Promise(function (resolve, reject) {
              var _a3;
              fetch(context.url, __spreadProps$4(__spreadValues$d(__spreadValues$d({}, defaultFetchOptions), context.options), {
                headers: __spreadValues$d(__spreadValues$d({}, headersToObject(defaultFetchOptions.headers)), headersToObject((_a3 = context.options) == null ? void 0 : _a3.headers))
              })).then( /*#__PURE__*/function () {
                var _ref34 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(fetchResponse) {
                  var _yield$options$afterF;
                  return _regeneratorRuntime().wrap(function _callee15$(_context15) {
                    while (1) switch (_context15.prev = _context15.next) {
                      case 0:
                        response.value = fetchResponse;
                        statusCode.value = fetchResponse.status;
                        _context15.next = 4;
                        return fetchResponse[config.type]();
                      case 4:
                        responseData = _context15.sent;
                        if (fetchResponse.ok) {
                          _context15.next = 8;
                          break;
                        }
                        data.value = initialData || null;
                        throw new Error(fetchResponse.statusText);
                      case 8:
                        if (!options.afterFetch) {
                          _context15.next = 13;
                          break;
                        }
                        _context15.next = 11;
                        return options.afterFetch({
                          data: responseData,
                          response: fetchResponse
                        });
                      case 11:
                        _yield$options$afterF = _context15.sent;
                        responseData = _yield$options$afterF.data;
                      case 13:
                        data.value = responseData;
                        responseEvent.trigger(fetchResponse);
                        return _context15.abrupt("return", resolve(fetchResponse));
                      case 16:
                      case "end":
                        return _context15.stop();
                    }
                  }, _callee15);
                }));
                return function (_x6) {
                  return _ref34.apply(this, arguments);
                };
              }()).catch( /*#__PURE__*/function () {
                var _ref35 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(fetchError) {
                  var errorData, _yield$options$onFetc;
                  return _regeneratorRuntime().wrap(function _callee16$(_context16) {
                    while (1) switch (_context16.prev = _context16.next) {
                      case 0:
                        errorData = fetchError.message || fetchError.name;
                        if (!options.onFetchError) {
                          _context16.next = 6;
                          break;
                        }
                        _context16.next = 4;
                        return options.onFetchError({
                          data: responseData,
                          error: fetchError,
                          response: response.value
                        });
                      case 4:
                        _yield$options$onFetc = _context16.sent;
                        errorData = _yield$options$onFetc.error;
                      case 6:
                        error.value = errorData;
                        errorEvent.trigger(fetchError);
                        if (!throwOnFailed) {
                          _context16.next = 10;
                          break;
                        }
                        return _context16.abrupt("return", reject(fetchError));
                      case 10:
                        return _context16.abrupt("return", resolve(null));
                      case 11:
                      case "end":
                        return _context16.stop();
                    }
                  }, _callee16);
                }));
                return function (_x7) {
                  return _ref35.apply(this, arguments);
                };
              }()).finally(function () {
                loading(false);
                if (timer) timer.stop();
                finallyEvent.trigger(null);
              });
            }));
          case 23:
          case "end":
            return _context17.stop();
        }
      }, _callee17);
    }));
    return function execute() {
      return _ref33.apply(this, arguments);
    };
  }();
  var refetch = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["B" /* toRef */])(options.refetch);
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])([refetch, Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["B" /* toRef */])(url)], function (_ref36) {
    var _ref37 = _slicedToArray(_ref36, 1),
      refetch2 = _ref37[0];
    return refetch2 && execute();
  }, {
    deep: true
  });
  var shell = {
    isFinished: isFinished,
    statusCode: statusCode,
    response: response,
    error: error,
    data: data,
    isFetching: isFetching,
    canAbort: canAbort,
    aborted: aborted,
    abort: abort,
    execute: execute,
    onFetchResponse: responseEvent.on,
    onFetchError: errorEvent.on,
    onFetchFinally: finallyEvent.on,
    // method
    get: setMethod("GET"),
    put: setMethod("PUT"),
    post: setMethod("POST"),
    delete: setMethod("DELETE"),
    patch: setMethod("PATCH"),
    head: setMethod("HEAD"),
    options: setMethod("OPTIONS"),
    // type
    json: setType("json"),
    text: setType("text"),
    blob: setType("blob"),
    arrayBuffer: setType("arrayBuffer"),
    formData: setType("formData")
  };
  function setMethod(method) {
    return function (payload, payloadType) {
      if (!isFetching.value) {
        config.method = method;
        config.payload = payload;
        config.payloadType = payloadType;
        if (Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["isRef"])(config.payload)) {
          Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])([refetch, Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["B" /* toRef */])(config.payload)], function (_ref38) {
            var _ref39 = _slicedToArray(_ref38, 1),
              refetch2 = _ref39[0];
            return refetch2 && execute();
          }, {
            deep: true
          });
        }
        var rawPayload = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(config.payload);
        if (!payloadType && rawPayload && Object.getPrototypeOf(rawPayload) === Object.prototype && !(rawPayload instanceof FormData)) config.payloadType = "json";
        return __spreadProps$4(__spreadValues$d({}, shell), {
          then: function then(onFulfilled, onRejected) {
            return waitUntilFinished().then(onFulfilled, onRejected);
          }
        });
      }
      return void 0;
    };
  }
  function waitUntilFinished() {
    return new Promise(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["H" /* until */])(isFinished).toBe(true).then(function () {
        return resolve(shell);
      }).catch(function (error2) {
        return reject(error2);
      });
    });
  }
  function setType(type) {
    return function () {
      if (!isFetching.value) {
        config.type = type;
        return __spreadProps$4(__spreadValues$d({}, shell), {
          then: function then(onFulfilled, onRejected) {
            return waitUntilFinished().then(onFulfilled, onRejected);
          }
        });
      }
      return void 0;
    };
  }
  if (options.immediate) Promise.resolve().then(function () {
    return execute();
  });
  return __spreadProps$4(__spreadValues$d({}, shell), {
    then: function then(onFulfilled, onRejected) {
      return waitUntilFinished().then(onFulfilled, onRejected);
    }
  });
}
function joinPaths(start, end) {
  if (!start.endsWith("/") && !end.startsWith("/")) return "".concat(start, "/").concat(end);
  return "".concat(start).concat(end);
}
var __defProp$c = Object.defineProperty;
var __getOwnPropSymbols$d = Object.getOwnPropertySymbols;
var __hasOwnProp$d = Object.prototype.hasOwnProperty;
var __propIsEnum$d = Object.prototype.propertyIsEnumerable;
var __defNormalProp$c = function __defNormalProp$c(obj, key, value) {
  return key in obj ? __defProp$c(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$c = function __spreadValues$c(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$d.call(b, prop)) __defNormalProp$c(a, prop, b[prop]);
  if (__getOwnPropSymbols$d) {
    var _iterator23 = _createForOfIteratorHelper(__getOwnPropSymbols$d(b)),
      _step23;
    try {
      for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
        var prop = _step23.value;
        if (__propIsEnum$d.call(b, prop)) __defNormalProp$c(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator23.e(err);
    } finally {
      _iterator23.f();
    }
  }
  return a;
};
var DEFAULT_OPTIONS = {
  multiple: true,
  accept: "*"
};
function useFileDialog() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$document4 = options.document,
    document = _options$document4 === void 0 ? defaultDocument : _options$document4;
  var files = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(null);
  var _createEventHook = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["e" /* createEventHook */])(),
    onChange = _createEventHook.on,
    trigger = _createEventHook.trigger;
  var input;
  if (document) {
    input = document.createElement("input");
    input.type = "file";
    input.onchange = function (event) {
      var result = event.target;
      files.value = result.files;
      trigger(files.value);
    };
  }
  var open = function open(localOptions) {
    if (!input) return;
    var _options = __spreadValues$c(__spreadValues$c(__spreadValues$c({}, DEFAULT_OPTIONS), options), localOptions);
    input.multiple = _options.multiple;
    input.accept = _options.accept;
    if (Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["i" /* hasOwn */])(_options, "capture")) input.capture = _options.capture;
    input.click();
  };
  var reset = function reset() {
    files.value = null;
    if (input) input.value = "";
  };
  return {
    files: Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["readonly"])(files),
    open: open,
    reset: reset,
    onChange: onChange
  };
}
var __defProp$b = Object.defineProperty;
var __getOwnPropSymbols$c = Object.getOwnPropertySymbols;
var __hasOwnProp$c = Object.prototype.hasOwnProperty;
var __propIsEnum$c = Object.prototype.propertyIsEnumerable;
var __defNormalProp$b = function __defNormalProp$b(obj, key, value) {
  return key in obj ? __defProp$b(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$b = function __spreadValues$b(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$c.call(b, prop)) __defNormalProp$b(a, prop, b[prop]);
  if (__getOwnPropSymbols$c) {
    var _iterator24 = _createForOfIteratorHelper(__getOwnPropSymbols$c(b)),
      _step24;
    try {
      for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
        var prop = _step24.value;
        if (__propIsEnum$c.call(b, prop)) __defNormalProp$b(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator24.e(err);
    } finally {
      _iterator24.f();
    }
  }
  return a;
};
function useFileSystemAccess() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$window15 = options.window,
    _window = _options$window15 === void 0 ? defaultWindow : _options$window15,
    _options$dataType = options.dataType,
    dataType = _options$dataType === void 0 ? "Text" : _options$dataType;
  var window = _window;
  var isSupported = useSupported(function () {
    return window && "showSaveFilePicker" in window && "showOpenFilePicker" in window;
  });
  var fileHandle = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])();
  var data = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])();
  var file = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])();
  var fileName = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    var _a, _b;
    return (_b = (_a = file.value) == null ? void 0 : _a.name) != null ? _b : "";
  });
  var fileMIME = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    var _a, _b;
    return (_b = (_a = file.value) == null ? void 0 : _a.type) != null ? _b : "";
  });
  var fileSize = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    var _a, _b;
    return (_b = (_a = file.value) == null ? void 0 : _a.size) != null ? _b : 0;
  });
  var fileLastModified = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    var _a, _b;
    return (_b = (_a = file.value) == null ? void 0 : _a.lastModified) != null ? _b : 0;
  });
  function open() {
    return _open2.apply(this, arguments);
  }
  function _open2() {
    _open2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
      var _options,
        _yield$window$showOpe,
        _yield$window$showOpe2,
        handle,
        _args18 = arguments;
      return _regeneratorRuntime().wrap(function _callee18$(_context18) {
        while (1) switch (_context18.prev = _context18.next) {
          case 0:
            _options = _args18.length > 0 && _args18[0] !== undefined ? _args18[0] : {};
            if (isSupported.value) {
              _context18.next = 3;
              break;
            }
            return _context18.abrupt("return");
          case 3:
            _context18.next = 5;
            return window.showOpenFilePicker(__spreadValues$b(__spreadValues$b({}, Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(options)), _options));
          case 5:
            _yield$window$showOpe = _context18.sent;
            _yield$window$showOpe2 = _slicedToArray(_yield$window$showOpe, 1);
            handle = _yield$window$showOpe2[0];
            fileHandle.value = handle;
            _context18.next = 11;
            return updateFile();
          case 11:
            _context18.next = 13;
            return updateData();
          case 13:
          case "end":
            return _context18.stop();
        }
      }, _callee18);
    }));
    return _open2.apply(this, arguments);
  }
  function create() {
    return _create.apply(this, arguments);
  }
  function _create() {
    _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
      var _options,
        _args19 = arguments;
      return _regeneratorRuntime().wrap(function _callee19$(_context19) {
        while (1) switch (_context19.prev = _context19.next) {
          case 0:
            _options = _args19.length > 0 && _args19[0] !== undefined ? _args19[0] : {};
            if (isSupported.value) {
              _context19.next = 3;
              break;
            }
            return _context19.abrupt("return");
          case 3:
            _context19.next = 5;
            return window.showSaveFilePicker(__spreadValues$b(__spreadValues$b({}, options), _options));
          case 5:
            fileHandle.value = _context19.sent;
            data.value = void 0;
            _context19.next = 9;
            return updateFile();
          case 9:
            _context19.next = 11;
            return updateData();
          case 11:
          case "end":
            return _context19.stop();
        }
      }, _callee19);
    }));
    return _create.apply(this, arguments);
  }
  function save() {
    return _save.apply(this, arguments);
  }
  function _save() {
    _save = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
      var _options,
        writableStream,
        _args20 = arguments;
      return _regeneratorRuntime().wrap(function _callee20$(_context20) {
        while (1) switch (_context20.prev = _context20.next) {
          case 0:
            _options = _args20.length > 0 && _args20[0] !== undefined ? _args20[0] : {};
            if (isSupported.value) {
              _context20.next = 3;
              break;
            }
            return _context20.abrupt("return");
          case 3:
            if (fileHandle.value) {
              _context20.next = 5;
              break;
            }
            return _context20.abrupt("return", saveAs(_options));
          case 5:
            if (!data.value) {
              _context20.next = 13;
              break;
            }
            _context20.next = 8;
            return fileHandle.value.createWritable();
          case 8:
            writableStream = _context20.sent;
            _context20.next = 11;
            return writableStream.write(data.value);
          case 11:
            _context20.next = 13;
            return writableStream.close();
          case 13:
            _context20.next = 15;
            return updateFile();
          case 15:
          case "end":
            return _context20.stop();
        }
      }, _callee20);
    }));
    return _save.apply(this, arguments);
  }
  function saveAs() {
    return _saveAs.apply(this, arguments);
  }
  function _saveAs() {
    _saveAs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
      var _options,
        writableStream,
        _args21 = arguments;
      return _regeneratorRuntime().wrap(function _callee21$(_context21) {
        while (1) switch (_context21.prev = _context21.next) {
          case 0:
            _options = _args21.length > 0 && _args21[0] !== undefined ? _args21[0] : {};
            if (isSupported.value) {
              _context21.next = 3;
              break;
            }
            return _context21.abrupt("return");
          case 3:
            _context21.next = 5;
            return window.showSaveFilePicker(__spreadValues$b(__spreadValues$b({}, options), _options));
          case 5:
            fileHandle.value = _context21.sent;
            if (!data.value) {
              _context21.next = 14;
              break;
            }
            _context21.next = 9;
            return fileHandle.value.createWritable();
          case 9:
            writableStream = _context21.sent;
            _context21.next = 12;
            return writableStream.write(data.value);
          case 12:
            _context21.next = 14;
            return writableStream.close();
          case 14:
            _context21.next = 16;
            return updateFile();
          case 16:
          case "end":
            return _context21.stop();
        }
      }, _callee21);
    }));
    return _saveAs.apply(this, arguments);
  }
  function updateFile() {
    return _updateFile.apply(this, arguments);
  }
  function _updateFile() {
    _updateFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
      var _a;
      return _regeneratorRuntime().wrap(function _callee22$(_context22) {
        while (1) switch (_context22.prev = _context22.next) {
          case 0:
            _context22.next = 2;
            return (_a = fileHandle.value) == null ? void 0 : _a.getFile();
          case 2:
            file.value = _context22.sent;
          case 3:
          case "end":
            return _context22.stop();
        }
      }, _callee22);
    }));
    return _updateFile.apply(this, arguments);
  }
  function updateData() {
    return _updateData.apply(this, arguments);
  }
  function _updateData() {
    _updateData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
      var _a, _b, type;
      return _regeneratorRuntime().wrap(function _callee23$(_context23) {
        while (1) switch (_context23.prev = _context23.next) {
          case 0:
            type = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(dataType);
            if (!(type === "Text")) {
              _context23.next = 7;
              break;
            }
            _context23.next = 4;
            return (_a = file.value) == null ? void 0 : _a.text();
          case 4:
            data.value = _context23.sent;
            _context23.next = 14;
            break;
          case 7:
            if (!(type === "ArrayBuffer")) {
              _context23.next = 13;
              break;
            }
            _context23.next = 10;
            return (_b = file.value) == null ? void 0 : _b.arrayBuffer();
          case 10:
            data.value = _context23.sent;
            _context23.next = 14;
            break;
          case 13:
            if (type === "Blob") data.value = file.value;
          case 14:
          case "end":
            return _context23.stop();
        }
      }, _callee23);
    }));
    return _updateData.apply(this, arguments);
  }
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(dataType);
  }, updateData);
  return {
    isSupported: isSupported,
    data: data,
    file: file,
    fileName: fileName,
    fileMIME: fileMIME,
    fileSize: fileSize,
    fileLastModified: fileLastModified,
    open: open,
    create: create,
    save: save,
    saveAs: saveAs,
    updateData: updateData
  };
}
function useFocus(target) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$initialValue4 = options.initialValue,
    initialValue = _options$initialValue4 === void 0 ? false : _options$initialValue4;
  var innerFocused = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  var targetElement = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return unrefElement(target);
  });
  useEventListener(targetElement, "focus", function () {
    return innerFocused.value = true;
  });
  useEventListener(targetElement, "blur", function () {
    return innerFocused.value = false;
  });
  var focused = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])({
    get: function get() {
      return innerFocused.value;
    },
    set: function set(value) {
      var _a, _b;
      if (!value && innerFocused.value) (_a = targetElement.value) == null ? void 0 : _a.blur();else if (value && !innerFocused.value) (_b = targetElement.value) == null ? void 0 : _b.focus();
    }
  });
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(targetElement, function () {
    focused.value = initialValue;
  }, {
    immediate: true,
    flush: "post"
  });
  return {
    focused: focused
  };
}
function useFocusWithin(target) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var activeElement = useActiveElement(options);
  var targetElement = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return unrefElement(target);
  });
  var focused = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return targetElement.value && activeElement.value ? targetElement.value.contains(activeElement.value) : false;
  });
  return {
    focused: focused
  };
}
function useFps(options) {
  var _a;
  var fps = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(0);
  if (typeof performance === "undefined") return fps;
  var every = (_a = options == null ? void 0 : options.every) != null ? _a : 10;
  var last = performance.now();
  var ticks = 0;
  useRafFn(function () {
    ticks += 1;
    if (ticks >= every) {
      var now = performance.now();
      var diff = now - last;
      fps.value = Math.round(1e3 / (diff / ticks));
      last = now;
      ticks = 0;
    }
  });
  return fps;
}
var eventHandlers = ["fullscreenchange", "webkitfullscreenchange", "webkitendfullscreen", "mozfullscreenchange", "MSFullscreenChange"];
function useFullscreen(target) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$document5 = options.document,
    document = _options$document5 === void 0 ? defaultDocument : _options$document5,
    _options$autoExit = options.autoExit,
    autoExit = _options$autoExit === void 0 ? false : _options$autoExit;
  var targetRef = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    var _a;
    return (_a = unrefElement(target)) != null ? _a : document == null ? void 0 : document.querySelector("html");
  });
  var isFullscreen = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  var requestMethod = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return ["requestFullscreen", "webkitRequestFullscreen", "webkitEnterFullscreen", "webkitEnterFullScreen", "webkitRequestFullScreen", "mozRequestFullScreen", "msRequestFullscreen"].find(function (m) {
      return document && m in document || targetRef.value && m in targetRef.value;
    });
  });
  var exitMethod = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return ["exitFullscreen", "webkitExitFullscreen", "webkitExitFullScreen", "webkitCancelFullScreen", "mozCancelFullScreen", "msExitFullscreen"].find(function (m) {
      return document && m in document || targetRef.value && m in targetRef.value;
    });
  });
  var fullscreenEnabled = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return ["fullScreen", "webkitIsFullScreen", "webkitDisplayingFullscreen", "mozFullScreen", "msFullscreenElement"].find(function (m) {
      return document && m in document || targetRef.value && m in targetRef.value;
    });
  });
  var fullscreenElementMethod = ["fullscreenElement", "webkitFullscreenElement", "mozFullScreenElement", "msFullscreenElement"].find(function (m) {
    return document && m in document;
  });
  var isSupported = useSupported(function () {
    return targetRef.value && document && requestMethod.value !== void 0 && exitMethod.value !== void 0 && fullscreenEnabled.value !== void 0;
  });
  var isCurrentElementFullScreen = function isCurrentElementFullScreen() {
    if (fullscreenElementMethod) return (document == null ? void 0 : document[fullscreenElementMethod]) === targetRef.value;
    return false;
  };
  var isElementFullScreen = function isElementFullScreen() {
    if (fullscreenEnabled.value) {
      if (document && document[fullscreenEnabled.value] != null) {
        return document[fullscreenEnabled.value];
      } else {
        var target2 = targetRef.value;
        if ((target2 == null ? void 0 : target2[fullscreenEnabled.value]) != null) {
          return Boolean(target2[fullscreenEnabled.value]);
        }
      }
    }
    return false;
  };
  function exit() {
    return _exit.apply(this, arguments);
  }
  function _exit() {
    _exit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
      var target2;
      return _regeneratorRuntime().wrap(function _callee24$(_context24) {
        while (1) switch (_context24.prev = _context24.next) {
          case 0:
            if (isSupported.value) {
              _context24.next = 2;
              break;
            }
            return _context24.abrupt("return");
          case 2:
            if (!exitMethod.value) {
              _context24.next = 12;
              break;
            }
            if (!((document == null ? void 0 : document[exitMethod.value]) != null)) {
              _context24.next = 8;
              break;
            }
            _context24.next = 6;
            return document[exitMethod.value]();
          case 6:
            _context24.next = 12;
            break;
          case 8:
            target2 = targetRef.value;
            if (!((target2 == null ? void 0 : target2[exitMethod.value]) != null)) {
              _context24.next = 12;
              break;
            }
            _context24.next = 12;
            return target2[exitMethod.value]();
          case 12:
            isFullscreen.value = false;
          case 13:
          case "end":
            return _context24.stop();
        }
      }, _callee24);
    }));
    return _exit.apply(this, arguments);
  }
  function enter() {
    return _enter.apply(this, arguments);
  }
  function _enter() {
    _enter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
      var target2;
      return _regeneratorRuntime().wrap(function _callee25$(_context25) {
        while (1) switch (_context25.prev = _context25.next) {
          case 0:
            if (isSupported.value) {
              _context25.next = 2;
              break;
            }
            return _context25.abrupt("return");
          case 2:
            if (!isElementFullScreen()) {
              _context25.next = 5;
              break;
            }
            _context25.next = 5;
            return exit();
          case 5:
            target2 = targetRef.value;
            if (!(requestMethod.value && (target2 == null ? void 0 : target2[requestMethod.value]) != null)) {
              _context25.next = 10;
              break;
            }
            _context25.next = 9;
            return target2[requestMethod.value]();
          case 9:
            isFullscreen.value = true;
          case 10:
          case "end":
            return _context25.stop();
        }
      }, _callee25);
    }));
    return _enter.apply(this, arguments);
  }
  function toggle() {
    return _toggle.apply(this, arguments);
  }
  function _toggle() {
    _toggle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
      return _regeneratorRuntime().wrap(function _callee26$(_context26) {
        while (1) switch (_context26.prev = _context26.next) {
          case 0:
            _context26.next = 2;
            return isFullscreen.value ? exit() : enter();
          case 2:
          case "end":
            return _context26.stop();
        }
      }, _callee26);
    }));
    return _toggle.apply(this, arguments);
  }
  var handlerCallback = function handlerCallback() {
    var isElementFullScreenValue = isElementFullScreen();
    if (!isElementFullScreenValue || isElementFullScreenValue && isCurrentElementFullScreen()) isFullscreen.value = isElementFullScreenValue;
  };
  useEventListener(document, eventHandlers, handlerCallback, false);
  useEventListener(function () {
    return unrefElement(targetRef);
  }, eventHandlers, handlerCallback, false);
  if (autoExit) Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["F" /* tryOnScopeDispose */])(exit);
  return {
    isSupported: isSupported,
    isFullscreen: isFullscreen,
    enter: enter,
    exit: exit,
    toggle: toggle
  };
}
function mapGamepadToXbox360Controller(gamepad) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    if (gamepad.value) {
      return {
        buttons: {
          a: gamepad.value.buttons[0],
          b: gamepad.value.buttons[1],
          x: gamepad.value.buttons[2],
          y: gamepad.value.buttons[3]
        },
        bumper: {
          left: gamepad.value.buttons[4],
          right: gamepad.value.buttons[5]
        },
        triggers: {
          left: gamepad.value.buttons[6],
          right: gamepad.value.buttons[7]
        },
        stick: {
          left: {
            horizontal: gamepad.value.axes[0],
            vertical: gamepad.value.axes[1],
            button: gamepad.value.buttons[10]
          },
          right: {
            horizontal: gamepad.value.axes[2],
            vertical: gamepad.value.axes[3],
            button: gamepad.value.buttons[11]
          }
        },
        dpad: {
          up: gamepad.value.buttons[12],
          down: gamepad.value.buttons[13],
          left: gamepad.value.buttons[14],
          right: gamepad.value.buttons[15]
        },
        back: gamepad.value.buttons[8],
        start: gamepad.value.buttons[9]
      };
    }
    return null;
  });
}
function useGamepad() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$navigator5 = options.navigator,
    navigator = _options$navigator5 === void 0 ? defaultNavigator : _options$navigator5;
  var isSupported = useSupported(function () {
    return navigator && "getGamepads" in navigator;
  });
  var gamepads = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])([]);
  var onConnectedHook = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["e" /* createEventHook */])();
  var onDisconnectedHook = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["e" /* createEventHook */])();
  var stateFromGamepad = function stateFromGamepad(gamepad) {
    var hapticActuators = [];
    var vibrationActuator = "vibrationActuator" in gamepad ? gamepad.vibrationActuator : null;
    if (vibrationActuator) hapticActuators.push(vibrationActuator);
    if (gamepad.hapticActuators) hapticActuators.push.apply(hapticActuators, _toConsumableArray(gamepad.hapticActuators));
    return {
      id: gamepad.id,
      hapticActuators: hapticActuators,
      index: gamepad.index,
      mapping: gamepad.mapping,
      connected: gamepad.connected,
      timestamp: gamepad.timestamp,
      axes: gamepad.axes.map(function (axes) {
        return axes;
      }),
      buttons: gamepad.buttons.map(function (button) {
        return {
          pressed: button.pressed,
          touched: button.touched,
          value: button.value
        };
      })
    };
  };
  var updateGamepadState = function updateGamepadState() {
    var _gamepads = (navigator == null ? void 0 : navigator.getGamepads()) || [];
    var _loop3 = function _loop3() {
      var gamepad = _gamepads[i];
      if (gamepad) {
        var index = gamepads.value.findIndex(function (_ref40) {
          var index2 = _ref40.index;
          return index2 === gamepad.index;
        });
        if (index > -1) gamepads.value[index] = stateFromGamepad(gamepad);
      }
    };
    for (var i = 0; i < _gamepads.length; ++i) {
      _loop3();
    }
  };
  var _useRafFn2 = useRafFn(updateGamepadState),
    isActive = _useRafFn2.isActive,
    pause = _useRafFn2.pause,
    resume = _useRafFn2.resume;
  var onGamepadConnected = function onGamepadConnected(gamepad) {
    if (!gamepads.value.some(function (_ref41) {
      var index = _ref41.index;
      return index === gamepad.index;
    })) {
      gamepads.value.push(stateFromGamepad(gamepad));
      onConnectedHook.trigger(gamepad.index);
    }
    resume();
  };
  var onGamepadDisconnected = function onGamepadDisconnected(gamepad) {
    gamepads.value = gamepads.value.filter(function (x) {
      return x.index !== gamepad.index;
    });
    onDisconnectedHook.trigger(gamepad.index);
  };
  useEventListener("gamepadconnected", function (e) {
    return onGamepadConnected(e.gamepad);
  });
  useEventListener("gamepaddisconnected", function (e) {
    return onGamepadDisconnected(e.gamepad);
  });
  Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["E" /* tryOnMounted */])(function () {
    var _gamepads = (navigator == null ? void 0 : navigator.getGamepads()) || [];
    if (_gamepads) {
      for (var i = 0; i < _gamepads.length; ++i) {
        var gamepad = _gamepads[i];
        if (gamepad) onGamepadConnected(gamepad);
      }
    }
  });
  pause();
  return {
    isSupported: isSupported,
    onConnected: onConnectedHook.on,
    onDisconnected: onDisconnectedHook.on,
    gamepads: gamepads,
    pause: pause,
    resume: resume,
    isActive: isActive
  };
}
function useGeolocation() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$enableHighAc = options.enableHighAccuracy,
    enableHighAccuracy = _options$enableHighAc === void 0 ? true : _options$enableHighAc,
    _options$maximumAge = options.maximumAge,
    maximumAge = _options$maximumAge === void 0 ? 3e4 : _options$maximumAge,
    _options$timeout = options.timeout,
    timeout = _options$timeout === void 0 ? 27e3 : _options$timeout,
    _options$navigator6 = options.navigator,
    navigator = _options$navigator6 === void 0 ? defaultNavigator : _options$navigator6,
    _options$immediate5 = options.immediate,
    immediate = _options$immediate5 === void 0 ? true : _options$immediate5;
  var isSupported = useSupported(function () {
    return navigator && "geolocation" in navigator;
  });
  var locatedAt = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(null);
  var error = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["shallowRef"])(null);
  var coords = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])({
    accuracy: 0,
    latitude: Infinity,
    longitude: Infinity,
    altitude: null,
    altitudeAccuracy: null,
    heading: null,
    speed: null
  });
  function updatePosition(position) {
    locatedAt.value = position.timestamp;
    coords.value = position.coords;
    error.value = null;
  }
  var watcher;
  function resume() {
    if (isSupported.value) {
      watcher = navigator.geolocation.watchPosition(updatePosition, function (err) {
        return error.value = err;
      }, {
        enableHighAccuracy: enableHighAccuracy,
        maximumAge: maximumAge,
        timeout: timeout
      });
    }
  }
  if (immediate) resume();
  function pause() {
    if (watcher && navigator) navigator.geolocation.clearWatch(watcher);
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["F" /* tryOnScopeDispose */])(function () {
    pause();
  });
  return {
    isSupported: isSupported,
    coords: coords,
    locatedAt: locatedAt,
    error: error,
    resume: resume,
    pause: pause
  };
}
var defaultEvents$1 = ["mousemove", "mousedown", "resize", "keydown", "touchstart", "wheel"];
var oneMinute = 6e4;
function useIdle() {
  var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : oneMinute;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$initialState = options.initialState,
    initialState = _options$initialState === void 0 ? false : _options$initialState,
    _options$listenForVis = options.listenForVisibilityChange,
    listenForVisibilityChange = _options$listenForVis === void 0 ? true : _options$listenForVis,
    _options$events = options.events,
    events = _options$events === void 0 ? defaultEvents$1 : _options$events,
    _options$window16 = options.window,
    window = _options$window16 === void 0 ? defaultWindow : _options$window16,
    _options$eventFilter2 = options.eventFilter,
    eventFilter = _options$eventFilter2 === void 0 ? Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["z" /* throttleFilter */])(50) : _options$eventFilter2;
  var idle = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(initialState);
  var lastActive = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["A" /* timestamp */])());
  var timer;
  var reset = function reset() {
    idle.value = false;
    clearTimeout(timer);
    timer = setTimeout(function () {
      return idle.value = true;
    }, timeout);
  };
  var onEvent = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["f" /* createFilterWrapper */])(eventFilter, function () {
    lastActive.value = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["A" /* timestamp */])();
    reset();
  });
  if (window) {
    var _document2 = window.document;
    var _iterator25 = _createForOfIteratorHelper(events),
      _step25;
    try {
      for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
        var event = _step25.value;
        useEventListener(window, event, onEvent, {
          passive: true
        });
      }
    } catch (err) {
      _iterator25.e(err);
    } finally {
      _iterator25.f();
    }
    if (listenForVisibilityChange) {
      useEventListener(_document2, "visibilitychange", function () {
        if (!_document2.hidden) onEvent();
      });
    }
    reset();
  }
  return {
    idle: idle,
    lastActive: lastActive,
    reset: reset
  };
}
var __defProp$a = Object.defineProperty;
var __getOwnPropSymbols$b = Object.getOwnPropertySymbols;
var __hasOwnProp$b = Object.prototype.hasOwnProperty;
var __propIsEnum$b = Object.prototype.propertyIsEnumerable;
var __defNormalProp$a = function __defNormalProp$a(obj, key, value) {
  return key in obj ? __defProp$a(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$a = function __spreadValues$a(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$b.call(b, prop)) __defNormalProp$a(a, prop, b[prop]);
  if (__getOwnPropSymbols$b) {
    var _iterator26 = _createForOfIteratorHelper(__getOwnPropSymbols$b(b)),
      _step26;
    try {
      for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
        var prop = _step26.value;
        if (__propIsEnum$b.call(b, prop)) __defNormalProp$a(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator26.e(err);
    } finally {
      _iterator26.f();
    }
  }
  return a;
};
function loadImage(_x8) {
  return _loadImage.apply(this, arguments);
}
function _loadImage() {
  _loadImage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee44(options) {
    return _regeneratorRuntime().wrap(function _callee44$(_context44) {
      while (1) switch (_context44.prev = _context44.next) {
        case 0:
          return _context44.abrupt("return", new Promise(function (resolve, reject) {
            var img = new Image();
            var src = options.src,
              srcset = options.srcset,
              sizes = options.sizes,
              clazz = options.class,
              loading = options.loading,
              crossorigin = options.crossorigin;
            img.src = src;
            if (srcset) img.srcset = srcset;
            if (sizes) img.sizes = sizes;
            if (clazz) img.className = clazz;
            if (loading) img.loading = loading;
            if (crossorigin) img.crossOrigin = crossorigin;
            img.onload = function () {
              return resolve(img);
            };
            img.onerror = reject;
          }));
        case 1:
        case "end":
          return _context44.stop();
      }
    }, _callee44);
  }));
  return _loadImage.apply(this, arguments);
}
function useImage(options) {
  var asyncStateOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var state = useAsyncState(function () {
    return loadImage(Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(options));
  }, void 0, __spreadValues$a({
    resetOnExecute: true
  }, asyncStateOptions));
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(options);
  }, function () {
    return state.execute(asyncStateOptions.delay);
  }, {
    deep: true
  });
  return state;
}
var ARRIVED_STATE_THRESHOLD_PIXELS = 1;
function useScroll(element) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$throttle = options.throttle,
    throttle = _options$throttle === void 0 ? 0 : _options$throttle,
    _options$idle = options.idle,
    idle = _options$idle === void 0 ? 200 : _options$idle,
    _options$onStop = options.onStop,
    onStop = _options$onStop === void 0 ? __WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["q" /* noop */] : _options$onStop,
    _options$onScroll = options.onScroll,
    onScroll = _options$onScroll === void 0 ? __WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["q" /* noop */] : _options$onScroll,
    _options$offset = options.offset,
    offset = _options$offset === void 0 ? {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    } : _options$offset,
    _options$eventListene = options.eventListenerOptions,
    eventListenerOptions = _options$eventListene === void 0 ? {
      capture: false,
      passive: true
    } : _options$eventListene,
    _options$behavior = options.behavior,
    behavior = _options$behavior === void 0 ? "auto" : _options$behavior;
  var internalX = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(0);
  var internalY = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(0);
  var x = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])({
    get: function get() {
      return internalX.value;
    },
    set: function set(x2) {
      scrollTo(x2, void 0);
    }
  });
  var y = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])({
    get: function get() {
      return internalY.value;
    },
    set: function set(y2) {
      scrollTo(void 0, y2);
    }
  });
  function scrollTo(_x, _y) {
    var _a, _b, _c;
    var _element = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(element);
    if (!_element) return;
    (_c = _element instanceof Document ? document.body : _element) == null ? void 0 : _c.scrollTo({
      top: (_a = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(_y)) != null ? _a : y.value,
      left: (_b = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(_x)) != null ? _b : x.value,
      behavior: Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(behavior)
    });
  }
  var isScrolling = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  var arrivedState = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["reactive"])({
    left: true,
    right: false,
    top: true,
    bottom: false
  });
  var directions = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["reactive"])({
    left: false,
    right: false,
    top: false,
    bottom: false
  });
  var onScrollEnd = function onScrollEnd(e) {
    if (!isScrolling.value) return;
    isScrolling.value = false;
    directions.left = false;
    directions.right = false;
    directions.top = false;
    directions.bottom = false;
    onStop(e);
  };
  var onScrollEndDebounced = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["I" /* useDebounceFn */])(onScrollEnd, throttle + idle);
  var setArrivedState = function setArrivedState(target) {
    var el = target === document ? target.documentElement : target;
    var _getComputedStyle = getComputedStyle(el),
      display = _getComputedStyle.display,
      flexDirection = _getComputedStyle.flexDirection;
    var scrollLeft = el.scrollLeft;
    directions.left = scrollLeft < internalX.value;
    directions.right = scrollLeft > internalX.value;
    var left = Math.abs(scrollLeft) <= 0 + (offset.left || 0);
    var right = Math.abs(scrollLeft) + el.clientWidth >= el.scrollWidth - (offset.right || 0) - ARRIVED_STATE_THRESHOLD_PIXELS;
    if (display === "flex" && flexDirection === "row-reverse") {
      arrivedState.left = right;
      arrivedState.right = left;
    } else {
      arrivedState.left = left;
      arrivedState.right = right;
    }
    internalX.value = scrollLeft;
    var scrollTop = el.scrollTop;
    if (target === document && !scrollTop) scrollTop = document.body.scrollTop;
    directions.top = scrollTop < internalY.value;
    directions.bottom = scrollTop > internalY.value;
    var top = Math.abs(scrollTop) <= 0 + (offset.top || 0);
    var bottom = Math.abs(scrollTop) + el.clientHeight >= el.scrollHeight - (offset.bottom || 0) - ARRIVED_STATE_THRESHOLD_PIXELS;
    if (display === "flex" && flexDirection === "column-reverse") {
      arrivedState.top = bottom;
      arrivedState.bottom = top;
    } else {
      arrivedState.top = top;
      arrivedState.bottom = bottom;
    }
    internalY.value = scrollTop;
  };
  var onScrollHandler = function onScrollHandler(e) {
    var eventTarget = e.target === document ? e.target.documentElement : e.target;
    setArrivedState(eventTarget);
    isScrolling.value = true;
    onScrollEndDebounced(e);
    onScroll(e);
  };
  useEventListener(element, "scroll", throttle ? Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["K" /* useThrottleFn */])(onScrollHandler, throttle, true, false) : onScrollHandler, eventListenerOptions);
  useEventListener(element, "scrollend", onScrollEnd, eventListenerOptions);
  return {
    x: x,
    y: y,
    isScrolling: isScrolling,
    arrivedState: arrivedState,
    directions: directions,
    measure: function measure() {
      var _element = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(element);
      if (_element) setArrivedState(_element);
    }
  };
}
var __defProp$9 = Object.defineProperty;
var __defProps$3 = Object.defineProperties;
var __getOwnPropDescs$3 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$a = Object.getOwnPropertySymbols;
var __hasOwnProp$a = Object.prototype.hasOwnProperty;
var __propIsEnum$a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$9 = function __defNormalProp$9(obj, key, value) {
  return key in obj ? __defProp$9(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$9 = function __spreadValues$9(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$a.call(b, prop)) __defNormalProp$9(a, prop, b[prop]);
  if (__getOwnPropSymbols$a) {
    var _iterator27 = _createForOfIteratorHelper(__getOwnPropSymbols$a(b)),
      _step27;
    try {
      for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
        var prop = _step27.value;
        if (__propIsEnum$a.call(b, prop)) __defNormalProp$9(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator27.e(err);
    } finally {
      _iterator27.f();
    }
  }
  return a;
};
var __spreadProps$3 = function __spreadProps$3(a, b) {
  return __defProps$3(a, __getOwnPropDescs$3(b));
};
function useInfiniteScroll(element, onLoadMore) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _a;
  var _options$direction = options.direction,
    direction = _options$direction === void 0 ? "bottom" : _options$direction,
    _options$interval = options.interval,
    interval = _options$interval === void 0 ? 100 : _options$interval;
  var state = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["reactive"])(useScroll(element, __spreadProps$3(__spreadValues$9({}, options), {
    offset: __spreadValues$9(_defineProperty({}, direction, (_a = options.distance) != null ? _a : 0), options.offset)
  })));
  var promise = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])();
  var isLoading = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return !!promise.value;
  });
  function checkAndLoad() {
    state.measure();
    var el = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(element);
    if (!el) return;
    var isNarrower = direction === "bottom" || direction === "top" ? el.scrollHeight <= el.clientHeight : el.scrollWidth <= el.clientWidth;
    if (state.arrivedState[direction] || isNarrower) {
      if (!promise.value) {
        promise.value = Promise.all([onLoadMore(state), new Promise(function (resolve) {
          return setTimeout(resolve, interval);
        })]).finally(function () {
          promise.value = null;
          Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["nextTick"])(function () {
            return checkAndLoad();
          });
        });
      }
    }
  }
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(function () {
    return [state.arrivedState[direction], Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(element)];
  }, checkAndLoad, {
    immediate: true
  });
  return {
    isLoading: isLoading
  };
}
var defaultEvents = ["mousedown", "mouseup", "keydown", "keyup"];
function useKeyModifier(modifier) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$events2 = options.events,
    events = _options$events2 === void 0 ? defaultEvents : _options$events2,
    _options$document6 = options.document,
    document = _options$document6 === void 0 ? defaultDocument : _options$document6,
    _options$initial = options.initial,
    initial = _options$initial === void 0 ? null : _options$initial;
  var state = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(initial);
  if (document) {
    events.forEach(function (listenerEvent) {
      useEventListener(document, listenerEvent, function (evt) {
        if (typeof evt.getModifierState === "function") state.value = evt.getModifierState(modifier);
      });
    });
  }
  return state;
}
function useLocalStorage(key, initialValue) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$window17 = options.window,
    window = _options$window17 === void 0 ? defaultWindow : _options$window17;
  return useStorage(key, initialValue, window == null ? void 0 : window.localStorage, options);
}
var DefaultMagicKeysAliasMap = {
  ctrl: "control",
  command: "meta",
  cmd: "meta",
  option: "alt",
  up: "arrowup",
  down: "arrowdown",
  left: "arrowleft",
  right: "arrowright"
};
function useMagicKeys() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$reactive = options.reactive,
    useReactive = _options$reactive === void 0 ? false : _options$reactive,
    _options$target = options.target,
    target = _options$target === void 0 ? defaultWindow : _options$target,
    _options$aliasMap = options.aliasMap,
    aliasMap = _options$aliasMap === void 0 ? DefaultMagicKeysAliasMap : _options$aliasMap,
    _options$passive = options.passive,
    passive = _options$passive === void 0 ? true : _options$passive,
    _options$onEventFired = options.onEventFired,
    onEventFired = _options$onEventFired === void 0 ? __WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["q" /* noop */] : _options$onEventFired;
  var current = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["reactive"])( /* @__PURE__ */new Set());
  var obj = {
    toJSON: function toJSON() {
      return {};
    },
    current: current
  };
  var refs = useReactive ? Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["reactive"])(obj) : obj;
  var metaDeps = /* @__PURE__ */new Set();
  var usedKeys = /* @__PURE__ */new Set();
  function setRefs(key, value) {
    if (key in refs) {
      if (useReactive) refs[key] = value;else refs[key].value = value;
    }
  }
  function reset() {
    current.clear();
    var _iterator28 = _createForOfIteratorHelper(usedKeys),
      _step28;
    try {
      for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
        var key = _step28.value;
        setRefs(key, false);
      }
    } catch (err) {
      _iterator28.e(err);
    } finally {
      _iterator28.f();
    }
  }
  function updateRefs(e, value) {
    var _a, _b;
    var key = (_a = e.key) == null ? void 0 : _a.toLowerCase();
    var code = (_b = e.code) == null ? void 0 : _b.toLowerCase();
    var values = [code, key].filter(Boolean);
    if (key) {
      if (value) current.add(key);else current.delete(key);
    }
    var _iterator29 = _createForOfIteratorHelper(values),
      _step29;
    try {
      for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
        var key2 = _step29.value;
        usedKeys.add(key2);
        setRefs(key2, value);
      }
    } catch (err) {
      _iterator29.e(err);
    } finally {
      _iterator29.f();
    }
    if (key === "meta" && !value) {
      metaDeps.forEach(function (key2) {
        current.delete(key2);
        setRefs(key2, false);
      });
      metaDeps.clear();
    } else if (typeof e.getModifierState === "function" && e.getModifierState("Meta") && value) {
      [].concat(_toConsumableArray(current), _toConsumableArray(values)).forEach(function (key2) {
        return metaDeps.add(key2);
      });
    }
  }
  useEventListener(target, "keydown", function (e) {
    updateRefs(e, true);
    return onEventFired(e);
  }, {
    passive: passive
  });
  useEventListener(target, "keyup", function (e) {
    updateRefs(e, false);
    return onEventFired(e);
  }, {
    passive: passive
  });
  useEventListener("blur", reset, {
    passive: true
  });
  useEventListener("focus", reset, {
    passive: true
  });
  var proxy = new Proxy(refs, {
    get: function get(target2, prop, rec) {
      if (typeof prop !== "string") return Reflect.get(target2, prop, rec);
      prop = prop.toLowerCase();
      if (prop in aliasMap) prop = aliasMap[prop];
      if (!(prop in refs)) {
        if (/[+_-]/.test(prop)) {
          var _keys = prop.split(/[+_-]/g).map(function (i) {
            return i.trim();
          });
          refs[prop] = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
            return _keys.every(function (key) {
              return Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(proxy[key]);
            });
          });
        } else {
          refs[prop] = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
        }
      }
      var r = Reflect.get(target2, prop, rec);
      return useReactive ? Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(r) : r;
    }
  });
  return proxy;
}
var __defProp$8 = Object.defineProperty;
var __getOwnPropSymbols$9 = Object.getOwnPropertySymbols;
var __hasOwnProp$9 = Object.prototype.hasOwnProperty;
var __propIsEnum$9 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$8 = function __defNormalProp$8(obj, key, value) {
  return key in obj ? __defProp$8(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$8 = function __spreadValues$8(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$9.call(b, prop)) __defNormalProp$8(a, prop, b[prop]);
  if (__getOwnPropSymbols$9) {
    var _iterator30 = _createForOfIteratorHelper(__getOwnPropSymbols$9(b)),
      _step30;
    try {
      for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
        var prop = _step30.value;
        if (__propIsEnum$9.call(b, prop)) __defNormalProp$8(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator30.e(err);
    } finally {
      _iterator30.f();
    }
  }
  return a;
};
function usingElRef(source, cb) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(source)) cb(Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(source));
}
function timeRangeToArray(timeRanges) {
  var ranges = [];
  for (var i = 0; i < timeRanges.length; ++i) ranges = [].concat(_toConsumableArray(ranges), [[timeRanges.start(i), timeRanges.end(i)]]);
  return ranges;
}
function tracksToArray(tracks) {
  return Array.from(tracks).map(function (_ref42, id) {
    var label = _ref42.label,
      kind = _ref42.kind,
      language = _ref42.language,
      mode = _ref42.mode,
      activeCues = _ref42.activeCues,
      cues = _ref42.cues,
      inBandMetadataTrackDispatchType = _ref42.inBandMetadataTrackDispatchType;
    return {
      id: id,
      label: label,
      kind: kind,
      language: language,
      mode: mode,
      activeCues: activeCues,
      cues: cues,
      inBandMetadataTrackDispatchType: inBandMetadataTrackDispatchType
    };
  });
}
var defaultOptions = {
  src: "",
  tracks: []
};
function useMediaControls(target) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  options = __spreadValues$8(__spreadValues$8({}, defaultOptions), options);
  var _options5 = options,
    _options5$document = _options5.document,
    document = _options5$document === void 0 ? defaultDocument : _options5$document;
  var currentTime = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(0);
  var duration = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(0);
  var seeking = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  var volume = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(1);
  var waiting = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  var ended = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  var playing = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  var rate = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(1);
  var stalled = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  var buffered = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])([]);
  var tracks = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])([]);
  var selectedTrack = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(-1);
  var isPictureInPicture = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  var muted = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  var supportsPictureInPicture = document && "pictureInPictureEnabled" in document;
  var sourceErrorEvent = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["e" /* createEventHook */])();
  var disableTrack = function disableTrack(track) {
    usingElRef(target, function (el) {
      if (track) {
        var id = typeof track === "number" ? track : track.id;
        el.textTracks[id].mode = "disabled";
      } else {
        for (var i = 0; i < el.textTracks.length; ++i) el.textTracks[i].mode = "disabled";
      }
      selectedTrack.value = -1;
    });
  };
  var enableTrack = function enableTrack(track) {
    var disableTracks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    usingElRef(target, function (el) {
      var id = typeof track === "number" ? track : track.id;
      if (disableTracks) disableTrack();
      el.textTracks[id].mode = "showing";
      selectedTrack.value = id;
    });
  };
  var togglePictureInPicture = function togglePictureInPicture() {
    return new Promise(function (resolve, reject) {
      usingElRef(target, /*#__PURE__*/function () {
        var _ref43 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee27(el) {
          return _regeneratorRuntime().wrap(function _callee27$(_context27) {
            while (1) switch (_context27.prev = _context27.next) {
              case 0:
                if (supportsPictureInPicture) {
                  if (!isPictureInPicture.value) {
                    el.requestPictureInPicture().then(resolve).catch(reject);
                  } else {
                    document.exitPictureInPicture().then(resolve).catch(reject);
                  }
                }
              case 1:
              case "end":
                return _context27.stop();
            }
          }, _callee27);
        }));
        return function (_x9) {
          return _ref43.apply(this, arguments);
        };
      }());
    });
  };
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watchEffect"])(function () {
    if (!document) return;
    var el = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(target);
    if (!el) return;
    var src = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(options.src);
    var sources = [];
    if (!src) return;
    if (typeof src === "string") sources = [{
      src: src
    }];else if (Array.isArray(src)) sources = src;else if (Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["o" /* isObject */])(src)) sources = [src];
    el.querySelectorAll("source").forEach(function (e) {
      e.removeEventListener("error", sourceErrorEvent.trigger);
      e.remove();
    });
    sources.forEach(function (_ref44) {
      var src2 = _ref44.src,
        type = _ref44.type;
      var source = document.createElement("source");
      source.setAttribute("src", src2);
      source.setAttribute("type", type || "");
      source.addEventListener("error", sourceErrorEvent.trigger);
      el.appendChild(source);
    });
    el.load();
  });
  Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["F" /* tryOnScopeDispose */])(function () {
    var el = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(target);
    if (!el) return;
    el.querySelectorAll("source").forEach(function (e) {
      return e.removeEventListener("error", sourceErrorEvent.trigger);
    });
  });
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])([target, volume], function () {
    var el = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(target);
    if (!el) return;
    el.volume = volume.value;
  });
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])([target, muted], function () {
    var el = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(target);
    if (!el) return;
    el.muted = muted.value;
  });
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])([target, rate], function () {
    var el = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(target);
    if (!el) return;
    el.playbackRate = rate.value;
  });
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watchEffect"])(function () {
    if (!document) return;
    var textTracks = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(options.tracks);
    var el = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(target);
    if (!textTracks || !textTracks.length || !el) return;
    el.querySelectorAll("track").forEach(function (e) {
      return e.remove();
    });
    textTracks.forEach(function (_ref45, i) {
      var isDefault = _ref45.default,
        kind = _ref45.kind,
        label = _ref45.label,
        src = _ref45.src,
        srcLang = _ref45.srcLang;
      var track = document.createElement("track");
      track.default = isDefault || false;
      track.kind = kind;
      track.label = label;
      track.src = src;
      track.srclang = srcLang;
      if (track.default) selectedTrack.value = i;
      el.appendChild(track);
    });
  });
  var _watchIgnorable2 = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["M" /* watchIgnorable */])(currentTime, function (time) {
      var el = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(target);
      if (!el) return;
      el.currentTime = time;
    }),
    ignoreCurrentTimeUpdates = _watchIgnorable2.ignoreUpdates;
  var _watchIgnorable3 = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["M" /* watchIgnorable */])(playing, function (isPlaying) {
      var el = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(target);
      if (!el) return;
      isPlaying ? el.play() : el.pause();
    }),
    ignorePlayingUpdates = _watchIgnorable3.ignoreUpdates;
  useEventListener(target, "timeupdate", function () {
    return ignoreCurrentTimeUpdates(function () {
      return currentTime.value = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(target).currentTime;
    });
  });
  useEventListener(target, "durationchange", function () {
    return duration.value = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(target).duration;
  });
  useEventListener(target, "progress", function () {
    return buffered.value = timeRangeToArray(Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(target).buffered);
  });
  useEventListener(target, "seeking", function () {
    return seeking.value = true;
  });
  useEventListener(target, "seeked", function () {
    return seeking.value = false;
  });
  useEventListener(target, "waiting", function () {
    return waiting.value = true;
  });
  useEventListener(target, "playing", function () {
    waiting.value = false;
    ended.value = false;
  });
  useEventListener(target, "ratechange", function () {
    return rate.value = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(target).playbackRate;
  });
  useEventListener(target, "stalled", function () {
    return stalled.value = true;
  });
  useEventListener(target, "ended", function () {
    return ended.value = true;
  });
  useEventListener(target, "pause", function () {
    return ignorePlayingUpdates(function () {
      return playing.value = false;
    });
  });
  useEventListener(target, "play", function () {
    return ignorePlayingUpdates(function () {
      return playing.value = true;
    });
  });
  useEventListener(target, "enterpictureinpicture", function () {
    return isPictureInPicture.value = true;
  });
  useEventListener(target, "leavepictureinpicture", function () {
    return isPictureInPicture.value = false;
  });
  useEventListener(target, "volumechange", function () {
    var el = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(target);
    if (!el) return;
    volume.value = el.volume;
    muted.value = el.muted;
  });
  var listeners = [];
  var stop = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])([target], function () {
    var el = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(target);
    if (!el) return;
    stop();
    listeners[0] = useEventListener(el.textTracks, "addtrack", function () {
      return tracks.value = tracksToArray(el.textTracks);
    });
    listeners[1] = useEventListener(el.textTracks, "removetrack", function () {
      return tracks.value = tracksToArray(el.textTracks);
    });
    listeners[2] = useEventListener(el.textTracks, "change", function () {
      return tracks.value = tracksToArray(el.textTracks);
    });
  });
  Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["F" /* tryOnScopeDispose */])(function () {
    return listeners.forEach(function (listener) {
      return listener();
    });
  });
  return {
    currentTime: currentTime,
    duration: duration,
    waiting: waiting,
    seeking: seeking,
    ended: ended,
    stalled: stalled,
    buffered: buffered,
    playing: playing,
    rate: rate,
    // Volume
    volume: volume,
    muted: muted,
    // Tracks
    tracks: tracks,
    selectedTrack: selectedTrack,
    enableTrack: enableTrack,
    disableTrack: disableTrack,
    // Picture in Picture
    supportsPictureInPicture: supportsPictureInPicture,
    togglePictureInPicture: togglePictureInPicture,
    isPictureInPicture: isPictureInPicture,
    // Events
    onSourceError: sourceErrorEvent.on
  };
}
function getMapVue2Compat() {
  var data = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["reactive"])({});
  return {
    get: function get(key) {
      return data[key];
    },
    set: function set(key, value) {
      return Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["set"])(data, key, value);
    },
    has: function has(key) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["i" /* hasOwn */])(data, key);
    },
    delete: function _delete(key) {
      return Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["del"])(data, key);
    },
    clear: function clear() {
      Object.keys(data).forEach(function (key) {
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["del"])(data, key);
      });
    }
  };
}
function useMemoize(resolver, options) {
  var initCache = function initCache() {
    if (options == null ? void 0 : options.cache) return Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["reactive"])(options.cache);
    if (__WEBPACK_IMPORTED_MODULE_1_vue_demi__["isVue2"]) return getMapVue2Compat();
    return Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["reactive"])( /* @__PURE__ */new Map());
  };
  var cache = initCache();
  var generateKey = function generateKey() {
    for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }
    return (options == null ? void 0 : options.getKey) ? options.getKey.apply(options, args) : JSON.stringify(args);
  };
  var _loadData = function _loadData(key) {
    for (var _len8 = arguments.length, args = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
      args[_key8 - 1] = arguments[_key8];
    }
    cache.set(key, resolver.apply(void 0, args));
    return cache.get(key);
  };
  var loadData = function loadData() {
    for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
      args[_key9] = arguments[_key9];
    }
    return _loadData.apply(void 0, [generateKey.apply(void 0, args)].concat(args));
  };
  var deleteData = function deleteData() {
    cache.delete(generateKey.apply(void 0, arguments));
  };
  var clearData = function clearData() {
    cache.clear();
  };
  var memoized = function memoized() {
    for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
      args[_key10] = arguments[_key10];
    }
    var key = generateKey.apply(void 0, args);
    if (cache.has(key)) return cache.get(key);
    return _loadData.apply(void 0, [key].concat(args));
  };
  memoized.load = loadData;
  memoized.delete = deleteData;
  memoized.clear = clearData;
  memoized.generateKey = generateKey;
  memoized.cache = cache;
  return memoized;
}
function useMemory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var memory = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])();
  var isSupported = useSupported(function () {
    return typeof performance !== "undefined" && "memory" in performance;
  });
  if (isSupported.value) {
    var _options$interval2 = options.interval,
      interval = _options$interval2 === void 0 ? 1e3 : _options$interval2;
    Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["J" /* useIntervalFn */])(function () {
      memory.value = performance.memory;
    }, interval, {
      immediate: options.immediate,
      immediateCallback: options.immediateCallback
    });
  }
  return {
    isSupported: isSupported,
    memory: memory
  };
}
var BuiltinExtractors = {
  page: function page(event) {
    return [event.pageX, event.pageY];
  },
  client: function client(event) {
    return [event.clientX, event.clientY];
  },
  screen: function screen(event) {
    return [event.screenX, event.screenY];
  },
  movement: function movement(event) {
    return event instanceof Touch ? null : [event.movementX, event.movementY];
  }
};
function useMouse() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$type = options.type,
    type = _options$type === void 0 ? "page" : _options$type,
    _options$touch = options.touch,
    touch = _options$touch === void 0 ? true : _options$touch,
    _options$resetOnTouch = options.resetOnTouchEnds,
    resetOnTouchEnds = _options$resetOnTouch === void 0 ? false : _options$resetOnTouch,
    _options$initialValue5 = options.initialValue,
    initialValue = _options$initialValue5 === void 0 ? {
      x: 0,
      y: 0
    } : _options$initialValue5,
    _options$window18 = options.window,
    window = _options$window18 === void 0 ? defaultWindow : _options$window18,
    _options$target2 = options.target,
    target = _options$target2 === void 0 ? window : _options$target2,
    eventFilter = options.eventFilter;
  var x = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(initialValue.x);
  var y = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(initialValue.y);
  var sourceType = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(null);
  var extractor = typeof type === "function" ? type : BuiltinExtractors[type];
  var mouseHandler = function mouseHandler(event) {
    var result = extractor(event);
    if (result) {
      var _result = _slicedToArray(result, 2);
      x.value = _result[0];
      y.value = _result[1];
      sourceType.value = "mouse";
    }
  };
  var touchHandler = function touchHandler(event) {
    if (event.touches.length > 0) {
      var result = extractor(event.touches[0]);
      if (result) {
        var _result2 = _slicedToArray(result, 2);
        x.value = _result2[0];
        y.value = _result2[1];
        sourceType.value = "touch";
      }
    }
  };
  var reset = function reset() {
    x.value = initialValue.x;
    y.value = initialValue.y;
  };
  var mouseHandlerWrapper = eventFilter ? function (event) {
    return eventFilter(function () {
      return mouseHandler(event);
    }, {});
  } : function (event) {
    return mouseHandler(event);
  };
  var touchHandlerWrapper = eventFilter ? function (event) {
    return eventFilter(function () {
      return touchHandler(event);
    }, {});
  } : function (event) {
    return touchHandler(event);
  };
  if (target) {
    useEventListener(target, "mousemove", mouseHandlerWrapper, {
      passive: true
    });
    useEventListener(target, "dragover", mouseHandlerWrapper, {
      passive: true
    });
    if (touch && type !== "movement") {
      useEventListener(target, "touchstart", touchHandlerWrapper, {
        passive: true
      });
      useEventListener(target, "touchmove", touchHandlerWrapper, {
        passive: true
      });
      if (resetOnTouchEnds) useEventListener(target, "touchend", reset, {
        passive: true
      });
    }
  }
  return {
    x: x,
    y: y,
    sourceType: sourceType
  };
}
function useMouseInElement(target) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$handleOutsid = options.handleOutside,
    handleOutside = _options$handleOutsid === void 0 ? true : _options$handleOutsid,
    _options$window19 = options.window,
    window = _options$window19 === void 0 ? defaultWindow : _options$window19;
  var _useMouse = useMouse(options),
    x = _useMouse.x,
    y = _useMouse.y,
    sourceType = _useMouse.sourceType;
  var targetRef = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(target != null ? target : window == null ? void 0 : window.document.body);
  var elementX = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(0);
  var elementY = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(0);
  var elementPositionX = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(0);
  var elementPositionY = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(0);
  var elementHeight = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(0);
  var elementWidth = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(0);
  var isOutside = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(true);
  var stop = function stop() {};
  if (window) {
    stop = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])([targetRef, x, y], function () {
      var el = unrefElement(targetRef);
      if (!el) return;
      var _el$getBoundingClient = el.getBoundingClientRect(),
        left = _el$getBoundingClient.left,
        top = _el$getBoundingClient.top,
        width = _el$getBoundingClient.width,
        height = _el$getBoundingClient.height;
      elementPositionX.value = left + window.pageXOffset;
      elementPositionY.value = top + window.pageYOffset;
      elementHeight.value = height;
      elementWidth.value = width;
      var elX = x.value - elementPositionX.value;
      var elY = y.value - elementPositionY.value;
      isOutside.value = width === 0 || height === 0 || elX < 0 || elY < 0 || elX > width || elY > height;
      if (handleOutside || !isOutside.value) {
        elementX.value = elX;
        elementY.value = elY;
      }
    }, {
      immediate: true
    });
    useEventListener(document, "mouseleave", function () {
      isOutside.value = true;
    });
  }
  return {
    x: x,
    y: y,
    sourceType: sourceType,
    elementX: elementX,
    elementY: elementY,
    elementPositionX: elementPositionX,
    elementPositionY: elementPositionY,
    elementHeight: elementHeight,
    elementWidth: elementWidth,
    isOutside: isOutside,
    stop: stop
  };
}
function useMousePressed() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$touch2 = options.touch,
    touch = _options$touch2 === void 0 ? true : _options$touch2,
    _options$drag = options.drag,
    drag = _options$drag === void 0 ? true : _options$drag,
    _options$initialValue6 = options.initialValue,
    initialValue = _options$initialValue6 === void 0 ? false : _options$initialValue6,
    _options$window20 = options.window,
    window = _options$window20 === void 0 ? defaultWindow : _options$window20;
  var pressed = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(initialValue);
  var sourceType = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(null);
  if (!window) {
    return {
      pressed: pressed,
      sourceType: sourceType
    };
  }
  var onPressed = function onPressed(srcType) {
    return function () {
      pressed.value = true;
      sourceType.value = srcType;
    };
  };
  var onReleased = function onReleased() {
    pressed.value = false;
    sourceType.value = null;
  };
  var target = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return unrefElement(options.target) || window;
  });
  useEventListener(target, "mousedown", onPressed("mouse"), {
    passive: true
  });
  useEventListener(window, "mouseleave", onReleased, {
    passive: true
  });
  useEventListener(window, "mouseup", onReleased, {
    passive: true
  });
  if (drag) {
    useEventListener(target, "dragstart", onPressed("mouse"), {
      passive: true
    });
    useEventListener(window, "drop", onReleased, {
      passive: true
    });
    useEventListener(window, "dragend", onReleased, {
      passive: true
    });
  }
  if (touch) {
    useEventListener(target, "touchstart", onPressed("touch"), {
      passive: true
    });
    useEventListener(window, "touchend", onReleased, {
      passive: true
    });
    useEventListener(window, "touchcancel", onReleased, {
      passive: true
    });
  }
  return {
    pressed: pressed,
    sourceType: sourceType
  };
}
function useNavigatorLanguage() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$window21 = options.window,
    window = _options$window21 === void 0 ? defaultWindow : _options$window21;
  var navigator = window == null ? void 0 : window.navigator;
  var isSupported = useSupported(function () {
    return navigator && "language" in navigator;
  });
  var language = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(navigator == null ? void 0 : navigator.language);
  useEventListener(window, "languagechange", function () {
    if (navigator) language.value = navigator.language;
  });
  return {
    isSupported: isSupported,
    language: language
  };
}
function useNetwork() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$window22 = options.window,
    window = _options$window22 === void 0 ? defaultWindow : _options$window22;
  var navigator = window == null ? void 0 : window.navigator;
  var isSupported = useSupported(function () {
    return navigator && "connection" in navigator;
  });
  var isOnline = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(true);
  var saveData = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  var offlineAt = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(void 0);
  var onlineAt = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(void 0);
  var downlink = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(void 0);
  var downlinkMax = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(void 0);
  var rtt = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(void 0);
  var effectiveType = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(void 0);
  var type = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])("unknown");
  var connection = isSupported.value && navigator.connection;
  function updateNetworkInformation() {
    if (!navigator) return;
    isOnline.value = navigator.onLine;
    offlineAt.value = isOnline.value ? void 0 : Date.now();
    onlineAt.value = isOnline.value ? Date.now() : void 0;
    if (connection) {
      downlink.value = connection.downlink;
      downlinkMax.value = connection.downlinkMax;
      effectiveType.value = connection.effectiveType;
      rtt.value = connection.rtt;
      saveData.value = connection.saveData;
      type.value = connection.type;
    }
  }
  if (window) {
    useEventListener(window, "offline", function () {
      isOnline.value = false;
      offlineAt.value = Date.now();
    });
    useEventListener(window, "online", function () {
      isOnline.value = true;
      onlineAt.value = Date.now();
    });
  }
  if (connection) useEventListener(connection, "change", updateNetworkInformation, false);
  updateNetworkInformation();
  return {
    isSupported: isSupported,
    isOnline: isOnline,
    saveData: saveData,
    offlineAt: offlineAt,
    onlineAt: onlineAt,
    downlink: downlink,
    downlinkMax: downlinkMax,
    effectiveType: effectiveType,
    rtt: rtt,
    type: type
  };
}
var __defProp$7 = Object.defineProperty;
var __getOwnPropSymbols$8 = Object.getOwnPropertySymbols;
var __hasOwnProp$8 = Object.prototype.hasOwnProperty;
var __propIsEnum$8 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$7 = function __defNormalProp$7(obj, key, value) {
  return key in obj ? __defProp$7(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$7 = function __spreadValues$7(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$8.call(b, prop)) __defNormalProp$7(a, prop, b[prop]);
  if (__getOwnPropSymbols$8) {
    var _iterator31 = _createForOfIteratorHelper(__getOwnPropSymbols$8(b)),
      _step31;
    try {
      for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
        var prop = _step31.value;
        if (__propIsEnum$8.call(b, prop)) __defNormalProp$7(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator31.e(err);
    } finally {
      _iterator31.f();
    }
  }
  return a;
};
function useNow() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$controls2 = options.controls,
    exposeControls = _options$controls2 === void 0 ? false : _options$controls2,
    _options$interval3 = options.interval,
    interval = _options$interval3 === void 0 ? "requestAnimationFrame" : _options$interval3;
  var now = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])( /* @__PURE__ */new Date());
  var update = function update() {
    return now.value = /* @__PURE__ */new Date();
  };
  var controls = interval === "requestAnimationFrame" ? useRafFn(update, {
    immediate: true
  }) : Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["J" /* useIntervalFn */])(update, interval, {
    immediate: true
  });
  if (exposeControls) {
    return __spreadValues$7({
      now: now
    }, controls);
  } else {
    return now;
  }
}
function useObjectUrl(object) {
  var url = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])();
  var release = function release() {
    if (url.value) URL.revokeObjectURL(url.value);
    url.value = void 0;
  };
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(object);
  }, function (newObject) {
    release();
    if (newObject) url.value = URL.createObjectURL(newObject);
  }, {
    immediate: true
  });
  Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["F" /* tryOnScopeDispose */])(release);
  return Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["readonly"])(url);
}
function useClamp(value, min, max) {
  if (typeof value === "function" || Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["isReadonly"])(value)) return Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["b" /* clamp */])(Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(value), Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(min), Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(max));
  });
  var _value = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(value);
  return Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])({
    get: function get() {
      return _value.value = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["b" /* clamp */])(_value.value, Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(min), Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(max));
    },
    set: function set(value2) {
      _value.value = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["b" /* clamp */])(value2, Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(min), Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(max));
    }
  });
}
function useOffsetPagination(options) {
  var _options$total = options.total,
    total = _options$total === void 0 ? Infinity : _options$total,
    _options$pageSize = options.pageSize,
    pageSize = _options$pageSize === void 0 ? 10 : _options$pageSize,
    _options$page = options.page,
    page = _options$page === void 0 ? 1 : _options$page,
    _options$onPageChange = options.onPageChange,
    onPageChange = _options$onPageChange === void 0 ? __WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["q" /* noop */] : _options$onPageChange,
    _options$onPageSizeCh = options.onPageSizeChange,
    onPageSizeChange = _options$onPageSizeCh === void 0 ? __WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["q" /* noop */] : _options$onPageSizeCh,
    _options$onPageCountC = options.onPageCountChange,
    onPageCountChange = _options$onPageCountC === void 0 ? __WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["q" /* noop */] : _options$onPageCountC;
  var currentPageSize = useClamp(pageSize, 1, Infinity);
  var pageCount = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return Math.max(1, Math.ceil(Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(total) / Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(currentPageSize)));
  });
  var currentPage = useClamp(page, 1, pageCount);
  var isFirstPage = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return currentPage.value === 1;
  });
  var isLastPage = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return currentPage.value === pageCount.value;
  });
  if (Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["isRef"])(page)) Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["y" /* syncRef */])(page, currentPage);
  if (Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["isRef"])(pageSize)) Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["y" /* syncRef */])(pageSize, currentPageSize);
  function prev() {
    currentPage.value--;
  }
  function next() {
    currentPage.value++;
  }
  var returnValue = {
    currentPage: currentPage,
    currentPageSize: currentPageSize,
    pageCount: pageCount,
    isFirstPage: isFirstPage,
    isLastPage: isLastPage,
    prev: prev,
    next: next
  };
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(currentPage, function () {
    onPageChange(Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["reactive"])(returnValue));
  });
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(currentPageSize, function () {
    onPageSizeChange(Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["reactive"])(returnValue));
  });
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(pageCount, function () {
    onPageCountChange(Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["reactive"])(returnValue));
  });
  return returnValue;
}
function useOnline() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _useNetwork = useNetwork(options),
    isOnline = _useNetwork.isOnline;
  return isOnline;
}
function usePageLeave() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$window23 = options.window,
    window = _options$window23 === void 0 ? defaultWindow : _options$window23;
  var isLeft = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  var handler = function handler(event) {
    if (!window) return;
    event = event || window.event;
    var from = event.relatedTarget || event.toElement;
    isLeft.value = !from;
  };
  if (window) {
    useEventListener(window, "mouseout", handler, {
      passive: true
    });
    useEventListener(window.document, "mouseleave", handler, {
      passive: true
    });
    useEventListener(window.document, "mouseenter", handler, {
      passive: true
    });
  }
  return isLeft;
}
function useParallax(target) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$deviceOrient = options.deviceOrientationTiltAdjust,
    deviceOrientationTiltAdjust = _options$deviceOrient === void 0 ? function (i) {
      return i;
    } : _options$deviceOrient,
    _options$deviceOrient2 = options.deviceOrientationRollAdjust,
    deviceOrientationRollAdjust = _options$deviceOrient2 === void 0 ? function (i) {
      return i;
    } : _options$deviceOrient2,
    _options$mouseTiltAdj = options.mouseTiltAdjust,
    mouseTiltAdjust = _options$mouseTiltAdj === void 0 ? function (i) {
      return i;
    } : _options$mouseTiltAdj,
    _options$mouseRollAdj = options.mouseRollAdjust,
    mouseRollAdjust = _options$mouseRollAdj === void 0 ? function (i) {
      return i;
    } : _options$mouseRollAdj,
    _options$window24 = options.window,
    window = _options$window24 === void 0 ? defaultWindow : _options$window24;
  var orientation = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["reactive"])(useDeviceOrientation({
    window: window
  }));
  var _useMouseInElement = useMouseInElement(target, {
      handleOutside: false,
      window: window
    }),
    x = _useMouseInElement.elementX,
    y = _useMouseInElement.elementY,
    width = _useMouseInElement.elementWidth,
    height = _useMouseInElement.elementHeight;
  var source = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    if (orientation.isSupported && (orientation.alpha != null && orientation.alpha !== 0 || orientation.gamma != null && orientation.gamma !== 0)) return "deviceOrientation";
    return "mouse";
  });
  var roll = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    if (source.value === "deviceOrientation") {
      var value = -orientation.beta / 90;
      return deviceOrientationRollAdjust(value);
    } else {
      var _value2 = -(y.value - height.value / 2) / height.value;
      return mouseRollAdjust(_value2);
    }
  });
  var tilt = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    if (source.value === "deviceOrientation") {
      var value = orientation.gamma / 90;
      return deviceOrientationTiltAdjust(value);
    } else {
      var _value3 = (x.value - width.value / 2) / width.value;
      return mouseTiltAdjust(_value3);
    }
  });
  return {
    roll: roll,
    tilt: tilt,
    source: source
  };
}
function useParentElement() {
  var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : useCurrentElement();
  var parentElement = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["shallowRef"])();
  var update = function update() {
    var el = unrefElement(element);
    if (el) parentElement.value = el.parentElement;
  };
  Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["E" /* tryOnMounted */])(update);
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(element);
  }, update);
  return parentElement;
}
var __getOwnPropSymbols$7 = Object.getOwnPropertySymbols;
var __hasOwnProp$7 = Object.prototype.hasOwnProperty;
var __propIsEnum$7 = Object.prototype.propertyIsEnumerable;
var __objRest$1 = function __objRest$1(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$7.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$7) {
    var _iterator32 = _createForOfIteratorHelper(__getOwnPropSymbols$7(source)),
      _step32;
    try {
      for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
        var prop = _step32.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$7.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator32.e(err);
    } finally {
      _iterator32.f();
    }
  }
  return target;
};
function usePerformanceObserver(options, callback) {
  var _a = options,
    _a$window3 = _a.window,
    window = _a$window3 === void 0 ? defaultWindow : _a$window3,
    _a$immediate = _a.immediate,
    immediate = _a$immediate === void 0 ? true : _a$immediate,
    performanceOptions = __objRest$1(_a, ["window", "immediate"]);
  var isSupported = useSupported(function () {
    return window && "PerformanceObserver" in window;
  });
  var observer;
  var stop = function stop() {
    observer == null ? void 0 : observer.disconnect();
  };
  var start = function start() {
    if (isSupported.value) {
      stop();
      observer = new PerformanceObserver(callback);
      observer.observe(performanceOptions);
    }
  };
  Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["F" /* tryOnScopeDispose */])(stop);
  if (immediate) start();
  return {
    isSupported: isSupported,
    start: start,
    stop: stop
  };
}
var __defProp$6 = Object.defineProperty;
var __defProps$2 = Object.defineProperties;
var __getOwnPropDescs$2 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$6 = Object.getOwnPropertySymbols;
var __hasOwnProp$6 = Object.prototype.hasOwnProperty;
var __propIsEnum$6 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6 = function __defNormalProp$6(obj, key, value) {
  return key in obj ? __defProp$6(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$6 = function __spreadValues$6(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$6.call(b, prop)) __defNormalProp$6(a, prop, b[prop]);
  if (__getOwnPropSymbols$6) {
    var _iterator33 = _createForOfIteratorHelper(__getOwnPropSymbols$6(b)),
      _step33;
    try {
      for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
        var prop = _step33.value;
        if (__propIsEnum$6.call(b, prop)) __defNormalProp$6(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator33.e(err);
    } finally {
      _iterator33.f();
    }
  }
  return a;
};
var __spreadProps$2 = function __spreadProps$2(a, b) {
  return __defProps$2(a, __getOwnPropDescs$2(b));
};
var defaultState = {
  x: 0,
  y: 0,
  pointerId: 0,
  pressure: 0,
  tiltX: 0,
  tiltY: 0,
  width: 0,
  height: 0,
  twist: 0,
  pointerType: null
};
var keys = /* @__PURE__ */Object.keys(defaultState);
function usePointer() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$target3 = options.target,
    target = _options$target3 === void 0 ? defaultWindow : _options$target3;
  var isInside = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  var state = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(options.initialValue || {});
  Object.assign(state.value, defaultState, state.value);
  var handler = function handler(event) {
    isInside.value = true;
    if (options.pointerTypes && !options.pointerTypes.includes(event.pointerType)) return;
    state.value = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["u" /* objectPick */])(event, keys, false);
  };
  if (target) {
    useEventListener(target, "pointerdown", handler, {
      passive: true
    });
    useEventListener(target, "pointermove", handler, {
      passive: true
    });
    useEventListener(target, "pointerleave", function () {
      return isInside.value = false;
    }, {
      passive: true
    });
  }
  return __spreadProps$2(__spreadValues$6({}, Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["C" /* toRefs */])(state)), {
    isInside: isInside
  });
}
function usePointerLock(target) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$document7 = options.document,
    document = _options$document7 === void 0 ? defaultDocument : _options$document7,
    pointerLockOptions = options.pointerLockOptions;
  var isSupported = useSupported(function () {
    return document && "pointerLockElement" in document;
  });
  var element = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])();
  var triggerElement = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])();
  var targetElement;
  if (isSupported.value) {
    useEventListener(document, "pointerlockchange", function () {
      var _a;
      var currentElement = (_a = document.pointerLockElement) != null ? _a : element.value;
      if (targetElement && currentElement === targetElement) {
        element.value = document.pointerLockElement;
        if (!element.value) targetElement = triggerElement.value = null;
      }
    });
    useEventListener(document, "pointerlockerror", function () {
      var _a;
      var currentElement = (_a = document.pointerLockElement) != null ? _a : element.value;
      if (targetElement && currentElement === targetElement) {
        var action = document.pointerLockElement ? "release" : "acquire";
        throw new Error("Failed to ".concat(action, " pointer lock."));
      }
    });
  }
  function lock(_x10, _x11) {
    return _lock.apply(this, arguments);
  }
  function _lock() {
    _lock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee28(e, options2) {
      var _a;
      return _regeneratorRuntime().wrap(function _callee28$(_context28) {
        while (1) switch (_context28.prev = _context28.next) {
          case 0:
            if (isSupported.value) {
              _context28.next = 2;
              break;
            }
            throw new Error("Pointer Lock API is not supported by your browser.");
          case 2:
            triggerElement.value = e instanceof Event ? e.currentTarget : null;
            targetElement = e instanceof Event ? (_a = unrefElement(target)) != null ? _a : triggerElement.value : unrefElement(e);
            if (targetElement) {
              _context28.next = 6;
              break;
            }
            throw new Error("Target element undefined.");
          case 6:
            targetElement.requestPointerLock(options2 != null ? options2 : pointerLockOptions);
            _context28.next = 9;
            return Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["H" /* until */])(element).toBe(targetElement);
          case 9:
            return _context28.abrupt("return", _context28.sent);
          case 10:
          case "end":
            return _context28.stop();
        }
      }, _callee28);
    }));
    return _lock.apply(this, arguments);
  }
  function unlock() {
    return _unlock.apply(this, arguments);
  }
  function _unlock() {
    _unlock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
      return _regeneratorRuntime().wrap(function _callee29$(_context29) {
        while (1) switch (_context29.prev = _context29.next) {
          case 0:
            if (element.value) {
              _context29.next = 2;
              break;
            }
            return _context29.abrupt("return", false);
          case 2:
            document.exitPointerLock();
            _context29.next = 5;
            return Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["H" /* until */])(element).toBeNull();
          case 5:
            return _context29.abrupt("return", true);
          case 6:
          case "end":
            return _context29.stop();
        }
      }, _callee29);
    }));
    return _unlock.apply(this, arguments);
  }
  return {
    isSupported: isSupported,
    element: element,
    triggerElement: triggerElement,
    lock: lock,
    unlock: unlock
  };
}
function usePointerSwipe(target) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var targetRef = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["B" /* toRef */])(target);
  var _options$threshold2 = options.threshold,
    threshold = _options$threshold2 === void 0 ? 50 : _options$threshold2,
    onSwipe = options.onSwipe,
    onSwipeEnd = options.onSwipeEnd,
    onSwipeStart = options.onSwipeStart;
  var posStart = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["reactive"])({
    x: 0,
    y: 0
  });
  var updatePosStart = function updatePosStart(x, y) {
    posStart.x = x;
    posStart.y = y;
  };
  var posEnd = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["reactive"])({
    x: 0,
    y: 0
  });
  var updatePosEnd = function updatePosEnd(x, y) {
    posEnd.x = x;
    posEnd.y = y;
  };
  var distanceX = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return posStart.x - posEnd.x;
  });
  var distanceY = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return posStart.y - posEnd.y;
  });
  var max = Math.max,
    abs = Math.abs;
  var isThresholdExceeded = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return max(abs(distanceX.value), abs(distanceY.value)) >= threshold;
  });
  var isSwiping = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  var isPointerDown = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  var direction = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    if (!isThresholdExceeded.value) return "none";
    if (abs(distanceX.value) > abs(distanceY.value)) {
      return distanceX.value > 0 ? "left" : "right";
    } else {
      return distanceY.value > 0 ? "up" : "down";
    }
  });
  var eventIsAllowed = function eventIsAllowed(e) {
    var _a, _b, _c;
    var isReleasingButton = e.buttons === 0;
    var isPrimaryButton = e.buttons === 1;
    return (_c = (_b = (_a = options.pointerTypes) == null ? void 0 : _a.includes(e.pointerType)) != null ? _b : isReleasingButton || isPrimaryButton) != null ? _c : true;
  };
  var stops = [useEventListener(target, "pointerdown", function (e) {
    var _a, _b;
    if (!eventIsAllowed(e)) return;
    isPointerDown.value = true;
    (_b = (_a = targetRef.value) == null ? void 0 : _a.style) == null ? void 0 : _b.setProperty("touch-action", "none");
    var eventTarget = e.target;
    eventTarget == null ? void 0 : eventTarget.setPointerCapture(e.pointerId);
    var x = e.clientX,
      y = e.clientY;
    updatePosStart(x, y);
    updatePosEnd(x, y);
    onSwipeStart == null ? void 0 : onSwipeStart(e);
  }), useEventListener(target, "pointermove", function (e) {
    if (!eventIsAllowed(e)) return;
    if (!isPointerDown.value) return;
    var x = e.clientX,
      y = e.clientY;
    updatePosEnd(x, y);
    if (!isSwiping.value && isThresholdExceeded.value) isSwiping.value = true;
    if (isSwiping.value) onSwipe == null ? void 0 : onSwipe(e);
  }), useEventListener(target, "pointerup", function (e) {
    var _a, _b;
    if (!eventIsAllowed(e)) return;
    if (isSwiping.value) onSwipeEnd == null ? void 0 : onSwipeEnd(e, direction.value);
    isPointerDown.value = false;
    isSwiping.value = false;
    (_b = (_a = targetRef.value) == null ? void 0 : _a.style) == null ? void 0 : _b.setProperty("touch-action", "initial");
  })];
  var stop = function stop() {
    return stops.forEach(function (s) {
      return s();
    });
  };
  return {
    isSwiping: Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["readonly"])(isSwiping),
    direction: Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["readonly"])(direction),
    posStart: Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["readonly"])(posStart),
    posEnd: Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["readonly"])(posEnd),
    distanceX: distanceX,
    distanceY: distanceY,
    stop: stop
  };
}
function usePreferredColorScheme(options) {
  var isLight = useMediaQuery("(prefers-color-scheme: light)", options);
  var isDark = useMediaQuery("(prefers-color-scheme: dark)", options);
  return Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    if (isDark.value) return "dark";
    if (isLight.value) return "light";
    return "no-preference";
  });
}
function usePreferredContrast(options) {
  var isMore = useMediaQuery("(prefers-contrast: more)", options);
  var isLess = useMediaQuery("(prefers-contrast: less)", options);
  var isCustom = useMediaQuery("(prefers-contrast: custom)", options);
  return Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    if (isMore.value) return "more";
    if (isLess.value) return "less";
    if (isCustom.value) return "custom";
    return "no-preference";
  });
}
function usePreferredLanguages() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$window25 = options.window,
    window = _options$window25 === void 0 ? defaultWindow : _options$window25;
  if (!window) return Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(["en"]);
  var navigator = window.navigator;
  var value = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(navigator.languages);
  useEventListener(window, "languagechange", function () {
    value.value = navigator.languages;
  });
  return value;
}
function usePreferredReducedMotion(options) {
  var isReduced = useMediaQuery("(prefers-reduced-motion: reduce)", options);
  return Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    if (isReduced.value) return "reduce";
    return "no-preference";
  });
}
function usePrevious(value, initialValue) {
  var previous = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["shallowRef"])(initialValue);
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["B" /* toRef */])(value), function (_, oldValue) {
    previous.value = oldValue;
  }, {
    flush: "sync"
  });
  return Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["readonly"])(previous);
}
function useScreenOrientation() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$window26 = options.window,
    window = _options$window26 === void 0 ? defaultWindow : _options$window26;
  var isSupported = useSupported(function () {
    return window && "screen" in window && "orientation" in window.screen;
  });
  var screenOrientation = isSupported.value ? window.screen.orientation : {};
  var orientation = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(screenOrientation.type);
  var angle = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(screenOrientation.angle || 0);
  if (isSupported.value) {
    useEventListener(window, "orientationchange", function () {
      orientation.value = screenOrientation.type;
      angle.value = screenOrientation.angle;
    });
  }
  var lockOrientation = function lockOrientation(type) {
    if (!isSupported.value) return Promise.reject(new Error("Not supported"));
    return screenOrientation.lock(type);
  };
  var unlockOrientation = function unlockOrientation() {
    if (isSupported.value) screenOrientation.unlock();
  };
  return {
    isSupported: isSupported,
    orientation: orientation,
    angle: angle,
    lockOrientation: lockOrientation,
    unlockOrientation: unlockOrientation
  };
}
var topVarName = "--vueuse-safe-area-top";
var rightVarName = "--vueuse-safe-area-right";
var bottomVarName = "--vueuse-safe-area-bottom";
var leftVarName = "--vueuse-safe-area-left";
function useScreenSafeArea() {
  var top = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])("");
  var right = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])("");
  var bottom = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])("");
  var left = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])("");
  if (__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["l" /* isClient */]) {
    var topCssVar = useCssVar(topVarName);
    var rightCssVar = useCssVar(rightVarName);
    var bottomCssVar = useCssVar(bottomVarName);
    var leftCssVar = useCssVar(leftVarName);
    topCssVar.value = "env(safe-area-inset-top, 0px)";
    rightCssVar.value = "env(safe-area-inset-right, 0px)";
    bottomCssVar.value = "env(safe-area-inset-bottom, 0px)";
    leftCssVar.value = "env(safe-area-inset-left, 0px)";
    update();
    useEventListener("resize", Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["I" /* useDebounceFn */])(update));
  }
  function update() {
    top.value = getValue(topVarName);
    right.value = getValue(rightVarName);
    bottom.value = getValue(bottomVarName);
    left.value = getValue(leftVarName);
  }
  return {
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    update: update
  };
}
function getValue(position) {
  return getComputedStyle(document.documentElement).getPropertyValue(position);
}
function useScriptTag(src) {
  var onLoaded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["q" /* noop */];
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$immediate6 = options.immediate,
    immediate = _options$immediate6 === void 0 ? true : _options$immediate6,
    _options$manual = options.manual,
    manual = _options$manual === void 0 ? false : _options$manual,
    _options$type2 = options.type,
    type = _options$type2 === void 0 ? "text/javascript" : _options$type2,
    _options$async = options.async,
    async = _options$async === void 0 ? true : _options$async,
    crossOrigin = options.crossOrigin,
    referrerPolicy = options.referrerPolicy,
    noModule = options.noModule,
    defer = options.defer,
    _options$document8 = options.document,
    document = _options$document8 === void 0 ? defaultDocument : _options$document8,
    _options$attrs = options.attrs,
    attrs = _options$attrs === void 0 ? {} : _options$attrs;
  var scriptTag = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(null);
  var _promise = null;
  var loadScript = function loadScript(waitForScriptLoad) {
    return new Promise(function (resolve, reject) {
      var resolveWithElement = function resolveWithElement(el2) {
        scriptTag.value = el2;
        resolve(el2);
        return el2;
      };
      if (!document) {
        resolve(false);
        return;
      }
      var shouldAppend = false;
      var el = document.querySelector("script[src=\"".concat(Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(src), "\"]"));
      if (!el) {
        el = document.createElement("script");
        el.type = type;
        el.async = async;
        el.src = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(src);
        if (defer) el.defer = defer;
        if (crossOrigin) el.crossOrigin = crossOrigin;
        if (noModule) el.noModule = noModule;
        if (referrerPolicy) el.referrerPolicy = referrerPolicy;
        Object.entries(attrs).forEach(function (_ref46) {
          var _ref47 = _slicedToArray(_ref46, 2),
            name = _ref47[0],
            value = _ref47[1];
          return el == null ? void 0 : el.setAttribute(name, value);
        });
        shouldAppend = true;
      } else if (el.hasAttribute("data-loaded")) {
        resolveWithElement(el);
      }
      el.addEventListener("error", function (event) {
        return reject(event);
      });
      el.addEventListener("abort", function (event) {
        return reject(event);
      });
      el.addEventListener("load", function () {
        el.setAttribute("data-loaded", "true");
        onLoaded(el);
        resolveWithElement(el);
      });
      if (shouldAppend) el = document.head.appendChild(el);
      if (!waitForScriptLoad) resolveWithElement(el);
    });
  };
  var load = function load() {
    var waitForScriptLoad = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    if (!_promise) _promise = loadScript(waitForScriptLoad);
    return _promise;
  };
  var unload = function unload() {
    if (!document) return;
    _promise = null;
    if (scriptTag.value) scriptTag.value = null;
    var el = document.querySelector("script[src=\"".concat(Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(src), "\"]"));
    if (el) document.head.removeChild(el);
  };
  if (immediate && !manual) Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["E" /* tryOnMounted */])(load);
  if (!manual) Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["G" /* tryOnUnmounted */])(unload);
  return {
    scriptTag: scriptTag,
    load: load,
    unload: unload
  };
}
function checkOverflowScroll(ele) {
  var style = window.getComputedStyle(ele);
  if (style.overflowX === "scroll" || style.overflowY === "scroll" || style.overflowX === "auto" && ele.clientHeight < ele.scrollHeight || style.overflowY === "auto" && ele.clientWidth < ele.scrollWidth) {
    return true;
  } else {
    var parent = ele.parentNode;
    if (!parent || parent.tagName === "BODY") return false;
    return checkOverflowScroll(parent);
  }
}
function preventDefault(rawEvent) {
  var e = rawEvent || window.event;
  var _target = e.target;
  if (checkOverflowScroll(_target)) return false;
  if (e.touches.length > 1) return true;
  if (e.preventDefault) e.preventDefault();
  return false;
}
function useScrollLock(element) {
  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var isLocked = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(initialState);
  var stopTouchMoveListener = null;
  var initialOverflow;
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["B" /* toRef */])(element), function (el) {
    if (el) {
      var ele = el;
      initialOverflow = ele.style.overflow;
      if (isLocked.value) ele.style.overflow = "hidden";
    }
  }, {
    immediate: true
  });
  var lock = function lock() {
    var ele = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(element);
    if (!ele || isLocked.value) return;
    if (__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["n" /* isIOS */]) {
      stopTouchMoveListener = useEventListener(ele, "touchmove", function (e) {
        preventDefault(e);
      }, {
        passive: false
      });
    }
    ele.style.overflow = "hidden";
    isLocked.value = true;
  };
  var unlock = function unlock() {
    var ele = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(element);
    if (!ele || !isLocked.value) return;
    __WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["n" /* isIOS */] && (stopTouchMoveListener == null ? void 0 : stopTouchMoveListener());
    ele.style.overflow = initialOverflow;
    isLocked.value = false;
  };
  Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["F" /* tryOnScopeDispose */])(unlock);
  return Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])({
    get: function get() {
      return isLocked.value;
    },
    set: function set(v) {
      if (v) lock();else unlock();
    }
  });
}
function useSessionStorage(key, initialValue) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$window27 = options.window,
    window = _options$window27 === void 0 ? defaultWindow : _options$window27;
  return useStorage(key, initialValue, window == null ? void 0 : window.sessionStorage, options);
}
var __defProp$5 = Object.defineProperty;
var __getOwnPropSymbols$5 = Object.getOwnPropertySymbols;
var __hasOwnProp$5 = Object.prototype.hasOwnProperty;
var __propIsEnum$5 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5 = function __defNormalProp$5(obj, key, value) {
  return key in obj ? __defProp$5(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$5 = function __spreadValues$5(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$5.call(b, prop)) __defNormalProp$5(a, prop, b[prop]);
  if (__getOwnPropSymbols$5) {
    var _iterator34 = _createForOfIteratorHelper(__getOwnPropSymbols$5(b)),
      _step34;
    try {
      for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
        var prop = _step34.value;
        if (__propIsEnum$5.call(b, prop)) __defNormalProp$5(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator34.e(err);
    } finally {
      _iterator34.f();
    }
  }
  return a;
};
function useShare() {
  var shareOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$navigator7 = options.navigator,
    navigator = _options$navigator7 === void 0 ? defaultNavigator : _options$navigator7;
  var _navigator = navigator;
  var isSupported = useSupported(function () {
    return _navigator && "canShare" in _navigator;
  });
  var share = /*#__PURE__*/function () {
    var _ref48 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee30() {
      var overrideOptions,
        data,
        granted,
        _args30 = arguments;
      return _regeneratorRuntime().wrap(function _callee30$(_context30) {
        while (1) switch (_context30.prev = _context30.next) {
          case 0:
            overrideOptions = _args30.length > 0 && _args30[0] !== undefined ? _args30[0] : {};
            if (!isSupported.value) {
              _context30.next = 7;
              break;
            }
            data = __spreadValues$5(__spreadValues$5({}, Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(shareOptions)), Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(overrideOptions));
            granted = true;
            if (data.files && _navigator.canShare) granted = _navigator.canShare({
              files: data.files
            });
            if (!granted) {
              _context30.next = 7;
              break;
            }
            return _context30.abrupt("return", _navigator.share(data));
          case 7:
          case "end":
            return _context30.stop();
        }
      }, _callee30);
    }));
    return function share() {
      return _ref48.apply(this, arguments);
    };
  }();
  return {
    isSupported: isSupported,
    share: share
  };
}
var defaultSortFn = function defaultSortFn(source, compareFn) {
  return source.sort(compareFn);
};
var defaultCompare = function defaultCompare(a, b) {
  return a - b;
};
function useSorted() {
  var _a, _b, _c, _d;
  for (var _len11 = arguments.length, args = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
    args[_key11] = arguments[_key11];
  }
  var source = args[0];
  var compareFn = defaultCompare;
  var options = {};
  if (args.length === 2) {
    if (_typeof(args[1]) === "object") {
      options = args[1];
      compareFn = (_a = options.compareFn) != null ? _a : defaultCompare;
    } else {
      compareFn = (_b = args[1]) != null ? _b : defaultCompare;
    }
  } else if (args.length > 2) {
    compareFn = (_c = args[1]) != null ? _c : defaultCompare;
    options = (_d = args[2]) != null ? _d : {};
  }
  var _options6 = options,
    _options6$dirty = _options6.dirty,
    dirty = _options6$dirty === void 0 ? false : _options6$dirty,
    _options6$sortFn = _options6.sortFn,
    sortFn = _options6$sortFn === void 0 ? defaultSortFn : _options6$sortFn;
  if (!dirty) return Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return sortFn(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(source)), compareFn);
  });
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watchEffect"])(function () {
    var result = sortFn(Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(source), compareFn);
    if (Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["isRef"])(source)) source.value = result;else source.splice.apply(source, [0, source.length].concat(_toConsumableArray(result)));
  });
  return source;
}
function useSpeechRecognition() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$interimResul = options.interimResults,
    interimResults = _options$interimResul === void 0 ? true : _options$interimResul,
    _options$continuous = options.continuous,
    continuous = _options$continuous === void 0 ? true : _options$continuous,
    _options$window28 = options.window,
    window = _options$window28 === void 0 ? defaultWindow : _options$window28;
  var lang = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["B" /* toRef */])(options.lang || "en-US");
  var isListening = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  var isFinal = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  var result = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])("");
  var error = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["shallowRef"])(void 0);
  var toggle = function toggle() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !isListening.value;
    isListening.value = value;
  };
  var start = function start() {
    isListening.value = true;
  };
  var stop = function stop() {
    isListening.value = false;
  };
  var SpeechRecognition = window && (window.SpeechRecognition || window.webkitSpeechRecognition);
  var isSupported = useSupported(function () {
    return SpeechRecognition;
  });
  var recognition;
  if (isSupported.value) {
    recognition = new SpeechRecognition();
    recognition.continuous = continuous;
    recognition.interimResults = interimResults;
    recognition.lang = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(lang);
    recognition.onstart = function () {
      isFinal.value = false;
    };
    Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(lang, function (lang2) {
      if (recognition && !isListening.value) recognition.lang = lang2;
    });
    recognition.onresult = function (event) {
      var transcript = Array.from(event.results).map(function (result2) {
        isFinal.value = result2.isFinal;
        return result2[0];
      }).map(function (result2) {
        return result2.transcript;
      }).join("");
      result.value = transcript;
      error.value = void 0;
    };
    recognition.onerror = function (event) {
      error.value = event;
    };
    recognition.onend = function () {
      isListening.value = false;
      recognition.lang = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(lang);
    };
    Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(isListening, function () {
      if (isListening.value) recognition.start();else recognition.stop();
    });
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["F" /* tryOnScopeDispose */])(function () {
    isListening.value = false;
  });
  return {
    isSupported: isSupported,
    isListening: isListening,
    isFinal: isFinal,
    recognition: recognition,
    result: result,
    error: error,
    toggle: toggle,
    start: start,
    stop: stop
  };
}
function useSpeechSynthesis(text) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$pitch = options.pitch,
    pitch = _options$pitch === void 0 ? 1 : _options$pitch,
    _options$rate = options.rate,
    rate = _options$rate === void 0 ? 1 : _options$rate,
    _options$volume = options.volume,
    volume = _options$volume === void 0 ? 1 : _options$volume,
    _options$window29 = options.window,
    window = _options$window29 === void 0 ? defaultWindow : _options$window29;
  var synth = window && window.speechSynthesis;
  var isSupported = useSupported(function () {
    return synth;
  });
  var isPlaying = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  var status = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])("init");
  var spokenText = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["B" /* toRef */])(text || "");
  var lang = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["B" /* toRef */])(options.lang || "en-US");
  var error = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["shallowRef"])(void 0);
  var toggle = function toggle() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !isPlaying.value;
    isPlaying.value = value;
  };
  var bindEventsForUtterance = function bindEventsForUtterance(utterance2) {
    utterance2.lang = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(lang);
    utterance2.voice = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(options.voice) || null;
    utterance2.pitch = pitch;
    utterance2.rate = rate;
    utterance2.volume = volume;
    utterance2.onstart = function () {
      isPlaying.value = true;
      status.value = "play";
    };
    utterance2.onpause = function () {
      isPlaying.value = false;
      status.value = "pause";
    };
    utterance2.onresume = function () {
      isPlaying.value = true;
      status.value = "play";
    };
    utterance2.onend = function () {
      isPlaying.value = false;
      status.value = "end";
    };
    utterance2.onerror = function (event) {
      error.value = event;
    };
  };
  var utterance = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    isPlaying.value = false;
    status.value = "init";
    var newUtterance = new SpeechSynthesisUtterance(spokenText.value);
    bindEventsForUtterance(newUtterance);
    return newUtterance;
  });
  var speak = function speak() {
    synth.cancel();
    utterance && synth.speak(utterance.value);
  };
  var stop = function stop() {
    synth.cancel();
    isPlaying.value = false;
  };
  if (isSupported.value) {
    bindEventsForUtterance(utterance.value);
    Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(lang, function (lang2) {
      if (utterance.value && !isPlaying.value) utterance.value.lang = lang2;
    });
    if (options.voice) {
      Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(options.voice, function () {
        synth.cancel();
      });
    }
    Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(isPlaying, function () {
      if (isPlaying.value) synth.resume();else synth.pause();
    });
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["F" /* tryOnScopeDispose */])(function () {
    isPlaying.value = false;
  });
  return {
    isSupported: isSupported,
    isPlaying: isPlaying,
    status: status,
    utterance: utterance,
    error: error,
    stop: stop,
    toggle: toggle,
    speak: speak
  };
}
function useStepper(steps, initialStep) {
  var stepsRef = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(steps);
  var stepNames = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return Array.isArray(stepsRef.value) ? stepsRef.value : Object.keys(stepsRef.value);
  });
  var index = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(stepNames.value.indexOf(initialStep != null ? initialStep : stepNames.value[0]));
  var current = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return at(index.value);
  });
  var isFirst = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return index.value === 0;
  });
  var isLast = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return index.value === stepNames.value.length - 1;
  });
  var next = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return stepNames.value[index.value + 1];
  });
  var previous = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return stepNames.value[index.value - 1];
  });
  function at(index2) {
    if (Array.isArray(stepsRef.value)) return stepsRef.value[index2];
    return stepsRef.value[stepNames.value[index2]];
  }
  function get(step) {
    if (!stepNames.value.includes(step)) return;
    return at(stepNames.value.indexOf(step));
  }
  function goTo(step) {
    if (stepNames.value.includes(step)) index.value = stepNames.value.indexOf(step);
  }
  function goToNext() {
    if (isLast.value) return;
    index.value++;
  }
  function goToPrevious() {
    if (isFirst.value) return;
    index.value--;
  }
  function goBackTo(step) {
    if (isAfter(step)) goTo(step);
  }
  function isNext(step) {
    return stepNames.value.indexOf(step) === index.value + 1;
  }
  function isPrevious(step) {
    return stepNames.value.indexOf(step) === index.value - 1;
  }
  function isCurrent(step) {
    return stepNames.value.indexOf(step) === index.value;
  }
  function isBefore(step) {
    return index.value < stepNames.value.indexOf(step);
  }
  function isAfter(step) {
    return index.value > stepNames.value.indexOf(step);
  }
  return {
    steps: stepsRef,
    stepNames: stepNames,
    index: index,
    current: current,
    next: next,
    previous: previous,
    isFirst: isFirst,
    isLast: isLast,
    at: at,
    get: get,
    goTo: goTo,
    goToNext: goToNext,
    goToPrevious: goToPrevious,
    goBackTo: goBackTo,
    isNext: isNext,
    isPrevious: isPrevious,
    isCurrent: isCurrent,
    isBefore: isBefore,
    isAfter: isAfter
  };
}
var __defProp$4 = Object.defineProperty;
var __getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4 = function __defNormalProp$4(obj, key, value) {
  return key in obj ? __defProp$4(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$4 = function __spreadValues$4(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$4.call(b, prop)) __defNormalProp$4(a, prop, b[prop]);
  if (__getOwnPropSymbols$4) {
    var _iterator35 = _createForOfIteratorHelper(__getOwnPropSymbols$4(b)),
      _step35;
    try {
      for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
        var prop = _step35.value;
        if (__propIsEnum$4.call(b, prop)) __defNormalProp$4(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator35.e(err);
    } finally {
      _iterator35.f();
    }
  }
  return a;
};
function useStorageAsync(key, initialValue, storage) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _a;
  var _options$flush3 = options.flush,
    flush = _options$flush3 === void 0 ? "pre" : _options$flush3,
    _options$deep4 = options.deep,
    deep = _options$deep4 === void 0 ? true : _options$deep4,
    _options$listenToStor3 = options.listenToStorageChanges,
    listenToStorageChanges = _options$listenToStor3 === void 0 ? true : _options$listenToStor3,
    _options$writeDefault2 = options.writeDefaults,
    writeDefaults = _options$writeDefault2 === void 0 ? true : _options$writeDefault2,
    _options$mergeDefault2 = options.mergeDefaults,
    mergeDefaults = _options$mergeDefault2 === void 0 ? false : _options$mergeDefault2,
    shallow = options.shallow,
    _options$window30 = options.window,
    window = _options$window30 === void 0 ? defaultWindow : _options$window30,
    eventFilter = options.eventFilter,
    _options$onError3 = options.onError,
    onError = _options$onError3 === void 0 ? function (e) {
      console.error(e);
    } : _options$onError3;
  var rawInit = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(initialValue);
  var type = guessSerializerType(rawInit);
  var data = (shallow ? __WEBPACK_IMPORTED_MODULE_1_vue_demi__["shallowRef"] : __WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(initialValue);
  var serializer = (_a = options.serializer) != null ? _a : StorageSerializers[type];
  if (!storage) {
    try {
      storage = getSSRHandler("getDefaultStorage", function () {
        var _a2;
        return (_a2 = defaultWindow) == null ? void 0 : _a2.localStorage;
      })();
    } catch (e) {
      onError(e);
    }
  }
  function read(_x12) {
    return _read.apply(this, arguments);
  }
  function _read() {
    _read = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee32(event) {
      var rawValue, value;
      return _regeneratorRuntime().wrap(function _callee32$(_context32) {
        while (1) switch (_context32.prev = _context32.next) {
          case 0:
            if (!(!storage || event && event.key !== key)) {
              _context32.next = 2;
              break;
            }
            return _context32.abrupt("return");
          case 2:
            _context32.prev = 2;
            if (!event) {
              _context32.next = 7;
              break;
            }
            _context32.t0 = event.newValue;
            _context32.next = 10;
            break;
          case 7:
            _context32.next = 9;
            return storage.getItem(key);
          case 9:
            _context32.t0 = _context32.sent;
          case 10:
            rawValue = _context32.t0;
            if (!(rawValue == null)) {
              _context32.next = 23;
              break;
            }
            data.value = rawInit;
            if (!(writeDefaults && rawInit !== null)) {
              _context32.next = 21;
              break;
            }
            _context32.t1 = storage;
            _context32.t2 = key;
            _context32.next = 18;
            return serializer.write(rawInit);
          case 18:
            _context32.t3 = _context32.sent;
            _context32.next = 21;
            return _context32.t1.setItem.call(_context32.t1, _context32.t2, _context32.t3);
          case 21:
            _context32.next = 33;
            break;
          case 23:
            if (!mergeDefaults) {
              _context32.next = 30;
              break;
            }
            _context32.next = 26;
            return serializer.read(rawValue);
          case 26:
            value = _context32.sent;
            if (typeof mergeDefaults === "function") data.value = mergeDefaults(value, rawInit);else if (type === "object" && !Array.isArray(value)) data.value = __spreadValues$4(__spreadValues$4({}, rawInit), value);else data.value = value;
            _context32.next = 33;
            break;
          case 30:
            _context32.next = 32;
            return serializer.read(rawValue);
          case 32:
            data.value = _context32.sent;
          case 33:
            _context32.next = 38;
            break;
          case 35:
            _context32.prev = 35;
            _context32.t4 = _context32["catch"](2);
            onError(_context32.t4);
          case 38:
          case "end":
            return _context32.stop();
        }
      }, _callee32, null, [[2, 35]]);
    }));
    return _read.apply(this, arguments);
  }
  read();
  if (window && listenToStorageChanges) useEventListener(window, "storage", function (e) {
    return Promise.resolve().then(function () {
      return read(e);
    });
  });
  if (storage) {
    Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["N" /* watchWithFilter */])(data, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee31() {
      return _regeneratorRuntime().wrap(function _callee31$(_context31) {
        while (1) switch (_context31.prev = _context31.next) {
          case 0:
            _context31.prev = 0;
            if (!(data.value == null)) {
              _context31.next = 6;
              break;
            }
            _context31.next = 4;
            return storage.removeItem(key);
          case 4:
            _context31.next = 13;
            break;
          case 6:
            _context31.t0 = storage;
            _context31.t1 = key;
            _context31.next = 10;
            return serializer.write(data.value);
          case 10:
            _context31.t2 = _context31.sent;
            _context31.next = 13;
            return _context31.t0.setItem.call(_context31.t0, _context31.t1, _context31.t2);
          case 13:
            _context31.next = 18;
            break;
          case 15:
            _context31.prev = 15;
            _context31.t3 = _context31["catch"](0);
            onError(_context31.t3);
          case 18:
          case "end":
            return _context31.stop();
        }
      }, _callee31, null, [[0, 15]]);
    })), {
      flush: flush,
      deep: deep,
      eventFilter: eventFilter
    });
  }
  return data;
}
var _id = 0;
function useStyleTag(css) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isLoaded = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  var _options$document9 = options.document,
    document = _options$document9 === void 0 ? defaultDocument : _options$document9,
    _options$immediate7 = options.immediate,
    immediate = _options$immediate7 === void 0 ? true : _options$immediate7,
    _options$manual2 = options.manual,
    manual = _options$manual2 === void 0 ? false : _options$manual2,
    _options$id = options.id,
    id = _options$id === void 0 ? "vueuse_styletag_".concat(++_id) : _options$id;
  var cssRef = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(css);
  var stop = function stop() {};
  var load = function load() {
    if (!document) return;
    var el = document.getElementById(id) || document.createElement("style");
    if (!el.isConnected) {
      el.type = "text/css";
      el.id = id;
      if (options.media) el.media = options.media;
      document.head.appendChild(el);
    }
    if (isLoaded.value) return;
    stop = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(cssRef, function (value) {
      el.textContent = value;
    }, {
      immediate: true
    });
    isLoaded.value = true;
  };
  var unload = function unload() {
    if (!document || !isLoaded.value) return;
    stop();
    document.head.removeChild(document.getElementById(id));
    isLoaded.value = false;
  };
  if (immediate && !manual) Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["E" /* tryOnMounted */])(load);
  if (!manual) Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["F" /* tryOnScopeDispose */])(unload);
  return {
    id: id,
    css: cssRef,
    unload: unload,
    load: load,
    isLoaded: Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["readonly"])(isLoaded)
  };
}
function useSwipe(target) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$threshold3 = options.threshold,
    threshold = _options$threshold3 === void 0 ? 50 : _options$threshold3,
    onSwipe = options.onSwipe,
    onSwipeEnd = options.onSwipeEnd,
    onSwipeStart = options.onSwipeStart,
    _options$passive2 = options.passive,
    passive = _options$passive2 === void 0 ? true : _options$passive2,
    _options$window31 = options.window,
    window = _options$window31 === void 0 ? defaultWindow : _options$window31;
  var coordsStart = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["reactive"])({
    x: 0,
    y: 0
  });
  var coordsEnd = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["reactive"])({
    x: 0,
    y: 0
  });
  var diffX = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return coordsStart.x - coordsEnd.x;
  });
  var diffY = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return coordsStart.y - coordsEnd.y;
  });
  var max = Math.max,
    abs = Math.abs;
  var isThresholdExceeded = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return max(abs(diffX.value), abs(diffY.value)) >= threshold;
  });
  var isSwiping = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  var direction = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    if (!isThresholdExceeded.value) return "none";
    if (abs(diffX.value) > abs(diffY.value)) {
      return diffX.value > 0 ? "left" : "right";
    } else {
      return diffY.value > 0 ? "up" : "down";
    }
  });
  var getTouchEventCoords = function getTouchEventCoords(e) {
    return [e.touches[0].clientX, e.touches[0].clientY];
  };
  var updateCoordsStart = function updateCoordsStart(x, y) {
    coordsStart.x = x;
    coordsStart.y = y;
  };
  var updateCoordsEnd = function updateCoordsEnd(x, y) {
    coordsEnd.x = x;
    coordsEnd.y = y;
  };
  var listenerOptions;
  var isPassiveEventSupported = checkPassiveEventSupport(window == null ? void 0 : window.document);
  if (!passive) listenerOptions = isPassiveEventSupported ? {
    passive: false,
    capture: true
  } : {
    capture: true
  };else listenerOptions = isPassiveEventSupported ? {
    passive: true
  } : {
    capture: false
  };
  var onTouchEnd = function onTouchEnd(e) {
    if (isSwiping.value) onSwipeEnd == null ? void 0 : onSwipeEnd(e, direction.value);
    isSwiping.value = false;
  };
  var stops = [useEventListener(target, "touchstart", function (e) {
    if (e.touches.length !== 1) return;
    if (listenerOptions.capture && !listenerOptions.passive) e.preventDefault();
    var _getTouchEventCoords = getTouchEventCoords(e),
      _getTouchEventCoords2 = _slicedToArray(_getTouchEventCoords, 2),
      x = _getTouchEventCoords2[0],
      y = _getTouchEventCoords2[1];
    updateCoordsStart(x, y);
    updateCoordsEnd(x, y);
    onSwipeStart == null ? void 0 : onSwipeStart(e);
  }, listenerOptions), useEventListener(target, "touchmove", function (e) {
    if (e.touches.length !== 1) return;
    var _getTouchEventCoords3 = getTouchEventCoords(e),
      _getTouchEventCoords4 = _slicedToArray(_getTouchEventCoords3, 2),
      x = _getTouchEventCoords4[0],
      y = _getTouchEventCoords4[1];
    updateCoordsEnd(x, y);
    if (!isSwiping.value && isThresholdExceeded.value) isSwiping.value = true;
    if (isSwiping.value) onSwipe == null ? void 0 : onSwipe(e);
  }, listenerOptions), useEventListener(target, "touchend", onTouchEnd, listenerOptions), useEventListener(target, "touchcancel", onTouchEnd, listenerOptions)];
  var stop = function stop() {
    return stops.forEach(function (s) {
      return s();
    });
  };
  return {
    isPassiveEventSupported: isPassiveEventSupported,
    isSwiping: isSwiping,
    direction: direction,
    coordsStart: coordsStart,
    coordsEnd: coordsEnd,
    lengthX: diffX,
    lengthY: diffY,
    stop: stop
  };
}
function checkPassiveEventSupport(document) {
  if (!document) return false;
  var supportsPassive = false;
  var optionsBlock = {
    get passive() {
      supportsPassive = true;
      return false;
    }
  };
  document.addEventListener("x", __WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["q" /* noop */], optionsBlock);
  document.removeEventListener("x", __WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["q" /* noop */]);
  return supportsPassive;
}
function useTemplateRefsList() {
  var refs = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])([]);
  refs.value.set = function (el) {
    if (el) refs.value.push(el);
  };
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["onBeforeUpdate"])(function () {
    refs.value.length = 0;
  });
  return refs;
}
function useTextDirection() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$document10 = options.document,
    document = _options$document10 === void 0 ? defaultDocument : _options$document10,
    _options$selector2 = options.selector,
    selector = _options$selector2 === void 0 ? "html" : _options$selector2,
    _options$observe2 = options.observe,
    observe = _options$observe2 === void 0 ? false : _options$observe2,
    _options$initialValue7 = options.initialValue,
    initialValue = _options$initialValue7 === void 0 ? "ltr" : _options$initialValue7;
  function getValue() {
    var _a, _b;
    return (_b = (_a = document == null ? void 0 : document.querySelector(selector)) == null ? void 0 : _a.getAttribute("dir")) != null ? _b : initialValue;
  }
  var dir = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(getValue());
  Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["E" /* tryOnMounted */])(function () {
    return dir.value = getValue();
  });
  if (observe && document) {
    useMutationObserver(document.querySelector(selector), function () {
      return dir.value = getValue();
    }, {
      attributes: true
    });
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])({
    get: function get() {
      return dir.value;
    },
    set: function set(v) {
      var _a, _b;
      dir.value = v;
      if (!document) return;
      if (dir.value) (_a = document.querySelector(selector)) == null ? void 0 : _a.setAttribute("dir", dir.value);else (_b = document.querySelector(selector)) == null ? void 0 : _b.removeAttribute("dir");
    }
  });
}
function getRangesFromSelection(selection) {
  var _a;
  var rangeCount = (_a = selection.rangeCount) != null ? _a : 0;
  var ranges = new Array(rangeCount);
  for (var i = 0; i < rangeCount; i++) {
    var range = selection.getRangeAt(i);
    ranges[i] = range;
  }
  return ranges;
}
function useTextSelection() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$window32 = options.window,
    window = _options$window32 === void 0 ? defaultWindow : _options$window32;
  var selection = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(null);
  var text = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    var _a, _b;
    return (_b = (_a = selection.value) == null ? void 0 : _a.toString()) != null ? _b : "";
  });
  var ranges = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return selection.value ? getRangesFromSelection(selection.value) : [];
  });
  var rects = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return ranges.value.map(function (range) {
      return range.getBoundingClientRect();
    });
  });
  function onSelectionChange() {
    selection.value = null;
    if (window) selection.value = window.getSelection();
  }
  if (window) useEventListener(window.document, "selectionchange", onSelectionChange);
  return {
    text: text,
    rects: rects,
    ranges: ranges,
    selection: selection
  };
}
function useTextareaAutosize(options) {
  var textarea = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(options == null ? void 0 : options.element);
  var input = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(options == null ? void 0 : options.input);
  var textareaScrollHeight = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(1);
  function triggerResize() {
    var _a, _b;
    if (!textarea.value) return;
    var height = "";
    textarea.value.style.height = "1px";
    textareaScrollHeight.value = (_a = textarea.value) == null ? void 0 : _a.scrollHeight;
    if (options == null ? void 0 : options.styleTarget) Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(options.styleTarget).style.height = "".concat(textareaScrollHeight.value, "px");else height = "".concat(textareaScrollHeight.value, "px");
    textarea.value.style.height = height;
    (_b = options == null ? void 0 : options.onResize) == null ? void 0 : _b.call(options);
  }
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])([input, textarea], triggerResize, {
    immediate: true
  });
  useResizeObserver(textarea, function () {
    return triggerResize();
  });
  if (options == null ? void 0 : options.watch) Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(options.watch, triggerResize, {
    immediate: true,
    deep: true
  });
  return {
    textarea: textarea,
    input: input,
    triggerResize: triggerResize
  };
}
var __defProp$3 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = function __defNormalProp$3(obj, key, value) {
  return key in obj ? __defProp$3(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$3 = function __spreadValues$3(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$3.call(b, prop)) __defNormalProp$3(a, prop, b[prop]);
  if (__getOwnPropSymbols$3) {
    var _iterator36 = _createForOfIteratorHelper(__getOwnPropSymbols$3(b)),
      _step36;
    try {
      for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
        var prop = _step36.value;
        if (__propIsEnum$3.call(b, prop)) __defNormalProp$3(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator36.e(err);
    } finally {
      _iterator36.f();
    }
  }
  return a;
};
var __spreadProps$1 = function __spreadProps$1(a, b) {
  return __defProps$1(a, __getOwnPropDescs$1(b));
};
function useThrottledRefHistory(source) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$throttle2 = options.throttle,
    throttle = _options$throttle2 === void 0 ? 200 : _options$throttle2,
    _options$trailing = options.trailing,
    trailing = _options$trailing === void 0 ? true : _options$trailing;
  var filter = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["z" /* throttleFilter */])(throttle, trailing);
  var history = useRefHistory(source, __spreadProps$1(__spreadValues$3({}, options), {
    eventFilter: filter
  }));
  return __spreadValues$3({}, history);
}
var __defProp$2 = Object.defineProperty;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = function __defNormalProp$2(obj, key, value) {
  return key in obj ? __defProp$2(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2 = function __spreadValues$2(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2) {
    var _iterator37 = _createForOfIteratorHelper(__getOwnPropSymbols$2(b)),
      _step37;
    try {
      for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
        var prop = _step37.value;
        if (__propIsEnum$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator37.e(err);
    } finally {
      _iterator37.f();
    }
  }
  return a;
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$2.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2) {
    var _iterator38 = _createForOfIteratorHelper(__getOwnPropSymbols$2(source)),
      _step38;
    try {
      for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
        var prop = _step38.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$2.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator38.e(err);
    } finally {
      _iterator38.f();
    }
  }
  return target;
};
var DEFAULT_UNITS = [{
  max: 6e4,
  value: 1e3,
  name: "second"
}, {
  max: 276e4,
  value: 6e4,
  name: "minute"
}, {
  max: 72e6,
  value: 36e5,
  name: "hour"
}, {
  max: 5184e5,
  value: 864e5,
  name: "day"
}, {
  max: 24192e5,
  value: 6048e5,
  name: "week"
}, {
  max: 28512e6,
  value: 2592e6,
  name: "month"
}, {
  max: Infinity,
  value: 31536e6,
  name: "year"
}];
var DEFAULT_MESSAGES = {
  justNow: "just now",
  past: function past(n) {
    return n.match(/\d/) ? "".concat(n, " ago") : n;
  },
  future: function future(n) {
    return n.match(/\d/) ? "in ".concat(n) : n;
  },
  month: function month(n, past) {
    return n === 1 ? past ? "last month" : "next month" : "".concat(n, " month").concat(n > 1 ? "s" : "");
  },
  year: function year(n, past) {
    return n === 1 ? past ? "last year" : "next year" : "".concat(n, " year").concat(n > 1 ? "s" : "");
  },
  day: function day(n, past) {
    return n === 1 ? past ? "yesterday" : "tomorrow" : "".concat(n, " day").concat(n > 1 ? "s" : "");
  },
  week: function week(n, past) {
    return n === 1 ? past ? "last week" : "next week" : "".concat(n, " week").concat(n > 1 ? "s" : "");
  },
  hour: function hour(n) {
    return "".concat(n, " hour").concat(n > 1 ? "s" : "");
  },
  minute: function minute(n) {
    return "".concat(n, " minute").concat(n > 1 ? "s" : "");
  },
  second: function second(n) {
    return "".concat(n, " second").concat(n > 1 ? "s" : "");
  },
  invalid: ""
};
function DEFAULT_FORMATTER(date) {
  return date.toISOString().slice(0, 10);
}
function useTimeAgo(time) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$controls3 = options.controls,
    exposeControls = _options$controls3 === void 0 ? false : _options$controls3,
    _options$updateInterv = options.updateInterval,
    updateInterval = _options$updateInterv === void 0 ? 3e4 : _options$updateInterv;
  var _a = useNow({
      interval: updateInterval,
      controls: true
    }),
    now = _a.now,
    controls = __objRest(_a, ["now"]);
  var timeAgo = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return formatTimeAgo(new Date(Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(time)), options, Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(now.value));
  });
  if (exposeControls) {
    return __spreadValues$2({
      timeAgo: timeAgo
    }, controls);
  } else {
    return timeAgo;
  }
}
function formatTimeAgo(from) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var now = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Date.now();
  var _a;
  var max = options.max,
    _options$messages = options.messages,
    messages = _options$messages === void 0 ? DEFAULT_MESSAGES : _options$messages,
    _options$fullDateForm = options.fullDateFormatter,
    fullDateFormatter = _options$fullDateForm === void 0 ? DEFAULT_FORMATTER : _options$fullDateForm,
    _options$units = options.units,
    units = _options$units === void 0 ? DEFAULT_UNITS : _options$units,
    _options$showSecond = options.showSecond,
    showSecond = _options$showSecond === void 0 ? false : _options$showSecond,
    _options$rounding = options.rounding,
    rounding = _options$rounding === void 0 ? "round" : _options$rounding;
  var roundFn = typeof rounding === "number" ? function (n) {
    return +n.toFixed(rounding);
  } : Math[rounding];
  var diff = +now - +from;
  var absDiff = Math.abs(diff);
  function getValue(diff2, unit) {
    return roundFn(Math.abs(diff2) / unit.value);
  }
  function format(diff2, unit) {
    var val = getValue(diff2, unit);
    var past = diff2 > 0;
    var str = applyFormat(unit.name, val, past);
    return applyFormat(past ? "past" : "future", str, past);
  }
  function applyFormat(name, val, isPast) {
    var formatter = messages[name];
    if (typeof formatter === "function") return formatter(val, isPast);
    return formatter.replace("{0}", val.toString());
  }
  if (absDiff < 6e4 && !showSecond) return messages.justNow;
  if (typeof max === "number" && absDiff > max) return fullDateFormatter(new Date(from));
  if (typeof max === "string") {
    var unitMax = (_a = units.find(function (i) {
      return i.name === max;
    })) == null ? void 0 : _a.max;
    if (unitMax && absDiff > unitMax) return fullDateFormatter(new Date(from));
  }
  var _iterator39 = _createForOfIteratorHelper(units.entries()),
    _step39;
  try {
    for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
      var _step39$value = _slicedToArray(_step39.value, 2),
        idx = _step39$value[0],
        unit = _step39$value[1];
      var val = getValue(diff, unit);
      if (val <= 0 && units[idx - 1]) return format(diff, units[idx - 1]);
      if (absDiff < unit.max) return format(diff, unit);
    }
  } catch (err) {
    _iterator39.e(err);
  } finally {
    _iterator39.f();
  }
  return messages.invalid;
}
function useTimeoutPoll(fn, interval, timeoutPollOptions) {
  var _useTimeoutFn = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["L" /* useTimeoutFn */])(loop, interval),
    start = _useTimeoutFn.start;
  var isActive = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  function loop() {
    return _loop4.apply(this, arguments);
  }
  function _loop4() {
    _loop4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee33() {
      return _regeneratorRuntime().wrap(function _callee33$(_context33) {
        while (1) switch (_context33.prev = _context33.next) {
          case 0:
            if (isActive.value) {
              _context33.next = 2;
              break;
            }
            return _context33.abrupt("return");
          case 2:
            _context33.next = 4;
            return fn();
          case 4:
            start();
          case 5:
          case "end":
            return _context33.stop();
        }
      }, _callee33);
    }));
    return _loop4.apply(this, arguments);
  }
  function resume() {
    if (!isActive.value) {
      isActive.value = true;
      loop();
    }
  }
  function pause() {
    isActive.value = false;
  }
  if (timeoutPollOptions == null ? void 0 : timeoutPollOptions.immediate) resume();
  Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["F" /* tryOnScopeDispose */])(pause);
  return {
    isActive: isActive,
    pause: pause,
    resume: resume
  };
}
var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = function __defNormalProp$1(obj, key, value) {
  return key in obj ? __defProp$1(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1 = function __spreadValues$1(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1) {
    var _iterator40 = _createForOfIteratorHelper(__getOwnPropSymbols$1(b)),
      _step40;
    try {
      for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
        var prop = _step40.value;
        if (__propIsEnum$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator40.e(err);
    } finally {
      _iterator40.f();
    }
  }
  return a;
};
function useTimestamp() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$controls4 = options.controls,
    exposeControls = _options$controls4 === void 0 ? false : _options$controls4,
    _options$offset2 = options.offset,
    offset = _options$offset2 === void 0 ? 0 : _options$offset2,
    _options$immediate8 = options.immediate,
    immediate = _options$immediate8 === void 0 ? true : _options$immediate8,
    _options$interval4 = options.interval,
    interval = _options$interval4 === void 0 ? "requestAnimationFrame" : _options$interval4,
    callback = options.callback;
  var ts = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["A" /* timestamp */])() + offset);
  var update = function update() {
    return ts.value = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["A" /* timestamp */])() + offset;
  };
  var cb = callback ? function () {
    update();
    callback(ts.value);
  } : update;
  var controls = interval === "requestAnimationFrame" ? useRafFn(cb, {
    immediate: immediate
  }) : Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["J" /* useIntervalFn */])(cb, interval, {
    immediate: immediate
  });
  if (exposeControls) {
    return __spreadValues$1({
      timestamp: ts
    }, controls);
  } else {
    return ts;
  }
}
function useTitle() {
  var newTitle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _a, _b;
  var _options$document11 = options.document,
    document = _options$document11 === void 0 ? defaultDocument : _options$document11;
  var title = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["B" /* toRef */])((_a = newTitle != null ? newTitle : document == null ? void 0 : document.title) != null ? _a : null);
  var isReadonly = newTitle && typeof newTitle === "function";
  function format(t) {
    if (!("titleTemplate" in options)) return t;
    var template = options.titleTemplate || "%s";
    return typeof template === "function" ? template(t) : Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(template).replace(/%s/g, t);
  }
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(title, function (t, o) {
    if (t !== o && document) document.title = format(typeof t === "string" ? t : "");
  }, {
    immediate: true
  });
  if (options.observe && !options.titleTemplate && document && !isReadonly) {
    useMutationObserver((_b = document.head) == null ? void 0 : _b.querySelector("title"), function () {
      if (document && document.title !== title.value) title.value = format(document.title);
    }, {
      childList: true
    });
  }
  return title;
}
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator41 = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step41;
    try {
      for (_iterator41.s(); !(_step41 = _iterator41.n()).done;) {
        var prop = _step41.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator41.e(err);
    } finally {
      _iterator41.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var _TransitionPresets = {
  easeInSine: [0.12, 0, 0.39, 0],
  easeOutSine: [0.61, 1, 0.88, 1],
  easeInOutSine: [0.37, 0, 0.63, 1],
  easeInQuad: [0.11, 0, 0.5, 0],
  easeOutQuad: [0.5, 1, 0.89, 1],
  easeInOutQuad: [0.45, 0, 0.55, 1],
  easeInCubic: [0.32, 0, 0.67, 0],
  easeOutCubic: [0.33, 1, 0.68, 1],
  easeInOutCubic: [0.65, 0, 0.35, 1],
  easeInQuart: [0.5, 0, 0.75, 0],
  easeOutQuart: [0.25, 1, 0.5, 1],
  easeInOutQuart: [0.76, 0, 0.24, 1],
  easeInQuint: [0.64, 0, 0.78, 0],
  easeOutQuint: [0.22, 1, 0.36, 1],
  easeInOutQuint: [0.83, 0, 0.17, 1],
  easeInExpo: [0.7, 0, 0.84, 0],
  easeOutExpo: [0.16, 1, 0.3, 1],
  easeInOutExpo: [0.87, 0, 0.13, 1],
  easeInCirc: [0.55, 0, 1, 0.45],
  easeOutCirc: [0, 0.55, 0.45, 1],
  easeInOutCirc: [0.85, 0, 0.15, 1],
  easeInBack: [0.36, 0, 0.66, -0.56],
  easeOutBack: [0.34, 1.56, 0.64, 1],
  easeInOutBack: [0.68, -0.6, 0.32, 1.6]
};
var TransitionPresets = /* @__PURE__ */Object.assign({}, {
  linear: __WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["j" /* identity */]
}, _TransitionPresets);
function createEasingFunction(_ref50) {
  var _ref51 = _slicedToArray(_ref50, 4),
    p0 = _ref51[0],
    p1 = _ref51[1],
    p2 = _ref51[2],
    p3 = _ref51[3];
  var a = function a(a1, a2) {
    return 1 - 3 * a2 + 3 * a1;
  };
  var b = function b(a1, a2) {
    return 3 * a2 - 6 * a1;
  };
  var c = function c(a1) {
    return 3 * a1;
  };
  var calcBezier = function calcBezier(t, a1, a2) {
    return ((a(a1, a2) * t + b(a1, a2)) * t + c(a1)) * t;
  };
  var getSlope = function getSlope(t, a1, a2) {
    return 3 * a(a1, a2) * t * t + 2 * b(a1, a2) * t + c(a1);
  };
  var getTforX = function getTforX(x) {
    var aGuessT = x;
    for (var i = 0; i < 4; ++i) {
      var currentSlope = getSlope(aGuessT, p0, p2);
      if (currentSlope === 0) return aGuessT;
      var currentX = calcBezier(aGuessT, p0, p2) - x;
      aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
  };
  return function (x) {
    return p0 === p1 && p2 === p3 ? x : calcBezier(getTforX(x), p1, p3);
  };
}
function lerp(a, b, alpha) {
  return a + alpha * (b - a);
}
function toVec(t) {
  return (typeof t === "number" ? [t] : t) || [];
}
function executeTransition(source, from, to) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _a, _b;
  var fromVal = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(from);
  var toVal = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(to);
  var v1 = toVec(fromVal);
  var v2 = toVec(toVal);
  var duration = (_a = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(options.duration)) != null ? _a : 1e3;
  var startedAt = Date.now();
  var endAt = Date.now() + duration;
  var trans = typeof options.transition === "function" ? options.transition : (_b = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(options.transition)) != null ? _b : __WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["j" /* identity */];
  var ease = typeof trans === "function" ? trans : createEasingFunction(trans);
  return new Promise(function (resolve) {
    source.value = fromVal;
    var tick = function tick() {
      var _a2;
      if ((_a2 = options.abort) == null ? void 0 : _a2.call(options)) {
        resolve();
        return;
      }
      var now = Date.now();
      var alpha = ease((now - startedAt) / duration);
      var arr = toVec(source.value).map(function (n, i) {
        return lerp(v1[i], v2[i], alpha);
      });
      if (Array.isArray(source.value)) source.value = arr.map(function (n, i) {
        var _a3, _b2;
        return lerp((_a3 = v1[i]) != null ? _a3 : 0, (_b2 = v2[i]) != null ? _b2 : 0, alpha);
      });else if (typeof source.value === "number") source.value = arr[0];
      if (now < endAt) {
        requestAnimationFrame(tick);
      } else {
        source.value = toVal;
        resolve();
      }
    };
    tick();
  });
}
function useTransition(source) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var currentId = 0;
  var sourceVal = function sourceVal() {
    var v = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(source);
    return typeof v === "number" ? v : v.map(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */]);
  };
  var outputRef = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(sourceVal());
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(sourceVal, /*#__PURE__*/function () {
    var _ref52 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee34(to) {
      var _a, _b, id, toVal;
      return _regeneratorRuntime().wrap(function _callee34$(_context34) {
        while (1) switch (_context34.prev = _context34.next) {
          case 0:
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(options.disabled)) {
              _context34.next = 2;
              break;
            }
            return _context34.abrupt("return");
          case 2:
            id = ++currentId;
            if (!options.delay) {
              _context34.next = 6;
              break;
            }
            _context34.next = 6;
            return Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["x" /* promiseTimeout */])(Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(options.delay));
          case 6:
            if (!(id !== currentId)) {
              _context34.next = 8;
              break;
            }
            return _context34.abrupt("return");
          case 8:
            toVal = Array.isArray(to) ? to.map(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */]) : Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(to);
            (_a = options.onStarted) == null ? void 0 : _a.call(options);
            _context34.next = 12;
            return executeTransition(outputRef, outputRef.value, toVal, __spreadProps(__spreadValues({}, options), {
              abort: function abort() {
                var _a2;
                return id !== currentId || ((_a2 = options.abort) == null ? void 0 : _a2.call(options));
              }
            }));
          case 12:
            (_b = options.onFinished) == null ? void 0 : _b.call(options);
          case 13:
          case "end":
            return _context34.stop();
        }
      }, _callee34);
    }));
    return function (_x13) {
      return _ref52.apply(this, arguments);
    };
  }(), {
    deep: true
  });
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(options.disabled);
  }, function (disabled) {
    if (disabled) {
      currentId++;
      outputRef.value = sourceVal();
    }
  });
  Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["F" /* tryOnScopeDispose */])(function () {
    currentId++;
  });
  return Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["D" /* toValue */])(options.disabled) ? sourceVal() : outputRef.value;
  });
}
function useUrlSearchParams() {
  var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "history";
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$initialValue8 = options.initialValue,
    initialValue = _options$initialValue8 === void 0 ? {} : _options$initialValue8,
    _options$removeNullis = options.removeNullishValues,
    removeNullishValues = _options$removeNullis === void 0 ? true : _options$removeNullis,
    _options$removeFalsyV = options.removeFalsyValues,
    removeFalsyValues = _options$removeFalsyV === void 0 ? false : _options$removeFalsyV,
    _options$write = options.write,
    enableWrite = _options$write === void 0 ? true : _options$write,
    _options$window33 = options.window,
    window = _options$window33 === void 0 ? defaultWindow : _options$window33;
  if (!window) return Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["reactive"])(initialValue);
  var state = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["reactive"])({});
  function getRawParams() {
    if (mode === "history") {
      return window.location.search || "";
    } else if (mode === "hash") {
      var hash = window.location.hash || "";
      var index = hash.indexOf("?");
      return index > 0 ? hash.slice(index) : "";
    } else {
      return (window.location.hash || "").replace(/^#/, "");
    }
  }
  function constructQuery(params) {
    var stringified = params.toString();
    if (mode === "history") return "".concat(stringified ? "?".concat(stringified) : "").concat(window.location.hash || "");
    if (mode === "hash-params") return "".concat(window.location.search || "").concat(stringified ? "#".concat(stringified) : "");
    var hash = window.location.hash || "#";
    var index = hash.indexOf("?");
    if (index > 0) return "".concat(hash.slice(0, index)).concat(stringified ? "?".concat(stringified) : "");
    return "".concat(hash).concat(stringified ? "?".concat(stringified) : "");
  }
  function read() {
    return new URLSearchParams(getRawParams());
  }
  function updateState(params) {
    var unusedKeys = new Set(Object.keys(state));
    var _iterator42 = _createForOfIteratorHelper(params.keys()),
      _step42;
    try {
      for (_iterator42.s(); !(_step42 = _iterator42.n()).done;) {
        var key = _step42.value;
        var paramsForKey = params.getAll(key);
        state[key] = paramsForKey.length > 1 ? paramsForKey : params.get(key) || "";
        unusedKeys.delete(key);
      }
    } catch (err) {
      _iterator42.e(err);
    } finally {
      _iterator42.f();
    }
    Array.from(unusedKeys).forEach(function (key) {
      return delete state[key];
    });
  }
  var _pausableWatch2 = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["w" /* pausableWatch */])(state, function () {
      var params = new URLSearchParams("");
      Object.keys(state).forEach(function (key) {
        var mapEntry = state[key];
        if (Array.isArray(mapEntry)) mapEntry.forEach(function (value) {
          return params.append(key, value);
        });else if (removeNullishValues && mapEntry == null) params.delete(key);else if (removeFalsyValues && !mapEntry) params.delete(key);else params.set(key, mapEntry);
      });
      write(params);
    }, {
      deep: true
    }),
    pause = _pausableWatch2.pause,
    resume = _pausableWatch2.resume;
  function write(params, shouldUpdate) {
    pause();
    if (shouldUpdate) updateState(params);
    window.history.replaceState(window.history.state, window.document.title, window.location.pathname + constructQuery(params));
    resume();
  }
  function onChanged() {
    if (!enableWrite) return;
    write(read(), true);
  }
  useEventListener(window, "popstate", onChanged, false);
  if (mode !== "history") useEventListener(window, "hashchange", onChanged, false);
  var initial = read();
  if (initial.keys().next().value) updateState(initial);else Object.assign(state, initialValue);
  return state;
}
function useUserMedia() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _a, _b;
  var enabled = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])((_a = options.enabled) != null ? _a : false);
  var autoSwitch = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])((_b = options.autoSwitch) != null ? _b : true);
  var constraints = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(options.constraints);
  var _options$navigator8 = options.navigator,
    navigator = _options$navigator8 === void 0 ? defaultNavigator : _options$navigator8;
  var isSupported = useSupported(function () {
    var _a2;
    return (_a2 = navigator == null ? void 0 : navigator.mediaDevices) == null ? void 0 : _a2.getUserMedia;
  });
  var stream = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["shallowRef"])();
  function getDeviceOptions(type) {
    switch (type) {
      case "video":
        {
          if (constraints.value) return constraints.value.video || false;
          break;
        }
      case "audio":
        {
          if (constraints.value) return constraints.value.audio || false;
          break;
        }
    }
  }
  function _start() {
    return _start4.apply(this, arguments);
  }
  function _start4() {
    _start4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee35() {
      return _regeneratorRuntime().wrap(function _callee35$(_context35) {
        while (1) switch (_context35.prev = _context35.next) {
          case 0:
            if (!(!isSupported.value || stream.value)) {
              _context35.next = 2;
              break;
            }
            return _context35.abrupt("return");
          case 2:
            _context35.next = 4;
            return navigator.mediaDevices.getUserMedia({
              video: getDeviceOptions("video"),
              audio: getDeviceOptions("audio")
            });
          case 4:
            stream.value = _context35.sent;
            return _context35.abrupt("return", stream.value);
          case 6:
          case "end":
            return _context35.stop();
        }
      }, _callee35);
    }));
    return _start4.apply(this, arguments);
  }
  function _stop() {
    var _a2;
    (_a2 = stream.value) == null ? void 0 : _a2.getTracks().forEach(function (t) {
      return t.stop();
    });
    stream.value = void 0;
  }
  function stop() {
    _stop();
    enabled.value = false;
  }
  function start() {
    return _start5.apply(this, arguments);
  }
  function _start5() {
    _start5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee36() {
      return _regeneratorRuntime().wrap(function _callee36$(_context36) {
        while (1) switch (_context36.prev = _context36.next) {
          case 0:
            _context36.next = 2;
            return _start();
          case 2:
            if (stream.value) enabled.value = true;
            return _context36.abrupt("return", stream.value);
          case 4:
          case "end":
            return _context36.stop();
        }
      }, _callee36);
    }));
    return _start5.apply(this, arguments);
  }
  function restart() {
    return _restart.apply(this, arguments);
  }
  function _restart() {
    _restart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee37() {
      return _regeneratorRuntime().wrap(function _callee37$(_context37) {
        while (1) switch (_context37.prev = _context37.next) {
          case 0:
            _stop();
            _context37.next = 3;
            return start();
          case 3:
            return _context37.abrupt("return", _context37.sent);
          case 4:
          case "end":
            return _context37.stop();
        }
      }, _callee37);
    }));
    return _restart.apply(this, arguments);
  }
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(enabled, function (v) {
    if (v) _start();else _stop();
  }, {
    immediate: true
  });
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(constraints, function () {
    if (autoSwitch.value && stream.value) restart();
  }, {
    immediate: true
  });
  return {
    isSupported: isSupported,
    stream: stream,
    start: start,
    stop: stop,
    restart: restart,
    constraints: constraints,
    enabled: enabled,
    autoSwitch: autoSwitch
  };
}
function useVModel(props, key, emit) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _a, _b, _c, _d, _e;
  var _options$clone3 = options.clone,
    clone = _options$clone3 === void 0 ? false : _options$clone3,
    _options$passive3 = options.passive,
    passive = _options$passive3 === void 0 ? false : _options$passive3,
    eventName = options.eventName,
    _options$deep5 = options.deep,
    deep = _options$deep5 === void 0 ? false : _options$deep5,
    defaultValue = options.defaultValue,
    shouldEmit = options.shouldEmit;
  var vm = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["getCurrentInstance"])();
  var _emit = emit || (vm == null ? void 0 : vm.emit) || ((_a = vm == null ? void 0 : vm.$emit) == null ? void 0 : _a.bind(vm)) || ((_c = (_b = vm == null ? void 0 : vm.proxy) == null ? void 0 : _b.$emit) == null ? void 0 : _c.bind(vm == null ? void 0 : vm.proxy));
  var event = eventName;
  if (!key) {
    if (__WEBPACK_IMPORTED_MODULE_1_vue_demi__["isVue2"]) {
      var modelOptions = (_e = (_d = vm == null ? void 0 : vm.proxy) == null ? void 0 : _d.$options) == null ? void 0 : _e.model;
      key = (modelOptions == null ? void 0 : modelOptions.value) || "value";
      if (!eventName) event = (modelOptions == null ? void 0 : modelOptions.event) || "input";
    } else {
      key = "modelValue";
    }
  }
  event = eventName || event || "update:".concat(key.toString());
  var cloneFn = function cloneFn(val) {
    return !clone ? val : typeof clone === "function" ? clone(val) : cloneFnJSON(val);
  };
  var getValue = function getValue() {
    return Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["m" /* isDef */])(props[key]) ? cloneFn(props[key]) : defaultValue;
  };
  var triggerEmit = function triggerEmit(value) {
    if (shouldEmit) {
      if (shouldEmit(value)) _emit(event, value);
    } else {
      _emit(event, value);
    }
  };
  if (passive) {
    var initialValue = getValue();
    var proxy = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(initialValue);
    Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(function () {
      return props[key];
    }, function (v) {
      return proxy.value = cloneFn(v);
    });
    Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(proxy, function (v) {
      if (v !== props[key] || deep) triggerEmit(v);
    }, {
      deep: deep
    });
    return proxy;
  } else {
    return Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])({
      get: function get() {
        return getValue();
      },
      set: function set(value) {
        triggerEmit(value);
      }
    });
  }
}
function useVModels(props, emit) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var ret = {};
  for (var key in props) ret[key] = useVModel(props, key, emit, options);
  return ret;
}
function useVibrate(options) {
  var _ref53 = options || {},
    _ref53$pattern = _ref53.pattern,
    pattern = _ref53$pattern === void 0 ? [] : _ref53$pattern,
    _ref53$interval = _ref53.interval,
    interval = _ref53$interval === void 0 ? 0 : _ref53$interval,
    _ref53$navigator = _ref53.navigator,
    navigator = _ref53$navigator === void 0 ? defaultNavigator : _ref53$navigator;
  var isSupported = useSupported(function () {
    return typeof navigator !== "undefined" && "vibrate" in navigator;
  });
  var patternRef = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["B" /* toRef */])(pattern);
  var intervalControls;
  var vibrate = function vibrate() {
    var pattern2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : patternRef.value;
    if (isSupported.value) navigator.vibrate(pattern2);
  };
  var stop = function stop() {
    if (isSupported.value) navigator.vibrate(0);
    intervalControls == null ? void 0 : intervalControls.pause();
  };
  if (interval > 0) {
    intervalControls = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["J" /* useIntervalFn */])(vibrate, interval, {
      immediate: false,
      immediateCallback: false
    });
  }
  return {
    isSupported: isSupported,
    pattern: pattern,
    intervalControls: intervalControls,
    vibrate: vibrate,
    stop: stop
  };
}
function useVirtualList(list, options) {
  var _ref54 = "itemHeight" in options ? useVerticalVirtualList(options, list) : useHorizontalVirtualList(options, list),
    containerStyle = _ref54.containerStyle,
    wrapperProps = _ref54.wrapperProps,
    scrollTo = _ref54.scrollTo,
    calculateRange = _ref54.calculateRange,
    currentList = _ref54.currentList,
    containerRef = _ref54.containerRef;
  return {
    list: currentList,
    scrollTo: scrollTo,
    containerProps: {
      ref: containerRef,
      onScroll: function onScroll() {
        calculateRange();
      },
      style: containerStyle
    },
    wrapperProps: wrapperProps
  };
}
function useVirtualListResources(list) {
  var containerRef = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(null);
  var size = useElementSize(containerRef);
  var currentList = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])([]);
  var source = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["shallowRef"])(list);
  var state = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])({
    start: 0,
    end: 10
  });
  return {
    state: state,
    source: source,
    currentList: currentList,
    size: size,
    containerRef: containerRef
  };
}
function createGetViewCapacity(state, source, itemSize) {
  return function (containerSize) {
    if (typeof itemSize === "number") return Math.ceil(containerSize / itemSize);
    var _state$value$start = state.value.start,
      start = _state$value$start === void 0 ? 0 : _state$value$start;
    var sum = 0;
    var capacity = 0;
    for (var i = start; i < source.value.length; i++) {
      var size = itemSize(i);
      sum += size;
      capacity = i;
      if (sum > containerSize) break;
    }
    return capacity - start;
  };
}
function createGetOffset(source, itemSize) {
  return function (scrollDirection) {
    if (typeof itemSize === "number") return Math.floor(scrollDirection / itemSize) + 1;
    var sum = 0;
    var offset = 0;
    for (var i = 0; i < source.value.length; i++) {
      var size = itemSize(i);
      sum += size;
      if (sum >= scrollDirection) {
        offset = i;
        break;
      }
    }
    return offset + 1;
  };
}
function createCalculateRange(type, overscan, getOffset, getViewCapacity, _ref55) {
  var containerRef = _ref55.containerRef,
    state = _ref55.state,
    currentList = _ref55.currentList,
    source = _ref55.source;
  return function () {
    var element = containerRef.value;
    if (element) {
      var offset = getOffset(type === "vertical" ? element.scrollTop : element.scrollLeft);
      var viewCapacity = getViewCapacity(type === "vertical" ? element.clientHeight : element.clientWidth);
      var from = offset - overscan;
      var to = offset + viewCapacity + overscan;
      state.value = {
        start: from < 0 ? 0 : from,
        end: to > source.value.length ? source.value.length : to
      };
      currentList.value = source.value.slice(state.value.start, state.value.end).map(function (ele, index) {
        return {
          data: ele,
          index: index + state.value.start
        };
      });
    }
  };
}
function createGetDistance(itemSize, source) {
  return function (index) {
    if (typeof itemSize === "number") {
      var size2 = index * itemSize;
      return size2;
    }
    var size = source.value.slice(0, index).reduce(function (sum, _, i) {
      return sum + itemSize(i);
    }, 0);
    return size;
  };
}
function useWatchForSizes(size, list, calculateRange) {
  Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])([size.width, size.height, list], function () {
    calculateRange();
  });
}
function createComputedTotalSize(itemSize, source) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    if (typeof itemSize === "number") return source.value.length * itemSize;
    return source.value.reduce(function (sum, _, index) {
      return sum + itemSize(index);
    }, 0);
  });
}
var scrollToDictionaryForElementScrollKey = {
  horizontal: "scrollLeft",
  vertical: "scrollTop"
};
function createScrollTo(type, calculateRange, getDistance, containerRef) {
  return function (index) {
    if (containerRef.value) {
      containerRef.value[scrollToDictionaryForElementScrollKey[type]] = getDistance(index);
      calculateRange();
    }
  };
}
function useHorizontalVirtualList(options, list) {
  var resources = useVirtualListResources(list);
  var state = resources.state,
    source = resources.source,
    currentList = resources.currentList,
    size = resources.size,
    containerRef = resources.containerRef;
  var containerStyle = {
    overflowX: "auto"
  };
  var itemWidth = options.itemWidth,
    _options$overscan = options.overscan,
    overscan = _options$overscan === void 0 ? 5 : _options$overscan;
  var getViewCapacity = createGetViewCapacity(state, source, itemWidth);
  var getOffset = createGetOffset(source, itemWidth);
  var calculateRange = createCalculateRange("horizontal", overscan, getOffset, getViewCapacity, resources);
  var getDistanceLeft = createGetDistance(itemWidth, source);
  var offsetLeft = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return getDistanceLeft(state.value.start);
  });
  var totalWidth = createComputedTotalSize(itemWidth, source);
  useWatchForSizes(size, list, calculateRange);
  var scrollTo = createScrollTo("horizontal", calculateRange, getDistanceLeft, containerRef);
  var wrapperProps = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return {
      style: {
        height: "100%",
        width: "".concat(totalWidth.value - offsetLeft.value, "px"),
        marginLeft: "".concat(offsetLeft.value, "px"),
        display: "flex"
      }
    };
  });
  return {
    scrollTo: scrollTo,
    calculateRange: calculateRange,
    wrapperProps: wrapperProps,
    containerStyle: containerStyle,
    currentList: currentList,
    containerRef: containerRef
  };
}
function useVerticalVirtualList(options, list) {
  var resources = useVirtualListResources(list);
  var state = resources.state,
    source = resources.source,
    currentList = resources.currentList,
    size = resources.size,
    containerRef = resources.containerRef;
  var containerStyle = {
    overflowY: "auto"
  };
  var itemHeight = options.itemHeight,
    _options$overscan2 = options.overscan,
    overscan = _options$overscan2 === void 0 ? 5 : _options$overscan2;
  var getViewCapacity = createGetViewCapacity(state, source, itemHeight);
  var getOffset = createGetOffset(source, itemHeight);
  var calculateRange = createCalculateRange("vertical", overscan, getOffset, getViewCapacity, resources);
  var getDistanceTop = createGetDistance(itemHeight, source);
  var offsetTop = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return getDistanceTop(state.value.start);
  });
  var totalHeight = createComputedTotalSize(itemHeight, source);
  useWatchForSizes(size, list, calculateRange);
  var scrollTo = createScrollTo("vertical", calculateRange, getDistanceTop, containerRef);
  var wrapperProps = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["computed"])(function () {
    return {
      style: {
        width: "100%",
        height: "".concat(totalHeight.value - offsetTop.value, "px"),
        marginTop: "".concat(offsetTop.value, "px")
      }
    };
  });
  return {
    calculateRange: calculateRange,
    scrollTo: scrollTo,
    containerStyle: containerStyle,
    wrapperProps: wrapperProps,
    currentList: currentList,
    containerRef: containerRef
  };
}
function useWakeLock() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$navigator9 = options.navigator,
    navigator = _options$navigator9 === void 0 ? defaultNavigator : _options$navigator9,
    _options$document12 = options.document,
    document = _options$document12 === void 0 ? defaultDocument : _options$document12;
  var wakeLock;
  var isSupported = useSupported(function () {
    return navigator && "wakeLock" in navigator;
  });
  var isActive = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  function onVisibilityChange() {
    return _onVisibilityChange.apply(this, arguments);
  }
  function _onVisibilityChange() {
    _onVisibilityChange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee38() {
      return _regeneratorRuntime().wrap(function _callee38$(_context38) {
        while (1) switch (_context38.prev = _context38.next) {
          case 0:
            if (!(!isSupported.value || !wakeLock)) {
              _context38.next = 2;
              break;
            }
            return _context38.abrupt("return");
          case 2:
            if (!(document && document.visibilityState === "visible")) {
              _context38.next = 6;
              break;
            }
            _context38.next = 5;
            return navigator.wakeLock.request("screen");
          case 5:
            wakeLock = _context38.sent;
          case 6:
            isActive.value = !wakeLock.released;
          case 7:
          case "end":
            return _context38.stop();
        }
      }, _callee38);
    }));
    return _onVisibilityChange.apply(this, arguments);
  }
  if (document) useEventListener(document, "visibilitychange", onVisibilityChange, {
    passive: true
  });
  function request(_x14) {
    return _request.apply(this, arguments);
  }
  function _request() {
    _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee39(type) {
      return _regeneratorRuntime().wrap(function _callee39$(_context39) {
        while (1) switch (_context39.prev = _context39.next) {
          case 0:
            if (isSupported.value) {
              _context39.next = 2;
              break;
            }
            return _context39.abrupt("return");
          case 2:
            _context39.next = 4;
            return navigator.wakeLock.request(type);
          case 4:
            wakeLock = _context39.sent;
            isActive.value = !wakeLock.released;
          case 6:
          case "end":
            return _context39.stop();
        }
      }, _callee39);
    }));
    return _request.apply(this, arguments);
  }
  function release() {
    return _release.apply(this, arguments);
  }
  function _release() {
    _release = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee40() {
      return _regeneratorRuntime().wrap(function _callee40$(_context40) {
        while (1) switch (_context40.prev = _context40.next) {
          case 0:
            if (!(!isSupported.value || !wakeLock)) {
              _context40.next = 2;
              break;
            }
            return _context40.abrupt("return");
          case 2:
            _context40.next = 4;
            return wakeLock.release();
          case 4:
            isActive.value = !wakeLock.released;
            wakeLock = null;
          case 6:
          case "end":
            return _context40.stop();
        }
      }, _callee40);
    }));
    return _release.apply(this, arguments);
  }
  return {
    isSupported: isSupported,
    isActive: isActive,
    request: request,
    release: release
  };
}
function useWebNotification() {
  var defaultOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _defaultOptions$windo = defaultOptions.window,
    window = _defaultOptions$windo === void 0 ? defaultWindow : _defaultOptions$windo;
  var isSupported = useSupported(function () {
    return !!window && "Notification" in window;
  });
  var notification = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(null);
  var requestPermission = /*#__PURE__*/function () {
    var _ref56 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee41() {
      return _regeneratorRuntime().wrap(function _callee41$(_context41) {
        while (1) switch (_context41.prev = _context41.next) {
          case 0:
            if (isSupported.value) {
              _context41.next = 2;
              break;
            }
            return _context41.abrupt("return");
          case 2:
            if (!("permission" in Notification && Notification.permission !== "denied")) {
              _context41.next = 5;
              break;
            }
            _context41.next = 5;
            return Notification.requestPermission();
          case 5:
          case "end":
            return _context41.stop();
        }
      }, _callee41);
    }));
    return function requestPermission() {
      return _ref56.apply(this, arguments);
    };
  }();
  var _createEventHook2 = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["e" /* createEventHook */])(),
    onClick = _createEventHook2.on,
    clickTrigger = _createEventHook2.trigger;
  var _createEventHook3 = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["e" /* createEventHook */])(),
    onShow = _createEventHook3.on,
    showTrigger = _createEventHook3.trigger;
  var _createEventHook4 = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["e" /* createEventHook */])(),
    onError = _createEventHook4.on,
    errorTrigger = _createEventHook4.trigger;
  var _createEventHook5 = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["e" /* createEventHook */])(),
    onClose = _createEventHook5.on,
    closeTrigger = _createEventHook5.trigger;
  var show = /*#__PURE__*/function () {
    var _ref57 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee42(overrides) {
      var options;
      return _regeneratorRuntime().wrap(function _callee42$(_context42) {
        while (1) switch (_context42.prev = _context42.next) {
          case 0:
            if (isSupported.value) {
              _context42.next = 2;
              break;
            }
            return _context42.abrupt("return");
          case 2:
            _context42.next = 4;
            return requestPermission();
          case 4:
            options = Object.assign({}, defaultOptions, overrides);
            notification.value = new Notification(options.title || "", options);
            notification.value.onclick = clickTrigger;
            notification.value.onshow = showTrigger;
            notification.value.onerror = errorTrigger;
            notification.value.onclose = closeTrigger;
            return _context42.abrupt("return", notification.value);
          case 11:
          case "end":
            return _context42.stop();
        }
      }, _callee42);
    }));
    return function show(_x15) {
      return _ref57.apply(this, arguments);
    };
  }();
  var close = function close() {
    if (notification.value) notification.value.close();
    notification.value = null;
  };
  Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["E" /* tryOnMounted */])( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee43() {
    return _regeneratorRuntime().wrap(function _callee43$(_context43) {
      while (1) switch (_context43.prev = _context43.next) {
        case 0:
          if (!isSupported.value) {
            _context43.next = 3;
            break;
          }
          _context43.next = 3;
          return requestPermission();
        case 3:
        case "end":
          return _context43.stop();
      }
    }, _callee43);
  })));
  Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["F" /* tryOnScopeDispose */])(close);
  if (isSupported.value && window) {
    var _document3 = window.document;
    useEventListener(_document3, "visibilitychange", function (e) {
      e.preventDefault();
      if (_document3.visibilityState === "visible") {
        close();
      }
    });
  }
  return {
    isSupported: isSupported,
    notification: notification,
    show: show,
    close: close,
    onClick: onClick,
    onShow: onShow,
    onError: onError,
    onClose: onClose
  };
}
var DEFAULT_PING_MESSAGE = "ping";
function resolveNestedOptions(options) {
  if (options === true) return {};
  return options;
}
function useWebSocket(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var onConnected = options.onConnected,
    onDisconnected = options.onDisconnected,
    onError = options.onError,
    onMessage = options.onMessage,
    _options$immediate9 = options.immediate,
    immediate = _options$immediate9 === void 0 ? true : _options$immediate9,
    _options$autoClose = options.autoClose,
    autoClose = _options$autoClose === void 0 ? true : _options$autoClose,
    _options$protocols = options.protocols,
    protocols = _options$protocols === void 0 ? [] : _options$protocols;
  var data = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(null);
  var status = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])("CLOSED");
  var wsRef = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])();
  var urlRef = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["B" /* toRef */])(url);
  var heartbeatPause;
  var heartbeatResume;
  var explicitlyClosed = false;
  var retried = 0;
  var bufferedData = [];
  var pongTimeoutWait;
  var close = function close() {
    var code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1e3;
    var reason = arguments.length > 1 ? arguments[1] : undefined;
    if (!wsRef.value) return;
    explicitlyClosed = true;
    heartbeatPause == null ? void 0 : heartbeatPause();
    wsRef.value.close(code, reason);
  };
  var _sendBuffer = function _sendBuffer() {
    if (bufferedData.length && wsRef.value && status.value === "OPEN") {
      for (var _i2 = 0, _bufferedData = bufferedData; _i2 < _bufferedData.length; _i2++) {
        var buffer = _bufferedData[_i2];
        wsRef.value.send(buffer);
      }
      bufferedData = [];
    }
  };
  var resetHeartbeat = function resetHeartbeat() {
    clearTimeout(pongTimeoutWait);
    pongTimeoutWait = void 0;
  };
  var send = function send(data2) {
    var useBuffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (!wsRef.value || status.value !== "OPEN") {
      if (useBuffer) bufferedData.push(data2);
      return false;
    }
    _sendBuffer();
    wsRef.value.send(data2);
    return true;
  };
  var _init = function _init() {
    if (explicitlyClosed || typeof urlRef.value === "undefined") return;
    var ws = new WebSocket(urlRef.value, protocols);
    wsRef.value = ws;
    status.value = "CONNECTING";
    ws.onopen = function () {
      status.value = "OPEN";
      onConnected == null ? void 0 : onConnected(ws);
      heartbeatResume == null ? void 0 : heartbeatResume();
      _sendBuffer();
    };
    ws.onclose = function (ev) {
      status.value = "CLOSED";
      wsRef.value = void 0;
      onDisconnected == null ? void 0 : onDisconnected(ws, ev);
      if (!explicitlyClosed && options.autoReconnect) {
        var _resolveNestedOptions = resolveNestedOptions(options.autoReconnect),
          _resolveNestedOptions2 = _resolveNestedOptions.retries,
          retries = _resolveNestedOptions2 === void 0 ? -1 : _resolveNestedOptions2,
          _resolveNestedOptions3 = _resolveNestedOptions.delay,
          delay = _resolveNestedOptions3 === void 0 ? 1e3 : _resolveNestedOptions3,
          onFailed = _resolveNestedOptions.onFailed;
        retried += 1;
        if (typeof retries === "number" && (retries < 0 || retried < retries)) setTimeout(_init, delay);else if (typeof retries === "function" && retries()) setTimeout(_init, delay);else onFailed == null ? void 0 : onFailed();
      }
    };
    ws.onerror = function (e) {
      onError == null ? void 0 : onError(ws, e);
    };
    ws.onmessage = function (e) {
      if (options.heartbeat) {
        resetHeartbeat();
        var _resolveNestedOptions4 = resolveNestedOptions(options.heartbeat),
          _resolveNestedOptions5 = _resolveNestedOptions4.message,
          message = _resolveNestedOptions5 === void 0 ? DEFAULT_PING_MESSAGE : _resolveNestedOptions5;
        if (e.data === message) return;
      }
      data.value = e.data;
      onMessage == null ? void 0 : onMessage(ws, e);
    };
  };
  if (options.heartbeat) {
    var _resolveNestedOptions6 = resolveNestedOptions(options.heartbeat),
      _resolveNestedOptions7 = _resolveNestedOptions6.message,
      message = _resolveNestedOptions7 === void 0 ? DEFAULT_PING_MESSAGE : _resolveNestedOptions7,
      _resolveNestedOptions8 = _resolveNestedOptions6.interval,
      interval = _resolveNestedOptions8 === void 0 ? 1e3 : _resolveNestedOptions8,
      _resolveNestedOptions9 = _resolveNestedOptions6.pongTimeout,
      pongTimeout = _resolveNestedOptions9 === void 0 ? 1e3 : _resolveNestedOptions9;
    var _useIntervalFn = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["J" /* useIntervalFn */])(function () {
        send(message, false);
        if (pongTimeoutWait != null) return;
        pongTimeoutWait = setTimeout(function () {
          close();
        }, pongTimeout);
      }, interval, {
        immediate: false
      }),
      pause = _useIntervalFn.pause,
      resume = _useIntervalFn.resume;
    heartbeatPause = pause;
    heartbeatResume = resume;
  }
  if (autoClose) {
    useEventListener(window, "beforeunload", function () {
      return close();
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["F" /* tryOnScopeDispose */])(close);
  }
  var open = function open() {
    close();
    explicitlyClosed = false;
    retried = 0;
    _init();
  };
  if (immediate) Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(urlRef, open, {
    immediate: true
  });
  return {
    data: data,
    status: status,
    close: close,
    send: send,
    open: open,
    ws: wsRef
  };
}
function useWebWorker(arg0, workerOptions, options) {
  var _ref59 = options != null ? options : {},
    _ref59$window = _ref59.window,
    window = _ref59$window === void 0 ? defaultWindow : _ref59$window;
  var data = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(null);
  var worker = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["shallowRef"])();
  var post = function post2(val) {
    if (!worker.value) return;
    worker.value.postMessage(val);
  };
  var terminate = function terminate2() {
    if (!worker.value) return;
    worker.value.terminate();
  };
  if (window) {
    if (typeof arg0 === "string") worker.value = new Worker(arg0, workerOptions);else if (typeof arg0 === "function") worker.value = arg0();else worker.value = arg0;
    worker.value.onmessage = function (e) {
      data.value = e.data;
    };
    Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["F" /* tryOnScopeDispose */])(function () {
      if (worker.value) worker.value.terminate();
    });
  }
  return {
    data: data,
    post: post,
    terminate: terminate,
    worker: worker
  };
}
function jobRunner(userFunc) {
  return function (e) {
    var userFuncArgs = e.data[0];
    return Promise.resolve(userFunc.apply(void 0, userFuncArgs)).then(function (result) {
      postMessage(["SUCCESS", result]);
    }).catch(function (error) {
      postMessage(["ERROR", error]);
    });
  };
}
function depsParser(deps) {
  if (deps.length === 0) return "";
  var depsString = deps.map(function (dep) {
    return "'".concat(dep, "'");
  }).toString();
  return "importScripts(".concat(depsString, ")");
}
function createWorkerBlobUrl(fn, deps) {
  var blobCode = "".concat(depsParser(deps), "; onmessage=(").concat(jobRunner, ")(").concat(fn, ")");
  var blob = new Blob([blobCode], {
    type: "text/javascript"
  });
  var url = URL.createObjectURL(blob);
  return url;
}
function useWebWorkerFn(fn) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$dependencies = options.dependencies,
    dependencies = _options$dependencies === void 0 ? [] : _options$dependencies,
    timeout = options.timeout,
    _options$window34 = options.window,
    window = _options$window34 === void 0 ? defaultWindow : _options$window34;
  var worker = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])();
  var workerStatus = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])("PENDING");
  var promise = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])({});
  var timeoutId = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])();
  var workerTerminate = function workerTerminate() {
    var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "PENDING";
    if (worker.value && worker.value._url && window) {
      worker.value.terminate();
      URL.revokeObjectURL(worker.value._url);
      promise.value = {};
      worker.value = void 0;
      window.clearTimeout(timeoutId.value);
      workerStatus.value = status;
    }
  };
  workerTerminate();
  Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["F" /* tryOnScopeDispose */])(workerTerminate);
  var generateWorker = function generateWorker() {
    var blobUrl = createWorkerBlobUrl(fn, dependencies);
    var newWorker = new Worker(blobUrl);
    newWorker._url = blobUrl;
    newWorker.onmessage = function (e) {
      var _promise$value = promise.value,
        _promise$value$resolv = _promise$value.resolve,
        resolve = _promise$value$resolv === void 0 ? function () {} : _promise$value$resolv,
        _promise$value$reject = _promise$value.reject,
        reject = _promise$value$reject === void 0 ? function () {} : _promise$value$reject;
      var _e$data = _slicedToArray(e.data, 2),
        status = _e$data[0],
        result = _e$data[1];
      switch (status) {
        case "SUCCESS":
          resolve(result);
          workerTerminate(status);
          break;
        default:
          reject(result);
          workerTerminate("ERROR");
          break;
      }
    };
    newWorker.onerror = function (e) {
      var _promise$value$reject2 = promise.value.reject,
        reject = _promise$value$reject2 === void 0 ? function () {} : _promise$value$reject2;
      reject(e);
      workerTerminate("ERROR");
    };
    if (timeout) {
      timeoutId.value = setTimeout(function () {
        return workerTerminate("TIMEOUT_EXPIRED");
      }, timeout);
    }
    return newWorker;
  };
  var callWorker = function callWorker() {
    for (var _len12 = arguments.length, fnArgs = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
      fnArgs[_key12] = arguments[_key12];
    }
    return new Promise(function (resolve, reject) {
      promise.value = {
        resolve: resolve,
        reject: reject
      };
      worker.value && worker.value.postMessage([[].concat(fnArgs)]);
      workerStatus.value = "RUNNING";
    });
  };
  var workerFn = function workerFn() {
    if (workerStatus.value === "RUNNING") {
      console.error("[useWebWorkerFn] You can only run one instance of the worker at a time.");
      return Promise.reject();
    }
    worker.value = generateWorker();
    return callWorker.apply(void 0, arguments);
  };
  return {
    workerFn: workerFn,
    workerStatus: workerStatus,
    workerTerminate: workerTerminate
  };
}
function useWindowFocus() {
  var _ref60 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref60$window = _ref60.window,
    window = _ref60$window === void 0 ? defaultWindow : _ref60$window;
  if (!window) return Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(false);
  var focused = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(window.document.hasFocus());
  useEventListener(window, "blur", function () {
    focused.value = false;
  });
  useEventListener(window, "focus", function () {
    focused.value = true;
  });
  return focused;
}
function useWindowScroll() {
  var _ref61 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref61$window = _ref61.window,
    window = _ref61$window === void 0 ? defaultWindow : _ref61$window;
  if (!window) {
    return {
      x: Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(0),
      y: Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(0)
    };
  }
  var x = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(window.scrollX);
  var y = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(window.scrollY);
  useEventListener(window, "scroll", function () {
    x.value = window.scrollX;
    y.value = window.scrollY;
  }, {
    capture: false,
    passive: true
  });
  return {
    x: x,
    y: y
  };
}
function useWindowSize() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$window35 = options.window,
    window = _options$window35 === void 0 ? defaultWindow : _options$window35,
    _options$initialWidth = options.initialWidth,
    initialWidth = _options$initialWidth === void 0 ? Infinity : _options$initialWidth,
    _options$initialHeigh = options.initialHeight,
    initialHeight = _options$initialHeigh === void 0 ? Infinity : _options$initialHeigh,
    _options$listenOrient = options.listenOrientation,
    listenOrientation = _options$listenOrient === void 0 ? true : _options$listenOrient,
    _options$includeScrol = options.includeScrollbar,
    includeScrollbar = _options$includeScrol === void 0 ? true : _options$includeScrol;
  var width = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(initialWidth);
  var height = Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["ref"])(initialHeight);
  var update = function update() {
    if (window) {
      if (includeScrollbar) {
        width.value = window.innerWidth;
        height.value = window.innerHeight;
      } else {
        width.value = window.document.documentElement.clientWidth;
        height.value = window.document.documentElement.clientHeight;
      }
    }
  };
  update();
  Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_shared__["E" /* tryOnMounted */])(update);
  useEventListener("resize", update, {
    passive: true
  });
  if (listenOrientation) {
    var matches = useMediaQuery("(orientation: portrait)");
    Object(__WEBPACK_IMPORTED_MODULE_1_vue_demi__["watch"])(matches, function () {
      return update();
    });
  }
  return {
    width: width,
    height: height
  };
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(33)))

/***/ }),

/***/ 1856:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InfographicSection_vue_vue_type_template_id_87598532_scoped_true___ = __webpack_require__(2363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InfographicSection_vue_vue_type_script_setup_true_lang_js___ = __webpack_require__(2087);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InfographicSection_vue_vue_type_style_index_0_id_87598532_prod_lang_scss_scoped_true___ = __webpack_require__(2365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(47);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__InfographicSection_vue_vue_type_script_setup_true_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__InfographicSection_vue_vue_type_template_id_87598532_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__InfographicSection_vue_vue_type_template_id_87598532_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "87598532",
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 1884:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FaqCollapsible_vue_vue_type_template_id_0a81fd94_scoped_true___ = __webpack_require__(1885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FaqCollapsible_vue_vue_type_script_setup_true_lang_js___ = __webpack_require__(1469);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FaqCollapsible_vue_vue_type_style_index_0_id_0a81fd94_prod_lang_scss_scoped_true___ = __webpack_require__(1887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(47);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__FaqCollapsible_vue_vue_type_script_setup_true_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__FaqCollapsible_vue_vue_type_template_id_0a81fd94_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__FaqCollapsible_vue_vue_type_template_id_0a81fd94_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "0a81fd94",
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 1885:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FaqCollapsible_vue_vue_type_template_id_0a81fd94_scoped_true___ = __webpack_require__(1886);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FaqCollapsible_vue_vue_type_template_id_0a81fd94_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FaqCollapsible_vue_vue_type_template_id_0a81fd94_scoped_true___["b"]; });


/***/ }),

/***/ 1886:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "faqCollapsible"
  }, [_c('button', {
    staticClass: "btn-unstyled titleWrapper",
    attrs: {
      "aria-controls": _setup.faqEntryId,
      "aria-expanded": _setup.isExpanded
    },
    on: {
      "click": function click($event) {
        _setup.isExpanded = !_setup.isExpanded;
      }
    }
  }, [_c('img', {
    staticClass: "chevronArrow",
    attrs: {
      "alt": "chevron icon",
      "src": _setup.props.hasWhiteArrow ? 'static/images/icons/Chevron.svg' : 'static/images/icons/chevron-dark.svg'
    }
  }), _vm._v(" "), _vm._t("title")], 2), _vm._v(" "), _c(_setup.SmoothReflow, {
    attrs: {
      "options": {
        transition: 'height 200ms'
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _setup.isExpanded,
      expression: "isExpanded"
    }],
    staticClass: "contentWrapper",
    attrs: {
      "id": _setup.faqEntryId
    }
  }, [_vm._t("content")], 2)])], 1);
};
var staticRenderFns = [];


/***/ }),

/***/ 1887:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FaqCollapsible_vue_vue_type_style_index_0_id_0a81fd94_prod_lang_scss_scoped_true___ = __webpack_require__(1888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FaqCollapsible_vue_vue_type_style_index_0_id_0a81fd94_prod_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FaqCollapsible_vue_vue_type_style_index_0_id_0a81fd94_prod_lang_scss_scoped_true___);
/* unused harmony reexport namespace */


/***/ }),

/***/ 1888:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1889);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(1043).default
var update = add("2a2c45e6", content, true, {});

/***/ }),

/***/ 1889:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1042)(true);
// imports


// module
exports.push([module.i, ".faqCollapsible[data-v-0a81fd94]{width:100%}.faqCollapsible .titleWrapper[data-v-0a81fd94]{display:flex;align-items:baseline;cursor:pointer;user-select:none}.faqCollapsible .titleWrapper .chevronArrow[data-v-0a81fd94]{padding:6px;margin-right:16px;color:#1d1f24;transition:transform .2s;transform:rotate(-90deg)}.faqCollapsible .titleWrapper[aria-expanded] .chevronArrow[data-v-0a81fd94]{transform:rotate(0)}.faqCollapsible .contentWrapper[data-v-0a81fd94]{margin-top:16px;margin-left:40px}", "", {"version":3,"sources":["/home/runner/work/frontend-desktop/frontend-desktop/src/components/reused-components/faqCollapsible/FaqCollapsible.vue"],"names":[],"mappings":"AAGA,iCACE,UAAA,CAEA,+CACE,aACA,qBACA,eACA,gBAAA,CAEA,6DACE,YACA,kBACA,cACA,yBACA,wBAAA,CAGF,4EACE,mBAAA,CAIJ,iDACE,gBACA,gBAAA,CAAA","file":"FaqCollapsible.vue?vue&type=style&index=0&id=0a81fd94&prod&lang=scss&scoped=true&","sourcesContent":["\n@import 'assets/scss/base/bootstrap_variables';\n\n.faqCollapsible {\n  width: 100%;\n\n  .titleWrapper {\n    display: flex;\n    align-items: baseline;\n    cursor: pointer;\n    user-select: none;\n\n    .chevronArrow {\n      padding: 6px;\n      margin-right: 16px;\n      color: $color-dark;\n      transition: transform $transition-duration;\n      transform: rotate(-90deg);\n    }\n\n    &[aria-expanded] .chevronArrow {\n      transform: rotate(0);\n    }\n  }\n\n  .contentWrapper {\n    margin-top: 16px;\n    margin-left: 40px;\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2081:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Home_vue_vue_type_script_setup_true_lang_js___ = __webpack_require__(2082);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Home_vue_vue_type_script_setup_true_lang_js___["a" /* default */]); 

/***/ }),

/***/ 2082:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vueuse_core__ = __webpack_require__(1855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_pages_home_BackgroundVideo_BackgroundVideo__ = __webpack_require__(2354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_pages_home_distributionSection_DistributionSection__ = __webpack_require__(2360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_pages_home_exploreSection_ExploreSection__ = __webpack_require__(2371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_pages_home_faqSection_FaqSection__ = __webpack_require__(2385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_pages_home_featuresFirstSection_FeaturesFirstSection__ = __webpack_require__(2391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_pages_home_featuresSecondSection_FeaturesSecondSection__ = __webpack_require__(2397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_pages_home_heroSection_HeroSection__ = __webpack_require__(2403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_pages_home_monetizeSection_MonetizeSection__ = __webpack_require__(2409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_pages_home_statisticsSection_StatisticsSection__ = __webpack_require__(2415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_pages_home_trustedPartnersSection_TrustedPartnersSection__ = __webpack_require__(2421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_reused_components_partnersBar_PartnersBar__ = __webpack_require__(2427);













/* harmony default export */ __webpack_exports__["a"] = ({
  __name: 'Home',
  setup: function setup(__props) {
    var isNarrowViewport = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_core__["a" /* useMediaQuery */])('(max-width: 767px)');
    var loadVideos = function loadVideos() {
      var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      // as soon as the video can play through, start playback and begin loading the next one
      var videos = document.querySelectorAll('video');
      videos.forEach(function (video, index) {
        if (index === 0) video.load();
        video.addEventListener('canplaythrough', function () {
          video.play();
          if (index < videos.length - 1) {
            setTimeout(function () {
              return videos[index + 1].load();
            }, timeout);
          }
        }, {
          once: true
        });
      });
    };
    Object(__WEBPACK_IMPORTED_MODULE_1_vue__["watch"])(isNarrowViewport, loadVideos);
    var observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5
    };
    var observerCallback = function observerCallback(entries) {
      entries.forEach(function (entry) {
        var sectionColor = entry.target.dataset.color;
        var bodyTarget = document.getElementById('transitionTarget');
        if (entry.isIntersecting && sectionColor !== undefined) {
          var colorPrefix = 'color-';
          var classes = bodyTarget.className.split(' ').filter(function (className) {
            return !className.startsWith(colorPrefix);
          });
          bodyTarget.className = classes.join(' ').trim();
          bodyTarget.classList.add("".concat(colorPrefix).concat(sectionColor));
        }
      });
    };
    var PanelsObserver = new IntersectionObserver(observerCallback, observerOptions);
    Object(__WEBPACK_IMPORTED_MODULE_1_vue__["onMounted"])(function () {
      loadVideos(1000);
      var panelsList = document.querySelectorAll('.panel');
      panelsList.forEach(function (panel) {
        PanelsObserver.observe(panel);
      });
    });
    Object(__WEBPACK_IMPORTED_MODULE_1_vue__["onUnmounted"])(function () {
      PanelsObserver.disconnect();
    });
    return {
      __sfc: true,
      isNarrowViewport: isNarrowViewport,
      loadVideos: loadVideos,
      observerOptions: observerOptions,
      observerCallback: observerCallback,
      PanelsObserver: PanelsObserver,
      BackgroundVideo: __WEBPACK_IMPORTED_MODULE_2_components_pages_home_BackgroundVideo_BackgroundVideo__["a" /* default */],
      DistributionSection: __WEBPACK_IMPORTED_MODULE_3_components_pages_home_distributionSection_DistributionSection__["a" /* default */],
      ExploreSection: __WEBPACK_IMPORTED_MODULE_4_components_pages_home_exploreSection_ExploreSection__["a" /* default */],
      FaqSection: __WEBPACK_IMPORTED_MODULE_5_components_pages_home_faqSection_FaqSection__["a" /* default */],
      FeaturesFirstSection: __WEBPACK_IMPORTED_MODULE_6_components_pages_home_featuresFirstSection_FeaturesFirstSection__["a" /* default */],
      FeaturesSecondSection: __WEBPACK_IMPORTED_MODULE_7_components_pages_home_featuresSecondSection_FeaturesSecondSection__["a" /* default */],
      HeroSection: __WEBPACK_IMPORTED_MODULE_8_components_pages_home_heroSection_HeroSection__["a" /* default */],
      MonetizeSection: __WEBPACK_IMPORTED_MODULE_9_components_pages_home_monetizeSection_MonetizeSection__["a" /* default */],
      StatisticsSection: __WEBPACK_IMPORTED_MODULE_10_components_pages_home_statisticsSection_StatisticsSection__["a" /* default */],
      TrustedPartnersSection: __WEBPACK_IMPORTED_MODULE_11_components_pages_home_trustedPartnersSection_TrustedPartnersSection__["a" /* default */],
      PartnersBar: __WEBPACK_IMPORTED_MODULE_12_components_reused_components_partnersBar_PartnersBar__["a" /* default */]
    };
  }
});

/***/ }),

/***/ 2083:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BackgroundVideo_vue_vue_type_script_setup_true_lang_js___ = __webpack_require__(2084);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BackgroundVideo_vue_vue_type_script_setup_true_lang_js___["a" /* default */]); 

/***/ }),

/***/ 2084:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_types__ = __webpack_require__(1126);

/* harmony default export */ __webpack_exports__["a"] = ({
  __name: 'BackgroundVideo',
  props: {
    isNarrowViewport: Object(__WEBPACK_IMPORTED_MODULE_0_vue_types__["d" /* bool */])().isRequired,
    name: Object(__WEBPACK_IMPORTED_MODULE_0_vue_types__["l" /* string */])().isRequired
  },
  setup: function setup(__props) {
    return {
      __sfc: true
    };
  }
});

/***/ }),

/***/ 2085:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DistributionSection_vue_vue_type_script_setup_true_lang_js___ = __webpack_require__(2086);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DistributionSection_vue_vue_type_script_setup_true_lang_js___["a" /* default */]); 

/***/ }),

/***/ 2086:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_router_composables__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_router_composables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_router_composables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_reused_components_infographicSection_InfographicSection__ = __webpack_require__(1856);


/* harmony default export */ __webpack_exports__["a"] = ({
  __name: 'DistributionSection',
  setup: function setup(__props) {
    var router = Object(__WEBPACK_IMPORTED_MODULE_0_vue_router_composables__["useRouter"])();
    return {
      __sfc: true,
      router: router,
      InfographicSection: __WEBPACK_IMPORTED_MODULE_1_components_reused_components_infographicSection_InfographicSection__["a" /* default */]
    };
  }
});

/***/ }),

/***/ 2087:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InfographicSection_vue_vue_type_script_setup_true_lang_js___ = __webpack_require__(2088);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InfographicSection_vue_vue_type_script_setup_true_lang_js___["a" /* default */]); 

/***/ }),

/***/ 2088:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_types__ = __webpack_require__(1126);

/* harmony default export */ __webpack_exports__["a"] = ({
  __name: 'InfographicSection',
  props: {
    hasWhiteText: Object(__WEBPACK_IMPORTED_MODULE_0_vue_types__["d" /* bool */])().def(false),
    hasInvertedLayout: Object(__WEBPACK_IMPORTED_MODULE_0_vue_types__["d" /* bool */])().def(false),
    title: Object(__WEBPACK_IMPORTED_MODULE_0_vue_types__["l" /* string */])().def('').isRequired,
    paragraph: Object(__WEBPACK_IMPORTED_MODULE_0_vue_types__["l" /* string */])().def(''),
    buttonClassName: Object(__WEBPACK_IMPORTED_MODULE_0_vue_types__["l" /* string */])().def('btn-round-yellow'),
    buttonText: Object(__WEBPACK_IMPORTED_MODULE_0_vue_types__["l" /* string */])(),
    onButtonClick: Object(__WEBPACK_IMPORTED_MODULE_0_vue_types__["e" /* func */])(),
    hasMainHeadingTitle: Object(__WEBPACK_IMPORTED_MODULE_0_vue_types__["d" /* bool */])().def(false)
  },
  setup: function setup(__props) {
    return {
      __sfc: true
    };
  }
});

/***/ }),

/***/ 2089:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ExploreSection_vue_vue_type_script_setup_true_lang_js___ = __webpack_require__(2090);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ExploreSection_vue_vue_type_script_setup_true_lang_js___["a" /* default */]); 

/***/ }),

/***/ 2090:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_reused_components_keenSlider_KeenSlider__ = __webpack_require__(2091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_conf__ = __webpack_require__(64);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }



/* harmony default export */ __webpack_exports__["a"] = ({
  __name: 'ExploreSection',
  setup: function setup(__props) {
    var _getCurrentInstance$p = Object(__WEBPACK_IMPORTED_MODULE_0_vue__["getCurrentInstance"])().proxy,
      http = _getCurrentInstance$p.$http,
      log = _getCurrentInstance$p.$log;
    var slideTitle = Object(__WEBPACK_IMPORTED_MODULE_0_vue__["ref"])('');
    var slideArtist = Object(__WEBPACK_IMPORTED_MODULE_0_vue__["ref"])('');
    var featuredPodcasts = Object(__WEBPACK_IMPORTED_MODULE_0_vue__["ref"])([]);
    var onHandleSlideDataUpdated = function onHandleSlideDataUpdated(_ref) {
      var artist = _ref.artist,
        title = _ref.title;
      slideTitle.value = title;
      slideArtist.value = artist;
    };
    var imagePath = function imagePath(file) {
      return __WEBPACK_IMPORTED_MODULE_2_conf__["a" /* default */].image.podcast.main + file;
    };
    var fetchFeaturedPodcasts = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _response$body$data, response, featuredPodcastsList;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return http.get("".concat(__WEBPACK_IMPORTED_MODULE_2_conf__["a" /* default */].url.podcasts, "/featured"));
            case 3:
              response = _context.sent;
              featuredPodcastsList = (_response$body$data = response.body.data) !== null && _response$body$data !== void 0 ? _response$body$data : [];
              return _context.abrupt("return", featuredPodcastsList.slice(0, 14));
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              log.error(_context.t0);
              return _context.abrupt("return", []);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 8]]);
      }));
      return function fetchFeaturedPodcasts() {
        return _ref2.apply(this, arguments);
      };
    }();
    Object(__WEBPACK_IMPORTED_MODULE_0_vue__["onMounted"])( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetchFeaturedPodcasts();
          case 2:
            featuredPodcasts.value = _context2.sent;
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })));
    return {
      __sfc: true,
      http: http,
      log: log,
      slideTitle: slideTitle,
      slideArtist: slideArtist,
      featuredPodcasts: featuredPodcasts,
      onHandleSlideDataUpdated: onHandleSlideDataUpdated,
      imagePath: imagePath,
      fetchFeaturedPodcasts: fetchFeaturedPodcasts,
      KeenSlider: __WEBPACK_IMPORTED_MODULE_1_components_reused_components_keenSlider_KeenSlider__["a" /* default */]
    };
  }
});

/***/ }),

/***/ 2091:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__KeenSlider_vue_vue_type_template_id_7f14f26f_scoped_true___ = __webpack_require__(2374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__KeenSlider_vue_vue_type_script_setup_true_lang_js___ = __webpack_require__(2092);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__KeenSlider_vue_vue_type_style_index_0_id_7f14f26f_prod_lang_scss_scoped_true___ = __webpack_require__(2379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(47);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__KeenSlider_vue_vue_type_script_setup_true_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__KeenSlider_vue_vue_type_template_id_7f14f26f_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__KeenSlider_vue_vue_type_template_id_7f14f26f_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "7f14f26f",
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 2092:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_KeenSlider_vue_vue_type_script_setup_true_lang_js___ = __webpack_require__(2093);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_KeenSlider_vue_vue_type_script_setup_true_lang_js___["a" /* default */]); 

/***/ }),

/***/ 2093:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_keen_slider_vue__ = __webpack_require__(2376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_keen_slider_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_keen_slider_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_types__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_keen_slider_keen_slider_min_css__ = __webpack_require__(2377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_keen_slider_keen_slider_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_keen_slider_keen_slider_min_css__);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }




/* harmony default export */ __webpack_exports__["a"] = ({
  __name: 'KeenSlider',
  props: {
    animationDuration: Object(__WEBPACK_IMPORTED_MODULE_2_vue_types__["g" /* number */])().def(5000),
    arrows: Object(__WEBPACK_IMPORTED_MODULE_2_vue_types__["d" /* bool */])().def(true),
    autoSwitch: Object(__WEBPACK_IMPORTED_MODULE_2_vue_types__["d" /* bool */])().def(false),
    autoSwitchTime: Object(__WEBPACK_IMPORTED_MODULE_2_vue_types__["g" /* number */])().def(3000),
    autoplay: Object(__WEBPACK_IMPORTED_MODULE_2_vue_types__["d" /* bool */])().def(false),
    dots: Object(__WEBPACK_IMPORTED_MODULE_2_vue_types__["d" /* bool */])().def(true),
    drag: Object(__WEBPACK_IMPORTED_MODULE_2_vue_types__["d" /* bool */])().def(false),
    dragSpeed: Object(__WEBPACK_IMPORTED_MODULE_2_vue_types__["g" /* number */])().def(1),
    loop: Object(__WEBPACK_IMPORTED_MODULE_2_vue_types__["d" /* bool */])().def(true),
    mode: Object(__WEBPACK_IMPORTED_MODULE_2_vue_types__["l" /* string */])().def('snap'),
    performanceMode: Object(__WEBPACK_IMPORTED_MODULE_2_vue_types__["d" /* bool */])().def(false),
    slideSpacingDesktop: Object(__WEBPACK_IMPORTED_MODULE_2_vue_types__["g" /* number */])().def(15),
    slideSpacingMobile: Object(__WEBPACK_IMPORTED_MODULE_2_vue_types__["g" /* number */])().def(5),
    slideSpacingSmallMobile: Object(__WEBPACK_IMPORTED_MODULE_2_vue_types__["g" /* number */])().def(5),
    slideSpacingTablet: Object(__WEBPACK_IMPORTED_MODULE_2_vue_types__["g" /* number */])().def(15),
    slideSpacingUltraWide: Object(__WEBPACK_IMPORTED_MODULE_2_vue_types__["g" /* number */])().def(30),
    slidesOrigin: Object(__WEBPACK_IMPORTED_MODULE_2_vue_types__["l" /* string */])().def('center'),
    slidesPerViewDesktop: Object(__WEBPACK_IMPORTED_MODULE_2_vue_types__["g" /* number */])().def(1),
    slidesPerViewMobile: Object(__WEBPACK_IMPORTED_MODULE_2_vue_types__["g" /* number */])().def(1),
    slidesPerViewSmallMobile: Object(__WEBPACK_IMPORTED_MODULE_2_vue_types__["g" /* number */])().def(1),
    slidesPerViewTablet: Object(__WEBPACK_IMPORTED_MODULE_2_vue_types__["g" /* number */])().def(1),
    slidesPerViewUltraWide: Object(__WEBPACK_IMPORTED_MODULE_2_vue_types__["g" /* number */])().def(1)
  },
  emits: ['onSlideDataUpdated'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;

    // @sort-keys

    var animation = {
      duration: props.animationDuration,
      easing: function easing(t) {
        return t;
      }
    };
    var current = Object(__WEBPACK_IMPORTED_MODULE_1_vue__["ref"])(0);
    var getSlideDataset = function getSlideDataset(slider) {
      var _slider$slides$curren, _slider$slides$curren2, _slider$slides$curren3, _slider$slides$curren4;
      return {
        title: ((_slider$slides$curren = slider.slides[current.value]) === null || _slider$slides$curren === void 0 ? void 0 : (_slider$slides$curren2 = _slider$slides$curren.dataset) === null || _slider$slides$curren2 === void 0 ? void 0 : _slider$slides$curren2.title) || '',
        artist: ((_slider$slides$curren3 = slider.slides[current.value]) === null || _slider$slides$curren3 === void 0 ? void 0 : (_slider$slides$curren4 = _slider$slides$curren3.dataset) === null || _slider$slides$curren4 === void 0 ? void 0 : _slider$slides$curren4.artist) || ''
      };
    };

    // @sort-keys
    var sliderOptions = {
      animationEnded: function animationEnded(s) {
        if (props.autoplay) {
          s.moveToIdx(s.track.details.abs + 5, true, animation);
        }
      },
      breakpoints: {
        '(max-width: 350px)': {
          slides: {
            perView: props.slidesPerViewSmallMobile,
            spacing: props.slideSpacingSmallMobile,
            origin: props.slidesOrigin
          }
        },
        '((min-width: 351px) and (max-width: 480px))': {
          slides: {
            perView: props.slidesPerViewMobile,
            spacing: props.slideSpacingMobile,
            origin: props.slidesOrigin
          }
        },
        '((min-width: 481px) and (max-width: 768px))': {
          slides: {
            perView: props.slidesPerViewTablet,
            spacing: props.slideSpacingTablet,
            origin: props.slidesOrigin
          }
        },
        '((min-width: 769px) and (max-width: 1200px))': {
          slides: {
            perView: props.slidesPerViewDesktop,
            spacing: props.slideSpacingDesktop,
            origin: props.slidesOrigin
          }
        }
      },
      created: function created(s) {
        emit('onSlideDataUpdated', getSlideDataset(s));
        if (props.autoplay) {
          s.moveToIdx(5, true, animation);
        }
      },
      drag: props.drag,
      dragSpeed: props.dragSpeed,
      initial: current.value,
      loop: props.loop,
      mode: props.mode,
      renderMode: props.performanceMode ? 'performance' : 'precision',
      slideChanged: function slideChanged(s) {
        current.value = s.track.details.rel;
        emit('onSlideDataUpdated', getSlideDataset(s));
      },
      slides: {
        perView: props.slidesPerViewUltraWide,
        spacing: props.slideSpacingUltraWide,
        origin: props.slidesOrigin
      },
      updated: function updated(s) {
        if (props.autoplay) {
          s.moveToIdx(s.track.details.abs + 5, true, animation);
        }
      }
    };
    var sliderPlugins = [function (slider) {
      if (!props.autoSwitch) return;
      var timeout;
      var mouseOver = false;
      function clearNextTimeout() {
        clearTimeout(timeout);
      }
      function nextTimeout() {
        clearTimeout(timeout);
        if (mouseOver) return;
        timeout = setTimeout(function () {
          slider.next();
        }, props.autoSwitchTime);
      }
      slider.on('created', function () {
        slider.container.addEventListener('mouseover', function () {
          mouseOver = true;
          clearNextTimeout();
        });
        slider.container.addEventListener('mouseout', function () {
          mouseOver = false;
          nextTimeout();
        });
        nextTimeout();
      });
      slider.on('dragStarted', clearNextTimeout);
      slider.on('animationEnded', nextTimeout);
      slider.on('updated', nextTimeout);
    }];
    var _useKeenSlider = Object(__WEBPACK_IMPORTED_MODULE_0_keen_slider_vue__["useKeenSlider"])(sliderOptions, sliderPlugins),
      _useKeenSlider2 = _slicedToArray(_useKeenSlider, 2),
      container = _useKeenSlider2[0],
      slider = _useKeenSlider2[1];
    var dotHelper = Object(__WEBPACK_IMPORTED_MODULE_1_vue__["computed"])(function () {
      return slider.value ? _toConsumableArray(Array.from({
        length: slider.value.track.details.slides.length
      }).keys()) : [];
    });
    return {
      __sfc: true,
      emit: emit,
      props: props,
      animation: animation,
      current: current,
      getSlideDataset: getSlideDataset,
      sliderOptions: sliderOptions,
      sliderPlugins: sliderPlugins,
      container: container,
      slider: slider,
      dotHelper: dotHelper
    };
  }
});

/***/ }),

/***/ 2094:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FaqSection_vue_vue_type_script_setup_true_lang_js___ = __webpack_require__(2095);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FaqSection_vue_vue_type_script_setup_true_lang_js___["a" /* default */]); 

/***/ }),

/***/ 2095:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_reused_components_faqCollapsible_FaqCollapsible__ = __webpack_require__(1884);

/* harmony default export */ __webpack_exports__["a"] = ({
  __name: 'FaqSection',
  setup: function setup(__props) {
    var faqList = [{
      question: 'How do I start a podcast?',
      answer: "\n      <p>\n      Record your episode on your phone or in your favorite studio.\n      Once you have recorded and produced your show there are just 4 more steps.\n      <ol>\n        <li>Upload your audio to Afripods</li>\n        <li>Use the FREE Afripods audio editor to produce your episode</li>\n        <li>Publish and distribute your episode to all outlets using your Afripods RSS feed</li>\n        <li>Promote your episode to your audience</li>\n      </ol>\n      </p>\n      <p>\n      Starting a podcast is easy, staying consistent is how you will grow and monetize your genius.\n      </p>\n      "
    }, {
      question: 'Is Afripods FREE?',
      answer: "\n      Yes it is!\n      Afripods is currently offering free podcast hosting for creators to upload and edit their podcasts\n      and view their analytics while growing their audience.\n      <a href=\"/creator\">Create your account</a> and start uploading your podcast today!\n      "
    }, {
      question: 'How do I make Money?',
      answer: "\n      Afripods is building a monetization platform for hosted podcasts.\n      This will be driven by advertising, and the amount earned will be based on the number of listens that a podcast receives.\n      We believe that African content creators should get paid for their content and have prioritised it in our technical plans.\n      Coming soon!\n      "
    }, {
      question: 'Can I move my podcast to Afripods?',
      answer: "\n      Yes, you can migrate your podcast to be hosted on Afripods in 3 simple steps.\n      Get started by clicking <a href=\"/podcaster/migrate\">here</a>.\n      "
    }, {
      question: 'If my podcast is on Afripods can it be listened to on Spotify, Apple, Google and other podcast platforms?',
      answer: "\n      Yes, once your podcast is uploaded to Afripods and registered on other distribution platforms,\n      your audience can listen on their preferred podcast platform(s) anywhere in the world.\n      "
    }, {
      question: 'What is the difference between Submit your RSS and Migrate to Afripods?',
      answer: "\n      When you submit your podcast to Afripods you are adding your RSS feed to our library.\n      When you migrate to Afripods you are leaving your current podcast host to enjoy Afripods'\n      free service which includes the top online audio editor in the world,\n      state of the industry statistics dashboard and top African podcasting community.\n      "
    }, {
      question: 'How can I get involved with the podcasting community?',
      answer: "\n      <p>\n      Welcome home.\n      We believe it takes a village to build community.\n      Podcasters need spaces to connect, ask questions, help others, learn and share ideas.\n      </p>\n      <p>\n      Join our countrywide virtual community meetups across the continent,\n      check out our blog posts,\n      watch our Instagram lives,\n      listen to our Twitter spaces,\n      follow us on all social media platforms for updates or email us at <a href=\"mailto:contactus@afripods.com\">contactus@afripods.com</a>.\n      </p>\n      <p>\n      Join us on  all social media platforms:\n      </p>\n\n      <div class=\"social-icons\">\n        <a class=\"social-icon-link\" href=\"https://www.instagram.com/afripods\" rel=\"external\">\n          <span class=\"sr-only\">Instagram</span><i class=\"fab fa-instagram fa-lg\"></i>\n        </a>\n        <a class=\"social-icon-link\" href=\"https://www.youtube.com/@afripods\" rel=\"external\">\n          <span class=\"sr-only\">Youtube</span><i class=\"fab fa-youtube fa-lg\"></i>\n        </a>\n        <a class=\"social-icon-link\" href=\"https://www.facebook.com/afripods\" rel=\"external\">\n          <span class=\"sr-only\">Facebook</span><i class=\"fab fa-facebook fa-lg\"></i>\n        </a>\n        <a class=\"social-icon-link\" href=\"https://twitter.com/afripods\" rel=\"external\">\n          <span class=\"sr-only\">Twitter</span><i class=\"fab fa-twitter fa-lg\"></i>\n        </a>\n        <a class=\"social-icon-link\" href=\"https://www.linkedin.com/company/afripods-ab\" rel=\"external\">\n          <span class=\"sr-only\">LinkedIn</span><i class=\"fab fa-linkedin fa-lg\"></i>\n        </a>\n      </div>\n      "
    }, {
      question: 'Can I add my podcast to the Afripods library?',
      answer: "\n      Yes of course!\n      You can keep your podcast on your current hosting platform and add your show\n      to the largest library of African stories on the planet by clicking <a href=\"https://afripods.africa/podcaster/submit\">here</a>.\n      "
    }, {
      question: 'Can I listen to a podcast in my vernacular language?',
      answer: "\n      Yes, Afripods offers the option to listen to podcasts in up to 50 languages on the Afripods platform.\n      Podcasts on Afripods have language tags assigned to them for the language in which they are recorded\n      and you can search for your language using our search filters.\n      "
    }, {
      question: 'How do I contact Afripods for partnership,  advertising and press opportunities?',
      answer: "\n      For partnership opportunities, please reach out to us at <a href=\"mailto:contactus@afripods.com\">contactus@afripods.com</a>\n      "
    }];
    return {
      __sfc: true,
      faqList: faqList,
      FaqCollapsible: __WEBPACK_IMPORTED_MODULE_0_components_reused_components_faqCollapsible_FaqCollapsible__["a" /* default */]
    };
  }
});

/***/ }),

/***/ 2096:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FeaturesFirstSection_vue_vue_type_script_setup_true_lang_js___ = __webpack_require__(2097);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FeaturesFirstSection_vue_vue_type_script_setup_true_lang_js___["a" /* default */]); 

/***/ }),

/***/ 2097:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vueuse_core__ = __webpack_require__(1855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router_composables__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router_composables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_router_composables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_types__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_reused_components_infographicSection_InfographicSection__ = __webpack_require__(1856);




/* harmony default export */ __webpack_exports__["a"] = ({
  __name: 'FeaturesFirstSection',
  props: {
    isNarrowViewport: Object(__WEBPACK_IMPORTED_MODULE_2_vue_types__["d" /* bool */])().isRequired
  },
  setup: function setup(__props) {
    var router = Object(__WEBPACK_IMPORTED_MODULE_1_vue_router_composables__["useRouter"])();
    var onRedirect = function onRedirect(routeName) {
      router.push({
        name: routeName
      });
    };
    var isNarrowViewport = Object(__WEBPACK_IMPORTED_MODULE_0__vueuse_core__["a" /* useMediaQuery */])('(max-width: 767px)');
    return {
      __sfc: true,
      router: router,
      onRedirect: onRedirect,
      isNarrowViewport: isNarrowViewport,
      InfographicSection: __WEBPACK_IMPORTED_MODULE_3_components_reused_components_infographicSection_InfographicSection__["a" /* default */]
    };
  }
});

/***/ }),

/***/ 2098:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FeaturesSecondSection_vue_vue_type_script_setup_true_lang_js___ = __webpack_require__(2099);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FeaturesSecondSection_vue_vue_type_script_setup_true_lang_js___["a" /* default */]); 

/***/ }),

/***/ 2099:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_router_composables__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_router_composables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_router_composables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_types__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_reused_components_infographicSection_InfographicSection__ = __webpack_require__(1856);



/* harmony default export */ __webpack_exports__["a"] = ({
  __name: 'FeaturesSecondSection',
  props: {
    isNarrowViewport: Object(__WEBPACK_IMPORTED_MODULE_1_vue_types__["d" /* bool */])().isRequired
  },
  setup: function setup(__props) {
    var router = Object(__WEBPACK_IMPORTED_MODULE_0_vue_router_composables__["useRouter"])();
    var onRedirect = function onRedirect(routeName) {
      router.push({
        name: routeName
      });
    };
    return {
      __sfc: true,
      router: router,
      onRedirect: onRedirect,
      InfographicSection: __WEBPACK_IMPORTED_MODULE_2_components_reused_components_infographicSection_InfographicSection__["a" /* default */]
    };
  }
});

/***/ }),

/***/ 2100:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_HeroSection_vue_vue_type_script_setup_true_lang_js___ = __webpack_require__(2101);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_HeroSection_vue_vue_type_script_setup_true_lang_js___["a" /* default */]); 

/***/ }),

/***/ 2101:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_router_composables__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_router_composables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_router_composables__);

/* harmony default export */ __webpack_exports__["a"] = ({
  __name: 'HeroSection',
  setup: function setup(__props) {
    var router = Object(__WEBPACK_IMPORTED_MODULE_0_vue_router_composables__["useRouter"])();

    // eslint-disable-next-line unicorn/prevent-abbreviations
    var onRedirect = function onRedirect(_ref) {
      var name = _ref.name,
        _ref$params = _ref.params,
        params = _ref$params === void 0 ? {} : _ref$params;
      var userIsLoggedIn = localStorage.getItem('afripodsLoggedInAccountType') !== null;
      router.push({
        name: userIsLoggedIn ? name : 'PodcasterRegister',
        params: params
      });
    };
    return {
      __sfc: true,
      router: router,
      onRedirect: onRedirect
    };
  }
});

/***/ }),

/***/ 2102:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_StatisticsSection_vue_vue_type_script_setup_true_lang_js___ = __webpack_require__(2103);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_StatisticsSection_vue_vue_type_script_setup_true_lang_js___["a" /* default */]); 

/***/ }),

/***/ 2103:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_router_composables__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_router_composables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_router_composables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_reused_components_infographicSection_InfographicSection__ = __webpack_require__(1856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_reused_components_keenSlider_KeenSlider__ = __webpack_require__(2091);



/* harmony default export */ __webpack_exports__["a"] = ({
  __name: 'StatisticsSection',
  setup: function setup(__props) {
    var router = Object(__WEBPACK_IMPORTED_MODULE_0_vue_router_composables__["useRouter"])();
    var onRedirect = function onRedirect(routeName) {
      router.push({
        name: routeName
      });
    };
    return {
      __sfc: true,
      router: router,
      onRedirect: onRedirect,
      InfographicSection: __WEBPACK_IMPORTED_MODULE_1_components_reused_components_infographicSection_InfographicSection__["a" /* default */],
      KeenSlider: __WEBPACK_IMPORTED_MODULE_2_components_reused_components_keenSlider_KeenSlider__["a" /* default */]
    };
  }
});

/***/ }),

/***/ 2104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PartnersBar_vue_vue_type_script_setup_true_lang_js___ = __webpack_require__(2105);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PartnersBar_vue_vue_type_script_setup_true_lang_js___["a" /* default */]); 

/***/ }),

/***/ 2105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_types__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_reused_components_partnersBar_DefaultPartnersList__ = __webpack_require__(2430);


/* harmony default export */ __webpack_exports__["a"] = ({
  __name: 'PartnersBar',
  props: {
    partnersList: Object(__WEBPACK_IMPORTED_MODULE_0_vue_types__["c" /* arrayOf */])(Object(__WEBPACK_IMPORTED_MODULE_0_vue_types__["k" /* shape */])({
      name: Object(__WEBPACK_IMPORTED_MODULE_0_vue_types__["l" /* string */])().isRequired,
      logo: Object(__WEBPACK_IMPORTED_MODULE_0_vue_types__["l" /* string */])().isRequired
    }).loose.isRequired).def(__WEBPACK_IMPORTED_MODULE_1_components_reused_components_partnersBar_DefaultPartnersList__["a" /* default */])
  },
  setup: function setup(__props) {
    return {
      __sfc: true
    };
  }
});

/***/ }),

/***/ 2352:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Home_vue_vue_type_template_id_1a6d6940_scoped_true___ = __webpack_require__(2353);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Home_vue_vue_type_template_id_1a6d6940_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Home_vue_vue_type_template_id_1a6d6940_scoped_true___["b"]; });


/***/ }),

/***/ 2353:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "homePage",
    attrs: {
      "id": "transitionTarget"
    }
  }, [_c('div', {
    staticClass: "videoSection",
    attrs: {
      "data-color": "blue"
    }
  }, [_c(_setup.BackgroundVideo, {
    attrs: {
      "is-narrow-viewport": _setup.isNarrowViewport,
      "name": "hero"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "heroSectionContent"
  }, [_c(_setup.HeroSection)], 1)], 1), _vm._v(" "), _c(_setup.PartnersBar), _vm._v(" "), _c('div', {
    staticClass: "panel",
    attrs: {
      "data-color": "blue"
    }
  }, [_c(_setup.ExploreSection)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel",
    attrs: {
      "data-color": "black"
    }
  }, [_c(_setup.FeaturesFirstSection, {
    attrs: {
      "is-narrow-viewport": _setup.isNarrowViewport
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "panel",
    attrs: {
      "data-color": "black"
    }
  }, [_c(_setup.FeaturesSecondSection, {
    attrs: {
      "is-narrow-viewport": _setup.isNarrowViewport
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "panel",
    attrs: {
      "data-color": "red"
    }
  }, [_c(_setup.DistributionSection)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel",
    attrs: {
      "data-color": "white"
    }
  }, [_c(_setup.StatisticsSection)], 1), _vm._v(" "), _c('div', {
    staticClass: "videoSection"
  }, [_c(_setup.BackgroundVideo, {
    attrs: {
      "is-narrow-viewport": _setup.isNarrowViewport,
      "name": "monetization"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "monetizeSectionContent"
  }, [_c(_setup.MonetizeSection)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel",
    attrs: {
      "data-color": "yellow"
    }
  }, [_c(_setup.FaqSection)], 1), _vm._v(" "), _c(_setup.TrustedPartnersSection)], 1);
};
var staticRenderFns = [];


/***/ }),

/***/ 2354:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BackgroundVideo_vue_vue_type_template_id_5ecbfd4e_scoped_true___ = __webpack_require__(2355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BackgroundVideo_vue_vue_type_script_setup_true_lang_js___ = __webpack_require__(2083);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BackgroundVideo_vue_vue_type_style_index_0_id_5ecbfd4e_prod_lang_scss_scoped_true___ = __webpack_require__(2357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(47);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__BackgroundVideo_vue_vue_type_script_setup_true_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__BackgroundVideo_vue_vue_type_template_id_5ecbfd4e_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__BackgroundVideo_vue_vue_type_template_id_5ecbfd4e_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "5ecbfd4e",
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 2355:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BackgroundVideo_vue_vue_type_template_id_5ecbfd4e_scoped_true___ = __webpack_require__(2356);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BackgroundVideo_vue_vue_type_template_id_5ecbfd4e_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BackgroundVideo_vue_vue_type_template_id_5ecbfd4e_scoped_true___["b"]; });


/***/ }),

/***/ 2356:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', [_c('div', {
    staticClass: "shadowOverlay"
  }), _vm._v(" "), _vm.isNarrowViewport ? _c('video', {
    staticClass: "backgroundVideo",
    attrs: {
      "poster": "static/videos/home-".concat(_vm.name, "-poster.1-1.q25.ns50.avif"),
      "loop": "",
      "muted": "",
      "playsinline": "",
      "preload": "none"
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": "static/videos/home-".concat(_vm.name, ".1-1.av1.qp100.mp4"),
      "type": "video/mp4; codecs=av01.0.05M.08"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "static/videos/home-".concat(_vm.name, ".1-1.hevc.crf28.mp4"),
      "type": "video/mp4; codecs=hvc1"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "static/videos/home-".concat(_vm.name, ".1-1.avc.crf28.mp4"),
      "type": "video/mp4; codecs=avc1.4D401E"
    }
  })]) : _c('video', {
    staticClass: "backgroundVideo",
    attrs: {
      "poster": "static/videos/home-".concat(_vm.name, "-poster.16-9.q30.ns50.avif"),
      "loop": "",
      "muted": "",
      "playsinline": "",
      "preload": "none"
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": "static/videos/home-".concat(_vm.name, ".16-9.av1.qp80.mp4"),
      "type": "video/mp4; codecs=av01.0.05M.08"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "static/videos/home-".concat(_vm.name, ".16-9.hevc.crf24.mp4"),
      "type": "video/mp4; codecs=hvc1"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "static/videos/home-".concat(_vm.name, ".16-9.avc.crf24.mp4"),
      "type": "video/mp4; codecs=avc1.4D401E"
    }
  })])]);
};
var staticRenderFns = [];


/***/ }),

/***/ 2357:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BackgroundVideo_vue_vue_type_style_index_0_id_5ecbfd4e_prod_lang_scss_scoped_true___ = __webpack_require__(2358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BackgroundVideo_vue_vue_type_style_index_0_id_5ecbfd4e_prod_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BackgroundVideo_vue_vue_type_style_index_0_id_5ecbfd4e_prod_lang_scss_scoped_true___);
/* unused harmony reexport namespace */


/***/ }),

/***/ 2358:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2359);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(1043).default
var update = add("7557eb88", content, true, {});

/***/ }),

/***/ 2359:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1042)(true);
// imports


// module
exports.push([module.i, ".shadowOverlay[data-v-5ecbfd4e]{position:absolute;z-index:5;width:100%;height:100%;background-color:rgba(0,0,0,.5)}.backgroundVideo[data-v-5ecbfd4e]{position:relative;z-index:1;width:100%;height:600px;object-fit:cover;object-position:top;max-height:calc(100vh - 70px)}@media(min-width: 768px){.backgroundVideo[data-v-5ecbfd4e]{width:100%;height:auto;object-position:center}}@media(min-width: 992px){.backgroundVideo[data-v-5ecbfd4e]{max-height:calc(100vh - 96px)}}", "", {"version":3,"sources":["/home/runner/work/frontend-desktop/frontend-desktop/src/components/pages/home/BackgroundVideo/BackgroundVideo.vue"],"names":[],"mappings":"AAGA,gCACE,kBACA,UACA,WACA,YACA,+BAAA,CAGF,kCACE,kBACA,UACA,WACA,aACA,iBACA,oBACA,6BAAA,CAEA,yBATF,kCAUI,WACA,YACA,sBAAA,CAAA,CAGF,yBAfF,kCAgBI,6BAAA,CAAA,CAAA","file":"BackgroundVideo.vue?vue&type=style&index=0&id=5ecbfd4e&prod&lang=scss&scoped=true&","sourcesContent":["\n@import 'assets/scss/base/bootstrap_variables';\n\n.shadowOverlay {\n  position: absolute;\n  z-index: 5;\n  width: 100%;\n  height: 100%;\n  background-color: rgb(0 0 0 / 50%);\n}\n\n.backgroundVideo {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  height: 600px;\n  object-fit: cover;\n  object-position: top;\n  max-height: calc(100vh - 70px); // main nav height\n\n  @media (min-width: $screen-sm-min) {\n    width: 100%;\n    height: auto;\n    object-position: center;\n  }\n\n  @media (min-width: $screen-md-min) {\n    max-height: calc(100vh - 96px);\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2360:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DistributionSection_vue_vue_type_template_id_675a0070_scoped_true___ = __webpack_require__(2361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DistributionSection_vue_vue_type_script_setup_true_lang_js___ = __webpack_require__(2085);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DistributionSection_vue_vue_type_style_index_0_id_675a0070_prod_lang_scss_scoped_true___ = __webpack_require__(2368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(47);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__DistributionSection_vue_vue_type_script_setup_true_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__DistributionSection_vue_vue_type_template_id_675a0070_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__DistributionSection_vue_vue_type_template_id_675a0070_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "675a0070",
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 2361:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DistributionSection_vue_vue_type_template_id_675a0070_scoped_true___ = __webpack_require__(2362);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DistributionSection_vue_vue_type_template_id_675a0070_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DistributionSection_vue_vue_type_template_id_675a0070_scoped_true___["b"]; });


/***/ }),

/***/ 2362:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('section', {
    staticClass: "distributionSection"
  }, [_c(_setup.InfographicSection, {
    attrs: {
      "button-class-name": 'btn-round-white',
      "button-text": 'Read more',
      "has-inverted-layout": true,
      "has-main-heading-title": true,
      "has-white-text": true,
      "on-button-click": function onButtonClick() {
        return _setup.router.push({
          name: 'GhostPage',
          params: {
            slug: 'how-to-distribute-your-rss-feed-to-other-platforms'
          }
        });
      },
      "paragraph": 'Expand and grow your audience by distributing to the top podcasting apps and directories in the world.',
      "title": 'Distribution'
    }
  }, [_c('img', {
    staticClass: "infographicImage",
    attrs: {
      "alt": "Afripods distribution",
      "src": "static/images/home/distribution.svg"
    }
  })])], 1);
};
var staticRenderFns = [];


/***/ }),

/***/ 2363:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InfographicSection_vue_vue_type_template_id_87598532_scoped_true___ = __webpack_require__(2364);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InfographicSection_vue_vue_type_template_id_87598532_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InfographicSection_vue_vue_type_template_id_87598532_scoped_true___["b"]; });


/***/ }),

/***/ 2364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "infographicSection"
  }, [_c('div', {
    staticClass: "infoContent",
    class: _vm.hasInvertedLayout ? 'orderSecond' : 'orderFirst'
  }, [_c('div', {
    staticClass: "textAndCtaWrapper",
    class: _vm.hasWhiteText && 'whiteText'
  }, [_c('h1', {
    class: _vm.hasMainHeadingTitle ? 'headingTitle' : 'infographicTitle'
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "infographicText"
  }, [_vm._v(_vm._s(_vm.paragraph))]), _vm._v(" "), _vm.buttonText ? _c('button', {
    staticClass: "infographicButton",
    class: _vm.buttonClassName,
    on: {
      "click": function click($event) {
        var _vm$onButtonClick;
        (_vm$onButtonClick = _vm.onButtonClick) === null || _vm$onButtonClick === void 0 ? void 0 : _vm$onButtonClick.call(_vm);
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.buttonText) + "\n      ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "graphicContent",
    class: _vm.hasInvertedLayout ? 'orderFirst' : 'orderSecond'
  }, [_vm._t("default")], 2)]);
};
var staticRenderFns = [];


/***/ }),

/***/ 2365:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InfographicSection_vue_vue_type_style_index_0_id_87598532_prod_lang_scss_scoped_true___ = __webpack_require__(2366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InfographicSection_vue_vue_type_style_index_0_id_87598532_prod_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InfographicSection_vue_vue_type_style_index_0_id_87598532_prod_lang_scss_scoped_true___);
/* unused harmony reexport namespace */


/***/ }),

/***/ 2366:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2367);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(1043).default
var update = add("47603c52", content, true, {});

/***/ }),

/***/ 2367:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1042)(true);
// imports


// module
exports.push([module.i, ".infographicSection[data-v-87598532]{display:flex;flex-direction:column;justify-content:flex-start;width:100%}@media(min-width: 768px){.infographicSection[data-v-87598532]{flex-direction:row;gap:2%}}.infographicSection .infoContent[data-v-87598532]{display:flex;flex-direction:column;align-items:center;justify-content:center;order:2;text-align:center}@media(min-width: 768px){.infographicSection .infoContent[data-v-87598532]{flex:0 1 36.8%;margin-top:80px;text-align:left}}.infographicSection .infoContent .textAndCtaWrapper[data-v-87598532]{display:flex;flex:1;flex-direction:column;justify-content:center;max-width:460px;color:#000}.infographicSection .infoContent .textAndCtaWrapper .infographicTitle[data-v-87598532]{font-size:1.75rem;font-weight:400;line-height:1.1;color:inherit}@media(min-width: 768px){.infographicSection .infoContent .textAndCtaWrapper .infographicTitle[data-v-87598532]{font-size:3rem}}.infographicSection .infoContent .textAndCtaWrapper .headingTitle[data-v-87598532]{font-size:2.125rem;font-weight:400;line-height:1.1;color:inherit;text-align:center}@media(min-width: 768px){.infographicSection .infoContent .textAndCtaWrapper .headingTitle[data-v-87598532]{font-size:3.25rem;text-align:left}}.infographicSection .infoContent .textAndCtaWrapper .infographicText[data-v-87598532]{max-width:500px;margin-top:32px;font-size:1rem;line-height:1.5;color:inherit}@media(min-width: 768px){.infographicSection .infoContent .textAndCtaWrapper .infographicText[data-v-87598532]{font-size:1.25rem}}.infographicSection .infoContent .textAndCtaWrapper .infographicButton[data-v-87598532]{margin:48px auto 0}@media(min-width: 768px){.infographicSection .infoContent .textAndCtaWrapper .infographicButton[data-v-87598532]{margin:48px 0 0}}.infographicSection .infoContent .whiteText[data-v-87598532]{color:#fff}.infographicSection .graphicContent[data-v-87598532]{display:flex;align-items:center;order:1;margin-top:64px}@media(min-width: 768px){.infographicSection .graphicContent[data-v-87598532]{flex:1;max-width:61.2%}}.infographicSection .orderFirst[data-v-87598532]{order:inherit}@media(min-width: 768px){.infographicSection .orderFirst[data-v-87598532]{order:1}}.infographicSection .orderSecond[data-v-87598532]{order:inherit}@media(min-width: 768px){.infographicSection .orderSecond[data-v-87598532]{order:2}}", "", {"version":3,"sources":["/home/runner/work/frontend-desktop/frontend-desktop/src/components/reused-components/infographicSection/InfographicSection.vue","/home/runner/work/frontend-desktop/frontend-desktop/assets/scss/base/_variables.scss"],"names":[],"mappings":"AAIA,qCACE,aACA,sBACA,2BACA,UAAA,CAEA,yBANF,qCAOI,mBACA,MAAA,CAAA,CAGF,kDACE,aACA,sBACA,mBACA,uBACA,QACA,iBAAA,CAEA,yBARF,kDASI,eACA,gBACA,eAAA,CAAA,CAGF,qEACE,aACA,OACA,sBACA,uBACA,gBACA,UCnBQ,CDqBR,uFACE,kBACA,gBACA,gBACA,aAAA,CAEA,yBANF,uFAOI,cAAA,CAAA,CAIJ,mFACE,mBACA,gBACA,gBACA,cACA,iBAAA,CAEA,yBAPF,mFAQI,kBACA,eAAA,CAAA,CAIJ,sFACE,gBACA,gBACA,eACA,gBACA,aAAA,CAEA,yBAPF,sFAQI,iBAAA,CAAA,CAIJ,wFACE,kBAAA,CAEA,yBAHF,wFAII,eAAA,CAAA,CAKN,6DACE,UCpEQ,CDwEZ,qDACE,aACA,mBACA,QACA,eAAA,CAEA,yBANF,qDAOI,OACA,eAAA,CAAA,CAIJ,iDACE,aAAA,CAEA,yBAHF,iDAII,OAAA,CAAA,CAIJ,kDACE,aAAA,CAEA,yBAHF,kDAII,OAAA,CAAA,CAAA","file":"InfographicSection.vue?vue&type=style&index=0&id=87598532&prod&lang=scss&scoped=true&","sourcesContent":["\n@import 'assets/scss/base/bootstrap_variables';\n@import 'assets/scss/base/functions';\n\n.infographicSection {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  width: 100%;\n\n  @media (min-width: $screen-sm-min) {\n    flex-direction: row;\n    gap: 2%;\n  }\n\n  .infoContent {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    order: 2;\n    text-align: center;\n\n    @media (min-width: $screen-sm-min) {\n      flex: 0 1 36.8%;\n      margin-top: 80px;\n      text-align: left;\n    }\n\n    .textAndCtaWrapper {\n      display: flex;\n      flex: 1;\n      flex-direction: column;\n      justify-content: center;\n      max-width: 460px;\n      color: $color-black;\n\n      .infographicTitle {\n        font-size: to-rem(28);\n        font-weight: 400;\n        line-height: 1.1;\n        color: inherit;\n\n        @media (min-width: $screen-sm-min) {\n          font-size: to-rem(48);\n        }\n      }\n\n      .headingTitle {\n        font-size: to-rem(34);\n        font-weight: 400;\n        line-height: 1.1;\n        color: inherit;\n        text-align: center;\n\n        @media (min-width: $screen-sm-min) {\n          font-size: to-rem(52);\n          text-align: left;\n        }\n      }\n\n      .infographicText {\n        max-width: 500px;\n        margin-top: 32px;\n        font-size: to-rem(16);\n        line-height: 1.5;\n        color: inherit;\n\n        @media (min-width: $screen-sm-min) {\n          font-size: to-rem(20);\n        }\n      }\n\n      .infographicButton {\n        margin: 48px auto 0;\n\n        @media (min-width: $screen-sm-min) {\n          margin: 48px 0 0;\n        }\n      }\n    }\n\n    & .whiteText {\n      color: $color-white;\n    }\n  }\n\n  .graphicContent {\n    display: flex;\n    align-items: center;\n    order: 1;\n    margin-top: 64px;\n\n    @media (min-width: $screen-sm-min) {\n      flex: 1;\n      max-width: 61.2%;\n    }\n  }\n\n  .orderFirst {\n    order: inherit;\n\n    @media (min-width: $screen-sm-min) {\n      order: 1;\n    }\n  }\n\n  .orderSecond {\n    order: inherit;\n\n    @media (min-width: $screen-sm-min) {\n      order: 2;\n    }\n  }\n}\n","// -----------------------------------------------------------------------------\n//                                  Variables\n// -----------------------------------------------------------------------------\n\n// --------------------------------- Colors ------------------------------------\n$brand-yellow: #fdd366;\n$brand-green: #259167;\n$brand-orange: #f2765d;\n$brand-blue: #2188bf;\n$color-informative-blue: #6594ee;\n$brand-blue-light: lighten($brand-blue, 10%);\n$brand-very-dark-blue: #1d1f24;\n$back-gray: #f3f3f3;\n$light-grey: #ddd;\n$border-color: #e3e3e3;\n$color-white: #fff;\n$color-black: #000;\n$color-dark: #1d1f24;\n$color-alert: #eb5757;\n$color-nation-dark: #1e1e1e;\n$background-color: #eef6fa;\n$color-grey: #aaa;\n$color-overlay-background: rgb(0 0 0 / 40%);\n$color-transparency-white: rgb(255 255 255 / 50%);\n$color-blue-secondary: #074ee8;\n$color-blue-secondary-light: lighten($color-blue-secondary, 10%);\n$color-green-secondary: #1da41a;\n$color-green-secondary-light: lighten($color-green-secondary, 10%);\n$spotify-green: #1db954;\n$apple-podcasts-purple: #b150e2;\n$google-blue: #4285f4;\n$notification-blue: #2188bf;\n$notification-border-blue: #1d7bad;\n$notification-warn: #ffb648;\n$notification-border-warn: #f48a06;\n$notification-error: #e54d42;\n$notification-border-error: #b82e24;\n$notification-success: #259167;\n$notification-border-success: #1f7c58;\n$bg-light-blue: #e5e5e5;\n$bg-alice-blue: #e6f6ff;\n$bg-light-blue-alternative: #eff6fa;\n$medium-turquoise: #429ac9;\n$color-pelorous: #2188bf;\n$light-orange: #fdefec;\n$black-russian: #111928;\n\n// ------------------------------- Transitions ---------------------------------\n$transition-duration: 0.2s;\n$ease-in-back: cubic-bezier(0.6, -0.28, 0.735, 0.045);\n$ease-out-back: cubic-bezier(0.175, 0.885, 0.32, 1.275);\n\n// ---------------------------------- Misc -------------------------------------\n$clear-icon-svg: \"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12'%3E%3Cpath fill='%237f8a8e' fill-rule='evenodd' d='M6 5.082 10.902.179a.642.642 0 0 1 .91.91L6.91 5.991l4.902 4.902a.643.643 0 1 1-.91.91L6.001 6.901l-4.902 4.902a.642.642 0 0 1-.91-.91l4.903-4.902L.188 1.089a.644.644 0 0 1 .91-.91Z'/%3E%3C/svg%3E\";\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2368:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DistributionSection_vue_vue_type_style_index_0_id_675a0070_prod_lang_scss_scoped_true___ = __webpack_require__(2369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DistributionSection_vue_vue_type_style_index_0_id_675a0070_prod_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DistributionSection_vue_vue_type_style_index_0_id_675a0070_prod_lang_scss_scoped_true___);
/* unused harmony reexport namespace */


/***/ }),

/***/ 2369:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2370);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(1043).default
var update = add("015e7050", content, true, {});

/***/ }),

/***/ 2370:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1042)(true);
// imports


// module
exports.push([module.i, ".distributionSection[data-v-675a0070]{display:flex;align-items:center;justify-content:center;width:100%;max-width:1200px;padding:0 16px;margin:88px auto}@media(min-width: 768px){.distributionSection[data-v-675a0070]{padding:0 32px}}.distributionSection .infographicImage[data-v-675a0070]{width:100%;max-width:460px;margin:0 auto}@media(min-width: 768px){.distributionSection .infographicImage[data-v-675a0070]{max-width:80%;margin:0}}", "", {"version":3,"sources":["/home/runner/work/frontend-desktop/frontend-desktop/src/components/pages/home/distributionSection/DistributionSection.vue"],"names":[],"mappings":"AAIA,sCACE,aACA,mBACA,uBACA,WACA,iBACA,eACA,gBAAA,CAEA,yBATF,sCAUI,cAAA,CAAA,CAGF,wDACE,WACA,gBACA,aAAA,CAEA,yBALF,wDAMI,cACA,QAAA,CAAA,CAAA","file":"DistributionSection.vue?vue&type=style&index=0&id=675a0070&prod&lang=scss&scoped=true&","sourcesContent":["\n@import 'assets/scss/base/bootstrap_variables';\n@import 'assets/scss/base/functions';\n\n.distributionSection {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  max-width: 1200px;\n  padding: 0 16px;\n  margin: 88px auto;\n\n  @media (min-width: $screen-sm-min) {\n    padding: 0 32px;\n  }\n\n  .infographicImage {\n    width: 100%;\n    max-width: 460px;\n    margin: 0 auto;\n\n    @media (min-width: $screen-sm-min) {\n      max-width: 80%;\n      margin: 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2371:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ExploreSection_vue_vue_type_template_id_5b27735a_scoped_true___ = __webpack_require__(2372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ExploreSection_vue_vue_type_script_setup_true_lang_js___ = __webpack_require__(2089);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ExploreSection_vue_vue_type_style_index_0_id_5b27735a_prod_lang_scss_scoped_true___ = __webpack_require__(2382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(47);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ExploreSection_vue_vue_type_script_setup_true_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__ExploreSection_vue_vue_type_template_id_5b27735a_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ExploreSection_vue_vue_type_template_id_5b27735a_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "5b27735a",
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 2372:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ExploreSection_vue_vue_type_template_id_5b27735a_scoped_true___ = __webpack_require__(2373);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ExploreSection_vue_vue_type_template_id_5b27735a_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ExploreSection_vue_vue_type_template_id_5b27735a_scoped_true___["b"]; });


/***/ }),

/***/ 2373:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('section', {
    staticClass: "exploreSection"
  }, [_c('h1', {
    staticClass: "exploreTitle"
  }, [_vm._v("Explore new African stories")]), _vm._v(" "), _setup.featuredPodcasts.length > 0 ? _c('div', {
    staticClass: "carouselContainer"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "phoneBackground"
  }), _vm._v(" "), _c('span', {
    staticClass: "datasetTitleTarget"
  }, [_vm._v(_vm._s(_setup.slideTitle))]), _vm._v(" "), _c('span', {
    staticClass: "datasetArtistTarget"
  }, [_vm._v(_vm._s(_setup.slideArtist))]), _vm._v(" "), _c(_setup.KeenSlider, {
    staticClass: "podcastsSlider",
    attrs: {
      "arrows": false,
      "auto-switch": true,
      "dots": false,
      "drag": true,
      "slides-per-view-desktop": 4.5,
      "slides-per-view-mobile": 1.7,
      "slides-per-view-small-mobile": 1.5,
      "slides-per-view-tablet": 3,
      "slides-per-view-ultra-wide": 5.5
    },
    on: {
      "onSlideDataUpdated": _setup.onHandleSlideDataUpdated
    }
  }, _vm._l(_setup.featuredPodcasts, function (podcast, index) {
    return _c('div', {
      key: podcast.id
    }, [_c('div', {
      key: _vm.key,
      staticClass: "keen-slider__slide slideSlot",
      attrs: {
        "data-artist": podcast.author.name,
        "data-title": podcast.title
      }
    }, [_c('img', {
      key: index,
      staticClass: "sliderImage",
      attrs: {
        "alt": podcast.title,
        "src": _setup.imagePath(podcast.images.main),
        "height": "390",
        "width": "390"
      }
    })])]);
  }), 0)], 1) : _vm._e(), _vm._v(" "), _c('RouterLink', {
    staticClass: "btn-round-white ctaButton",
    attrs: {
      "to": {
        name: 'Listen'
      }
    }
  }, [_vm._v("Listen now")])], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "phoneFrame"
  }, [_c('img', {
    attrs: {
      "alt": "A phone showing a podcast player interface",
      "height": "671",
      "src": "/static/images/home/phone-frame.webp",
      "width": "324"
    }
  })]);
}];


/***/ }),

/***/ 2374:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_KeenSlider_vue_vue_type_template_id_7f14f26f_scoped_true___ = __webpack_require__(2375);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_KeenSlider_vue_vue_type_template_id_7f14f26f_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_KeenSlider_vue_vue_type_template_id_7f14f26f_scoped_true___["b"]; });


/***/ }),

/***/ 2375:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "keen-slider-wrapper"
  }, [_c('div', {
    staticClass: "navigation-wrapper"
  }, [_c('div', {
    ref: "container",
    staticClass: "keen-slider"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm.arrows ? _c('button', {
    staticClass: "btn-unstyled arrow arrow--left",
    class: {
      'arrow--disabled': !_vm.loop && _setup.current === 0
    },
    on: {
      "click": function click($event) {
        return _setup.slider.prev();
      }
    }
  }, [_c('svg', {
    attrs: {
      "height": "26",
      "width": "14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13 1 1 13l12 12",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }
  })])]) : _vm._e(), _vm._v(" "), _setup.slider && _vm.arrows ? _c('button', {
    staticClass: "arrow arrow--right btn-unstyled",
    class: {
      'arrow--disabled': !_vm.loop && _setup.current === _setup.slider.track.details.slides.length - 1
    },
    on: {
      "click": function click($event) {
        return _setup.slider.next();
      }
    }
  }, [_c('svg', {
    attrs: {
      "height": "26",
      "width": "14"
    }
  }, [_c('path', {
    attrs: {
      "d": "m1 25 12-12L1 1",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }
  })])]) : _vm._e()]), _vm._v(" "), _setup.slider && _vm.dots ? _c('div', {
    staticClass: "dots"
  }, _vm._l(_setup.dotHelper, function (index) {
    return _c('button', {
      key: index,
      staticClass: "dot",
      class: {
        active: _setup.current === index
      },
      on: {
        "click": function click($event) {
          return _setup.slider.moveToIdx(index);
        }
      }
    });
  }), 0) : _vm._e()]);
};
var staticRenderFns = [];


/***/ }),

/***/ 2376:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:!0});var n=__webpack_require__(29),t=function(){return t=Object.assign||function(n){for(var t,i=1,e=arguments.length;i<e;i++)for(var r in t=arguments[i])Object.prototype.hasOwnProperty.call(t,r)&&(n[r]=t[r]);return n},t.apply(this,arguments)};function i(n,t,i){if(i||2===arguments.length)for(var e,r=0,a=t.length;r<a;r++)!e&&r in t||(e||(e=Array.prototype.slice.call(t,0,r)),e[r]=t[r]);return n.concat(e||Array.prototype.slice.call(t))}function e(n){return Array.prototype.slice.call(n)}function r(n,t){var i=Math.floor(n);return i===t||i+1===t?n:t}function a(){return Date.now()}function o(n,t,i){if(t="data-keen-slider-"+t,null===i)return n.removeAttribute(t);n.setAttribute(t,i||"")}function u(n,t){return t=t||document,"function"==typeof n&&(n=n(t)),Array.isArray(n)?n:"string"==typeof n?e(t.querySelectorAll(n)):n instanceof HTMLElement?[n]:n instanceof NodeList?e(n):[]}function s(n){n.raw&&(n=n.raw),n.cancelable&&!n.defaultPrevented&&n.preventDefault()}function c(n){n.raw&&(n=n.raw),n.stopPropagation&&n.stopPropagation()}function d(){var n=[];return{add:function(t,i,e,r){t.addListener?t.addListener(e):t.addEventListener(i,e,r),n.push([t,i,e,r])},input:function(n,t,i,e){this.add(n,t,function(n){return function(t){t.nativeEvent&&(t=t.nativeEvent);var i=t.changedTouches||[],e=t.targetTouches||[],r=t.detail&&t.detail.x?t.detail:null;return n({id:r?r.identifier?r.identifier:"i":e[0]?e[0]?e[0].identifier:"e":"d",idChanged:r?r.identifier?r.identifier:"i":i[0]?i[0]?i[0].identifier:"e":"d",raw:t,x:r&&r.x?r.x:e[0]?e[0].screenX:r?r.x:t.pageX,y:r&&r.y?r.y:e[0]?e[0].screenY:r?r.y:t.pageY})}}(i),e)},purge:function(){n.forEach((function(n){n[0].removeListener?n[0].removeListener(n[2]):n[0].removeEventListener(n[1],n[2],n[3])})),n=[]}}}function l(n,t,i){return Math.min(Math.max(n,t),i)}function f(n){return(n>0?1:0)-(n<0?1:0)||+n}function p(n){var t=n.getBoundingClientRect();return{height:r(t.height,n.offsetHeight),width:r(t.width,n.offsetWidth)}}function v(n,t,i,e){var r=n&&n[t];return null==r?i:e&&"function"==typeof r?r():r}function h(n){return Math.round(1e6*n)/1e6}function m(n){var t,i,e,r,a,o;function u(t){o||(o=t),s(!0);var a=t-o;a>e&&(a=e);var l=r[i];if(l[3]<a)return i++,u(t);var f=l[2],p=l[4],v=l[0],h=l[1]*(0,l[5])(0===p?1:(a-f)/p);if(h&&n.track.to(v+h),a<e)return d();o=null,s(!1),c(null),n.emit("animationEnded")}function s(n){t.active=n}function c(n){t.targetIdx=n}function d(){var n;n=u,a=window.requestAnimationFrame(n)}function l(){var t;t=a,window.cancelAnimationFrame(t),s(!1),c(null),o&&n.emit("animationStopped"),o=null}return t={active:!1,start:function(t){if(l(),n.track.details){var a=0,o=n.track.details.position;i=0,e=0,r=t.map((function(n){var t,i=Number(o),r=null!==(t=n.earlyExit)&&void 0!==t?t:n.duration,u=n.easing,s=n.distance*u(r/n.duration)||0;o+=s;var c=e;return e+=r,a+=s,[i,n.distance,c,e,n.duration,u]})),c(n.track.distToIdx(a)),d(),n.emit("animationStarted")}},stop:l,targetIdx:null}}function g(n){var t,e,r,o,u,s,c,d,p,m,g,b,x,k,y=1/0,w=[],M=null,T=0;function C(n){_(T+n)}function E(n){var t=z(T+n).abs;return D(t)?t:null}function z(n){var t=Math.floor(Math.abs(h(n/e))),r=h((n%e+e)%e);r===e&&(r=0);var a=f(n),o=c.indexOf(i([],c,!0).reduce((function(n,t){return Math.abs(t-r)<Math.abs(n-r)?t:n}))),u=o;return a<0&&t++,o===s&&(u=0,t+=a>0?1:-1),{abs:u+t*s*a,origin:o,rel:u}}function I(n,t,i){var e;if(t||!S())return A(n,i);if(!D(n))return null;var r=z(null!=i?i:T),a=r.abs,o=n-r.rel,u=a+o;e=A(u);var c=A(u-s*f(o));return(null!==c&&Math.abs(c)<Math.abs(e)||null===e)&&(e=c),h(e)}function A(n,t){if(null==t&&(t=h(T)),!D(n)||null===n)return null;n=Math.round(n);var i=z(t),r=i.abs,a=i.rel,o=i.origin,u=O(n),d=(t%e+e)%e,l=c[o],f=Math.floor((n-(r-a))/s)*e;return h(l-d-l+c[u]+f+(o===s?e:0))}function D(n){return L(n)===n}function L(n){return l(n,p,m)}function S(){return o.loop}function O(n){return(n%s+s)%s}function _(t){var i;i=t-T,w.push({distance:i,timestamp:a()}),w.length>6&&(w=w.slice(-6)),T=h(t);var e=P().abs;if(e!==M){var r=null!==M;M=e,r&&n.emit("slideChanged")}}function P(i){var a=i?null:function(){if(s){var n=S(),t=n?(T%e+e)%e:T,i=(n?T%e:T)-u[0][2],a=0-(i<0&&n?e-Math.abs(i):i),c=0,d=z(T),l=d.abs,v=d.rel,h=u[v][2],y=u.map((function(t,i){var r=a+c;(r<0-t[0]||r>1)&&(r+=(Math.abs(r)>e-1&&n?e:0)*f(-r));var u=i-v,d=f(u),p=u+l;n&&(-1===d&&r>h&&(p+=s),1===d&&r<h&&(p-=s),null!==g&&p<g&&(r+=e),null!==b&&p>b&&(r-=e));var m=r+t[0]+t[1],x=Math.max(r>=0&&m<=1?1:m<0||r>1?0:r<0?Math.min(1,(t[0]+r)/t[0]):(1-r)/t[0],0);return c+=t[0]+t[1],{abs:p,distance:o.rtl?-1*r+1-t[0]:r,portion:x,size:t[0]}}));return l=L(l),v=O(l),{abs:L(l),length:r,max:k,maxIdx:m,min:x,minIdx:p,position:T,progress:n?t/e:T/r,rel:v,slides:y,slidesLength:e}}}();return t.details=a,n.emit("detailsChanged"),a}return t={absToRel:O,add:C,details:null,distToIdx:E,idxToDist:I,init:function(t){if(function(){if(o=n.options,u=(o.trackConfig||[]).map((function(n){return[v(n,"size",1),v(n,"spacing",0),v(n,"origin",0)]})),s=u.length){e=h(u.reduce((function(n,t){return n+t[0]+t[1]}),0));var t,i=s-1;r=h(e+u[0][2]-u[i][0]-u[i][2]-u[i][1]),c=u.reduce((function(n,i){if(!n)return[0];var e=u[n.length-1],r=n[n.length-1]+(e[0]+e[2])+e[1];return r-=i[2],n[n.length-1]>r&&(r=n[n.length-1]),r=h(r),n.push(r),(!t||t<r)&&(d=n.length-1),t=r,n}),null),0===r&&(d=0),c.push(h(e))}}(),!s)return P(!0);var i;!function(){var t=n.options.range,i=n.options.loop;g=p=i?v(i,"min",-1/0):0,b=m=i?v(i,"max",y):d;var e=v(t,"min",null),r=v(t,"max",null);e&&(p=e),r&&(m=r),x=p===-1/0?p:n.track.idxToDist(p||0,!0,0),k=m===y?m:I(m,!0,0),null===r&&(b=m),v(t,"align",!1)&&m!==y&&0===u[O(m)][2]&&(k-=1-u[O(m)][0],m=E(k-T)),x=h(x),k=h(k)}(),i=t,Number(i)===i?C(A(L(t))):P()},to:_,velocity:function(){var n=a(),t=w.reduce((function(t,i){var e=i.distance,r=i.timestamp;return n-r>200||(f(e)!==f(t.distance)&&t.distance&&(t={distance:0,lastTimestamp:0,time:0}),t.time&&(t.distance+=e),t.lastTimestamp&&(t.time+=r-t.lastTimestamp),t.lastTimestamp=r),t}),{distance:0,lastTimestamp:0,time:0});return t.distance/t.time||0}}}function b(n){var t,i,e,r,a,o,u,s;function c(n){return 2*n}function d(n){return l(n,u,s)}function p(n){return 1-Math.pow(1-n,3)}function v(){return e?n.track.velocity():0}function h(){b();var t="free-snap"===n.options.mode,i=n.track,e=v();r=f(e);var u=n.track.details,s=[];if(e||!t){var l=m(e),h=l.dist,g=l.dur;if(g=c(g),h*=r,t){var x=i.idxToDist(i.distToIdx(h),!0);x&&(h=x)}s.push({distance:h,duration:g,easing:p});var k=u.position,y=k+h;if(y<a||y>o){var w=y<a?a-k:o-k,M=0,T=e;if(f(w)===r){var C=Math.min(Math.abs(w)/Math.abs(h),1),E=function(n){return 1-Math.pow(1-n,1/3)}(C)*g;s[0].earlyExit=E,T=e*(1-C)}else s[0].earlyExit=0,M+=w;var z=m(T,100),I=z.dist*r;n.options.rubberband&&(s.push({distance:I,duration:c(z.dur),easing:p}),s.push({distance:-I+M,duration:500,easing:p}))}n.animator.start(s)}else n.moveToIdx(d(u.abs),!0,{duration:500,easing:function(n){return 1+--n*n*n*n*n}})}function m(n,t){void 0===t&&(t=1e3);var i=147e-9+(n=Math.abs(n))/t;return{dist:Math.pow(n,2)/i,dur:n/i}}function g(){var t=n.track.details;t&&(a=t.min,o=t.max,u=t.minIdx,s=t.maxIdx)}function b(){n.animator.stop()}n.on("updated",g),n.on("optionsChanged",g),n.on("created",g),n.on("dragStarted",(function(){e=!1,b(),t=i=n.track.details.abs})),n.on("dragChecked",(function(){e=!0})),n.on("dragEnded",(function(){var e=n.options.mode;"snap"===e&&function(){var e=n.track,r=n.track.details,u=r.position,s=f(v());(u>o||u<a)&&(s=0);var c=t+s;0===r.slides[e.absToRel(c)].portion&&(c-=s),t!==i&&(c=i),f(e.idxToDist(c,!0))!==s&&(c+=s),c=d(c);var l=e.idxToDist(c,!0);n.animator.start([{distance:l,duration:500,easing:function(n){return 1+--n*n*n*n*n}}])}(),"free"!==e&&"free-snap"!==e||h()})),n.on("dragged",(function(){i=n.track.details.abs}))}function x(n){var t,i,e,r,a,o,p,v,h,m,g,b,x,k,y,w,M,T,C=d();function E(t){if(o&&v===t.id){var u=D(t);if(h){if(!A(t))return I(t);m=u,h=!1,n.emit("dragChecked")}if(w)return m=u;s(t);var d=function(t){if(M===-1/0&&T===1/0)return t;var e=n.track.details,o=e.length,u=e.position,s=l(t,M-u,T-u);if(0===o)return 0;if(!n.options.rubberband)return s;if(u<=T&&u>=M)return t;if(u<M&&i>0||u>T&&i<0)return t;var c=(u<M?u-M:u-T)/o,d=r*o,f=Math.abs(c*d),p=Math.max(0,1-f/a*2);return p*p*t}(p(m-u)/r*e);i=f(d);var x=n.track.details.position;(x>M&&x<T||x===M&&i>0||x===T&&i<0)&&c(t),g+=d,!b&&Math.abs(g*r)>5&&(b=!0),n.track.add(d),m=u,n.emit("dragged")}}function z(t){!o&&n.track.details&&n.track.details.length&&(g=0,o=!0,b=!1,h=!0,v=t.id,A(t),m=D(t),n.emit("dragStarted"))}function I(t){o&&v===t.idChanged&&(o=!1,n.emit("dragEnded"))}function A(n){var t=L(),i=t?n.y:n.x,e=t?n.x:n.y,r=void 0!==x&&void 0!==k&&Math.abs(k-e)<=Math.abs(x-i);return x=i,k=e,r}function D(n){return L()?n.y:n.x}function L(){return n.options.vertical}function S(){r=n.size,a=L()?window.innerHeight:window.innerWidth;var t=n.track.details;t&&(M=t.min,T=t.max)}function O(n){b&&(c(n),s(n))}function _(){if(C.purge(),n.options.drag&&!n.options.disabled){var i;i=n.options.dragSpeed||1,p="function"==typeof i?i:function(n){return n*i},e=n.options.rtl?-1:1,S(),t=n.container,function(){var n="data-keen-slider-clickable";u("[".concat(n,"]:not([").concat(n,"=false])"),t).map((function(n){C.add(n,"dragstart",c),C.add(n,"mousedown",c),C.add(n,"touchstart",c)}))}(),C.add(t,"dragstart",(function(n){s(n)})),C.add(t,"click",O,{capture:!0}),C.input(t,"ksDragStart",z),C.input(t,"ksDrag",E),C.input(t,"ksDragEnd",I),C.input(t,"mousedown",z),C.input(t,"mousemove",E),C.input(t,"mouseleave",I),C.input(t,"mouseup",I),C.input(t,"touchstart",z,{passive:!0}),C.input(t,"touchmove",E,{passive:!1}),C.input(t,"touchend",I),C.input(t,"touchcancel",I),C.add(window,"wheel",(function(n){o&&s(n)}));var r="data-keen-slider-scrollable";u("[".concat(r,"]:not([").concat(r,"=false])"),n.container).map((function(n){return function(n){var t;C.input(n,"touchstart",(function(n){t=D(n),w=!0,y=!0}),{passive:!0}),C.input(n,"touchmove",(function(i){var e=L(),r=e?n.scrollHeight-n.clientHeight:n.scrollWidth-n.clientWidth,a=t-D(i),o=e?n.scrollTop:n.scrollLeft,u=e&&"scroll"===n.style.overflowY||!e&&"scroll"===n.style.overflowX;if(t=D(i),(a<0&&o>0||a>0&&o<r)&&y&&u)return w=!0;y=!1,s(i),w=!1})),C.input(n,"touchend",(function(){w=!1}))}(n)}))}}n.on("updated",S),n.on("optionsChanged",_),n.on("created",_),n.on("destroyed",C.purge)}function k(n){var t,i,e=null;function r(t,i,e){n.animator.active?o(t,i,e):requestAnimationFrame((function(){return o(t,i,e)}))}function a(){r(!1,!1,i)}function o(i,r,a){var o=0,u=n.size,d=n.track.details;if(d&&t){var l=d.slides;t.forEach((function(n,t){if(i)!e&&r&&s(n,null,a),c(n,null,a);else{if(!l[t])return;var d=l[t].size*u;!e&&r&&s(n,d,a),c(n,l[t].distance*u-o,a),o+=d}}))}}function u(t){return"performance"===n.options.renderMode?Math.round(t):t}function s(n,t,i){var e=i?"height":"width";null!==t&&(t=u(t)+"px"),n.style["min-"+e]=t,n.style["max-"+e]=t}function c(n,t,i){if(null!==t){t=u(t);var e=i?t:0;t="translate3d(".concat(i?0:t,"px, ").concat(e,"px, 0)")}n.style.transform=t,n.style["-webkit-transform"]=t}function d(){t&&(o(!0,!0,i),t=null),n.on("detailsChanged",a,!0)}function l(){r(!1,!0,i)}function f(){d(),i=n.options.vertical,n.options.disabled||"custom"===n.options.renderMode||(e="auto"===v(n.options.slides,"perView",null),n.on("detailsChanged",a),(t=n.slides).length&&l())}n.on("created",f),n.on("optionsChanged",f),n.on("beforeOptionsChanged",(function(){d()})),n.on("updated",l),n.on("destroyed",d)}function y(n,i){return function(e){var r,a,s,c,l,f,h=d();function m(n){var t;o(e.container,"reverse","rtl"!==(t=e.container,window.getComputedStyle(t,null).getPropertyValue("direction"))||n?null:""),o(e.container,"v",e.options.vertical&&!n?"":null),o(e.container,"disabled",e.options.disabled&&!n?"":null)}function g(){b()&&M()}function b(){var n=null;if(c.forEach((function(t){t.matches&&(n=t.__media)})),n===r)return!1;r||e.emit("beforeOptionsChanged"),r=n;var i=n?s.breakpoints[n]:s;return e.options=t(t({},s),i),m(),I(),A(),C(),!0}function x(n){var t=p(n);return(e.options.vertical?t.height:t.width)/e.size||1}function k(){return e.options.trackConfig.length}function y(n){for(var o in r=!1,s=t(t({},i),n),h.purge(),a=e.size,c=[],s.breakpoints||[]){var u=window.matchMedia(o);u.__media=o,c.push(u),h.add(u,"change",g)}h.add(window,"orientationchange",z),h.add(window,"resize",E),b()}function w(n){e.animator.stop();var t=e.track.details;e.track.init(null!=n?n:t?t.abs:0)}function M(n){w(n),e.emit("optionsChanged")}function T(n,t){if(n)return y(n),void M(t);I(),A();var i=k();C(),k()!==i?M(t):w(t),e.emit("updated")}function C(){var n=e.options.slides;if("function"==typeof n)return e.options.trackConfig=n(e.size,e.slides);for(var t=e.slides,i=t.length,r="number"==typeof n?n:v(n,"number",i,!0),a=[],o=v(n,"perView",1,!0),u=v(n,"spacing",0,!0)/e.size||0,s="auto"===o?u:u/o,c=v(n,"origin","auto"),d=0,l=0;l<r;l++){var f="auto"===o?x(t[l]):1/o-u+s,p="center"===c?.5-f/2:"auto"===c?0:c;a.push({origin:p,size:f,spacing:u}),d+=f}if(d+=u*(r-1),"auto"===c&&!e.options.loop&&1!==o){var h=0;a.map((function(n){var t=d-h;return h+=n.size+u,t>=1||(n.origin=1-t-(d>1?0:1-d)),n}))}e.options.trackConfig=a}function E(){I();var n=e.size;e.options.disabled||n===a||(a=n,T())}function z(){E(),setTimeout(E,500),setTimeout(E,2e3)}function I(){var n=p(e.container);e.size=(e.options.vertical?n.height:n.width)||1}function A(){e.slides=u(e.options.selector,e.container)}e.container=(f=u(n,l||document)).length?f[0]:null,e.destroy=function(){h.purge(),e.emit("destroyed"),m(!0)},e.prev=function(){e.moveToIdx(e.track.details.abs-1,!0)},e.next=function(){e.moveToIdx(e.track.details.abs+1,!0)},e.update=T,y(e.options)}}var w=function(n,t,e){try{return function(n,t){var i,e={};return i={emit:function(n){e[n]&&e[n].forEach((function(n){n(i)}));var t=i.options&&i.options[n];t&&t(i)},moveToIdx:function(n,t,e){var r=i.track.idxToDist(n,t);if(r){var a=i.options.defaultAnimation;i.animator.start([{distance:r,duration:v(e||a,"duration",500),easing:v(e||a,"easing",(function(n){return 1+--n*n*n*n*n}))}])}},on:function(n,t,i){void 0===i&&(i=!1),e[n]||(e[n]=[]);var r=e[n].indexOf(t);r>-1?i&&delete e[n][r]:i||e[n].push(t)},options:n},function(){if(i.track=g(i),i.animator=m(i),t)for(var n=0,e=t;n<e.length;n++)(0,e[n])(i);i.track.init(i.options.initial||0),i.emit("created")}(),i}(t,i([y(n,{drag:!0,mode:"snap",renderMode:"precision",rubberband:!0,selector:".keen-slider__slide"}),k,x,b],e||[],!0))}catch(n){console.error(n)}};exports.useKeenSlider=function(t,i){var e=n.ref(),r=n.ref();return n.isRef(t)&&n.watch(t,(function(n,t){r.value&&r.value.update(n)})),n.onMounted((function(){e.value&&(r.value=new w(e.value,n.isRef(t)?t.value:t,i))})),n.onUnmounted((function(){r.value&&r.value.destroy()})),[e,r]};


/***/ }),

/***/ 2377:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2378);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(1043).default
var update = add("3576aba0", content, true, {});

/***/ }),

/***/ 2378:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1042)(true);
// imports


// module
exports.push([module.i, ".keen-slider:not([data-keen-slider-disabled]){-webkit-touch-callout:none;-webkit-tap-highlight-color:transparent;align-content:flex-start;display:flex;overflow:hidden;position:relative;touch-action:pan-y;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-khtml-user-select:none;width:100%}.keen-slider:not([data-keen-slider-disabled]) .keen-slider__slide{min-height:100%;overflow:hidden;position:relative;width:100%}.keen-slider:not([data-keen-slider-disabled])[data-keen-slider-reverse]{flex-direction:row-reverse}.keen-slider:not([data-keen-slider-disabled])[data-keen-slider-v]{flex-wrap:wrap}", "", {"version":3,"sources":["/home/runner/work/frontend-desktop/frontend-desktop/node_modules/.pnpm/keen-slider@6.8.5/node_modules/keen-slider/keen-slider.min.css"],"names":[],"mappings":"AAAA,8CAA8C,2BAA2B,wCAAwC,yBAAyB,aAAa,gBAAgB,kBAAkB,mBAAmB,yBAAyB,sBAAsB,qBAAqB,iBAAiB,wBAAwB,UAAU,CAAC,kEAAkE,gBAAgB,gBAAgB,kBAAkB,UAAU,CAAC,wEAAwE,0BAA0B,CAAC,kEAAkE,cAAc,CAAC","file":"keen-slider.min.css","sourcesContent":[".keen-slider:not([data-keen-slider-disabled]){-webkit-touch-callout:none;-webkit-tap-highlight-color:transparent;align-content:flex-start;display:flex;overflow:hidden;position:relative;touch-action:pan-y;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-khtml-user-select:none;width:100%}.keen-slider:not([data-keen-slider-disabled]) .keen-slider__slide{min-height:100%;overflow:hidden;position:relative;width:100%}.keen-slider:not([data-keen-slider-disabled])[data-keen-slider-reverse]{flex-direction:row-reverse}.keen-slider:not([data-keen-slider-disabled])[data-keen-slider-v]{flex-wrap:wrap}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2379:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_KeenSlider_vue_vue_type_style_index_0_id_7f14f26f_prod_lang_scss_scoped_true___ = __webpack_require__(2380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_KeenSlider_vue_vue_type_style_index_0_id_7f14f26f_prod_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_KeenSlider_vue_vue_type_style_index_0_id_7f14f26f_prod_lang_scss_scoped_true___);
/* unused harmony reexport namespace */


/***/ }),

/***/ 2380:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2381);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(1043).default
var update = add("07a87370", content, true, {});

/***/ }),

/***/ 2381:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1042)(true);
// imports


// module
exports.push([module.i, ".keen-slider-wrapper[data-v-7f14f26f]{width:100%;height:100%}.navigation-wrapper[data-v-7f14f26f]{position:relative}.dots[data-v-7f14f26f]{display:flex;justify-content:center;padding:6px 0;margin-top:-6px}.dot[data-v-7f14f26f]{width:10px;height:10px;padding:5px;margin:0 12px;cursor:pointer;background:#fff;border:1px solid #1d1f24;border-radius:50%}.dot[data-v-7f14f26f]:focus{outline:none}.dot.active[data-v-7f14f26f]{background:#000}.arrow[data-v-7f14f26f]{position:absolute;top:50%;width:30px;height:30px;cursor:pointer;opacity:1;transition:opacity .2s;transform:translateY(-50%)}@media(min-width: 768px){.arrow[data-v-7f14f26f]{width:20px;height:20px}}.arrow svg[data-v-7f14f26f]{fill:none;stroke:#1d1f24}.arrow--left[data-v-7f14f26f]{left:-10px}@media(min-width: 768px){.arrow--left[data-v-7f14f26f]{left:10px}}.arrow--right[data-v-7f14f26f]{right:-10px;left:auto}@media(min-width: 768px){.arrow--right[data-v-7f14f26f]{right:10px}}.arrow--disabled[data-v-7f14f26f]{pointer-events:none;opacity:0}", "", {"version":3,"sources":["/home/runner/work/frontend-desktop/frontend-desktop/src/components/reused-components/keenSlider/KeenSlider.vue","/home/runner/work/frontend-desktop/frontend-desktop/assets/scss/base/_variables.scss"],"names":[],"mappings":"AAIA,sCACE,WACA,WAAA,CAGF,qCACE,iBAAA,CAGF,uBACE,aACA,uBACA,cACA,eAAA,CAGF,sBACE,WACA,YACA,YACA,cACA,eACA,gBACA,yBACA,iBAAA,CAGF,4BACE,YAAA,CAGF,6BACE,eCpBY,CDuBd,wBACE,kBACA,QACA,WACA,YACA,eACA,UACA,uBACA,0BAAA,CAEA,yBAVF,wBAWI,WACA,WAAA,CAAA,CAGF,4BACE,UACA,cCvCS,CD2Cb,8BACE,UAAA,CAEA,yBAHF,8BAII,SAAA,CAAA,CAIJ,+BACE,YACA,SAAA,CAEA,yBAJF,+BAKI,UAAA,CAAA,CAIJ,kCACE,oBACA,SAAA,CAAA","file":"KeenSlider.vue?vue&type=style&index=0&id=7f14f26f&prod&lang=scss&scoped=true&","sourcesContent":["\n@import 'assets/scss/base/bootstrap_variables';\n@import 'assets/scss/base/functions';\n\n.keen-slider-wrapper {\n  width: 100%;\n  height: 100%;\n}\n\n.navigation-wrapper {\n  position: relative;\n}\n\n.dots {\n  display: flex;\n  justify-content: center;\n  padding: 6px 0;\n  margin-top: -6px;\n}\n\n.dot {\n  width: 10px;\n  height: 10px;\n  padding: 5px;\n  margin: 0 12px;\n  cursor: pointer;\n  background: $color-white;\n  border: 1px solid $color-dark;\n  border-radius: 50%;\n}\n\n.dot:focus {\n  outline: none;\n}\n\n.dot.active {\n  background: $color-black;\n}\n\n.arrow {\n  position: absolute;\n  top: 50%;\n  width: 30px;\n  height: 30px;\n  cursor: pointer;\n  opacity: 1;\n  transition: opacity $transition-duration;\n  transform: translateY(-50%);\n\n  @media (min-width: $screen-sm-min) {\n    width: 20px;\n    height: 20px;\n  }\n\n  svg {\n    fill: none;\n    stroke: $color-dark;\n  }\n}\n\n.arrow--left {\n  left: -10px;\n\n  @media (min-width: $screen-sm-min) {\n    left: 10px;\n  }\n}\n\n.arrow--right {\n  right: -10px;\n  left: auto;\n\n  @media (min-width: $screen-sm-min) {\n    right: 10px;\n  }\n}\n\n.arrow--disabled {\n  pointer-events: none;\n  opacity: 0;\n}\n","// -----------------------------------------------------------------------------\n//                                  Variables\n// -----------------------------------------------------------------------------\n\n// --------------------------------- Colors ------------------------------------\n$brand-yellow: #fdd366;\n$brand-green: #259167;\n$brand-orange: #f2765d;\n$brand-blue: #2188bf;\n$color-informative-blue: #6594ee;\n$brand-blue-light: lighten($brand-blue, 10%);\n$brand-very-dark-blue: #1d1f24;\n$back-gray: #f3f3f3;\n$light-grey: #ddd;\n$border-color: #e3e3e3;\n$color-white: #fff;\n$color-black: #000;\n$color-dark: #1d1f24;\n$color-alert: #eb5757;\n$color-nation-dark: #1e1e1e;\n$background-color: #eef6fa;\n$color-grey: #aaa;\n$color-overlay-background: rgb(0 0 0 / 40%);\n$color-transparency-white: rgb(255 255 255 / 50%);\n$color-blue-secondary: #074ee8;\n$color-blue-secondary-light: lighten($color-blue-secondary, 10%);\n$color-green-secondary: #1da41a;\n$color-green-secondary-light: lighten($color-green-secondary, 10%);\n$spotify-green: #1db954;\n$apple-podcasts-purple: #b150e2;\n$google-blue: #4285f4;\n$notification-blue: #2188bf;\n$notification-border-blue: #1d7bad;\n$notification-warn: #ffb648;\n$notification-border-warn: #f48a06;\n$notification-error: #e54d42;\n$notification-border-error: #b82e24;\n$notification-success: #259167;\n$notification-border-success: #1f7c58;\n$bg-light-blue: #e5e5e5;\n$bg-alice-blue: #e6f6ff;\n$bg-light-blue-alternative: #eff6fa;\n$medium-turquoise: #429ac9;\n$color-pelorous: #2188bf;\n$light-orange: #fdefec;\n$black-russian: #111928;\n\n// ------------------------------- Transitions ---------------------------------\n$transition-duration: 0.2s;\n$ease-in-back: cubic-bezier(0.6, -0.28, 0.735, 0.045);\n$ease-out-back: cubic-bezier(0.175, 0.885, 0.32, 1.275);\n\n// ---------------------------------- Misc -------------------------------------\n$clear-icon-svg: \"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12'%3E%3Cpath fill='%237f8a8e' fill-rule='evenodd' d='M6 5.082 10.902.179a.642.642 0 0 1 .91.91L6.91 5.991l4.902 4.902a.643.643 0 1 1-.91.91L6.001 6.901l-4.902 4.902a.642.642 0 0 1-.91-.91l4.903-4.902L.188 1.089a.644.644 0 0 1 .91-.91Z'/%3E%3C/svg%3E\";\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2382:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ExploreSection_vue_vue_type_style_index_0_id_5b27735a_prod_lang_scss_scoped_true___ = __webpack_require__(2383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ExploreSection_vue_vue_type_style_index_0_id_5b27735a_prod_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ExploreSection_vue_vue_type_style_index_0_id_5b27735a_prod_lang_scss_scoped_true___);
/* unused harmony reexport namespace */


/***/ }),

/***/ 2383:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2384);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(1043).default
var update = add("3b6b3d12", content, true, {});

/***/ }),

/***/ 2384:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1042)(true);
// imports


// module
exports.push([module.i, ".exploreSection[data-v-5b27735a]{display:flex;flex:1;flex-direction:column;align-items:center;margin-top:88px}@media(min-width: 768px){.exploreSection[data-v-5b27735a]{margin-top:120px}}.exploreSection .exploreTitle[data-v-5b27735a]{font-size:2.125rem;font-weight:400;line-height:1.1;color:inherit;text-align:center}@media(min-width: 768px){.exploreSection .exploreTitle[data-v-5b27735a]{font-size:3.25rem}}.exploreSection .carouselContainer[data-v-5b27735a]{position:relative;width:100vw;margin-top:56px;user-select:none}.exploreSection .carouselContainer .phoneFrame[data-v-5b27735a]{position:absolute;top:-5px;left:50%;z-index:20;width:324px;pointer-events:none;transform:translate(-50%, 0)}.exploreSection .carouselContainer .phoneFrame img[data-v-5b27735a]{width:100%;height:100%;object-fit:contain;pointer-events:none}.exploreSection .carouselContainer .phoneBackground[data-v-5b27735a]{position:absolute;top:97px;left:50%;z-index:5;width:220px;height:220px;pointer-events:none;background-color:#1d1f24;transform:translate(-50%, 0)}.exploreSection .carouselContainer .podcastsSlider[data-v-5b27735a]{margin-top:109px}.exploreSection .carouselContainer .podcastsSlider .slideSlot[data-v-5b27735a]{z-index:10;display:flex;align-items:center;justify-content:center}.exploreSection .carouselContainer .podcastsSlider .slideSlot .sliderImage[data-v-5b27735a]{width:195px;height:195px;overflow:hidden;border-radius:12px;box-shadow:0 16px 40px rgba(0,0,0,.4);object-fit:cover}.exploreSection .carouselContainer .podcastsSlider[data-v-5b27735a] .keen-slider,.exploreSection .carouselContainer .podcastsSlider .keen-slider__slide[data-v-5b27735a]{overflow:visible}.exploreSection .carouselContainer .datasetTitleTarget[data-v-5b27735a]{position:absolute;top:340px;left:50%;z-index:25;font-size:.9375rem;color:#fff;white-space:pre;transform:translate(-50%, 0)}@media(min-width: 768px){.exploreSection .carouselContainer .datasetTitleTarget[data-v-5b27735a]{font-size:1.0625rem}}.exploreSection .carouselContainer .datasetArtistTarget[data-v-5b27735a]{position:absolute;top:318px;left:50%;z-index:25;font-size:.75rem;color:#d9534f;white-space:pre;transform:translate(-50%, 0)}@media(min-width: 768px){.exploreSection .carouselContainer .datasetArtistTarget[data-v-5b27735a]{font-size:.875rem}}.exploreSection .ctaButton[data-v-5b27735a]{margin-top:402px}", "", {"version":3,"sources":["/home/runner/work/frontend-desktop/frontend-desktop/src/components/pages/home/exploreSection/ExploreSection.vue"],"names":[],"mappings":"AAIA,iCACE,aACA,OACA,sBACA,mBACA,eAAA,CAEA,yBAPF,iCAQI,gBAAA,CAAA,CAGF,+CACE,mBACA,gBACA,gBACA,cACA,iBAAA,CAEA,yBAPF,+CAQI,iBAAA,CAAA,CAIJ,oDACE,kBACA,YACA,gBACA,gBAAA,CAEA,gEACE,kBACA,SACA,SACA,WACA,YACA,oBACA,4BAAA,CAEA,oEACE,WACA,YACA,mBACA,mBAAA,CAIJ,qEACE,kBACA,SACA,SACA,UACA,YACA,aACA,oBACA,yBACA,4BAAA,CAGF,oEACE,gBAAA,CAEA,+EACE,WACA,aACA,mBACA,sBAAA,CAEA,4FACE,YACA,aACA,gBACA,mBACA,sCACA,gBAAA,CAIJ,yKAEE,gBAAA,CAIJ,wEACE,kBACA,UACA,SACA,WACA,mBACA,WACA,gBACA,4BAAA,CAEA,yBAVF,wEAWI,mBAAA,CAAA,CAIJ,yEACE,kBACA,UACA,SACA,WACA,iBACA,cACA,gBACA,4BAAA,CAEA,yBAVF,yEAWI,iBAAA,CAAA,CAKN,4CACE,gBAAA,CAAA","file":"ExploreSection.vue?vue&type=style&index=0&id=5b27735a&prod&lang=scss&scoped=true&","sourcesContent":["\n@import 'assets/scss/base/bootstrap_variables';\n@import 'assets/scss/base/functions';\n\n.exploreSection {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 88px;\n\n  @media (min-width: $screen-sm-min) {\n    margin-top: 120px;\n  }\n\n  .exploreTitle {\n    font-size: to-rem(34);\n    font-weight: 400;\n    line-height: 1.1;\n    color: inherit;\n    text-align: center;\n\n    @media (min-width: $screen-sm-min) {\n      font-size: to-rem(52);\n    }\n  }\n\n  .carouselContainer {\n    position: relative;\n    width: 100vw;\n    margin-top: 56px;\n    user-select: none;\n\n    .phoneFrame {\n      position: absolute;\n      top: -5px;\n      left: 50%;\n      z-index: 20;\n      width: 324px;\n      pointer-events: none;\n      transform: translate(-50%, 0);\n\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: contain;\n        pointer-events: none;\n      }\n    }\n\n    .phoneBackground {\n      position: absolute;\n      top: 97px;\n      left: 50%;\n      z-index: 5;\n      width: 220px;\n      height: 220px;\n      pointer-events: none;\n      background-color: #1d1f24;\n      transform: translate(-50%, 0);\n    }\n\n    .podcastsSlider {\n      margin-top: 109px;\n\n      .slideSlot {\n        z-index: 10;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        .sliderImage {\n          width: 195px;\n          height: 195px;\n          overflow: hidden;\n          border-radius: 12px;\n          box-shadow: 0 16px 40px rgb(0 0 0 / 40%);\n          object-fit: cover;\n        }\n      }\n\n      :deep(.keen-slider),\n      .keen-slider__slide {\n        overflow: visible; // so the box-shadow is visible\n      }\n    }\n\n    .datasetTitleTarget {\n      position: absolute;\n      top: 340px;\n      left: 50%;\n      z-index: 25;\n      font-size: to-rem(15);\n      color: $color-white;\n      white-space: pre;\n      transform: translate(-50%, 0);\n\n      @media (min-width: $screen-sm-min) {\n        font-size: to-rem(17);\n      }\n    }\n\n    .datasetArtistTarget {\n      position: absolute;\n      top: 318px;\n      left: 50%;\n      z-index: 25;\n      font-size: to-rem(12);\n      color: $brand-danger;\n      white-space: pre;\n      transform: translate(-50%, 0);\n\n      @media (min-width: $screen-sm-min) {\n        font-size: to-rem(14);\n      }\n    }\n  }\n\n  .ctaButton {\n    margin-top: 402px;\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2385:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FaqSection_vue_vue_type_template_id_4ebbab36_scoped_true___ = __webpack_require__(2386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FaqSection_vue_vue_type_script_setup_true_lang_js___ = __webpack_require__(2094);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FaqSection_vue_vue_type_style_index_0_id_4ebbab36_prod_lang_scss_scoped_true___ = __webpack_require__(2388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(47);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__FaqSection_vue_vue_type_script_setup_true_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__FaqSection_vue_vue_type_template_id_4ebbab36_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__FaqSection_vue_vue_type_template_id_4ebbab36_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "4ebbab36",
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 2386:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FaqSection_vue_vue_type_template_id_4ebbab36_scoped_true___ = __webpack_require__(2387);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FaqSection_vue_vue_type_template_id_4ebbab36_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FaqSection_vue_vue_type_template_id_4ebbab36_scoped_true___["b"]; });


/***/ }),

/***/ 2387:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('section', {
    staticClass: "faqSection"
  }, [_c('h1', {
    staticClass: "faqSectionTitle"
  }, [_vm._v("FAQ")]), _vm._v(" "), _c('div', {
    staticClass: "faqsContainer"
  }, _vm._l(_setup.faqList, function (faq) {
    return _c('div', {
      key: faq.question,
      staticClass: "faqCollapsibleWrapper"
    }, [_c(_setup.FaqCollapsible, {
      staticClass: "faqCollapsible",
      scopedSlots: _vm._u([{
        key: "title",
        fn: function fn() {
          return [_c('span', {
            staticClass: "faqTitle"
          }, [_vm._v(_vm._s(faq.question))])];
        },
        proxy: true
      }, {
        key: "content",
        fn: function fn() {
          return [_c('span', {
            directives: [{
              name: "dompurify-html",
              rawName: "v-dompurify-html",
              value: faq.answer,
              expression: "faq.answer"
            }],
            staticClass: "faqContent"
          })];
        },
        proxy: true
      }], null, true)
    })], 1);
  }), 0), _vm._v(" "), _c('RouterLink', {
    staticClass: "btn-round-white faqButton",
    attrs: {
      "to": {
        name: 'HelpPages'
      }
    }
  }, [_vm._v("Learn more")])], 1);
};
var staticRenderFns = [];


/***/ }),

/***/ 2388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FaqSection_vue_vue_type_style_index_0_id_4ebbab36_prod_lang_scss_scoped_true___ = __webpack_require__(2389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FaqSection_vue_vue_type_style_index_0_id_4ebbab36_prod_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FaqSection_vue_vue_type_style_index_0_id_4ebbab36_prod_lang_scss_scoped_true___);
/* unused harmony reexport namespace */


/***/ }),

/***/ 2389:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2390);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(1043).default
var update = add("0922f759", content, true, {});

/***/ }),

/***/ 2390:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1042)(true);
// imports


// module
exports.push([module.i, ".faqSection[data-v-4ebbab36]{display:flex;flex:1;flex-direction:column;align-items:center;max-width:1200px;padding:0 16px;margin:60px auto;color:#000}@media(min-width: 768px){.faqSection[data-v-4ebbab36]{padding:0 32px;margin:120px auto}}.faqSection .faqsContainer[data-v-4ebbab36]{display:flex;flex-flow:row wrap;justify-content:space-evenly;margin-top:32px}@media(min-width: 768px){.faqSection .faqsContainer[data-v-4ebbab36]{margin-top:54px}}.faqSection .faqsContainer .faqCollapsibleWrapper[data-v-4ebbab36]{display:flex;flex-basis:100%}@media(min-width: 768px){.faqSection .faqsContainer .faqCollapsibleWrapper[data-v-4ebbab36]{flex-basis:50%}}.faqSection .faqsContainer .faqCollapsibleWrapper .faqCollapsible[data-v-4ebbab36]{margin-top:40px}.faqSection .faqsContainer .faqCollapsibleWrapper .faqCollapsible .faqTitle[data-v-4ebbab36]{font-size:1.375rem;font-weight:600;line-height:1.2}@media(min-width: 768px){.faqSection .faqsContainer .faqCollapsibleWrapper .faqCollapsible .faqTitle[data-v-4ebbab36]{font-size:1.875rem}}.faqSection .faqsContainer .faqCollapsibleWrapper .faqCollapsible .faqContent[data-v-4ebbab36]{font-size:1.125rem;font-weight:400;line-height:1.5}@media(min-width: 768px){.faqSection .faqsContainer .faqCollapsibleWrapper .faqCollapsible .faqContent[data-v-4ebbab36]{font-size:1.25rem}}.faqSection .faqSectionTitle[data-v-4ebbab36]{font-size:2rem;font-weight:400;line-height:1.1;color:inherit}@media(min-width: 768px){.faqSection .faqSectionTitle[data-v-4ebbab36]{font-size:3.25rem}}.faqSection .faqButton[data-v-4ebbab36]{margin-top:60px}@media(min-width: 768px){.faqSection .faqButton[data-v-4ebbab36]{margin-top:120px}}[data-v-4ebbab36] .faqContent a{color:#6594ee}[data-v-4ebbab36] .faqContent ol,[data-v-4ebbab36] .faqContent li{list-style:outside;list-style-type:decimal}[data-v-4ebbab36] .faqContent .social-icons{display:flex;column-gap:10px;align-items:flex-end;justify-content:start;order:6;height:100%}@media(min-width: 992px){[data-v-4ebbab36] .faqContent .social-icons{column-gap:clamp(8px,1.2vw,16px);order:4;margin:0}}[data-v-4ebbab36] .faqContent .social-icons .social-icon-link{display:block;font-size:3.75rem;color:#000;transition:color .2s}[data-v-4ebbab36] .faqContent .social-icons .social-icon-link:hover{color:#f2765d}@media(min-width: 992px){[data-v-4ebbab36] .faqContent .social-icons .social-icon-link{font-size:2.1875rem}}", "", {"version":3,"sources":["/home/runner/work/frontend-desktop/frontend-desktop/src/components/pages/home/faqSection/FaqSection.vue","/home/runner/work/frontend-desktop/frontend-desktop/assets/scss/base/_variables.scss"],"names":[],"mappings":"AAIA,6BACE,aACA,OACA,sBACA,mBACA,iBACA,eACA,iBACA,UCIY,CDFZ,yBAVF,6BAWI,eACA,iBAAA,CAAA,CAGF,4CACE,aACA,mBACA,6BACA,eAAA,CAEA,yBANF,4CAOI,eAAA,CAAA,CAGF,mEACE,aACA,eAAA,CAEA,yBAJF,mEAKI,cAAA,CAAA,CAGF,mFACE,eAAA,CAEA,6FACE,mBACA,gBACA,eAAA,CAEA,yBALF,6FAMI,kBAAA,CAAA,CAIJ,+FACE,mBACA,gBACA,eAAA,CAEA,yBALF,+FAMI,iBAAA,CAAA,CAOV,8CACE,eACA,gBACA,gBACA,aAAA,CAEA,yBANF,8CAOI,iBAAA,CAAA,CAIJ,wCACE,eAAA,CAEA,yBAHF,wCAII,gBAAA,CAAA,CAMJ,gCACE,aC5EqB,CD+EvB,kEAEE,mBACA,uBAAA,CAGF,4CACE,aACA,gBACA,qBACA,sBACA,QACA,WAAA,CAEA,yBARF,4CASI,iCACA,QACA,QAAA,CAAA,CAGF,8DACE,cACA,kBACA,WACA,oBAAA,CAEA,oEACE,aC5GO,CD+GT,yBAVF,8DAWI,mBAAA,CAAA,CAAA","file":"FaqSection.vue?vue&type=style&index=0&id=4ebbab36&prod&lang=scss&scoped=true&","sourcesContent":["\n@import 'assets/scss/base/bootstrap_variables';\n@import 'assets/scss/base/functions';\n\n.faqSection {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  align-items: center;\n  max-width: 1200px;\n  padding: 0 16px;\n  margin: 60px auto;\n  color: $color-black;\n\n  @media (min-width: $screen-sm-min) {\n    padding: 0 32px;\n    margin: 120px auto;\n  }\n\n  .faqsContainer {\n    display: flex;\n    flex-flow: row wrap;\n    justify-content: space-evenly;\n    margin-top: 32px;\n\n    @media (min-width: $screen-sm-min) {\n      margin-top: 54px;\n    }\n\n    .faqCollapsibleWrapper {\n      display: flex;\n      flex-basis: 100%;\n\n      @media (min-width: $screen-sm-min) {\n        flex-basis: 50%;\n      }\n\n      .faqCollapsible {\n        margin-top: 40px;\n\n        .faqTitle {\n          font-size: to-rem(22);\n          font-weight: 600;\n          line-height: 1.2;\n\n          @media (min-width: $screen-sm-min) {\n            font-size: to-rem(30);\n          }\n        }\n\n        .faqContent {\n          font-size: to-rem(18);\n          font-weight: 400;\n          line-height: 1.5;\n\n          @media (min-width: $screen-sm-min) {\n            font-size: to-rem(20);\n          }\n        }\n      }\n    }\n  }\n\n  .faqSectionTitle {\n    font-size: to-rem(32);\n    font-weight: 400;\n    line-height: 1.1;\n    color: inherit;\n\n    @media (min-width: $screen-sm-min) {\n      font-size: to-rem(52);\n    }\n  }\n\n  .faqButton {\n    margin-top: 60px;\n\n    @media (min-width: $screen-sm-min) {\n      margin-top: 120px;\n    }\n  }\n}\n\n:deep(.faqContent) {\n  a {\n    color: $color-informative-blue;\n  }\n\n  ol,\n  li {\n    list-style: outside;\n    list-style-type: decimal;\n  }\n\n  .social-icons {\n    display: flex;\n    column-gap: 10px;\n    align-items: flex-end;\n    justify-content: start;\n    order: 6;\n    height: 100%;\n\n    @media (min-width: $screen-md-min) {\n      column-gap: clamp(8px, 1.2vw, 16px);\n      order: 4;\n      margin: 0;\n    }\n\n    .social-icon-link {\n      display: block;\n      font-size: to-rem(60);\n      color: $color-black;\n      transition: color 0.2s;\n\n      &:hover {\n        color: $brand-orange;\n      }\n\n      @media (min-width: $screen-md-min) {\n        font-size: to-rem(35);\n      }\n    }\n  }\n}\n","// -----------------------------------------------------------------------------\n//                                  Variables\n// -----------------------------------------------------------------------------\n\n// --------------------------------- Colors ------------------------------------\n$brand-yellow: #fdd366;\n$brand-green: #259167;\n$brand-orange: #f2765d;\n$brand-blue: #2188bf;\n$color-informative-blue: #6594ee;\n$brand-blue-light: lighten($brand-blue, 10%);\n$brand-very-dark-blue: #1d1f24;\n$back-gray: #f3f3f3;\n$light-grey: #ddd;\n$border-color: #e3e3e3;\n$color-white: #fff;\n$color-black: #000;\n$color-dark: #1d1f24;\n$color-alert: #eb5757;\n$color-nation-dark: #1e1e1e;\n$background-color: #eef6fa;\n$color-grey: #aaa;\n$color-overlay-background: rgb(0 0 0 / 40%);\n$color-transparency-white: rgb(255 255 255 / 50%);\n$color-blue-secondary: #074ee8;\n$color-blue-secondary-light: lighten($color-blue-secondary, 10%);\n$color-green-secondary: #1da41a;\n$color-green-secondary-light: lighten($color-green-secondary, 10%);\n$spotify-green: #1db954;\n$apple-podcasts-purple: #b150e2;\n$google-blue: #4285f4;\n$notification-blue: #2188bf;\n$notification-border-blue: #1d7bad;\n$notification-warn: #ffb648;\n$notification-border-warn: #f48a06;\n$notification-error: #e54d42;\n$notification-border-error: #b82e24;\n$notification-success: #259167;\n$notification-border-success: #1f7c58;\n$bg-light-blue: #e5e5e5;\n$bg-alice-blue: #e6f6ff;\n$bg-light-blue-alternative: #eff6fa;\n$medium-turquoise: #429ac9;\n$color-pelorous: #2188bf;\n$light-orange: #fdefec;\n$black-russian: #111928;\n\n// ------------------------------- Transitions ---------------------------------\n$transition-duration: 0.2s;\n$ease-in-back: cubic-bezier(0.6, -0.28, 0.735, 0.045);\n$ease-out-back: cubic-bezier(0.175, 0.885, 0.32, 1.275);\n\n// ---------------------------------- Misc -------------------------------------\n$clear-icon-svg: \"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12'%3E%3Cpath fill='%237f8a8e' fill-rule='evenodd' d='M6 5.082 10.902.179a.642.642 0 0 1 .91.91L6.91 5.991l4.902 4.902a.643.643 0 1 1-.91.91L6.001 6.901l-4.902 4.902a.642.642 0 0 1-.91-.91l4.903-4.902L.188 1.089a.644.644 0 0 1 .91-.91Z'/%3E%3C/svg%3E\";\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2391:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FeaturesFirstSection_vue_vue_type_template_id_586207fe_scoped_true___ = __webpack_require__(2392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FeaturesFirstSection_vue_vue_type_script_setup_true_lang_js___ = __webpack_require__(2096);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FeaturesFirstSection_vue_vue_type_style_index_0_id_586207fe_prod_lang_scss_scoped_true___ = __webpack_require__(2394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(47);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__FeaturesFirstSection_vue_vue_type_script_setup_true_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__FeaturesFirstSection_vue_vue_type_template_id_586207fe_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__FeaturesFirstSection_vue_vue_type_template_id_586207fe_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "586207fe",
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 2392:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FeaturesFirstSection_vue_vue_type_template_id_586207fe_scoped_true___ = __webpack_require__(2393);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FeaturesFirstSection_vue_vue_type_template_id_586207fe_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FeaturesFirstSection_vue_vue_type_template_id_586207fe_scoped_true___["b"]; });


/***/ }),

/***/ 2393:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('section', {
    staticClass: "featuresSection"
  }, [_c('h1', {
    staticClass: "featuresSectionTitle"
  }, [_vm._v("Some of our features")]), _vm._v(" "), _c('div', {
    staticClass: "featuresSectionContent"
  }, [_c(_setup.InfographicSection, {
    staticClass: "featuresInfoSection",
    attrs: {
      "button-class-name": 'btn-round-yellow',
      "button-text": 'Get started',
      "has-white-text": true,
      "on-button-click": function onButtonClick() {
        return _setup.onRedirect('PodcasterRegister');
      },
      "paragraph": 'Record your episode on your phone or in your favorite studio and use our creator tools to produce, distribute to and grow your audience.',
      "title": 'Edit and publish your podcast all in one place'
    }
  }, [_c('div', {
    staticClass: "videoContainer"
  }, [_setup.isNarrowViewport ? _c('video', {
    attrs: {
      "poster": "static/videos/audio-editor-poster.720p.q60.webp",
      "loop": "",
      "muted": "",
      "playsinline": "",
      "preload": "none"
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": "static/videos/audio-editor.720p.av1.qp100.mp4",
      "type": "video/mp4; codecs=av01.0.05M.08"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "static/videos/audio-editor.720p.hevc.crf28.mp4",
      "type": "video/mp4; codecs=hvc1"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "static/videos/audio-editor.720p.avc.crf28.mp4",
      "type": "video/mp4; codecs=avc1.4D401E"
    }
  })]) : _c('video', {
    attrs: {
      "poster": "static/videos/audio-editor-poster.720p.q60.webp",
      "loop": "",
      "muted": "",
      "playsinline": "",
      "preload": "none"
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": "static/videos/audio-editor.1080p.av1.qp80.mp4",
      "type": "video/mp4; codecs=av01.0.05M.08"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "static/videos/audio-editor.1080p.hevc.crf24.mp4",
      "type": "video/mp4; codecs=hvc1"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "static/videos/audio-editor.1080p.avc.crf24.mp4",
      "type": "video/mp4; codecs=avc1.4D401E"
    }
  })])])])], 1)]);
};
var staticRenderFns = [];


/***/ }),

/***/ 2394:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FeaturesFirstSection_vue_vue_type_style_index_0_id_586207fe_prod_lang_scss_scoped_true___ = __webpack_require__(2395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FeaturesFirstSection_vue_vue_type_style_index_0_id_586207fe_prod_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FeaturesFirstSection_vue_vue_type_style_index_0_id_586207fe_prod_lang_scss_scoped_true___);
/* unused harmony reexport namespace */


/***/ }),

/***/ 2395:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2396);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(1043).default
var update = add("0f120fe8", content, true, {});

/***/ }),

/***/ 2396:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1042)(true);
// imports


// module
exports.push([module.i, ".featuresSection[data-v-586207fe]{display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;max-width:1440px;padding:0 16px;margin:88px auto 0}@media(min-width: 768px){.featuresSection[data-v-586207fe]{padding:0 32px;margin:120px auto 0}}.featuresSection .featuresSectionTitle[data-v-586207fe]{font-size:2.125rem;font-weight:400;line-height:1.1;color:inherit;text-align:center}@media(min-width: 768px){.featuresSection .featuresSectionTitle[data-v-586207fe]{font-size:3.25rem}}.featuresSection .featuresSectionContent[data-v-586207fe]{display:flex;flex-direction:column;justify-content:center;width:100%}@media(min-width: 768px){.featuresSection .featuresSectionContent[data-v-586207fe]{justify-content:unset}}.featuresSection .featuresSectionContent .featuresInfoSection[data-v-586207fe]{width:100vw;margin-top:56px;margin-left:-14.5px}@media(min-width: 768px){.featuresSection .featuresSectionContent .featuresInfoSection[data-v-586207fe]{width:unset;margin-top:80px;margin-left:unset}}.featuresSection .featuresSectionContent .videoContainer[data-v-586207fe]{position:relative;right:50%;left:50%;width:100vw;aspect-ratio:710/448;margin-right:-50vw;margin-left:-50vw;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='710' height='448' fill='none'%3E%3Cg filter='url(%23a)'%3E%3Cellipse cx='354.842' cy='399.991' fill='%23000' rx='310.196' ry='3.413'/%3E%3C/g%3E%3Cpath fill='%231A202C' stroke='%234A5568' stroke-width='2' d='M104.18 1h503.381c14.911 0 27 12.088 27 27v346.15a3 3 0 0 1-3 3H80.18a3 3 0 0 1-3-3V28c0-14.912 12.088-27 27-27Z'/%3E%3Cpath fill='%23000' d='M79.607 25.413c0-12.15 9.85-22 22-22h508.526c12.15 0 22 9.85 22 22v338.403H79.607V25.413Z'/%3E%3Cpath fill='%23A3ACB1' d='M9 377.423a2 2 0 0 1 2-2h687a2 2 0 0 1 2 2v10.286H9v-10.286Z'/%3E%3Cpath fill='url(%23b)' d='M9 377.423a2 2 0 0 1 2-2h687a2 2 0 0 1 2 2v10.286H9v-10.286Z'/%3E%3Cpath fill='%23647279' d='M9 387.711h691l-1.8.361a399.988 399.988 0 0 1-78.755 7.83H83.931c-25.2 0-50.326-2.747-74.931-8.191Z'/%3E%3Cpath fill='url(%23c)' d='M9 387.711h691l-1.8.361a399.988 399.988 0 0 1-78.755 7.83H83.931c-25.2 0-50.326-2.747-74.931-8.191Z'/%3E%3Cpath fill='%2396A1A8' fill-rule='evenodd' d='M297.625 375.423c.353 5.336 4.812 9.556 10.26 9.556h93.916c5.449 0 9.907-4.22 10.26-9.556H297.625Z' clip-rule='evenodd'/%3E%3Cpath fill='url(%23d)' fill-rule='evenodd' d='M297.625 375.423c.353 5.336 4.812 9.556 10.26 9.556h93.916c5.449 0 9.907-4.22 10.26-9.556H297.625Z' clip-rule='evenodd'/%3E%3Cdefs%3E%3ClinearGradient id='b' x1='9' x2='700' y1='381.566' y2='381.566' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%230D1012'/%3E%3Cstop offset='.03' stop-color='%23CAD4DB'/%3E%3Cstop offset='.063' stop-color='%23242729'/%3E%3Cstop offset='.134' stop-color='%23A3ACB1'/%3E%3Cstop offset='.866' stop-color='%23A3ACB1'/%3E%3Cstop offset='.942' stop-color='%23242729'/%3E%3Cstop offset='.971' stop-color='%23CAD4DB'/%3E%3Cstop offset='.996' stop-color='%230D1012'/%3E%3C/linearGradient%3E%3ClinearGradient id='c' x1='354.5' x2='354.5' y1='387.711' y2='395.902' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%237A7F83'/%3E%3Cstop offset='1' stop-color='%230B0B0E'/%3E%3C/linearGradient%3E%3ClinearGradient id='d' x1='308.914' x2='402.829' y1='381.225' y2='381.225' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%233C3C3C'/%3E%3Cstop offset='.318' stop-color='%233C3C3C' stop-opacity='0'/%3E%3Cstop offset='.661' stop-color='%233C3C3C' stop-opacity='0'/%3E%3Cstop offset='1' stop-color='%23444'/%3E%3C/linearGradient%3E%3Cfilter id='a' width='708.393' height='94.826' x='.646' y='352.578' color-interpolation-filters='sRGB' filterUnits='userSpaceOnUse'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeGaussianBlur result='effect1_foregroundBlur_4992_10327' stdDeviation='22'/%3E%3C/filter%3E%3C/defs%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:top center;background-size:contain}@media(min-width: 768px){.featuresSection .featuresSectionContent .videoContainer[data-v-586207fe]{right:unset;left:unset;width:100%;margin-right:unset;margin-left:unset}}.featuresSection .featuresSectionContent .videoContainer video[data-v-586207fe]{position:absolute;top:7.2%;left:50%;width:76%;max-width:640px;transform:translateX(-50%)}", "", {"version":3,"sources":["/home/runner/work/frontend-desktop/frontend-desktop/src/components/pages/home/featuresFirstSection/FeaturesFirstSection.vue"],"names":[],"mappings":"AAIA,kCACE,aACA,sBACA,mBACA,uBACA,WACA,iBACA,eACA,kBAAA,CAEA,yBAVF,kCAWI,eACA,mBAAA,CAAA,CAGF,wDACE,mBACA,gBACA,gBACA,cACA,iBAAA,CAEA,yBAPF,wDAQI,iBAAA,CAAA,CAIJ,0DACE,aACA,sBACA,uBACA,UAAA,CAEA,yBANF,0DAOI,qBAAA,CAAA,CAGF,+EACE,YACA,gBACA,mBAAA,CAEA,yBALF,+EAMI,YACA,gBACA,iBAAA,CAAA,CAIJ,0EACE,kBACA,UACA,SACA,YACA,qBACA,mBACA,kBACA,qsFACA,4BACA,+BACA,uBAAA,CAEA,yBAbF,0EAcI,YACA,WACA,WACA,mBACA,iBAAA,CAAA,CAGF,gFACE,kBACA,SACA,SACA,UACA,gBACA,0BAAA,CAAA","file":"FeaturesFirstSection.vue?vue&type=style&index=0&id=586207fe&prod&lang=scss&scoped=true&","sourcesContent":["\n@import 'assets/scss/base/bootstrap_variables';\n@import 'assets/scss/base/functions';\n\n.featuresSection {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  max-width: 1440px;\n  padding: 0 16px;\n  margin: 88px auto 0;\n\n  @media (min-width: $screen-sm-min) {\n    padding: 0 32px;\n    margin: 120px auto 0;\n  }\n\n  .featuresSectionTitle {\n    font-size: to-rem(34);\n    font-weight: 400;\n    line-height: 1.1;\n    color: inherit;\n    text-align: center;\n\n    @media (min-width: $screen-sm-min) {\n      font-size: to-rem(52);\n    }\n  }\n\n  .featuresSectionContent {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    width: 100%;\n\n    @media (min-width: $screen-sm-min) {\n      justify-content: unset;\n    }\n\n    .featuresInfoSection {\n      width: 100vw;\n      margin-top: 56px;\n      margin-left: -14.5px;\n\n      @media (min-width: $screen-sm-min) {\n        width: unset;\n        margin-top: 80px;\n        margin-left: unset;\n      }\n    }\n\n    .videoContainer {\n      position: relative;\n      right: 50%;\n      left: 50%;\n      width: 100vw;\n      aspect-ratio: 710/448;\n      margin-right: -50vw;\n      margin-left: -50vw;\n      background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='710' height='448' fill='none'%3E%3Cg filter='url(%23a)'%3E%3Cellipse cx='354.842' cy='399.991' fill='%23000' rx='310.196' ry='3.413'/%3E%3C/g%3E%3Cpath fill='%231A202C' stroke='%234A5568' stroke-width='2' d='M104.18 1h503.381c14.911 0 27 12.088 27 27v346.15a3 3 0 0 1-3 3H80.18a3 3 0 0 1-3-3V28c0-14.912 12.088-27 27-27Z'/%3E%3Cpath fill='%23000' d='M79.607 25.413c0-12.15 9.85-22 22-22h508.526c12.15 0 22 9.85 22 22v338.403H79.607V25.413Z'/%3E%3Cpath fill='%23A3ACB1' d='M9 377.423a2 2 0 0 1 2-2h687a2 2 0 0 1 2 2v10.286H9v-10.286Z'/%3E%3Cpath fill='url(%23b)' d='M9 377.423a2 2 0 0 1 2-2h687a2 2 0 0 1 2 2v10.286H9v-10.286Z'/%3E%3Cpath fill='%23647279' d='M9 387.711h691l-1.8.361a399.988 399.988 0 0 1-78.755 7.83H83.931c-25.2 0-50.326-2.747-74.931-8.191Z'/%3E%3Cpath fill='url(%23c)' d='M9 387.711h691l-1.8.361a399.988 399.988 0 0 1-78.755 7.83H83.931c-25.2 0-50.326-2.747-74.931-8.191Z'/%3E%3Cpath fill='%2396A1A8' fill-rule='evenodd' d='M297.625 375.423c.353 5.336 4.812 9.556 10.26 9.556h93.916c5.449 0 9.907-4.22 10.26-9.556H297.625Z' clip-rule='evenodd'/%3E%3Cpath fill='url(%23d)' fill-rule='evenodd' d='M297.625 375.423c.353 5.336 4.812 9.556 10.26 9.556h93.916c5.449 0 9.907-4.22 10.26-9.556H297.625Z' clip-rule='evenodd'/%3E%3Cdefs%3E%3ClinearGradient id='b' x1='9' x2='700' y1='381.566' y2='381.566' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%230D1012'/%3E%3Cstop offset='.03' stop-color='%23CAD4DB'/%3E%3Cstop offset='.063' stop-color='%23242729'/%3E%3Cstop offset='.134' stop-color='%23A3ACB1'/%3E%3Cstop offset='.866' stop-color='%23A3ACB1'/%3E%3Cstop offset='.942' stop-color='%23242729'/%3E%3Cstop offset='.971' stop-color='%23CAD4DB'/%3E%3Cstop offset='.996' stop-color='%230D1012'/%3E%3C/linearGradient%3E%3ClinearGradient id='c' x1='354.5' x2='354.5' y1='387.711' y2='395.902' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%237A7F83'/%3E%3Cstop offset='1' stop-color='%230B0B0E'/%3E%3C/linearGradient%3E%3ClinearGradient id='d' x1='308.914' x2='402.829' y1='381.225' y2='381.225' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%233C3C3C'/%3E%3Cstop offset='.318' stop-color='%233C3C3C' stop-opacity='0'/%3E%3Cstop offset='.661' stop-color='%233C3C3C' stop-opacity='0'/%3E%3Cstop offset='1' stop-color='%23444'/%3E%3C/linearGradient%3E%3Cfilter id='a' width='708.393' height='94.826' x='.646' y='352.578' color-interpolation-filters='sRGB' filterUnits='userSpaceOnUse'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeGaussianBlur result='effect1_foregroundBlur_4992_10327' stdDeviation='22'/%3E%3C/filter%3E%3C/defs%3E%3C/svg%3E\");\n      background-repeat: no-repeat;\n      background-position: top center;\n      background-size: contain;\n\n      @media (min-width: $screen-sm-min) {\n        right: unset;\n        left: unset;\n        width: 100%;\n        margin-right: unset;\n        margin-left: unset;\n      }\n\n      video {\n        position: absolute;\n        top: 7.2%;\n        left: 50%;\n        width: 76%;\n        max-width: 640px;\n        transform: translateX(-50%);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2397:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FeaturesSecondSection_vue_vue_type_template_id_12783411_scoped_true___ = __webpack_require__(2398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FeaturesSecondSection_vue_vue_type_script_setup_true_lang_js___ = __webpack_require__(2098);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FeaturesSecondSection_vue_vue_type_style_index_0_id_12783411_prod_lang_scss_scoped_true___ = __webpack_require__(2400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(47);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__FeaturesSecondSection_vue_vue_type_script_setup_true_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__FeaturesSecondSection_vue_vue_type_template_id_12783411_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__FeaturesSecondSection_vue_vue_type_template_id_12783411_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "12783411",
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 2398:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FeaturesSecondSection_vue_vue_type_template_id_12783411_scoped_true___ = __webpack_require__(2399);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FeaturesSecondSection_vue_vue_type_template_id_12783411_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FeaturesSecondSection_vue_vue_type_template_id_12783411_scoped_true___["b"]; });


/***/ }),

/***/ 2399:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('section', {
    staticClass: "featuresSection"
  }, [_c('div', {
    staticClass: "featuresSectionContent"
  }, [_c(_setup.InfographicSection, {
    staticClass: "featuresInfoSection",
    attrs: {
      "button-text": 'Get started',
      "has-inverted-layout": true,
      "has-white-text": true,
      "on-button-click": function onButtonClick() {
        return _setup.onRedirect('PodcasterRegister');
      },
      "paragraph": 'Make your content available anywhere on the web with our fully customizable web player.',
      "title": 'Embed your podcast on any website'
    }
  }, [_vm.isNarrowViewport ? _c('video', {
    staticClass: "video",
    attrs: {
      "poster": "static/videos/embed-player-poster.576p.webp",
      "loop": "",
      "muted": "",
      "playsinline": "",
      "preload": "none"
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": "static/videos/embed-player.576p.av1.qp100.mp4",
      "type": "video/mp4; codecs=av01.0.05M.08"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "static/videos/embed-player.576p.hevc.crf28.mp4",
      "type": "video/mp4; codecs=hvc1"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "static/videos/embed-player.576p.avc.crf28.mp4",
      "type": "video/mp4; codecs=avc1.4D401E"
    }
  })]) : _c('video', {
    staticClass: "video",
    attrs: {
      "poster": "static/videos/embed-player-poster.576p.webp",
      "loop": "",
      "muted": "",
      "playsinline": "",
      "preload": "none"
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": "static/videos/embed-player.1152p.av1.qp80.mp4",
      "type": "video/mp4; codecs=av01.0.05M.08"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "static/videos/embed-player.1152p.hevc.crf24.mp4",
      "type": "video/mp4; codecs=hvc1"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "static/videos/embed-player.1152p.avc.crf24.mp4",
      "type": "video/mp4; codecs=avc1.4D401E"
    }
  })])])], 1)]);
};
var staticRenderFns = [];


/***/ }),

/***/ 2400:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FeaturesSecondSection_vue_vue_type_style_index_0_id_12783411_prod_lang_scss_scoped_true___ = __webpack_require__(2401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FeaturesSecondSection_vue_vue_type_style_index_0_id_12783411_prod_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FeaturesSecondSection_vue_vue_type_style_index_0_id_12783411_prod_lang_scss_scoped_true___);
/* unused harmony reexport namespace */


/***/ }),

/***/ 2401:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2402);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(1043).default
var update = add("444c118c", content, true, {});

/***/ }),

/***/ 2402:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1042)(true);
// imports


// module
exports.push([module.i, ".featuresSection[data-v-12783411]{display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;max-width:1440px;padding:0 16px;margin:88px auto 0}@media(min-width: 768px){.featuresSection[data-v-12783411]{padding:0 32px;margin:120px auto 0}}.featuresSection .featuresSectionContent[data-v-12783411]{display:flex;flex-direction:column;width:100%}.featuresSection .featuresSectionContent .featuresInfoSection[data-v-12783411]{margin-top:56px}@media(min-width: 768px){.featuresSection .featuresSectionContent .featuresInfoSection[data-v-12783411]{margin-top:80px}}.featuresSection .featuresSectionContent .video[data-v-12783411]{width:100%;max-width:576px;margin:0 auto 32px;pointer-events:none;border-radius:12px}@media(min-width: 768px){.featuresSection .featuresSectionContent .video[data-v-12783411]{max-width:90%;margin:0}}@media(min-width: 1536px){.featuresSection .featuresSectionContent .video[data-v-12783411]{max-width:768px}}", "", {"version":3,"sources":["/home/runner/work/frontend-desktop/frontend-desktop/src/components/pages/home/featuresSecondSection/FeaturesSecondSection.vue"],"names":[],"mappings":"AAIA,kCACE,aACA,sBACA,mBACA,uBACA,WACA,iBACA,eACA,kBAAA,CAEA,yBAVF,kCAWI,eACA,mBAAA,CAAA,CAGF,0DACE,aACA,sBACA,UAAA,CAEA,+EACE,eAAA,CAEA,yBAHF,+EAII,eAAA,CAAA,CAIJ,iEACE,WACA,gBACA,mBACA,oBACA,kBAAA,CAEA,yBAPF,iEAQI,cACA,QAAA,CAAA,CAGF,0BAZF,iEAaI,eAAA,CAAA,CAAA","file":"FeaturesSecondSection.vue?vue&type=style&index=0&id=12783411&prod&lang=scss&scoped=true&","sourcesContent":["\n@import 'assets/scss/base/bootstrap_variables';\n@import 'assets/scss/base/functions';\n\n.featuresSection {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  max-width: 1440px;\n  padding: 0 16px;\n  margin: 88px auto 0;\n\n  @media (min-width: $screen-sm-min) {\n    padding: 0 32px;\n    margin: 120px auto 0;\n  }\n\n  .featuresSectionContent {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n\n    .featuresInfoSection {\n      margin-top: 56px;\n\n      @media (min-width: $screen-sm-min) {\n        margin-top: 80px;\n      }\n    }\n\n    .video {\n      width: 100%;\n      max-width: 576px;\n      margin: 0 auto 32px;\n      pointer-events: none;\n      border-radius: 12px;\n\n      @media (min-width: $screen-sm-min) {\n        max-width: 90%;\n        margin: 0;\n      }\n\n      @media (min-width: $screen-xl-min) {\n        max-width: 768px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2403:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HeroSection_vue_vue_type_template_id_266226f4_scoped_true___ = __webpack_require__(2404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HeroSection_vue_vue_type_script_setup_true_lang_js___ = __webpack_require__(2100);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HeroSection_vue_vue_type_style_index_0_id_266226f4_prod_lang_scss_scoped_true___ = __webpack_require__(2406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(47);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__HeroSection_vue_vue_type_script_setup_true_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__HeroSection_vue_vue_type_template_id_266226f4_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__HeroSection_vue_vue_type_template_id_266226f4_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "266226f4",
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 2404:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_HeroSection_vue_vue_type_template_id_266226f4_scoped_true___ = __webpack_require__(2405);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_HeroSection_vue_vue_type_template_id_266226f4_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_HeroSection_vue_vue_type_template_id_266226f4_scoped_true___["b"]; });


/***/ }),

/***/ 2405:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('section', {
    staticClass: "heroSection"
  }, [_c('h1', {
    staticClass: "heroTitle"
  }, [_vm._v("Africa's #1 Podcast Hosting and Monetizing platform")]), _vm._v(" "), _c('p', {
    staticClass: "heroText"
  }, [_vm._v("Afripods is the easiest way to produce, edit and grow your podcast audience in Africa.")]), _vm._v(" "), _c('button', {
    staticClass: "btn-round-yellow heroButton",
    on: {
      "click": function click($event) {
        return _setup.onRedirect({
          name: 'PodcasterPodcastListAdd',
          params: {
            section: 'list',
            action: 'add',
            recordId: '0'
          }
        });
      }
    }
  }, [_vm._v("\n    Create your podcast for free\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "heroText"
  }, [_vm._v("\n    Already have a podcast?\n    "), _c('button', {
    staticClass: "btn-unstyled",
    on: {
      "click": function click($event) {
        return _setup.onRedirect({
          name: 'PodcasterMigratePodcast'
        });
      }
    }
  }, [_vm._v("Migrate it here")])])]);
};
var staticRenderFns = [];


/***/ }),

/***/ 2406:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_HeroSection_vue_vue_type_style_index_0_id_266226f4_prod_lang_scss_scoped_true___ = __webpack_require__(2407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_HeroSection_vue_vue_type_style_index_0_id_266226f4_prod_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_HeroSection_vue_vue_type_style_index_0_id_266226f4_prod_lang_scss_scoped_true___);
/* unused harmony reexport namespace */


/***/ }),

/***/ 2407:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2408);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(1043).default
var update = add("27fde302", content, true, {});

/***/ }),

/***/ 2408:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1042)(true);
// imports


// module
exports.push([module.i, ".heroSection[data-v-266226f4]{text-shadow:0 4px 4px rgba(0,0,0,.25)}.heroSection .heroTitle[data-v-266226f4]{font-size:clamp(2.25rem,4.7vw + .0625rem,4.5rem);font-weight:400;line-height:1.1;color:inherit}@media(min-width: 768px){.heroSection .heroTitle[data-v-266226f4]{max-width:70%}}@media(min-width: 1536px){.heroSection .heroTitle[data-v-266226f4]{max-width:900px}}.heroSection .heroText[data-v-266226f4]{margin-top:32px;font-size:1rem;line-height:1.5}@media(min-width: 992px){.heroSection .heroText[data-v-266226f4]{font-size:1.25rem}}.heroSection .heroText button[data-v-266226f4]{font-weight:600;color:#fff;text-decoration:underline}.heroSection .heroButton[data-v-266226f4]{margin-top:32px}", "", {"version":3,"sources":["/home/runner/work/frontend-desktop/frontend-desktop/src/components/pages/home/heroSection/HeroSection.vue"],"names":[],"mappings":"AAIA,8BACE,qCAAA,CAEA,yCACE,iDACA,gBACA,gBACA,aAAA,CAEA,yBANF,yCAOI,aAAA,CAAA,CAGF,0BAVF,yCAWI,eAAA,CAAA,CAIJ,wCACE,gBACA,eACA,eAAA,CAEA,yBALF,wCAMI,iBAAA,CAAA,CAGF,+CACE,gBACA,WACA,yBAAA,CAIJ,0CACE,eAAA,CAAA","file":"HeroSection.vue?vue&type=style&index=0&id=266226f4&prod&lang=scss&scoped=true&","sourcesContent":["\n@import 'assets/scss/base/bootstrap_variables';\n@import 'assets/scss/base/functions';\n\n.heroSection {\n  text-shadow: 0 4px 4px rgb(0 0 0 / 25%);\n\n  .heroTitle {\n    font-size: clamp(to-rem(36), 4.7vw + to-rem(1), to-rem(72));\n    font-weight: 400;\n    line-height: 1.1;\n    color: inherit;\n\n    @media (min-width: $screen-sm-min) {\n      max-width: 70%;\n    }\n\n    @media (min-width: $screen-xl-min) {\n      max-width: 900px;\n    }\n  }\n\n  .heroText {\n    margin-top: 32px;\n    font-size: to-rem(16);\n    line-height: 1.5;\n\n    @media (min-width: $screen-md-min) {\n      font-size: to-rem(20);\n    }\n\n    button {\n      font-weight: 600;\n      color: $color-white;\n      text-decoration: underline;\n    }\n  }\n\n  .heroButton {\n    margin-top: 32px;\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2409:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MonetizeSection_vue_vue_type_template_id_0131c6e3_scoped_true___ = __webpack_require__(2410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MonetizeSection_vue_vue_type_style_index_0_id_0131c6e3_prod_lang_scss_scoped_true___ = __webpack_require__(2412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(47);

var script = {}



/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__MonetizeSection_vue_vue_type_template_id_0131c6e3_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__MonetizeSection_vue_vue_type_template_id_0131c6e3_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "0131c6e3",
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 2410:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MonetizeSection_vue_vue_type_template_id_0131c6e3_scoped_true___ = __webpack_require__(2411);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MonetizeSection_vue_vue_type_template_id_0131c6e3_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MonetizeSection_vue_vue_type_template_id_0131c6e3_scoped_true___["b"]; });


/***/ }),

/***/ 2411:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "monetizeSection"
  }, [_c('h1', {
    staticClass: "monetizeTitle"
  }, [_vm._v("Monetize your podcasts")]), _vm._v(" "), _c('p', {
    staticClass: "monetizeText"
  }, [_vm._v("Earn money for your podcast through advertising and sponsorship from top global brands.")]), _vm._v(" "), _c('RouterLink', {
    staticClass: "btn-round-white monetizeButton",
    attrs: {
      "to": {
        name: 'GhostPage',
        params: {
          slug: 'monetization'
        }
      }
    }
  }, [_vm._v("\n    Find out more\n  ")])], 1);
};
var staticRenderFns = [];


/***/ }),

/***/ 2412:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MonetizeSection_vue_vue_type_style_index_0_id_0131c6e3_prod_lang_scss_scoped_true___ = __webpack_require__(2413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MonetizeSection_vue_vue_type_style_index_0_id_0131c6e3_prod_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MonetizeSection_vue_vue_type_style_index_0_id_0131c6e3_prod_lang_scss_scoped_true___);
/* unused harmony reexport namespace */


/***/ }),

/***/ 2413:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2414);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(1043).default
var update = add("05c51a92", content, true, {});

/***/ }),

/***/ 2414:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1042)(true);
// imports


// module
exports.push([module.i, ".monetizeSection[data-v-0131c6e3]{display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center}.monetizeSection .monetizeTitle[data-v-0131c6e3]{font-size:1.75rem;font-weight:400;line-height:1.1;color:#fff}@media(min-width: 768px){.monetizeSection .monetizeTitle[data-v-0131c6e3]{font-size:3.25rem}}.monetizeSection .monetizeText[data-v-0131c6e3]{max-width:500px;margin-top:32px;font-size:1rem;line-height:1.5}@media(min-width: 768px){.monetizeSection .monetizeText[data-v-0131c6e3]{max-width:unset;font-size:1.25rem}}.monetizeSection .monetizeButton[data-v-0131c6e3]{margin-top:80px}", "", {"version":3,"sources":["/home/runner/work/frontend-desktop/frontend-desktop/src/components/pages/home/monetizeSection/MonetizeSection.vue"],"names":[],"mappings":"AAIA,kCACE,aACA,sBACA,mBACA,uBACA,iBAAA,CAEA,iDACE,kBACA,gBACA,gBACA,UAAA,CAEA,yBANF,iDAOI,iBAAA,CAAA,CAIJ,gDACE,gBACA,gBACA,eACA,eAAA,CAEA,yBANF,gDAOI,gBACA,iBAAA,CAAA,CAIJ,kDACE,eAAA,CAAA","file":"MonetizeSection.vue?vue&type=style&index=0&id=0131c6e3&prod&lang=scss&scoped=true&","sourcesContent":["\n@import 'assets/scss/base/bootstrap_variables';\n@import 'assets/scss/base/functions';\n\n.monetizeSection {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n\n  .monetizeTitle {\n    font-size: to-rem(28);\n    font-weight: 400;\n    line-height: 1.1;\n    color: $color-white;\n\n    @media (min-width: $screen-sm-min) {\n      font-size: to-rem(52);\n    }\n  }\n\n  .monetizeText {\n    max-width: 500px;\n    margin-top: 32px;\n    font-size: to-rem(16);\n    line-height: 1.5;\n\n    @media (min-width: $screen-sm-min) {\n      max-width: unset;\n      font-size: to-rem(20);\n    }\n  }\n\n  .monetizeButton {\n    margin-top: 80px;\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2415:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StatisticsSection_vue_vue_type_template_id_64843e74_scoped_true___ = __webpack_require__(2416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StatisticsSection_vue_vue_type_script_setup_true_lang_js___ = __webpack_require__(2102);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StatisticsSection_vue_vue_type_style_index_0_id_64843e74_prod_lang_scss_scoped_true___ = __webpack_require__(2418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(47);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__StatisticsSection_vue_vue_type_script_setup_true_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__StatisticsSection_vue_vue_type_template_id_64843e74_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__StatisticsSection_vue_vue_type_template_id_64843e74_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "64843e74",
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 2416:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_StatisticsSection_vue_vue_type_template_id_64843e74_scoped_true___ = __webpack_require__(2417);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_StatisticsSection_vue_vue_type_template_id_64843e74_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_StatisticsSection_vue_vue_type_template_id_64843e74_scoped_true___["b"]; });


/***/ }),

/***/ 2417:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "sectionFrame"
  }, [_c('section', {
    staticClass: "statisticsSection"
  }, [_c(_setup.InfographicSection, {
    staticClass: "statisticsInfographicSection",
    attrs: {
      "button-class-name": 'btn-round-black',
      "has-main-heading-title": true,
      "has-white-text": false,
      "on-button-click": function onButtonClick() {
        return _setup.onRedirect('PodcasterRegister');
      },
      "paragraph": 'Monetize and grow your audience using our powerful data and insights that track listenership across devices, regions, countries and more.',
      "title": 'Analytics',
      "button-text": "Create your podcast"
    }
  }, [_c(_setup.KeenSlider, {
    attrs: {
      "arrows": false,
      "auto-switch": true,
      "drag": true
    }
  }, [_c('div', {
    staticClass: "keen-slider__slide slideSlot"
  }, [_c('img', {
    staticClass: "sliderImage",
    attrs: {
      "alt": "Chart showing geographical distribution of podcast episode downloads within Africa",
      "height": "467",
      "src": "static/images/home/analytics-slides/analytics-slide-01.webp",
      "width": "570"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "slideShadow"
  })]), _vm._v(" "), _c('div', {
    staticClass: "keen-slider__slide slideSlot"
  }, [_c('img', {
    staticClass: "sliderImage",
    attrs: {
      "alt": "Chart showing source distribution of podcast episode downloads",
      "height": "467",
      "src": "static/images/home/analytics-slides/analytics-slide-02.webp",
      "width": "570"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "slideShadow"
  })]), _vm._v(" "), _c('div', {
    staticClass: "keen-slider__slide slideSlot"
  }, [_c('img', {
    staticClass: "sliderImage",
    attrs: {
      "alt": "Chart showing podcast episode downloads by time of day",
      "height": "467",
      "src": "static/images/home/analytics-slides/analytics-slide-03.webp",
      "width": "570"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "slideShadow"
  })]), _vm._v(" "), _c('div', {
    staticClass: "keen-slider__slide slideSlot"
  }, [_c('img', {
    staticClass: "sliderImage",
    attrs: {
      "alt": "Chart showing geographical distribution of podcast episode downloads globally",
      "height": "467",
      "src": "static/images/home/analytics-slides/analytics-slide-04.webp",
      "width": "570"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "slideShadow"
  })])])], 1)], 1)]);
};
var staticRenderFns = [];


/***/ }),

/***/ 2418:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_StatisticsSection_vue_vue_type_style_index_0_id_64843e74_prod_lang_scss_scoped_true___ = __webpack_require__(2419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_StatisticsSection_vue_vue_type_style_index_0_id_64843e74_prod_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_StatisticsSection_vue_vue_type_style_index_0_id_64843e74_prod_lang_scss_scoped_true___);
/* unused harmony reexport namespace */


/***/ }),

/***/ 2419:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2420);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(1043).default
var update = add("1c79c3b0", content, true, {});

/***/ }),

/***/ 2420:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1042)(true);
// imports


// module
exports.push([module.i, ".sectionFrame[data-v-64843e74]{width:100vw;min-height:calc(100vh - 72px);background-color:#fff;background-image:url(\"/static/images/home/frame-pattern-darker.svg\");background-repeat:no-repeat;background-attachment:fixed;background-position:top;background-size:cover}@media(min-width: 768px){.sectionFrame[data-v-64843e74]{min-height:calc(100vh - 96px)}}.sectionFrame .statisticsSection[data-v-64843e74]{display:flex;align-items:center;justify-content:center;width:100%;max-width:1252px;height:100%;padding:0 16px;margin:40px auto;color:#000;background-color:rgba(0,0,0,0)}@media(min-width: 768px){.sectionFrame .statisticsSection[data-v-64843e74]{padding:0 32px}}.sectionFrame .statisticsSection .statisticsInfographicSection[data-v-64843e74]{margin-top:0}.sectionFrame .statisticsSection .statisticsInfographicSection .slideSlot[data-v-64843e74]{display:flex;flex-direction:column;align-items:center;justify-content:center;width:712.5px;height:auto}.sectionFrame .statisticsSection .statisticsInfographicSection .slideSlot .sliderImage[data-v-64843e74]{z-index:2;width:100%;max-width:572px;height:auto;border:1px solid #ddd;border-radius:4px}@media(min-width: 768px){.sectionFrame .statisticsSection .statisticsInfographicSection .slideSlot .sliderImage[data-v-64843e74]{width:80%}}.sectionFrame .statisticsSection .statisticsInfographicSection .slideSlot .slideShadow[data-v-64843e74]{z-index:1;width:70%;height:15px;margin-bottom:20px;background:rgba(0,0,0,.3);filter:blur(10px);border-radius:50%}", "", {"version":3,"sources":["/home/runner/work/frontend-desktop/frontend-desktop/src/components/pages/home/statisticsSection/StatisticsSection.vue"],"names":[],"mappings":"AAIA,+BACE,YACA,8BACA,sBACA,qEACA,4BACA,4BACA,wBACA,qBAAA,CAEA,yBAVF,+BAWI,6BAAA,CAAA,CAGF,kDACE,aACA,mBACA,uBACA,WACA,iBACA,YACA,eACA,iBACA,WACA,8BAAA,CAEA,yBAZF,kDAaI,cAAA,CAAA,CAGF,gFACE,YAAA,CAEA,2FACE,aACA,sBACA,mBACA,uBACA,cACA,WAAA,CAEA,wGACE,UACA,WACA,gBACA,YACA,sBACA,iBAAA,CAEA,yBARF,wGASI,SAAA,CAAA,CAIJ,wGACE,UACA,UACA,YACA,mBACA,0BACA,kBACA,iBAAA,CAAA","file":"StatisticsSection.vue?vue&type=style&index=0&id=64843e74&prod&lang=scss&scoped=true&","sourcesContent":["\n@import 'assets/scss/base/bootstrap_variables';\n@import 'assets/scss/base/functions';\n\n.sectionFrame {\n  width: 100vw;\n  min-height: calc(100vh - 72px);\n  background-color: $color-white;\n  background-image: url('/static/images/home/frame-pattern-darker.svg');\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  background-position: top;\n  background-size: cover;\n\n  @media (min-width: $screen-sm-min) {\n    min-height: calc(100vh - 96px);\n  }\n\n  .statisticsSection {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    max-width: 1252px;\n    height: 100%;\n    padding: 0 16px;\n    margin: 40px auto;\n    color: $color-black;\n    background-color: transparent;\n\n    @media (min-width: $screen-sm-min) {\n      padding: 0 32px;\n    }\n\n    .statisticsInfographicSection {\n      margin-top: 0;\n\n      .slideSlot {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        width: 712.5px;\n        height: auto;\n\n        .sliderImage {\n          z-index: 2;\n          width: 100%;\n          max-width: 572px;\n          height: auto;\n          border: 1px solid $light-grey;\n          border-radius: 4px;\n\n          @media (min-width: $screen-sm-min) {\n            width: 80%;\n          }\n        }\n\n        .slideShadow {\n          z-index: 1;\n          width: 70%;\n          height: 15px;\n          margin-bottom: 20px;\n          background: rgb(0 0 0 / 30%);\n          filter: blur(10px);\n          border-radius: 50%;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2421:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TrustedPartnersSection_vue_vue_type_template_id_4516281a_scoped_true___ = __webpack_require__(2422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TrustedPartnersSection_vue_vue_type_style_index_0_id_4516281a_prod_lang_scss_scoped_true___ = __webpack_require__(2424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(47);

var script = {}



/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__TrustedPartnersSection_vue_vue_type_template_id_4516281a_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__TrustedPartnersSection_vue_vue_type_template_id_4516281a_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "4516281a",
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 2422:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TrustedPartnersSection_vue_vue_type_template_id_4516281a_scoped_true___ = __webpack_require__(2423);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TrustedPartnersSection_vue_vue_type_template_id_4516281a_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TrustedPartnersSection_vue_vue_type_template_id_4516281a_scoped_true___["b"]; });


/***/ }),

/***/ 2423:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "trustedPartnersSection"
  }, [_c('h1', {
    staticClass: "trustedPartnersTitle"
  }, [_vm._v("Trusted by")]), _vm._v(" "), _c('picture', {
    staticClass: "trustedPartnersPicture"
  }, [_c('source', {
    attrs: {
      "media": "(max-width: 767px)",
      "srcset": "static/images/home/trusted-by-logo-wall-mobile-686.webp" + " 686w, " + "static/images/home/trusted-by-logo-wall-mobile-914.webp" + " 914w"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width: 768px) and (max-width: 1199px)",
      "srcset": "static/images/home/trusted-by-logo-wall-1219.webp" + " 1219w"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width: 1200px) and (min-resolution: 120dpi)",
      "srcset": "static/images/home/trusted-by-logo-wall-1829.webp" + " 1829w"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width: 1536px)",
      "srcset": "static/images/home/trusted-by-logo-wall-1829.webp" + " 1829w"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logoWallImage",
    attrs: {
      "alt": "Afripods partners",
      "height": "742",
      "src": "static/images/home/trusted-by-logo-wall-1219.webp",
      "width": "1219"
    }
  })])]);
}];


/***/ }),

/***/ 2424:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TrustedPartnersSection_vue_vue_type_style_index_0_id_4516281a_prod_lang_scss_scoped_true___ = __webpack_require__(2425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TrustedPartnersSection_vue_vue_type_style_index_0_id_4516281a_prod_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TrustedPartnersSection_vue_vue_type_style_index_0_id_4516281a_prod_lang_scss_scoped_true___);
/* unused harmony reexport namespace */


/***/ }),

/***/ 2425:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2426);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(1043).default
var update = add("211edc46", content, true, {});

/***/ }),

/***/ 2426:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1042)(true);
// imports


// module
exports.push([module.i, ".trustedPartnersSection[data-v-4516281a]{display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;padding:100px 16px;background-color:#fff;background-image:url(\"/static/images/home/frame-pattern-darker.svg\");background-repeat:no-repeat;background-attachment:fixed;background-position:top;background-size:cover}@media(min-width: 768px){.trustedPartnersSection[data-v-4516281a]{padding:100px 32px}}.trustedPartnersSection .trustedPartnersTitle[data-v-4516281a]{font-size:1.75rem;font-weight:400;line-height:1.1}@media(min-width: 768px){.trustedPartnersSection .trustedPartnersTitle[data-v-4516281a]{font-size:3rem}}.trustedPartnersSection .trustedPartnersPicture[data-v-4516281a]{margin-top:48px}.trustedPartnersSection .trustedPartnersPicture .logoWallImage[data-v-4516281a]{width:100%;max-width:1219px;height:auto}", "", {"version":3,"sources":["/home/runner/work/frontend-desktop/frontend-desktop/src/components/pages/home/trustedPartnersSection/TrustedPartnersSection.vue"],"names":[],"mappings":"AAIA,yCACE,aACA,sBACA,mBACA,uBACA,WACA,mBACA,sBACA,qEACA,4BACA,4BACA,wBACA,qBAAA,CAEA,yBAdF,yCAeI,kBAAA,CAAA,CAGF,+DACE,kBACA,gBACA,eAAA,CAEA,yBALF,+DAMI,cAAA,CAAA,CAIJ,iEACE,eAAA,CAEA,gFACE,WACA,iBACA,WAAA,CAAA","file":"TrustedPartnersSection.vue?vue&type=style&index=0&id=4516281a&prod&lang=scss&scoped=true&","sourcesContent":["\n@import 'assets/scss/base/bootstrap_variables';\n@import 'assets/scss/base/functions';\n\n.trustedPartnersSection {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 100px 16px;\n  background-color: $color-white;\n  background-image: url('/static/images/home/frame-pattern-darker.svg');\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  background-position: top;\n  background-size: cover;\n\n  @media (min-width: $screen-sm-min) {\n    padding: 100px 32px;\n  }\n\n  .trustedPartnersTitle {\n    font-size: to-rem(28);\n    font-weight: 400;\n    line-height: 1.1;\n\n    @media (min-width: $screen-sm-min) {\n      font-size: to-rem(48);\n    }\n  }\n\n  .trustedPartnersPicture {\n    margin-top: 48px;\n\n    .logoWallImage {\n      width: 100%;\n      max-width: 1219px;\n      height: auto;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2427:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PartnersBar_vue_vue_type_template_id_7644d3f4_scoped_true___ = __webpack_require__(2428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PartnersBar_vue_vue_type_script_setup_true_lang_js___ = __webpack_require__(2104);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PartnersBar_vue_vue_type_style_index_0_id_7644d3f4_prod_lang_scss_scoped_true___ = __webpack_require__(2431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(47);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__PartnersBar_vue_vue_type_script_setup_true_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__PartnersBar_vue_vue_type_template_id_7644d3f4_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__PartnersBar_vue_vue_type_template_id_7644d3f4_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "7644d3f4",
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 2428:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PartnersBar_vue_vue_type_template_id_7644d3f4_scoped_true___ = __webpack_require__(2429);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PartnersBar_vue_vue_type_template_id_7644d3f4_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PartnersBar_vue_vue_type_template_id_7644d3f4_scoped_true___["b"]; });


/***/ }),

/***/ 2429:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('section', {
    staticClass: "partnersBar"
  }, _vm._l(_vm.partnersList, function (partner) {
    return _c('div', {
      key: partner.name,
      staticClass: "logoWrapper"
    }, [_c('img', {
      staticClass: "partnerLogo",
      attrs: {
        "alt": partner.name,
        "src": partner.logo
      }
    })]);
  }), 0);
};
var staticRenderFns = [];


/***/ }),

/***/ 2430:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var DefaultPartnersList = [{
  name: 'BBC World Service',
  logo: 'static/images/partner-logos/bbc-world-service.svg'
}, {
  name: 'Africa Media Festival',
  logo: 'static/images/partner-logos/amf.svg'
}, {
  name: 'Podcast Movement',
  logo: 'static/images/partner-logos/podcast-movement.svg'
}, {
  name: 'The Guardian',
  logo: 'static/images/partner-logos/guardian.svg'
}, {
  name: 'Apple Podcasts',
  logo: 'static/images/partner-logos/apple-podcasts.svg'
}, {
  name: 'Forbes Africa',
  logo: 'static/images/partner-logos/forbes-africa.svg'
}, {
  name: 'Podnews',
  logo: 'static/images/partner-logos/podnews.svg'
}, {
  name: 'Advertising Week Africa',
  logo: 'static/images/partner-logos/awa.svg'
}];
/* harmony default export */ __webpack_exports__["a"] = (DefaultPartnersList);

/***/ }),

/***/ 2431:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PartnersBar_vue_vue_type_style_index_0_id_7644d3f4_prod_lang_scss_scoped_true___ = __webpack_require__(2432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PartnersBar_vue_vue_type_style_index_0_id_7644d3f4_prod_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PartnersBar_vue_vue_type_style_index_0_id_7644d3f4_prod_lang_scss_scoped_true___);
/* unused harmony reexport namespace */


/***/ }),

/***/ 2432:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2433);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(1043).default
var update = add("929c205c", content, true, {});

/***/ }),

/***/ 2433:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1042)(true);
// imports


// module
exports.push([module.i, ".partnersBar[data-v-7644d3f4]{display:flex;flex-wrap:wrap;gap:2%;align-items:center;justify-content:space-between;width:100%;padding:24px;background-color:#fff}@media(min-width: 768px){.partnersBar[data-v-7644d3f4]{padding:40px 120px}}.partnersBar .logoWrapper[data-v-7644d3f4]{width:8%;min-width:50px;max-width:130px;margin:12px auto}.partnersBar .logoWrapper .partnerLogo[data-v-7644d3f4]{width:100%;aspect-ratio:1/1;object-fit:contain}", "", {"version":3,"sources":["/home/runner/work/frontend-desktop/frontend-desktop/src/components/reused-components/partnersBar/PartnersBar.vue","/home/runner/work/frontend-desktop/frontend-desktop/assets/scss/base/_variables.scss"],"names":[],"mappings":"AAGA,8BACE,aACA,eACA,OACA,mBACA,8BACA,WACA,aACA,qBCIY,CDFZ,yBAVF,8BAWI,kBAAA,CAAA,CAGF,2CACE,SACA,eACA,gBACA,gBAAA,CAEA,wDACE,WACA,iBACA,kBAAA,CAAA","file":"PartnersBar.vue?vue&type=style&index=0&id=7644d3f4&prod&lang=scss&scoped=true&","sourcesContent":["\n@import 'assets/scss/base/bootstrap_variables';\n\n.partnersBar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2%;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 24px;\n  background-color: $color-white;\n\n  @media (min-width: $screen-sm-min) {\n    padding: 40px 120px;\n  }\n\n  .logoWrapper {\n    width: 8%;\n    min-width: 50px;\n    max-width: 130px;\n    margin: 12px auto;\n\n    .partnerLogo {\n      width: 100%;\n      aspect-ratio: 1/1;\n      object-fit: contain;\n    }\n  }\n}\n","// -----------------------------------------------------------------------------\n//                                  Variables\n// -----------------------------------------------------------------------------\n\n// --------------------------------- Colors ------------------------------------\n$brand-yellow: #fdd366;\n$brand-green: #259167;\n$brand-orange: #f2765d;\n$brand-blue: #2188bf;\n$color-informative-blue: #6594ee;\n$brand-blue-light: lighten($brand-blue, 10%);\n$brand-very-dark-blue: #1d1f24;\n$back-gray: #f3f3f3;\n$light-grey: #ddd;\n$border-color: #e3e3e3;\n$color-white: #fff;\n$color-black: #000;\n$color-dark: #1d1f24;\n$color-alert: #eb5757;\n$color-nation-dark: #1e1e1e;\n$background-color: #eef6fa;\n$color-grey: #aaa;\n$color-overlay-background: rgb(0 0 0 / 40%);\n$color-transparency-white: rgb(255 255 255 / 50%);\n$color-blue-secondary: #074ee8;\n$color-blue-secondary-light: lighten($color-blue-secondary, 10%);\n$color-green-secondary: #1da41a;\n$color-green-secondary-light: lighten($color-green-secondary, 10%);\n$spotify-green: #1db954;\n$apple-podcasts-purple: #b150e2;\n$google-blue: #4285f4;\n$notification-blue: #2188bf;\n$notification-border-blue: #1d7bad;\n$notification-warn: #ffb648;\n$notification-border-warn: #f48a06;\n$notification-error: #e54d42;\n$notification-border-error: #b82e24;\n$notification-success: #259167;\n$notification-border-success: #1f7c58;\n$bg-light-blue: #e5e5e5;\n$bg-alice-blue: #e6f6ff;\n$bg-light-blue-alternative: #eff6fa;\n$medium-turquoise: #429ac9;\n$color-pelorous: #2188bf;\n$light-orange: #fdefec;\n$black-russian: #111928;\n\n// ------------------------------- Transitions ---------------------------------\n$transition-duration: 0.2s;\n$ease-in-back: cubic-bezier(0.6, -0.28, 0.735, 0.045);\n$ease-out-back: cubic-bezier(0.175, 0.885, 0.32, 1.275);\n\n// ---------------------------------- Misc -------------------------------------\n$clear-icon-svg: \"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12'%3E%3Cpath fill='%237f8a8e' fill-rule='evenodd' d='M6 5.082 10.902.179a.642.642 0 0 1 .91.91L6.91 5.991l4.902 4.902a.643.643 0 1 1-.91.91L6.001 6.901l-4.902 4.902a.642.642 0 0 1-.91-.91l4.903-4.902L.188 1.089a.644.644 0 0 1 .91-.91Z'/%3E%3C/svg%3E\";\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2434:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Home_vue_vue_type_style_index_0_id_1a6d6940_prod_lang_scss_scoped_true___ = __webpack_require__(2435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Home_vue_vue_type_style_index_0_id_1a6d6940_prod_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Home_vue_vue_type_style_index_0_id_1a6d6940_prod_lang_scss_scoped_true___);
/* unused harmony reexport namespace */


/***/ }),

/***/ 2435:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2436);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(1043).default
var update = add("75ad6f26", content, true, {});

/***/ }),

/***/ 2436:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1042)(true);
// imports


// module
exports.push([module.i, ".homePage[data-v-1a6d6940]{font-family:\"Barlow\",times,serif;font-weight:400;line-height:1;color:#fff;background-color:#6594ee;background-image:url(\"/static/images/home/frame-pattern.svg\");background-repeat:no-repeat;background-attachment:fixed;background-position:top;background-size:cover;transition:background-color 1.5s ease-out}.homePage .videoSection[data-v-1a6d6940]{position:relative}.homePage .videoSection .heroSectionContent[data-v-1a6d6940]{position:absolute;top:10vh;left:50%;z-index:10;width:100%;max-width:1264px;min-height:auto;padding:0 16px;transform:translateX(-50%)}@media(min-width: 768px){.homePage .videoSection .heroSectionContent[data-v-1a6d6940]{top:unset;bottom:80px;padding:0 32px}}@media(min-width: 1536px){.homePage .videoSection .heroSectionContent[data-v-1a6d6940]{left:110px;max-width:unset;transform:unset}}.homePage .videoSection .monetizeSectionContent[data-v-1a6d6940]{position:absolute;top:50%;left:50%;z-index:10;width:100%;min-height:auto;padding:12px;transform:translate(-50%, -50%)}.homePage .panel[data-v-1a6d6940]{display:flex;min-height:calc(100vh - 72px)}@media(min-width: 768px){.homePage .panel[data-v-1a6d6940]{min-height:calc(100vh - 96px)}}.color-blue[data-v-1a6d6940]{background-color:#6594ee}.color-black[data-v-1a6d6940]{background-color:#000}.color-red[data-v-1a6d6940]{background-color:#f2765d}.color-white[data-v-1a6d6940]{background-color:#fff}.color-yellow[data-v-1a6d6940]{background-color:#fdd366}[data-v-1a6d6940] video{pointer-events:none}[data-v-1a6d6940] .keen-slider{cursor:grab}[data-v-1a6d6940] .keen-slider:active{cursor:grabbing}", "", {"version":3,"sources":["/home/runner/work/frontend-desktop/frontend-desktop/src/components/pages/home/Home.vue","/home/runner/work/frontend-desktop/frontend-desktop/assets/scss/base/_variables.scss"],"names":[],"mappings":"AAIA,2BACE,iCACA,gBACA,cACA,WACA,yBACA,8DACA,4BACA,4BACA,wBACA,sBACA,yCAAA,CAEA,yCACE,iBAAA,CAEA,6DACE,kBACA,SACA,SACA,WACA,WACA,iBACA,gBACA,eACA,0BAAA,CAEA,yBAXF,6DAYI,UACA,YACA,cAAA,CAAA,CAGF,0BAjBF,6DAkBI,WACA,gBACA,eAAA,CAAA,CAIJ,iEACE,kBACA,QACA,SACA,WACA,WACA,gBACA,aACA,+BAAA,CAIJ,kCACE,aACA,6BAAA,CAEA,yBAJF,kCAKI,6BAAA,CAAA,CAMN,6BACE,wBC3DuB,CD8DzB,8BACE,qBCxDY,CD2Dd,4BACE,wBCrEa,CDwEf,8BACE,qBCjEY,CDoEd,+BACE,wBC/Ea,CDoFf,wBACE,mBAAA,CAGF,+BACE,WAAA,CAEA,sCACE,eAAA,CAAA","file":"Home.vue?vue&type=style&index=0&id=1a6d6940&prod&lang=scss&scoped=true&","sourcesContent":["\n@import 'assets/scss/base/bootstrap_variables';\n@import 'assets/scss/base/functions';\n\n.homePage {\n  font-family: $font-family-barlow;\n  font-weight: 400;\n  line-height: 1;\n  color: $color-white;\n  background-color: $color-informative-blue;\n  background-image: url('/static/images/home/frame-pattern.svg');\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  background-position: top;\n  background-size: cover;\n  transition: background-color 1.5s ease-out;\n\n  .videoSection {\n    position: relative;\n\n    .heroSectionContent {\n      position: absolute;\n      top: 10vh;\n      left: 50%;\n      z-index: 10;\n      width: 100%;\n      max-width: 1264px;\n      min-height: auto;\n      padding: 0 16px;\n      transform: translateX(-50%);\n\n      @media (min-width: $screen-sm-min) {\n        top: unset;\n        bottom: 80px;\n        padding: 0 32px;\n      }\n\n      @media (min-width: $screen-xl-min) {\n        left: 110px;\n        max-width: unset;\n        transform: unset;\n      }\n    }\n\n    .monetizeSectionContent {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      z-index: 10;\n      width: 100%;\n      min-height: auto;\n      padding: 12px;\n      transform: translate(-50%, -50%);\n    }\n  }\n\n  .panel {\n    display: flex;\n    min-height: calc(100vh - 72px);\n\n    @media (min-width: $screen-sm-min) {\n      min-height: calc(100vh - 96px);\n    }\n  }\n}\n\n// eslint-disable vue-scoped-css/no-unused-selector\n.color-blue {\n  background-color: $color-informative-blue;\n}\n\n.color-black {\n  background-color: $color-black;\n}\n\n.color-red {\n  background-color: $brand-orange;\n}\n\n.color-white {\n  background-color: $color-white;\n}\n\n.color-yellow {\n  background-color: $brand-yellow;\n}\n\n// eslint-enable vue-scoped-css/no-unused-selector\n\n:deep(video) {\n  pointer-events: none;\n}\n\n:deep(.keen-slider) {\n  cursor: grab;\n\n  &:active {\n    cursor: grabbing;\n  }\n}\n","// -----------------------------------------------------------------------------\n//                                  Variables\n// -----------------------------------------------------------------------------\n\n// --------------------------------- Colors ------------------------------------\n$brand-yellow: #fdd366;\n$brand-green: #259167;\n$brand-orange: #f2765d;\n$brand-blue: #2188bf;\n$color-informative-blue: #6594ee;\n$brand-blue-light: lighten($brand-blue, 10%);\n$brand-very-dark-blue: #1d1f24;\n$back-gray: #f3f3f3;\n$light-grey: #ddd;\n$border-color: #e3e3e3;\n$color-white: #fff;\n$color-black: #000;\n$color-dark: #1d1f24;\n$color-alert: #eb5757;\n$color-nation-dark: #1e1e1e;\n$background-color: #eef6fa;\n$color-grey: #aaa;\n$color-overlay-background: rgb(0 0 0 / 40%);\n$color-transparency-white: rgb(255 255 255 / 50%);\n$color-blue-secondary: #074ee8;\n$color-blue-secondary-light: lighten($color-blue-secondary, 10%);\n$color-green-secondary: #1da41a;\n$color-green-secondary-light: lighten($color-green-secondary, 10%);\n$spotify-green: #1db954;\n$apple-podcasts-purple: #b150e2;\n$google-blue: #4285f4;\n$notification-blue: #2188bf;\n$notification-border-blue: #1d7bad;\n$notification-warn: #ffb648;\n$notification-border-warn: #f48a06;\n$notification-error: #e54d42;\n$notification-border-error: #b82e24;\n$notification-success: #259167;\n$notification-border-success: #1f7c58;\n$bg-light-blue: #e5e5e5;\n$bg-alice-blue: #e6f6ff;\n$bg-light-blue-alternative: #eff6fa;\n$medium-turquoise: #429ac9;\n$color-pelorous: #2188bf;\n$light-orange: #fdefec;\n$black-russian: #111928;\n\n// ------------------------------- Transitions ---------------------------------\n$transition-duration: 0.2s;\n$ease-in-back: cubic-bezier(0.6, -0.28, 0.735, 0.045);\n$ease-out-back: cubic-bezier(0.175, 0.885, 0.32, 1.275);\n\n// ---------------------------------- Misc -------------------------------------\n$clear-icon-svg: \"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12'%3E%3Cpath fill='%237f8a8e' fill-rule='evenodd' d='M6 5.082 10.902.179a.642.642 0 0 1 .91.91L6.91 5.991l4.902 4.902a.643.643 0 1 1-.91.91L6.001 6.901l-4.902 4.902a.642.642 0 0 1-.91-.91l4.903-4.902L.188 1.089a.644.644 0 0 1 .91-.91Z'/%3E%3C/svg%3E\";\n"],"sourceRoot":""}]);

// exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/4.3427244105ed191711c8.js